import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string with format `Y-m-d`, e.g. `2011-05-23`. */
  Date: any;
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-01-01 13:00:00`. */
  DateTime: any;
  /** Arbitrary data encoded in JavaScript Object Notation. See https://www.json.org. */
  JsonField: any;
  /**
   * Loose type that allows any value. Be careful when passing in large `Int` or `Float` literals,
   * as they may not be parsed correctly on the server side. Use `String` literals if you are
   * dealing with really large numbers to be on the safe side.
   */
  Mixed: any;
  /**
   * Loose type that allows any value. Be careful when passing in large `Int` or `Float` literals,
   * as they may not be parsed correctly on the server side. Use `String` literals if you are
   * dealing with really large numbers to be on the safe side.
   */
  MixedField: any;
  /** A timestamp string */
  Timestamp: any;
  /** Can be used as an argument to upload files using https://github.com/jaydenseric/graphql-multipart-request-spec */
  Upload: any;
};

export type QLAccessToken = {
  __typename?: 'AccessToken';
  created_at?: Maybe<Scalars['Timestamp']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  plain_token?: Maybe<Scalars['String']>;
};

export type QLAddon = {
  __typename?: 'Addon';
  active?: Maybe<Scalars['Boolean']>;
  cancellable?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type QLAnnouncement = {
  __typename?: 'Announcement';
  action_text?: Maybe<Scalars['String']>;
  action_url?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  created_at?: Maybe<Scalars['Timestamp']>;
  creator: QLUser;
  id: Scalars['ID'];
  parsed_body?: Maybe<Scalars['String']>;
  popup?: Maybe<Scalars['Boolean']>;
};

export type QLAppointmentName = {
  __typename?: 'AppointmentName';
  name?: Maybe<Scalars['String']>;
};

export type QLAutomation = {
  __typename?: 'Automation';
  active?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  assigned_tags?: Maybe<Array<Maybe<QLTag>>>;
  category_name?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Timestamp']>;
  delivery_type?: Maybe<QLAutomationDeliveryTypeEnum>;
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  email_content?: Maybe<QLEmailTemplateContent>;
  ever_ran?: Maybe<Scalars['Boolean']>;
  /** The ID of the automation */
  id: Scalars['ID'];
  name: Scalars['String'];
  one_off?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  reply_to?: Maybe<Scalars['String']>;
  segment?: Maybe<QLSegment>;
  segment_id?: Maybe<Scalars['ID']>;
  send_window_end_minutes?: Maybe<Scalars['Int']>;
  send_window_start_minutes?: Maybe<Scalars['Int']>;
  start_at?: Maybe<Scalars['Timestamp']>;
  subject?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags_add?: Maybe<Scalars['Boolean']>;
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  todo_assigned_to?: Maybe<QLUser>;
  todo_assigned_to_id?: Maybe<Scalars['ID']>;
  todo_overdue_hours?: Maybe<Scalars['Int']>;
  todo_postponed_hours?: Maybe<Scalars['Int']>;
  todo_priority?: Maybe<QLTodoPriority>;
  todo_tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  todo_team_group?: Maybe<QLTeamGroup>;
  todo_team_group_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['Timestamp']>;
};

export type QLAutomationAction = {
  __typename?: 'AutomationAction';
  action?: Maybe<Scalars['String']>;
  affected?: Maybe<QLClient>;
  affected_id?: Maybe<Scalars['ID']>;
  affected_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Timestamp']>;
  creator_id?: Maybe<Scalars['ID']>;
  creator_type?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  related?: Maybe<QLTag>;
  related_id?: Maybe<Scalars['ID']>;
  related_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Timestamp']>;
};

/** A paginated list of AutomationAction items. */
export type QLAutomationActionPaginator = {
  __typename?: 'AutomationActionPaginator';
  /** A list of AutomationAction items. */
  data: Array<QLAutomationAction>;
  /** Pagination information about the list of items. */
  paginatorInfo: QLPaginatorInfo;
};

export enum QLAutomationBulkActionEnum {
  ARCHIVE = 'ARCHIVE',
  PAUSE = 'PAUSE',
  RUN = 'RUN',
  UNARCHIVE = 'UNARCHIVE'
}

export type QLAutomationCategory = {
  __typename?: 'AutomationCategory';
  name?: Maybe<Scalars['String']>;
};

export enum QLAutomationDeliveryTypeEnum {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  TAG = 'TAG',
  TODO = 'TODO'
}

export type QLAutomationFilterGroupInput = {
  filters: Array<InputMaybe<QLFilterInput>>;
  operator_is_and?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Scalars['ID']>;
};

export type QLAutomationReorderInput = {
  id: Scalars['ID'];
  order: Scalars['Int'];
};

export type QLAutomationSegmentInput = {
  filter_groups?: InputMaybe<Array<InputMaybe<QLAutomationFilterGroupInput>>>;
  /** The ID of the segment */
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type QLAutomationStatInput = {
  ends_at?: InputMaybe<Scalars['Timestamp']>;
  id?: InputMaybe<Scalars['ID']>;
  starts_at?: InputMaybe<Scalars['Timestamp']>;
};

export type QLAutomationStats = {
  __typename?: 'AutomationStats';
  automation?: Maybe<QLAutomation>;
  bounced?: Maybe<Scalars['Int']>;
  clicked?: Maybe<Scalars['Int']>;
  delivered?: Maybe<Scalars['Int']>;
  opened?: Maybe<Scalars['Int']>;
  sent?: Maybe<Scalars['Int']>;
};

export type QLAutomationStatsEmailOrSms = {
  __typename?: 'AutomationStatsEmailOrSms';
  bounced?: Maybe<Scalars['Int']>;
  clicked?: Maybe<Scalars['Int']>;
  delivered?: Maybe<Scalars['Int']>;
  opened?: Maybe<Scalars['Int']>;
  sent?: Maybe<Scalars['Int']>;
};

export type QLAutomationStatsTag = {
  __typename?: 'AutomationStatsTag';
  created?: Maybe<Scalars['Int']>;
};

export type QLAutomationStatsTodo = {
  __typename?: 'AutomationStatsTodo';
  completed?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['Int']>;
  deleted?: Maybe<Scalars['Int']>;
  open?: Maybe<Scalars['Int']>;
  postponed?: Maybe<Scalars['Int']>;
};

export type QLBatchTagClientIdentifier = {
  __typename?: 'BatchTagClientIdentifier';
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  mobile_phone?: Maybe<Scalars['String']>;
};

export type QLBatchTagClientIdentifierInput = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  mobile_phone?: InputMaybe<Scalars['String']>;
};

export type QLBatchTagInvalidRowDetail = {
  __typename?: 'BatchTagInvalidRowDetail';
  data?: Maybe<QLBatchTagClientIdentifier>;
  index: Scalars['Int'];
  reason: Scalars['String'];
};

export type QLBatchTagResult = {
  __typename?: 'BatchTagResult';
  clientsTagged?: Maybe<Scalars['Int']>;
  invalidRows?: Maybe<Array<QLBatchTagInvalidRowDetail>>;
  leadsCreated?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  rowsInvalid?: Maybe<Scalars['Int']>;
  rowsProcessed?: Maybe<Scalars['Int']>;
  rowsValid?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

export type QLBrand = {
  __typename?: 'Brand';
  brand_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type QLCatalogAutomation = {
  __typename?: 'CatalogAutomation';
  active?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  assigned_tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  category_name?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  delivery_type?: Maybe<QLAutomationDeliveryTypeEnum>;
  description?: Maybe<Scalars['String']>;
  email_content?: Maybe<QLEmailTemplateContent>;
  name?: Maybe<Scalars['String']>;
  one_off?: Maybe<Scalars['Boolean']>;
  reply_to?: Maybe<Scalars['String']>;
  segment: QLSegment;
  send_window_end_minutes?: Maybe<Scalars['Int']>;
  send_window_start_minutes?: Maybe<Scalars['Int']>;
  start_at?: Maybe<Scalars['Timestamp']>;
  subject?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags_add?: Maybe<Scalars['Boolean']>;
  todo_assigned_to_id?: Maybe<Scalars['ID']>;
  todo_overdue_hours?: Maybe<Scalars['Int']>;
  todo_postponed_hours?: Maybe<Scalars['Int']>;
  todo_priority?: Maybe<QLTodoPriority>;
  todo_tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  todo_team_group_id?: Maybe<Scalars['ID']>;
};

export type QLCatalogCategoryName = {
  __typename?: 'CatalogCategoryName';
  name?: Maybe<Scalars['String']>;
};

export type QLCatalogItem = {
  __typename?: 'CatalogItem';
  automation?: Maybe<QLCatalogAutomation>;
  brand?: Maybe<QLBrand>;
  brand_id?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  long_description: Scalars['String'];
  name: Scalars['String'];
  provider?: Maybe<QLProvidersEnum>;
  variable_fields?: Maybe<Array<QLCatalogItemVariable>>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type QLCatalogItemInput = {
  automation?: InputMaybe<QLCreateAutomationInput>;
  brand_id?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  long_description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<QLProvidersEnum>;
  variable_fields: Array<QLCatalogItemVariableInput>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type QLCatalogItemToAutomationInput = {
  automation_name: Scalars['String'];
  todo_assigned_to_id?: InputMaybe<Scalars['ID']>;
  variables: Array<QLCatalogItemVariableToAutomationInput>;
};

export type QLCatalogItemVariable = {
  __typename?: 'CatalogItemVariable';
  field_description: Scalars['String'];
  field_name: Scalars['String'];
  field_type: QLOperatorTypeEnum;
  id: Scalars['String'];
};

export type QLCatalogItemVariableInput = {
  field_description: Scalars['String'];
  field_name: Scalars['String'];
  field_type: QLOperatorTypeEnum;
  id: Scalars['String'];
};

export type QLCatalogItemVariableToAutomationInput = {
  id: Scalars['ID'];
  value?: InputMaybe<Scalars['MixedField']>;
};

export type QLChangePasswordInput = {
  current_password: Scalars['String'];
  password: Scalars['String'];
  password_confirmation: Scalars['String'];
};

export type QLClassModel = {
  __typename?: 'ClassModel';
  cancelled?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['Timestamp']>;
  event_type?: Maybe<QLClassType>;
  external_id?: Maybe<Scalars['String']>;
  /** The ID of the class */
  id: Scalars['ID'];
  is_virtual?: Maybe<Scalars['Boolean']>;
  location?: Maybe<QLLocation>;
  location_id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  staff?: Maybe<QLStaff>;
  staff_id?: Maybe<Scalars['ID']>;
  start_time?: Maybe<Scalars['Timestamp']>;
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  virtual_data?: Maybe<QLClassVirtualData>;
  virtual_url?: Maybe<Scalars['String']>;
  visits?: Maybe<Array<Maybe<QLVisit>>>;
};

export type QLClassName = {
  __typename?: 'ClassName';
  name?: Maybe<Scalars['String']>;
};

/** Class type */
export enum QLClassType {
  /** Appointment */
  APPOINTMENT = 'APPOINTMENT',
  /** Type class */
  TYPE_CLASS = 'TYPE_CLASS'
}

export type QLClassVirtualData = {
  __typename?: 'ClassVirtualData';
  virtual_id?: Maybe<Scalars['String']>;
  virtual_info?: Maybe<Scalars['String']>;
  virtual_password?: Maybe<Scalars['String']>;
};

export type QLClassVirtualDataInput = {
  virtual_id?: InputMaybe<Scalars['String']>;
  virtual_info?: InputMaybe<Scalars['String']>;
  virtual_password?: InputMaybe<Scalars['String']>;
};

export type QLClient = {
  __typename?: 'Client';
  active?: Maybe<Scalars['Boolean']>;
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_line?: Maybe<Scalars['String']>;
  address_postal_code?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  /** A date in timestamp format */
  birthday?: Maybe<Scalars['Timestamp']>;
  can_contact_by_email?: Maybe<Scalars['Boolean']>;
  can_contact_by_sms?: Maybe<Scalars['Boolean']>;
  /** A date in timestamp format */
  created_at?: Maybe<Scalars['Timestamp']>;
  /** A date in timestamp format */
  creation_date?: Maybe<Scalars['Timestamp']>;
  current_package?: Maybe<QLPackage>;
  education?: Maybe<Array<Maybe<QLClientEducation>>>;
  email?: Maybe<Scalars['String']>;
  email_opt_in?: Maybe<Scalars['Boolean']>;
  email_opt_in_reminder_at?: Maybe<Scalars['Timestamp']>;
  emergency_contact_info_email?: Maybe<Scalars['String']>;
  emergency_contact_info_name?: Maybe<Scalars['String']>;
  emergency_contact_info_phone?: Maybe<Scalars['String']>;
  emergency_contact_info_relationship?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  frozen?: Maybe<Scalars['Boolean']>;
  /** @deprecated Field removed */
  google_plus?: Maybe<Scalars['String']>;
  /** @deprecated Field removed */
  google_plus_followers?: Maybe<Scalars['Int']>;
  home_location?: Maybe<QLLocation>;
  home_location_id?: Maybe<Scalars['ID']>;
  /** The ID of the client */
  id: Scalars['ID'];
  instagram?: Maybe<Scalars['String']>;
  instagram_bio?: Maybe<Scalars['String']>;
  instagram_followers?: Maybe<Scalars['Int']>;
  instagram_following?: Maybe<Scalars['Int']>;
  is_company?: Maybe<Scalars['Boolean']>;
  is_lead?: Maybe<Scalars['Boolean']>;
  is_prospect?: Maybe<Scalars['Boolean']>;
  job_organization?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  last_appointment?: Maybe<QLVisit>;
  last_appointment_at?: Maybe<Scalars['Timestamp']>;
  last_attendance_at?: Maybe<Scalars['Timestamp']>;
  last_discussion?: Maybe<QLDiscussion>;
  last_event?: Maybe<QLVisit>;
  last_name?: Maybe<Scalars['String']>;
  last_visit?: Maybe<QLVisit>;
  last_visit_at?: Maybe<Scalars['Timestamp']>;
  lead_completed?: Maybe<Scalars['Boolean']>;
  lead_signed_up_id?: Maybe<Scalars['ID']>;
  liability_release?: Maybe<Scalars['Boolean']>;
  linkedin?: Maybe<Scalars['String']>;
  linkedin_bio?: Maybe<Scalars['String']>;
  linkedin_followers?: Maybe<Scalars['Int']>;
  linkedin_following?: Maybe<Scalars['Int']>;
  ltv?: Maybe<Scalars['Float']>;
  mbo_index_values?: Maybe<Array<Maybe<QLMboIndexValue>>>;
  mbo_member_status?: Maybe<QLMboMemberStatus>;
  mobile_phone?: Maybe<Scalars['String']>;
  mutes?: Maybe<Array<Maybe<QLTemporaryMute>>>;
  next_appointment?: Maybe<QLVisit>;
  next_event?: Maybe<QLVisit>;
  next_visit?: Maybe<QLVisit>;
  note_generic?: Maybe<Scalars['String']>;
  note_red?: Maybe<Scalars['String']>;
  note_yellow?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<QLClientNote>>>;
  phone_home?: Maybe<Scalars['String']>;
  phone_work?: Maybe<Scalars['String']>;
  phone_work_ext?: Maybe<Scalars['String']>;
  photos?: Maybe<Array<Maybe<QLMedia>>>;
  products?: Maybe<Array<Maybe<QLProduct>>>;
  promotional_email_opt_in?: Maybe<Scalars['Boolean']>;
  referred_by?: Maybe<Scalars['String']>;
  /** Information about who referred this client (stored in the refer_info field internally) */
  referrer?: Maybe<QLClientReferrer>;
  tags?: Maybe<Array<Maybe<QLTag>>>;
  /** The team */
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  total_appointments?: Maybe<Scalars['Int']>;
  total_club_counts?: Maybe<Scalars['Int']>;
  total_form_instances?: Maybe<Scalars['Int']>;
  total_notes?: Maybe<Scalars['Int']>;
  total_open_discussions?: Maybe<Scalars['Int']>;
  total_period_counts?: Maybe<Scalars['Int']>;
  total_sales?: Maybe<Scalars['Int']>;
  total_todos?: Maybe<Scalars['Int']>;
  total_visits?: Maybe<Scalars['Int']>;
  twitter?: Maybe<Scalars['String']>;
  twitter_bio?: Maybe<Scalars['String']>;
  twitter_followers?: Maybe<Scalars['Int']>;
  twitter_following?: Maybe<Scalars['Int']>;
  /** A date in timestamp format when the client unsubscribed from email communications */
  unsubscribed_email_at?: Maybe<Scalars['Timestamp']>;
  /** A date in timestamp format */
  unsubscribed_sms_at?: Maybe<Scalars['Timestamp']>;
  unsubscribed_sms_text?: Maybe<Scalars['Boolean']>;
  /** A date in timestamp format */
  updated_at?: Maybe<Scalars['Timestamp']>;
  username?: Maybe<Scalars['String']>;
  visits?: Maybe<Array<Maybe<QLVisit>>>;
};

export type QLClientClassType = {
  __typename?: 'ClientClassType';
  cc?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type QLClientEducation = {
  __typename?: 'ClientEducation';
  degree?: Maybe<Scalars['String']>;
  end_year?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type QLClientEngagementDetailStats = {
  __typename?: 'ClientEngagementDetailStats';
  bounced?: Maybe<Scalars['Int']>;
  clicked?: Maybe<Scalars['Int']>;
  delivered?: Maybe<Scalars['Int']>;
  opened?: Maybe<Scalars['Int']>;
  sent?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type QLClientEngagementStats = {
  __typename?: 'ClientEngagementStats';
  email?: Maybe<QLClientEngagementDetailStats>;
  sms?: Maybe<QLClientEngagementDetailStats>;
};

export type QLClientMuteHistoryPayload = {
  __typename?: 'ClientMuteHistoryPayload';
  message?: Maybe<Scalars['String']>;
  mutes: Array<QLTemporaryMute>;
  success: Scalars['Boolean'];
};

/** A client note */
export type QLClientNote = QLNote & {
  __typename?: 'ClientNote';
  /** A date in timestamp format */
  archived_at?: Maybe<Scalars['Timestamp']>;
  client?: Maybe<QLClient>;
  /** A date in timestamp format */
  created_at?: Maybe<Scalars['Timestamp']>;
  created_by?: Maybe<QLUser>;
  created_by_id?: Maybe<Scalars['ID']>;
  /** The ID of the client */
  id: Scalars['ID'];
  note: Scalars['String'];
  note_model_id?: Maybe<Scalars['ID']>;
  note_model_type?: Maybe<Scalars['String']>;
  /** The team */
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  /** A date in timestamp format */
  updated_at?: Maybe<Scalars['Timestamp']>;
};

/** A paginated list of ClientNote items. */
export type QLClientNotePaginator = {
  __typename?: 'ClientNotePaginator';
  /** A list of ClientNote items. */
  data: Array<QLClientNote>;
  /** Pagination information about the list of items. */
  paginatorInfo: QLPaginatorInfo;
};

/** A paginated list of Client items. */
export type QLClientPaginator = {
  __typename?: 'ClientPaginator';
  /** A list of Client items. */
  data: Array<QLClient>;
  /** Pagination information about the list of items. */
  paginatorInfo: QLPaginatorInfo;
};

export type QLClientProduct = {
  __typename?: 'ClientProduct';
  client?: Maybe<QLClient>;
  client_id?: Maybe<Scalars['ID']>;
  /** The ID of the package */
  id: Scalars['ID'];
  product?: Maybe<QLProduct>;
  product_id?: Maybe<Scalars['ID']>;
  sale?: Maybe<QLSale>;
  sale_id?: Maybe<Scalars['ID']>;
  /** A date in timestamp format */
  sold_at?: Maybe<Scalars['Timestamp']>;
};

/** A paginated list of ClientProduct items. */
export type QLClientProductPaginator = {
  __typename?: 'ClientProductPaginator';
  /** A list of ClientProduct items. */
  data: Array<QLClientProduct>;
  /** Pagination information about the list of items. */
  paginatorInfo: QLPaginatorInfo;
};

/** A person who referred a client */
export type QLClientReferrer = {
  __typename?: 'ClientReferrer';
  /** The referrer's email address for contact purposes */
  email?: Maybe<Scalars['String']>;
  /** The referrer's first name */
  first_name?: Maybe<Scalars['String']>;
  /** The referrer's last name */
  last_name?: Maybe<Scalars['String']>;
  /** The referrer's geographical location or area */
  location?: Maybe<Scalars['String']>;
  /** The referrer's phone number for contact purposes */
  phone?: Maybe<Scalars['String']>;
};

export type QLClientStartTime = {
  __typename?: 'ClientStartTime';
  cc?: Maybe<Scalars['Int']>;
  start_minutes: Scalars['Int'];
};

export type QLClientStats = {
  __typename?: 'ClientStats';
  engagements_stats?: Maybe<QLClientEngagementStats>;
  other?: Maybe<Scalars['Int']>;
  total_engagements?: Maybe<Scalars['Int']>;
  upcoming_events?: Maybe<Scalars['Int']>;
};

export type QLClientTagUploadResult = {
  __typename?: 'ClientTagUploadResult';
  clientsTagged?: Maybe<Scalars['Int']>;
  leadsCreated?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum QLClientVisitFilterEnum {
  ALL = 'ALL',
  PAST = 'PAST',
  UPCOMING = 'UPCOMING'
}

export type QLClientsUnsubscribedStats = {
  __typename?: 'ClientsUnsubscribedStats';
  emails: Scalars['Int'];
  emails_past: Scalars['Int'];
  sms: Scalars['Int'];
  sms_past: Scalars['Int'];
};

/** A contract */
export type QLContract = {
  __typename?: 'Contract';
  /** A date in timestamp format */
  agreement_date?: Maybe<Scalars['Timestamp']>;
  /** The client */
  client?: Maybe<QLClient>;
  client_id?: Maybe<Scalars['ID']>;
  /** A date in timestamp format */
  end_date?: Maybe<Scalars['Timestamp']>;
  external_id?: Maybe<Scalars['String']>;
  /** The ID of the location */
  id: Scalars['ID'];
  is_active?: Maybe<Scalars['Boolean']>;
  is_inactive?: Maybe<Scalars['Boolean']>;
  is_suspended?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  /** A date in timestamp format */
  start_date?: Maybe<Scalars['Timestamp']>;
  status?: Maybe<Scalars['String']>;
  /** The team */
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
};

export type QLContractName = {
  __typename?: 'ContractName';
  name?: Maybe<Scalars['String']>;
};

/** A paginated list of Contract items. */
export type QLContractPaginator = {
  __typename?: 'ContractPaginator';
  /** A list of Contract items. */
  data: Array<QLContract>;
  /** Pagination information about the list of items. */
  paginatorInfo: QLPaginatorInfo;
};

/** Contract status */
export enum QLContractStatus {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Inactive */
  INACTIVE = 'INACTIVE',
  /** Suspended */
  SUSPENDED = 'SUSPENDED'
}

export type QLCoupon = {
  __typename?: 'Coupon';
  amount_off?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['String']>;
  duration_in_months?: Maybe<Scalars['Int']>;
  percent_off?: Maybe<Scalars['Int']>;
};

export type QLCreateAutomationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  category_name?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  delivery_type?: InputMaybe<QLAutomationDeliveryTypeEnum>;
  description?: InputMaybe<Scalars['String']>;
  email_content?: InputMaybe<QLEmailTemplateContentInput>;
  name?: InputMaybe<Scalars['String']>;
  one_off?: InputMaybe<Scalars['Boolean']>;
  reply_to?: InputMaybe<Scalars['String']>;
  segment: QLAutomationSegmentInput;
  send_window_end_minutes?: InputMaybe<Scalars['Int']>;
  send_window_start_minutes?: InputMaybe<Scalars['Int']>;
  start_at?: InputMaybe<Scalars['Timestamp']>;
  subject?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tags_add?: InputMaybe<Scalars['Boolean']>;
  todo_assigned_to_id?: InputMaybe<Scalars['ID']>;
  todo_overdue_hours?: InputMaybe<Scalars['Int']>;
  todo_postponed_hours?: InputMaybe<Scalars['Int']>;
  todo_priority?: InputMaybe<QLTodoPriority>;
  todo_tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  todo_team_group_id?: InputMaybe<Scalars['ID']>;
};

export type QLCreateFormInput = {
  allow_leads: Scalars['Boolean'];
  category?: InputMaybe<Scalars['String']>;
  content: Array<InputMaybe<QLFormBlockInput>>;
  description?: InputMaybe<Scalars['String']>;
  email_cc?: InputMaybe<Scalars['String']>;
  is_legal: Scalars['Boolean'];
  mbo_update_client?: InputMaybe<Scalars['Boolean']>;
  mbo_upload_lead?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  send_to_mbo?: InputMaybe<Scalars['Boolean']>;
  thank_you_message?: InputMaybe<Scalars['String']>;
  thank_you_url?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type QLCreateTeamInput = {
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<QLProvidersEnum>;
  timezone?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type QLCurrentRole = {
  __typename?: 'CurrentRole';
  at_least?: Maybe<QLRoleAtLeast>;
  role?: Maybe<QLUserRoleEnum>;
};

export type QLCurrentlyMutedClientsPayload = {
  __typename?: 'CurrentlyMutedClientsPayload';
  message?: Maybe<Scalars['String']>;
  mutes: Array<QLTemporaryMute>;
  success: Scalars['Boolean'];
};

export type QLDiscussion = {
  __typename?: 'Discussion';
  automation?: Maybe<QLAutomation>;
  automation_id?: Maybe<Scalars['ID']>;
  bounced?: Maybe<Scalars['Boolean']>;
  clicked?: Maybe<Scalars['Boolean']>;
  /** The client */
  client?: Maybe<QLClient>;
  client_id?: Maybe<Scalars['ID']>;
  closed?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['Timestamp']>;
  delivered?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  last_contacted_at?: Maybe<Scalars['Timestamp']>;
  last_message?: Maybe<QLMessage>;
  messages?: Maybe<Array<Maybe<QLMessage>>>;
  opened?: Maybe<Scalars['Boolean']>;
  sent?: Maybe<Scalars['Boolean']>;
  sms?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
  /** The team */
  team?: Maybe<QLTeam>;
  team_has_responded?: Maybe<Scalars['Boolean']>;
  team_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['Timestamp']>;
};

/** A paginated list of Discussion items. */
export type QLDiscussionPaginator = {
  __typename?: 'DiscussionPaginator';
  /** A list of Discussion items. */
  data: Array<QLDiscussion>;
  /** Pagination information about the list of items. */
  paginatorInfo: QLPaginatorInfo;
};

export type QLEditFormInput = {
  allow_leads?: InputMaybe<Scalars['Boolean']>;
  archive_404?: InputMaybe<Scalars['Boolean']>;
  archive_text?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Array<InputMaybe<QLFormBlockInput>>>;
  description?: InputMaybe<Scalars['String']>;
  email_cc?: InputMaybe<Scalars['String']>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_legal?: InputMaybe<Scalars['Boolean']>;
  mbo_update_client?: InputMaybe<Scalars['Boolean']>;
  mbo_upload_lead?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  send_to_mbo?: InputMaybe<Scalars['Boolean']>;
  thank_you_message?: InputMaybe<Scalars['String']>;
  thank_you_url?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type QLEmailPreview = {
  __typename?: 'EmailPreview';
  html: Scalars['String'];
  subject: Scalars['String'];
};

export type QLEmailTemplate = {
  __typename?: 'EmailTemplate';
  automation?: Maybe<QLAutomation>;
  automation_id?: Maybe<Scalars['ID']>;
  brand_id?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['String']>;
  /** A date in timestamp format */
  created_at?: Maybe<Scalars['Timestamp']>;
  email?: Maybe<QLEmailTemplateContent>;
  /** The ID of the email template */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  /** The team */
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  thumbnail?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Timestamp']>;
};

export type QLEmailTemplateContent = {
  __typename?: 'EmailTemplateContent';
  html?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['JsonField']>;
};

export type QLEmailTemplateContentInput = {
  html?: InputMaybe<Scalars['String']>;
  json?: InputMaybe<Scalars['JsonField']>;
};

/** Input type for updating event insight segments */
export type QLEventInsightSegmentInput = {
  /** Whether the segment is archived */
  archived: Scalars['Boolean'];
  /** The ID of the segment to update */
  id: Scalars['ID'];
  /** The order position of the segment */
  order: Scalars['Int'];
  /** Whether the segment should be highlighted on the dashboard */
  visible_dashboard: Scalars['Boolean'];
};

export type QLExcludedEventName = {
  __typename?: 'ExcludedEventName';
  /** The ID of the excluded event */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
};

export type QLExportResult = {
  __typename?: 'ExportResult';
  status?: Maybe<Scalars['Boolean']>;
};

/** Field type enum */
export enum QLFieldTypeEnum {
  /** Date */
  DATE = 'DATE',
  /** Email */
  EMAIL = 'EMAIL',
  /** First name */
  FIRST_NAME = 'FIRST_NAME',
  /** Image */
  IMAGE = 'IMAGE',
  /** Last name */
  LAST_NAME = 'LAST_NAME',
  /** Multiple */
  MULTIPLE = 'MULTIPLE',
  /** Phone */
  PHONE = 'PHONE',
  /** Radio */
  RADIO = 'RADIO',
  /** Select */
  SELECT = 'SELECT',
  /** Signature */
  SIGNATURE = 'SIGNATURE',
  /** State */
  STATE = 'STATE',
  /** Text area */
  TEXT_AREA = 'TEXT_AREA',
  /** Text block */
  TEXT_BLOCK = 'TEXT_BLOCK',
  /** Text input */
  TEXT_INPUT = 'TEXT_INPUT',
  /** Yes no */
  YES_NO = 'YES_NO'
}

/** A filter */
export type QLFilter = {
  __typename?: 'Filter';
  field?: Maybe<Scalars['String']>;
  operator?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['JsonField']>;
  type?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
};

/** A group of filters */
export type QLFilterGroup = {
  __typename?: 'FilterGroup';
  filters?: Maybe<Array<Maybe<QLFilter>>>;
  operator_is_and?: Maybe<Scalars['Boolean']>;
  uid?: Maybe<Scalars['ID']>;
};

export type QLFilterGroupInput = {
  filters?: InputMaybe<Array<InputMaybe<QLFilterInput>>>;
  operator_is_and?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Scalars['ID']>;
};

export type QLFilterInput = {
  options?: InputMaybe<Scalars['JsonField']>;
  type?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['ID']>;
};

export type QLForgotPasswordInput = {
  email: Scalars['String'];
};

export type QLForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  message?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type QLForm = {
  __typename?: 'Form';
  allow_leads?: Maybe<Scalars['Boolean']>;
  archive_404?: Maybe<Scalars['Boolean']>;
  archive_text?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  cc?: Maybe<Scalars['Int']>;
  content?: Maybe<Array<Maybe<QLFormField>>>;
  created_at?: Maybe<Scalars['Timestamp']>;
  description?: Maybe<Scalars['String']>;
  editable?: Maybe<Scalars['Boolean']>;
  email_cc?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_archived?: Maybe<Scalars['Boolean']>;
  is_legal?: Maybe<Scalars['Boolean']>;
  mbo_update_client?: Maybe<Scalars['Boolean']>;
  mbo_upload_lead?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  send_to_mbo?: Maybe<Scalars['Boolean']>;
  short_url?: Maybe<Scalars['String']>;
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  thank_you_message?: Maybe<Scalars['String']>;
  thank_you_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Timestamp']>;
};

export type QLFormBlockInput = {
  content?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  kind?: InputMaybe<QLFieldTypeEnum>;
  mapping?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  prefill?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type QLFormCatalogCategoryName = {
  __typename?: 'FormCatalogCategoryName';
  name?: Maybe<Scalars['String']>;
};

export type QLFormCatalogItem = {
  __typename?: 'FormCatalogItem';
  brand?: Maybe<QLBrand>;
  brand_id?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  form_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  long_description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  provider?: Maybe<QLProvidersEnum>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type QLFormCategory = {
  __typename?: 'FormCategory';
  name?: Maybe<Scalars['String']>;
};

export type QLFormField = {
  __typename?: 'FormField';
  content?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  kind?: Maybe<QLFieldTypeEnum>;
  mapping?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  prefill?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type QLFormInstance = {
  __typename?: 'FormInstance';
  client?: Maybe<QLClient>;
  client_id?: Maybe<Scalars['ID']>;
  created_at?: Maybe<Scalars['Timestamp']>;
  form?: Maybe<QLForm>;
  form_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  ip_address?: Maybe<Scalars['String']>;
  pdf_url?: Maybe<Scalars['String']>;
  responses?: Maybe<Array<Maybe<QLFormInstanceResponse>>>;
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['Timestamp']>;
};

/** A paginated list of FormInstance items. */
export type QLFormInstancePaginator = {
  __typename?: 'FormInstancePaginator';
  /** A list of FormInstance items. */
  data: Array<QLFormInstance>;
  /** Pagination information about the list of items. */
  paginatorInfo: QLPaginatorInfo;
};

export type QLFormInstanceResponse = {
  __typename?: 'FormInstanceResponse';
  answer?: Maybe<Scalars['String']>;
  client?: Maybe<QLClient>;
  client_id?: Maybe<Scalars['ID']>;
  form?: Maybe<QLForm>;
  form_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  question: Scalars['String'];
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
};

export type QLFormStatInput = {
  ends_at?: InputMaybe<Scalars['Timestamp']>;
  id?: InputMaybe<Scalars['ID']>;
  starts_at?: InputMaybe<Scalars['Timestamp']>;
};

export type QLFormStatsCompletionTimes = {
  __typename?: 'FormStatsCompletionTimes';
  completed?: Maybe<Scalars['Int']>;
};

export type QLFormStatsFirstCompletion = {
  __typename?: 'FormStatsFirstCompletion';
  first?: Maybe<Scalars['Timestamp']>;
};

export type QLFormStatsHistoryItem = {
  __typename?: 'FormStatsHistoryItem';
  cc: Scalars['Int'];
  timestamp: Scalars['Timestamp'];
};

export type QLFormStatsSingleField = {
  __typename?: 'FormStatsSingleField';
  answer: Scalars['String'];
  cc: Scalars['Int'];
};

export type QLFormWithCount = {
  __typename?: 'FormWithCount';
  allow_leads?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['String']>;
  cc?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  is_archived?: Maybe<Scalars['Boolean']>;
  is_legal?: Maybe<Scalars['Boolean']>;
  last_completion_at?: Maybe<Scalars['Timestamp']>;
  name?: Maybe<Scalars['String']>;
};

export type QLInvitation = {
  __typename?: 'Invitation';
  created_at: Scalars['Timestamp'];
  email: Scalars['String'];
  id: Scalars['ID'];
  role: QLUserRoleEnum;
  team?: Maybe<QLTeam>;
  team_id: Scalars['ID'];
  token: Scalars['String'];
  updated_at: Scalars['Timestamp'];
};

export type QLInvoice = {
  __typename?: 'Invoice';
  date?: Maybe<Scalars['Timestamp']>;
  id?: Maybe<Scalars['ID']>;
  total?: Maybe<Scalars['Int']>;
};

export type QLLocation = {
  __typename?: 'Location';
  address_city?: Maybe<Scalars['String']>;
  address_line?: Maybe<Scalars['String']>;
  address_postal_code?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  business_description?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  /** The ID of the location */
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  /** The team */
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  timezone?: Maybe<Scalars['String']>;
};

export type QLLoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  remember?: InputMaybe<Scalars['Boolean']>;
};

export type QLMboIndex = {
  __typename?: 'MboIndex';
  external_id: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  team?: Maybe<QLTeam>;
  team_id: Scalars['ID'];
  values?: Maybe<Array<Maybe<QLMboIndexValue>>>;
};

export type QLMboIndexValue = {
  __typename?: 'MboIndexValue';
  external_id: Scalars['Int'];
  id: Scalars['ID'];
  mbo_index?: Maybe<QLMboIndex>;
  name: Scalars['String'];
  team?: Maybe<QLTeam>;
  team_id: Scalars['ID'];
};

/** Mbo member status */
export enum QLMboMemberStatus {
  /** Active */
  Active = 'Active',
  /** Declined */
  Declined = 'Declined',
  /** Expired */
  Expired = 'Expired',
  /** Non member */
  NonMember = 'NonMember',
  /** Other */
  Other = 'Other',
  /** Suspended */
  Suspended = 'Suspended',
  /** Terminated */
  Terminated = 'Terminated'
}

/** A media item */
export type QLMedia = {
  __typename?: 'Media';
  collection?: Maybe<Scalars['String']>;
  /** The ID of the media */
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type QLMessage = {
  __typename?: 'Message';
  automation?: Maybe<QLAutomation>;
  automation_id?: Maybe<Scalars['ID']>;
  bounced?: Maybe<Scalars['Boolean']>;
  clicked?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['Timestamp']>;
  delivered?: Maybe<Scalars['Boolean']>;
  /** The discussion that created the message */
  discussion?: Maybe<QLDiscussion>;
  discussion_id?: Maybe<Scalars['ID']>;
  error_code?: Maybe<QLMessageErrorType>;
  from_client?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  opened?: Maybe<Scalars['Boolean']>;
  sent?: Maybe<Scalars['Boolean']>;
  subject?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Timestamp']>;
  /** The user that created the message */
  user?: Maybe<QLUser>;
  user_id?: Maybe<Scalars['ID']>;
};

/** Type of error received from our SMS provider */
export enum QLMessageErrorType {
  /** BlockedByStop */
  BlockedByStop = 'BlockedByStop',
  /** DestinationPermanentlyUnavailable */
  DestinationPermanentlyUnavailable = 'DestinationPermanentlyUnavailable',
  /** DestinationTemporaryUnavailable */
  DestinationTemporaryUnavailable = 'DestinationTemporaryUnavailable',
  /** InvalidDestinationNumber */
  InvalidDestinationNumber = 'InvalidDestinationNumber',
  /** InvalidMessage */
  InvalidMessage = 'InvalidMessage',
  /** InvalidSourceNumber */
  InvalidSourceNumber = 'InvalidSourceNumber',
  /** LoopDetected */
  LoopDetected = 'LoopDetected',
  /** NetworkError */
  NetworkError = 'NetworkError',
  /** NoRoute */
  NoRoute = 'NoRoute',
  /** ProhibitedByCarrier */
  ProhibitedByCarrier = 'ProhibitedByCarrier',
  /** Spam */
  Spam = 'Spam',
  /** TooLong */
  TooLong = 'TooLong'
}

export type QLMindBodyApiPrepareResult = {
  __typename?: 'MindBodyApiPrepareResult';
  authorization_link: Scalars['String'];
};

export type QLMutation = {
  __typename?: 'Mutation';
  AddCatalogToAutomations?: Maybe<QLAutomation>;
  AddCatalogToForms?: Maybe<QLForm>;
  AnnouncementsUpdateRead?: Maybe<QLUser>;
  ArchiveForm?: Maybe<QLForm>;
  BatchTagClients?: Maybe<QLBatchTagResult>;
  BulkUpdateAutomations?: Maybe<Array<Maybe<QLAutomation>>>;
  BulkUpdateTodos?: Maybe<QLSimpleResponse>;
  ChangePassword: QLSimpleResponse;
  CloneAutomation?: Maybe<QLAutomation>;
  CopyAutomation?: Maybe<QLAutomation>;
  CopyEmailTemplate?: Maybe<QLEmailTemplate>;
  CopyForm?: Maybe<QLForm>;
  CopySegment?: Maybe<QLSegment>;
  CreateAutomation?: Maybe<QLAutomation>;
  CreateDiscussion?: Maybe<QLDiscussion>;
  CreateDiscussionEvent?: Maybe<QLDiscussion>;
  CreateEmailTemplate?: Maybe<QLEmailTemplate>;
  CreateExcludedEventName?: Maybe<QLExcludedEventName>;
  CreateForm?: Maybe<QLForm>;
  CreateNote?: Maybe<QLClientNote>;
  CreateProspect?: Maybe<QLClient>;
  CreateSegment?: Maybe<QLSegment>;
  CreateTeam?: Maybe<QLTeam>;
  CreateTodo?: Maybe<QLTodo>;
  CreateVirtualClassInfo?: Maybe<QLVirtualClassInfo>;
  CreateZapierToken?: Maybe<QLAccessToken>;
  DeleteCatalogItem?: Maybe<QLCatalogItem>;
  DeleteEmailTemplate?: Maybe<QLEmailTemplate>;
  DeleteExcludedEventName?: Maybe<QLExcludedEventName>;
  DeleteSegment?: Maybe<QLSegment>;
  DeleteVirtualClassInfo?: Maybe<QLVirtualClassInfo>;
  DeleteZapierToken?: Maybe<QLSimpleResponse>;
  DiscussionAddMessage?: Maybe<QLDiscussion>;
  DuplicateForm?: Maybe<QLForm>;
  EditForm?: Maybe<QLForm>;
  EditTodo?: Maybe<QLTodo>;
  EmailPreview?: Maybe<QLEmailPreview>;
  EmailPreviewSend?: Maybe<QLSimpleResponse>;
  ExportAutomation?: Maybe<QLExportResult>;
  ExportClients?: Maybe<QLExportResult>;
  ExportClientsUnsubscribed?: Maybe<QLExportResult>;
  ExportForm?: Maybe<QLExportResult>;
  FitDegreeApiSet?: Maybe<QLTeam>;
  LeaveTeam?: Maybe<QLUser>;
  MindBodyApiPrepare?: Maybe<QLMindBodyApiPrepareResult>;
  MindBodyApiSet?: Maybe<QLTeam>;
  NoteTemplateCreate?: Maybe<QLNoteTemplate>;
  NoteTemplateDelete?: Maybe<QLNoteTemplate>;
  NoteTemplateUpdate?: Maybe<QLNoteTemplate>;
  Pike13SetBusiness?: Maybe<QLTeam>;
  QuickResponseCreate?: Maybe<QLQuickResponse>;
  QuickResponseDelete?: Maybe<QLQuickResponse>;
  QuickResponseSaveOrder: Array<QLQuickResponse>;
  QuickResponseUpdate?: Maybe<QLQuickResponse>;
  ReadNotifications?: Maybe<Array<Maybe<QLNotification>>>;
  ReorderAutomation?: Maybe<QLAutomation>;
  ReorderAutomations?: Maybe<Array<Maybe<QLAutomation>>>;
  ReorderSegment?: Maybe<QLSegment>;
  ResetEventInsightSegmentOrders?: Maybe<Array<Maybe<QLSegment>>>;
  RoleChange?: Maybe<QLTeam>;
  SaveCatalogItem?: Maybe<QLCatalogItem>;
  SaveEventInsightSegments: Array<QLSegment>;
  SendAutomationManually?: Maybe<QLSimpleResponse>;
  SendEmailOptInReminder?: Maybe<QLClient>;
  SwitchTeam?: Maybe<QLTeam>;
  TodoAssign?: Maybe<QLTodo>;
  UpdateAutomation?: Maybe<QLAutomation>;
  UpdateAutomationFull?: Maybe<QLAutomation>;
  UpdateClass?: Maybe<QLClassModel>;
  UpdateClient?: Maybe<QLClient>;
  UpdateDiscussion?: Maybe<QLDiscussion>;
  UpdateEmailTemplate?: Maybe<QLEmailTemplate>;
  UpdateLead?: Maybe<QLClient>;
  UpdateNote?: Maybe<QLClientNote>;
  UpdateNotificationToken?: Maybe<QLNotificationToken>;
  UpdateSegment?: Maybe<QLSegment>;
  UpdateTeam?: Maybe<QLTeam>;
  UpdateTeamLogoImage?: Maybe<QLTeam>;
  UpdateTeamPeriodCountSettings?: Maybe<QLTeam>;
  UpdateTeamProfileImage?: Maybe<QLTeam>;
  UpdateTodo?: Maybe<QLTodo>;
  UpdateUser?: Maybe<QLUser>;
  UpdateUserProfileImage?: Maybe<QLUser>;
  UpdateUserTeamGroups?: Maybe<QLTeam>;
  UpdateVirtualClassInfo?: Maybe<QLVirtualClassInfo>;
  /** Archive a tag */
  archiveTag?: Maybe<QLTag>;
  cancelSubscription?: Maybe<QLTeamSubscription>;
  generatePaymentToken: QLStripeIntent;
  invitation_accept?: Maybe<QLTeam>;
  invitation_refuse?: Maybe<QLTeam>;
  invitation_reject?: Maybe<QLInvitation>;
  invite?: Maybe<QLInvitation>;
  login: QLUser;
  logout?: Maybe<QLUser>;
  muteClient: QLMuteClientPayload;
  resumeSubscription?: Maybe<QLTeamSubscription>;
  startAddon?: Maybe<QLTeamSubscription>;
  startSubscription?: Maybe<QLTeamSubscription>;
  stopAddon?: Maybe<QLTeamSubscription>;
  /** Unarchive a tag */
  unarchiveTag?: Maybe<QLTag>;
  unmuteClient: QLUnmuteClientPayload;
  updatePaymentMethod?: Maybe<QLTeam>;
};


export type QLMutationAddCatalogToAutomationsArgs = {
  catalog_data: QLCatalogItemToAutomationInput;
  catalog_id: Scalars['ID'];
};


export type QLMutationAddCatalogToFormsArgs = {
  catalog_id: Scalars['ID'];
  form_name: Scalars['String'];
};


export type QLMutationArchiveFormArgs = {
  archive: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type QLMutationBatchTagClientsArgs = {
  action: QLTagAction;
  clients: Array<QLBatchTagClientIdentifierInput>;
  tagNames: Array<Scalars['String']>;
};


export type QLMutationBulkUpdateAutomationsArgs = {
  action: QLAutomationBulkActionEnum;
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type QLMutationBulkUpdateTodosArgs = {
  action?: InputMaybe<Scalars['String']>;
  assigned_to_id?: InputMaybe<Scalars['ID']>;
  automation_id?: InputMaybe<Scalars['ID']>;
  closed?: InputMaybe<Scalars['Boolean']>;
  created_after?: InputMaybe<Scalars['String']>;
  created_before?: InputMaybe<Scalars['String']>;
  home_location_id?: InputMaybe<Scalars['ID']>;
  manual?: InputMaybe<Scalars['Boolean']>;
  open?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  overdue_after?: InputMaybe<Scalars['String']>;
  overdue_before?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  scheduled?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['ID']>;
  team_group_id?: InputMaybe<Scalars['ID']>;
};


export type QLMutationChangePasswordArgs = {
  input: QLChangePasswordInput;
};


export type QLMutationCloneAutomationArgs = {
  id: Scalars['ID'];
};


export type QLMutationCopyAutomationArgs = {
  destination_team_id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type QLMutationCopyEmailTemplateArgs = {
  destination_team_id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type QLMutationCopyFormArgs = {
  destination_team_id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type QLMutationCopySegmentArgs = {
  destination_team_id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type QLMutationCreateAutomationArgs = {
  automation: QLCreateAutomationInput;
};


export type QLMutationCreateDiscussionArgs = {
  client_id: Scalars['ID'];
  is_email: Scalars['Boolean'];
  message?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};


export type QLMutationCreateDiscussionEventArgs = {
  client_id: Scalars['ID'];
  is_email: Scalars['Boolean'];
  message?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};


export type QLMutationCreateEmailTemplateArgs = {
  email_content: QLEmailTemplateContentInput;
  name: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
};


export type QLMutationCreateExcludedEventNameArgs = {
  name: Scalars['String'];
};


export type QLMutationCreateFormArgs = {
  form: QLCreateFormInput;
};


export type QLMutationCreateNoteArgs = {
  client_id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
};


export type QLMutationCreateProspectArgs = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  mobile_phone?: InputMaybe<Scalars['String']>;
  referred_by?: InputMaybe<Scalars['String']>;
};


export type QLMutationCreateSegmentArgs = {
  data?: InputMaybe<QLSegmentInput>;
};


export type QLMutationCreateTeamArgs = {
  input: QLCreateTeamInput;
};


export type QLMutationCreateTodoArgs = {
  assigned_to_id?: InputMaybe<Scalars['ID']>;
  client_id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  overdue_at?: InputMaybe<Scalars['Int']>;
  postponed_to?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
  priority_type?: InputMaybe<QLTodoPriority>;
  subject?: InputMaybe<Scalars['String']>;
  team_group_id?: InputMaybe<Scalars['ID']>;
};


export type QLMutationCreateVirtualClassInfoArgs = {
  day_of_week?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  start_time?: InputMaybe<Scalars['Int']>;
  virtual_data?: InputMaybe<QLClassVirtualDataInput>;
  virtual_url: Scalars['String'];
};


export type QLMutationCreateZapierTokenArgs = {
  name: Scalars['String'];
};


export type QLMutationDeleteCatalogItemArgs = {
  id: Scalars['ID'];
};


export type QLMutationDeleteEmailTemplateArgs = {
  id: Scalars['ID'];
};


export type QLMutationDeleteExcludedEventNameArgs = {
  id: Scalars['ID'];
};


export type QLMutationDeleteSegmentArgs = {
  id: Scalars['ID'];
};


export type QLMutationDeleteVirtualClassInfoArgs = {
  id: Scalars['ID'];
};


export type QLMutationDeleteZapierTokenArgs = {
  id: Scalars['ID'];
};


export type QLMutationDiscussionAddMessageArgs = {
  id: Scalars['ID'];
  message: Scalars['String'];
};


export type QLMutationDuplicateFormArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type QLMutationEditFormArgs = {
  form: QLEditFormInput;
  id: Scalars['ID'];
};


export type QLMutationEditTodoArgs = {
  assigned_to_id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  overdue_at?: InputMaybe<Scalars['Int']>;
  postponed_to?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
  priority_type?: InputMaybe<QLTodoPriority>;
  subject?: InputMaybe<Scalars['String']>;
  team_group_id?: InputMaybe<Scalars['ID']>;
};


export type QLMutationEmailPreviewArgs = {
  body: Scalars['String'];
  client_id?: InputMaybe<Scalars['ID']>;
  subject: Scalars['String'];
};


export type QLMutationEmailPreviewSendArgs = {
  body: Scalars['String'];
  client_id?: InputMaybe<Scalars['ID']>;
  subject: Scalars['String'];
};


export type QLMutationExportAutomationArgs = {
  id: Scalars['ID'];
};


export type QLMutationExportClientsArgs = {
  segment: QLSegmentInput;
};


export type QLMutationExportClientsUnsubscribedArgs = {
  medium: QLUnsubscribeMediumEnum;
};


export type QLMutationExportFormArgs = {
  id: Scalars['ID'];
};


export type QLMutationFitDegreeApiSetArgs = {
  api_key: Scalars['String'];
};


export type QLMutationLeaveTeamArgs = {
  id: Scalars['ID'];
};


export type QLMutationMindBodyApiPrepareArgs = {
  site_id?: InputMaybe<Scalars['String']>;
};


export type QLMutationMindBodyApiSetArgs = {
  site_id: Scalars['String'];
};


export type QLMutationNoteTemplateCreateArgs = {
  body: Scalars['String'];
  title: Scalars['String'];
};


export type QLMutationNoteTemplateDeleteArgs = {
  id: Scalars['ID'];
};


export type QLMutationNoteTemplateUpdateArgs = {
  body: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};


export type QLMutationPike13SetBusinessArgs = {
  id: Scalars['String'];
  subdomain: Scalars['String'];
  timezone?: InputMaybe<Scalars['String']>;
};


export type QLMutationQuickResponseCreateArgs = {
  content: Scalars['String'];
  team_id: Scalars['ID'];
  title: Scalars['String'];
};


export type QLMutationQuickResponseDeleteArgs = {
  id: Scalars['ID'];
};


export type QLMutationQuickResponseSaveOrderArgs = {
  items: Array<QLQuickResponseOrderInput>;
};


export type QLMutationQuickResponseUpdateArgs = {
  content: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};


export type QLMutationReadNotificationsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QLMutationReorderAutomationArgs = {
  id: Scalars['ID'];
  order: Scalars['Int'];
};


export type QLMutationReorderAutomationsArgs = {
  order: Array<InputMaybe<QLAutomationReorderInput>>;
};


export type QLMutationReorderSegmentArgs = {
  archived: Scalars['Boolean'];
  id: Scalars['ID'];
  order: Scalars['Int'];
};


export type QLMutationResetEventInsightSegmentOrdersArgs = {
  first?: InputMaybe<Scalars['ID']>;
  second?: InputMaybe<Scalars['ID']>;
  third?: InputMaybe<Scalars['ID']>;
};


export type QLMutationRoleChangeArgs = {
  role?: InputMaybe<QLUserRoleEnum>;
  user_id: Scalars['ID'];
};


export type QLMutationSaveCatalogItemArgs = {
  catalogItem: QLCatalogItemInput;
  id?: InputMaybe<Scalars['ID']>;
};


export type QLMutationSaveEventInsightSegmentsArgs = {
  segments: Array<QLEventInsightSegmentInput>;
};


export type QLMutationSendAutomationManuallyArgs = {
  automation_id: Scalars['ID'];
  client_id: Scalars['ID'];
};


export type QLMutationSendEmailOptInReminderArgs = {
  id: Scalars['ID'];
};


export type QLMutationSwitchTeamArgs = {
  id: Scalars['ID'];
};


export type QLMutationTodoAssignArgs = {
  assigned_to_id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  team_group_id?: InputMaybe<Scalars['ID']>;
};


export type QLMutationUpdateAutomationArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assigned_tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['ID'];
};


export type QLMutationUpdateAutomationFullArgs = {
  automation: QLCreateAutomationInput;
  id: Scalars['ID'];
};


export type QLMutationUpdateClassArgs = {
  id: Scalars['ID'];
  is_virtual: Scalars['Boolean'];
  virtual_data?: InputMaybe<QLClassVirtualDataInput>;
  virtual_url?: InputMaybe<Scalars['String']>;
};


export type QLMutationUpdateClientArgs = {
  id: Scalars['ID'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unsubscribed_email_at?: InputMaybe<Scalars['Int']>;
  unsubscribed_sms_at?: InputMaybe<Scalars['Int']>;
};


export type QLMutationUpdateDiscussionArgs = {
  closed: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type QLMutationUpdateEmailTemplateArgs = {
  email_content: QLEmailTemplateContentInput;
  id: Scalars['ID'];
  name: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
};


export type QLMutationUpdateLeadArgs = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  frozen?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  last_name?: InputMaybe<Scalars['String']>;
  mobile_phone?: InputMaybe<Scalars['String']>;
  referred_by?: InputMaybe<Scalars['String']>;
};


export type QLMutationUpdateNoteArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
};


export type QLMutationUpdateNotificationTokenArgs = {
  device?: InputMaybe<Scalars['String']>;
  serial?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


export type QLMutationUpdateSegmentArgs = {
  data?: InputMaybe<QLSegmentInput>;
  id: Scalars['ID'];
};


export type QLMutationUpdateTeamArgs = {
  input: QLUpdateTeamInput;
};


export type QLMutationUpdateTeamLogoImageArgs = {
  photo: Scalars['Upload'];
};


export type QLMutationUpdateTeamPeriodCountSettingsArgs = {
  period_count_data: QLPeriodDataInput;
  period_count_type: QLPeriodCountType;
};


export type QLMutationUpdateTeamProfileImageArgs = {
  photo: Scalars['Upload'];
};


export type QLMutationUpdateTodoArgs = {
  completed_action_note?: InputMaybe<Scalars['String']>;
  completed_action_type?: InputMaybe<QLTodoCompletionTypeEnum>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QLMutationUpdateUserArgs = {
  input: QLUpdateUserInput;
};


export type QLMutationUpdateUserProfileImageArgs = {
  photo: Scalars['Upload'];
};


export type QLMutationUpdateUserTeamGroupsArgs = {
  groups: Array<InputMaybe<Scalars['String']>>;
  id: Scalars['ID'];
};


export type QLMutationUpdateVirtualClassInfoArgs = {
  day_of_week?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['Int']>;
  virtual_data?: InputMaybe<QLClassVirtualDataInput>;
  virtual_url?: InputMaybe<Scalars['String']>;
};


export type QLMutationArchiveTagArgs = {
  id: Scalars['ID'];
};


export type QLMutationInvitationAcceptArgs = {
  token: Scalars['String'];
};


export type QLMutationInvitationRefuseArgs = {
  token: Scalars['String'];
};


export type QLMutationInvitationRejectArgs = {
  id: Scalars['ID'];
};


export type QLMutationInviteArgs = {
  email: Scalars['String'];
  role: QLUserRoleEnum;
  team_id: Scalars['ID'];
};


export type QLMutationLoginArgs = {
  input?: InputMaybe<QLLoginInput>;
};


export type QLMutationMuteClientArgs = {
  client_id: Scalars['ID'];
  muted_until: Scalars['Timestamp'];
};


export type QLMutationStartAddonArgs = {
  addon: Scalars['String'];
};


export type QLMutationStartSubscriptionArgs = {
  coupon?: InputMaybe<Scalars['String']>;
  payment_method?: InputMaybe<Scalars['String']>;
  plan: Scalars['String'];
};


export type QLMutationStopAddonArgs = {
  addon: Scalars['String'];
};


export type QLMutationUnarchiveTagArgs = {
  id: Scalars['ID'];
};


export type QLMutationUnmuteClientArgs = {
  client_id: Scalars['ID'];
};


export type QLMutationUpdatePaymentMethodArgs = {
  payment_method: Scalars['String'];
};

export type QLMuteClientPayload = {
  __typename?: 'MuteClientPayload';
  message?: Maybe<Scalars['String']>;
  mute?: Maybe<QLTemporaryMute>;
  success: Scalars['Boolean'];
};

export type QLNewPasswordWithCodeInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  password_confirmation: Scalars['String'];
  token: Scalars['String'];
};

export type QLNote = {
  /** A date in timestamp format */
  archived_at?: Maybe<Scalars['Timestamp']>;
  /** A date in timestamp format */
  created_at?: Maybe<Scalars['Timestamp']>;
  created_by?: Maybe<QLUser>;
  created_by_id?: Maybe<Scalars['ID']>;
  /** The ID of the client */
  id: Scalars['ID'];
  note: Scalars['String'];
  note_model_id?: Maybe<Scalars['ID']>;
  note_model_type?: Maybe<Scalars['String']>;
  /** The team */
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  /** A date in timestamp format */
  updated_at?: Maybe<Scalars['Timestamp']>;
};

export type QLNoteTemplate = {
  __typename?: 'NoteTemplate';
  body: Scalars['String'];
  createdBy?: Maybe<QLUser>;
  created_at?: Maybe<Scalars['Timestamp']>;
  created_by?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['Timestamp']>;
};

/** A paginated list of NoteTemplate items. */
export type QLNoteTemplatePaginator = {
  __typename?: 'NoteTemplatePaginator';
  /** A list of NoteTemplate items. */
  data: Array<QLNoteTemplate>;
  /** Pagination information about the list of items. */
  paginatorInfo: QLPaginatorInfo;
};

export type QLNotification = {
  __typename?: 'Notification';
  action_text?: Maybe<Scalars['String']>;
  action_url?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  created_at?: Maybe<Scalars['Timestamp']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  read: Scalars['Boolean'];
  team?: Maybe<QLTeam>;
  user: QLUser;
};

export type QLNotificationToken = {
  __typename?: 'NotificationToken';
  device?: Maybe<Scalars['String']>;
  serial?: Maybe<Scalars['String']>;
  token: Scalars['String'];
};

/** Operator type enum */
export enum QLOperatorTypeEnum {
  /** Appointment package used ql operator */
  AppointmentPackageUsedQlOperator = 'AppointmentPackageUsedQlOperator',
  /** Class name ql operator */
  ClassNameQlOperator = 'ClassNameQlOperator',
  /** Client tag operator */
  ClientTagOperator = 'ClientTagOperator',
  /** Communication received ql operator */
  CommunicationReceivedQlOperator = 'CommunicationReceivedQlOperator',
  /** Contract name ql operator */
  ContractNameQlOperator = 'ContractNameQlOperator',
  /** Day of week operator */
  DayOfWeekOperator = 'DayOfWeekOperator',
  /** Event name ql operator */
  EventNameQlOperator = 'EventNameQlOperator',
  /** Exact date operator */
  ExactDateOperator = 'ExactDateOperator',
  /** Exact time operator */
  ExactTimeOperator = 'ExactTimeOperator',
  /** Fixed value operator */
  FixedValueOperator = 'FixedValueOperator',
  /** Location operator */
  LocationOperator = 'LocationOperator',
  /** Multiple choice operator */
  MultipleChoiceOperator = 'MultipleChoiceOperator',
  /** Multiple text operator */
  MultipleTextOperator = 'MultipleTextOperator',
  /** Numeric operator */
  NumericOperator = 'NumericOperator',
  /** Package name ql operator */
  PackageNameQlOperator = 'PackageNameQlOperator',
  /** Product type ql operator */
  ProductTypeQlOperator = 'ProductTypeQlOperator',
  /** Staff name ql operator */
  StaffNameQlOperator = 'StaffNameQlOperator',
  /** Text operator */
  TextOperator = 'TextOperator'
}

/** Allows ordering a list of records. */
export type QLOrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String'];
  /** The direction that is used for ordering. */
  order: QLSortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum QLOrderByRelationAggregateFunction {
  /** Amount of items. */
  COUNT = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum QLOrderByRelationWithColumnAggregateFunction {
  /** Average. */
  AVG = 'AVG',
  /** Amount of items. */
  COUNT = 'COUNT',
  /** Maximum. */
  MAX = 'MAX',
  /** Minimum. */
  MIN = 'MIN',
  /** Sum. */
  SUM = 'SUM'
}

/** A package */
export type QLPackage = {
  __typename?: 'Package';
  active?: Maybe<Scalars['Boolean']>;
  /** A date in timestamp format */
  active_at?: Maybe<Scalars['Timestamp']>;
  cancelled?: Maybe<Scalars['Boolean']>;
  client?: Maybe<QLClient>;
  client_id?: Maybe<Scalars['ID']>;
  /** A date in timestamp format */
  contract_expires_at?: Maybe<Scalars['Timestamp']>;
  /** A date in timestamp format */
  created_at?: Maybe<Scalars['Timestamp']>;
  current?: Maybe<Scalars['Boolean']>;
  days_difference?: Maybe<Scalars['Int']>;
  /** A date in timestamp format */
  expires_at?: Maybe<Scalars['Timestamp']>;
  external_id?: Maybe<Scalars['String']>;
  has_rolling_activation?: Maybe<Scalars['Boolean']>;
  /** The ID of the package */
  id: Scalars['ID'];
  is_rolling_active?: Maybe<Scalars['Boolean']>;
  last_used_at?: Maybe<Scalars['Timestamp']>;
  name?: Maybe<Scalars['String']>;
  /** A date in timestamp format */
  original_active_at?: Maybe<Scalars['Timestamp']>;
  /** A date in timestamp format */
  payment_at?: Maybe<Scalars['Timestamp']>;
  qta?: Maybe<Scalars['Int']>;
  remaining?: Maybe<Scalars['Int']>;
  /** The team */
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  /** A date in timestamp format */
  updated_at?: Maybe<Scalars['Timestamp']>;
};

export type QLPackageName = {
  __typename?: 'PackageName';
  name?: Maybe<Scalars['String']>;
};

/** A paginated list of Package items. */
export type QLPackagePaginator = {
  __typename?: 'PackagePaginator';
  /** A list of Package items. */
  data: Array<QLPackage>;
  /** Pagination information about the list of items. */
  paginatorInfo: QLPaginatorInfo;
};

/** Package status */
export enum QLPackageStatus {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Inactive */
  INACTIVE = 'INACTIVE',
  /** Used */
  USED = 'USED'
}

/** Information about pagination using a fully featured paginator. */
export type QLPaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** Number of items per page. */
  perPage: Scalars['Int'];
  /** Number of total available items. */
  total: Scalars['Int'];
};

/** Period count type */
export enum QLPeriodCountType {
  /** All time */
  ALL_TIME = 'ALL_TIME',
  /** Api */
  API = 'API',
  /** Day of year */
  DAY_OF_YEAR = 'DAY_OF_YEAR'
}

export type QLPeriodData = {
  __typename?: 'PeriodData';
  period: QLPeriodCountType;
  value: Scalars['Int'];
};

export type QLPeriodDataInput = {
  period: QLPeriodCountType;
  value: Scalars['Int'];
};

export type QLPike13AuthLink = {
  __typename?: 'Pike13AuthLink';
  link: Scalars['String'];
};

export type QLPike13Business = {
  __typename?: 'Pike13Business';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type QLPlaceholder = {
  __typename?: 'Placeholder';
  group?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  subgroup?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type QLPlan = {
  __typename?: 'Plan';
  active: Scalars['Boolean'];
  addon?: Maybe<Scalars['Boolean']>;
  addon_type?: Maybe<Scalars['String']>;
  attributes?: Maybe<QLPlanAttributes>;
  features?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['String'];
  interval?: Maybe<QLPlanInterval>;
  name: Scalars['String'];
  price: Scalars['Int'];
  trial_days?: Maybe<Scalars['Int']>;
};

export type QLPlanAttributes = {
  __typename?: 'PlanAttributes';
  contract?: Maybe<Scalars['Boolean']>;
  special?: Maybe<Scalars['Boolean']>;
};

/** Plan interval */
export enum QLPlanInterval {
  /** Monthly */
  MONTHLY = 'MONTHLY',
  /** Yearly */
  YEARLY = 'YEARLY'
}

/** A product */
export type QLProduct = {
  __typename?: 'Product';
  /** The ID of the product */
  id: Scalars['ID'];
  /** Product name */
  name: Scalars['String'];
  /** The team */
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
};

export type QLProductName = {
  __typename?: 'ProductName';
  name?: Maybe<Scalars['String']>;
};

/** A paginated list of Product items. */
export type QLProductPaginator = {
  __typename?: 'ProductPaginator';
  /** A list of Product items. */
  data: Array<QLProduct>;
  /** Pagination information about the list of items. */
  paginatorInfo: QLPaginatorInfo;
};

/** Providers enum */
export enum QLProvidersEnum {
  /** Club ready */
  ClubReady = 'ClubReady',
  /** Fit degree */
  FitDegree = 'FitDegree',
  /** Mariana tek */
  MarianaTek = 'MarianaTek',
  /** Mind body */
  MindBody = 'MindBody',
  /** Pike13 */
  Pike13 = 'Pike13'
}

export type QLQuery = {
  __typename?: 'Query';
  Pike13AuthUrl?: Maybe<QLPike13AuthLink>;
  Pike13GetBusinesses?: Maybe<Array<Maybe<QLPike13Business>>>;
  addons?: Maybe<Array<Maybe<QLPlan>>>;
  announcements?: Maybe<Array<Maybe<QLAnnouncement>>>;
  appointment_names?: Maybe<Array<Maybe<QLAppointmentName>>>;
  automation?: Maybe<QLAutomation>;
  automation_actions: QLAutomationActionPaginator;
  automation_categories: Array<QLAutomationCategory>;
  automation_stat_email_or_sms?: Maybe<QLAutomationStatsEmailOrSms>;
  automation_stat_tag?: Maybe<QLAutomationStatsTag>;
  automation_stat_todo?: Maybe<QLAutomationStatsTodo>;
  automations: Array<QLAutomation>;
  automations_stats?: Maybe<Array<Maybe<QLAutomationStats>>>;
  brands?: Maybe<Array<Maybe<QLBrand>>>;
  catalog_categories?: Maybe<Array<Maybe<QLCatalogCategoryName>>>;
  catalog_item?: Maybe<QLCatalogItem>;
  catalog_items: Array<QLCatalogItem>;
  class_names?: Maybe<Array<Maybe<QLClassName>>>;
  classes: Array<QLClassModel>;
  client?: Maybe<QLClient>;
  clientMuteHistory: QLClientMuteHistoryPayload;
  client_appointment_staff_names?: Maybe<Array<Maybe<QLClientClassType>>>;
  client_appointment_times?: Maybe<Array<Maybe<QLClientStartTime>>>;
  client_class_times?: Maybe<Array<Maybe<QLClientStartTime>>>;
  client_class_types?: Maybe<Array<Maybe<QLClientClassType>>>;
  client_products: QLClientProductPaginator;
  client_stats?: Maybe<QLClientStats>;
  client_visits: QLVisitPaginator;
  clients: QLClientPaginator;
  clients_list: QLClientPaginator;
  clients_search: QLClientPaginator;
  clients_today?: Maybe<QLSimpleDataBoxValue>;
  clients_today_first?: Maybe<QLSimpleDataBoxValue>;
  clients_unsubscribed: QLClientPaginator;
  clients_unsubscribed_stats?: Maybe<QLClientsUnsubscribedStats>;
  contract?: Maybe<QLContract>;
  contract_names?: Maybe<Array<Maybe<QLContractName>>>;
  contracts: QLContractPaginator;
  current_team?: Maybe<QLTeam>;
  currentlyMutedClients: QLCurrentlyMutedClientsPayload;
  discussion?: Maybe<QLDiscussion>;
  discussions: QLDiscussionPaginator;
  email_template?: Maybe<QLEmailTemplate>;
  email_templates: Array<QLEmailTemplate>;
  event_calculate_segment: QLClientPaginator;
  event_names?: Maybe<Array<Maybe<QLClassName>>>;
  excluded_event_names: Array<QLExcludedEventName>;
  form?: Maybe<QLForm>;
  form_catalog_categories?: Maybe<Array<Maybe<QLFormCatalogCategoryName>>>;
  form_catalog_item?: Maybe<QLFormCatalogItem>;
  form_catalog_items: Array<QLFormCatalogItem>;
  form_categories: Array<QLFormCategory>;
  form_instance?: Maybe<QLFormInstance>;
  form_instances: QLFormInstancePaginator;
  form_instances_recap?: Maybe<Array<Maybe<QLFormWithCount>>>;
  form_stat_completion_times?: Maybe<QLFormStatsCompletionTimes>;
  form_stat_field?: Maybe<Array<Maybe<QLFormStatsSingleField>>>;
  form_stat_first_completion?: Maybe<QLFormStatsFirstCompletion>;
  form_stat_history?: Maybe<Array<Maybe<QLFormStatsHistoryItem>>>;
  forms: Array<QLForm>;
  invitations_pending?: Maybe<Array<Maybe<QLInvitation>>>;
  invoices?: Maybe<Array<Maybe<QLInvoice>>>;
  mbo_indexes?: Maybe<Array<Maybe<QLMboIndex>>>;
  me?: Maybe<QLUser>;
  message?: Maybe<QLMessage>;
  messages?: Maybe<Array<Maybe<QLMessage>>>;
  my_subscription?: Maybe<QLTeamSubscription>;
  my_todos: QLTodoPaginator;
  next_class?: Maybe<QLClassModel>;
  note?: Maybe<QLClientNote>;
  noteTemplate?: Maybe<QLNoteTemplate>;
  noteTemplates: QLNoteTemplatePaginator;
  notes: QLClientNotePaginator;
  notifications?: Maybe<Array<Maybe<QLNotification>>>;
  package?: Maybe<QLPackage>;
  package_names?: Maybe<Array<Maybe<QLPackageName>>>;
  packages: QLPackagePaginator;
  placeholders?: Maybe<Array<Maybe<QLPlaceholder>>>;
  plans?: Maybe<Array<Maybe<QLPlan>>>;
  product?: Maybe<QLProduct>;
  product_names?: Maybe<Array<Maybe<QLProductName>>>;
  products: QLProductPaginator;
  quick_responses?: Maybe<Array<Maybe<QLQuickResponse>>>;
  sale?: Maybe<QLSale>;
  sales: QLSalePaginator;
  segment?: Maybe<QLSegment>;
  segments: Array<QLSegment>;
  single_class?: Maybe<QLClassModel>;
  single_invitation?: Maybe<QLInvitation>;
  staff?: Maybe<QLStaff>;
  staffs: Array<QLStaff>;
  status: QLStatus;
  tags?: Maybe<Array<Maybe<QLTag>>>;
  team?: Maybe<QLTeam>;
  team_pending_invitations?: Maybe<Array<Maybe<QLInvitation>>>;
  teams?: Maybe<Array<Maybe<QLTeam>>>;
  todo?: Maybe<QLTodo>;
  todos: QLTodoPaginator;
  virtual_class?: Maybe<QLVirtualClassInfo>;
  virtual_classes_info: Array<QLVirtualClassInfo>;
  zapier_tokens?: Maybe<Array<Maybe<QLAccessToken>>>;
};


export type QLQueryAutomationArgs = {
  id: Scalars['ID'];
};


export type QLQueryAutomationActionsArgs = {
  first: Scalars['Int'];
  id: Scalars['ID'];
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QLQueryAutomationStatEmailOrSmsArgs = {
  input: QLAutomationStatInput;
};


export type QLQueryAutomationStatTagArgs = {
  input: QLAutomationStatInput;
};


export type QLQueryAutomationStatTodoArgs = {
  input: QLAutomationStatInput;
};


export type QLQueryAutomationsArgs = {
  disabled?: InputMaybe<Scalars['Boolean']>;
};


export type QLQueryAutomationsStatsArgs = {
  days_back: Scalars['Int'];
};


export type QLQueryCatalogItemArgs = {
  id: Scalars['ID'];
};


export type QLQueryClassesArgs = {
  after?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Int']>;
  location_id?: InputMaybe<Scalars['ID']>;
};


export type QLQueryClientArgs = {
  id: Scalars['ID'];
};


export type QLQueryClientMuteHistoryArgs = {
  client_id: Scalars['ID'];
};


export type QLQueryClientAppointmentStaffNamesArgs = {
  id: Scalars['ID'];
};


export type QLQueryClientAppointmentTimesArgs = {
  id: Scalars['ID'];
};


export type QLQueryClientClassTimesArgs = {
  id: Scalars['ID'];
};


export type QLQueryClientClassTypesArgs = {
  id: Scalars['ID'];
};


export type QLQueryClientProductsArgs = {
  client_id: Scalars['ID'];
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QLQueryClientStatsArgs = {
  id: Scalars['ID'];
};


export type QLQueryClientVisitsArgs = {
  client_id: Scalars['ID'];
  filter: QLClientVisitFilterEnum;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<QLClassType>;
};


export type QLQueryClientsArgs = {
  first: Scalars['Int'];
  home_location_id?: InputMaybe<Scalars['ID']>;
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QLQueryClientsListArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
  segment: QLSegmentInput;
};


export type QLQueryClientsSearchArgs = {
  first: Scalars['Int'];
  onlyContactableViaEmail?: InputMaybe<Scalars['Boolean']>;
  onlyContactableViaSms?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
};


export type QLQueryClientsTodayArgs = {
  location_id: Scalars['ID'];
};


export type QLQueryClientsTodayFirstArgs = {
  location_id: Scalars['ID'];
};


export type QLQueryClientsUnsubscribedArgs = {
  first: Scalars['Int'];
  medium: QLUnsubscribeMediumEnum;
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QLQueryClientsUnsubscribedStatsArgs = {
  days: Scalars['Int'];
};


export type QLQueryContractArgs = {
  id: Scalars['ID'];
};


export type QLQueryContractsArgs = {
  client_id?: InputMaybe<Scalars['ID']>;
  expiring_days?: InputMaybe<Scalars['Int']>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<QLContractStatus>;
};


export type QLQueryDiscussionArgs = {
  id: Scalars['ID'];
};


export type QLQueryDiscussionsArgs = {
  automation_id?: InputMaybe<Scalars['ID']>;
  bounced?: InputMaybe<Scalars['Boolean']>;
  clicked?: InputMaybe<Scalars['Boolean']>;
  client_id?: InputMaybe<Scalars['ID']>;
  closed?: InputMaybe<Scalars['Boolean']>;
  delivered?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  home_location_id?: InputMaybe<Scalars['ID']>;
  last_contacted_at_from?: InputMaybe<Scalars['Timestamp']>;
  last_contacted_at_to?: InputMaybe<Scalars['Timestamp']>;
  only_automations?: InputMaybe<Scalars['Boolean']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
  sms?: InputMaybe<Scalars['Boolean']>;
  team_has_responded?: InputMaybe<Scalars['Boolean']>;
};


export type QLQueryEmailTemplateArgs = {
  id: Scalars['ID'];
};


export type QLQueryEventCalculateSegmentArgs = {
  class_model_id: Scalars['ID'];
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
  segment: QLSegmentInput;
};


export type QLQueryFormArgs = {
  id: Scalars['ID'];
};


export type QLQueryFormCatalogItemArgs = {
  id: Scalars['ID'];
};


export type QLQueryFormInstanceArgs = {
  id: Scalars['ID'];
};


export type QLQueryFormInstancesArgs = {
  client_id?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  form_id?: InputMaybe<Scalars['ID']>;
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QLQueryFormInstancesRecapArgs = {
  client_id: Scalars['ID'];
};


export type QLQueryFormStatCompletionTimesArgs = {
  input: QLFormStatInput;
};


export type QLQueryFormStatFieldArgs = {
  input: QLFormStatInput;
  question_id: Scalars['ID'];
};


export type QLQueryFormStatFirstCompletionArgs = {
  input: QLFormStatInput;
};


export type QLQueryFormStatHistoryArgs = {
  input: QLFormStatInput;
};


export type QLQueryMessageArgs = {
  id: Scalars['ID'];
};


export type QLQueryMessagesArgs = {
  discussion_id: Scalars['ID'];
};


export type QLQueryMyTodosArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QLQueryNextClassArgs = {
  location_id?: InputMaybe<Scalars['ID']>;
};


export type QLQueryNoteArgs = {
  id: Scalars['ID'];
};


export type QLQueryNoteTemplateArgs = {
  id: Scalars['ID'];
};


export type QLQueryNoteTemplatesArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QLQueryNotesArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  client_id?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QLQueryPackageArgs = {
  id: Scalars['ID'];
};


export type QLQueryPackagesArgs = {
  client_id?: InputMaybe<Scalars['ID']>;
  expiring_days?: InputMaybe<Scalars['Int']>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<QLPackageStatus>;
};


export type QLQueryProductArgs = {
  id: Scalars['ID'];
};


export type QLQueryProductsArgs = {
  first?: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QLQuerySaleArgs = {
  id: Scalars['ID'];
};


export type QLQuerySalesArgs = {
  client_id?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QLQuerySegmentArgs = {
  id: Scalars['ID'];
};


export type QLQuerySegmentsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  is_communication?: InputMaybe<Scalars['Boolean']>;
  is_event?: InputMaybe<Scalars['Boolean']>;
  only_deliverable_by_email?: InputMaybe<Scalars['Boolean']>;
  only_deliverable_by_sms?: InputMaybe<Scalars['Boolean']>;
  visible_dashboard?: InputMaybe<Scalars['Boolean']>;
};


export type QLQuerySingleClassArgs = {
  id: Scalars['ID'];
};


export type QLQuerySingleInvitationArgs = {
  token: Scalars['String'];
};


export type QLQueryStaffArgs = {
  id: Scalars['ID'];
};


export type QLQueryTagsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};


export type QLQueryTeamArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QLQueryTeamPendingInvitationsArgs = {
  team_id: Scalars['ID'];
};


export type QLQueryTodoArgs = {
  id: Scalars['ID'];
};


export type QLQueryTodosArgs = {
  assigned_to_id?: InputMaybe<Scalars['ID']>;
  automation_id?: InputMaybe<Scalars['ID']>;
  client_id?: InputMaybe<Scalars['ID']>;
  closed?: InputMaybe<Scalars['Boolean']>;
  created_after?: InputMaybe<Scalars['String']>;
  created_before?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  home_location_id?: InputMaybe<Scalars['ID']>;
  manual?: InputMaybe<Scalars['Boolean']>;
  open?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Array<QLOrderByClause>>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  overdue_after?: InputMaybe<Scalars['String']>;
  overdue_before?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
  scheduled?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['ID']>;
  team_group_id?: InputMaybe<Scalars['ID']>;
};


export type QLQueryVirtualClassArgs = {
  id: Scalars['ID'];
};

export type QLQuickResponse = {
  __typename?: 'QuickResponse';
  content: Scalars['String'];
  created_at?: Maybe<Scalars['Timestamp']>;
  id: Scalars['ID'];
  order: Scalars['Int'];
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['Timestamp']>;
};

export type QLQuickResponseOrderInput = {
  order: Scalars['Int'];
  quick_response_id: Scalars['ID'];
};

export type QLRoleAtLeast = {
  __typename?: 'RoleAtLeast';
  admin?: Maybe<Scalars['Boolean']>;
  manager?: Maybe<Scalars['Boolean']>;
  member?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<Scalars['Boolean']>;
};

/** A sale */
export type QLSale = {
  __typename?: 'Sale';
  client?: Maybe<QLClient>;
  client_id?: Maybe<Scalars['ID']>;
  /** The ID of the product */
  id: Scalars['ID'];
  /** Product name */
  price?: Maybe<Scalars['Float']>;
  /** A date in timestamp format */
  sold_at?: Maybe<Scalars['Timestamp']>;
  /** The team */
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
};

/** A paginated list of Sale items. */
export type QLSalePaginator = {
  __typename?: 'SalePaginator';
  /** A list of Sale items. */
  data: Array<QLSale>;
  /** Pagination information about the list of items. */
  paginatorInfo: QLPaginatorInfo;
};

export type QLSegment = {
  __typename?: 'Segment';
  archived?: Maybe<Scalars['Boolean']>;
  filters?: Maybe<Array<Maybe<QLFilterGroup>>>;
  /** The ID of the segment */
  id: Scalars['ID'];
  is_communication?: Maybe<Scalars['Boolean']>;
  is_event?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  only_deliverable_by_email?: Maybe<Scalars['Boolean']>;
  only_deliverable_by_sms?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  /** The team */
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  visible_dashboard?: Maybe<Scalars['Boolean']>;
};

/** A segment to send as input */
export type QLSegmentInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  filter_groups?: InputMaybe<Array<InputMaybe<QLFilterGroupInput>>>;
  /** The ID of the segment */
  id?: InputMaybe<Scalars['ID']>;
  is_communication?: InputMaybe<Scalars['Boolean']>;
  is_event?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  only_deliverable_by_email?: InputMaybe<Scalars['Boolean']>;
  only_deliverable_by_sms?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  visible_dashboard?: InputMaybe<Scalars['Boolean']>;
};

export type QLSimpleDataBoxValue = {
  __typename?: 'SimpleDataBoxValue';
  value?: Maybe<Scalars['Float']>;
};

export type QLSimpleResponse = {
  __typename?: 'SimpleResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type QLSimpleStatNumber = {
  __typename?: 'SimpleStatNumber';
  result?: Maybe<Scalars['Int']>;
};

export type QLSmsBundle = {
  __typename?: 'SmsBundle';
  created_at?: Maybe<Scalars['Timestamp']>;
  expired?: Maybe<Scalars['Boolean']>;
  expired_at?: Maybe<Scalars['Timestamp']>;
  id: Scalars['ID'];
  is_purchased?: Maybe<Scalars['Boolean']>;
  starts_at?: Maybe<Scalars['Timestamp']>;
  units?: Maybe<Scalars['Int']>;
  units_left?: Maybe<Scalars['Int']>;
};

/** Directions for ordering a list of records. */
export enum QLSortOrder {
  /** Sort records in ascending order. */
  ASC = 'ASC',
  /** Sort records in descending order. */
  DESC = 'DESC'
}

export type QLStaff = {
  __typename?: 'Staff';
  /** @deprecated Field removed */
  bio?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  /** The ID of the staff */
  id: Scalars['ID'];
  ismale?: Maybe<Scalars['Boolean']>;
  last_name?: Maybe<Scalars['String']>;
  mobile_phone?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  /** The team */
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
};

export type QLStatus = {
  __typename?: 'Status';
  discussions?: Maybe<QLStatusDiscussions>;
  todos?: Maybe<QLStatusTodos>;
  total_clients?: Maybe<Scalars['Int']>;
};

export type QLStatusDiscussions = {
  __typename?: 'StatusDiscussions';
  open?: Maybe<Scalars['Int']>;
  open_sms?: Maybe<Scalars['Int']>;
};

export type QLStatusTodos = {
  __typename?: 'StatusTodos';
  open?: Maybe<Scalars['Int']>;
  overdue?: Maybe<Scalars['Int']>;
  postponed?: Maybe<Scalars['Int']>;
};

export type QLStripeIntent = {
  __typename?: 'StripeIntent';
  client_secret: Scalars['String'];
};

/** Subscription status */
export enum QLSubscriptionStatus {
  /** Active */
  active = 'active',
  /** Canceled */
  canceled = 'canceled',
  /** Incomplete */
  incomplete = 'incomplete',
  /** Incomplete expired */
  incompleteExpired = 'incompleteExpired',
  /** Past due */
  pastDue = 'pastDue',
  /** Trialing */
  trialing = 'trialing',
  /** Unpaid */
  unpaid = 'unpaid'
}

/** A tag */
export type QLTag = {
  __typename?: 'Tag';
  /** Whether the tag is archived */
  archived: Scalars['Boolean'];
  /** The ID of the tag */
  id: Scalars['ID'];
  kind?: Maybe<QLTagKindEnum>;
  name: Scalars['String'];
  /** The team */
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
};

export enum QLTagAction {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

/** The kind of tag */
export enum QLTagKindEnum {
  AUTOMATION = 'AUTOMATION',
  CLIENT = 'CLIENT',
  TODO = 'TODO'
}

export type QLTeam = {
  __typename?: 'Team';
  addon_forms?: Maybe<Scalars['Boolean']>;
  addon_zapier?: Maybe<Scalars['Boolean']>;
  addons?: Maybe<Array<Maybe<QLAddon>>>;
  address?: Maybe<Scalars['String']>;
  all_users?: Maybe<Array<Maybe<QLUser>>>;
  api_set?: Maybe<Scalars['Boolean']>;
  approved?: Maybe<Scalars['Boolean']>;
  /** @deprecated Field removed */
  billing_address?: Maybe<Scalars['String']>;
  /** @deprecated Field removed */
  billing_address_line_2?: Maybe<Scalars['String']>;
  /** @deprecated Field removed */
  billing_city?: Maybe<Scalars['String']>;
  /** @deprecated Field removed */
  billing_country?: Maybe<Scalars['String']>;
  /** @deprecated Field removed */
  billing_state?: Maybe<Scalars['String']>;
  /** @deprecated Field removed */
  billing_zip?: Maybe<Scalars['String']>;
  book_class_url?: Maybe<Scalars['String']>;
  brand?: Maybe<QLBrand>;
  brand_id?: Maybe<Scalars['ID']>;
  brand_name?: Maybe<Scalars['String']>;
  can_create_automations?: Maybe<Scalars['Boolean']>;
  card_country?: Maybe<Scalars['String']>;
  clubready_start_date?: Maybe<Scalars['Timestamp']>;
  color?: Maybe<Scalars['String']>;
  contract_1_discount_code?: Maybe<Scalars['String']>;
  contract_1_discount_price?: Maybe<Scalars['String']>;
  contract_1_name?: Maybe<Scalars['String']>;
  contract_1_optional_1?: Maybe<Scalars['String']>;
  contract_1_optional_2?: Maybe<Scalars['String']>;
  contract_1_optional_3?: Maybe<Scalars['String']>;
  contract_1_optional_4?: Maybe<Scalars['String']>;
  contract_1_price?: Maybe<Scalars['String']>;
  contract_1_url?: Maybe<Scalars['String']>;
  contract_2_discount_code?: Maybe<Scalars['String']>;
  contract_2_discount_price?: Maybe<Scalars['String']>;
  contract_2_name?: Maybe<Scalars['String']>;
  contract_2_optional_1?: Maybe<Scalars['String']>;
  contract_2_optional_2?: Maybe<Scalars['String']>;
  contract_2_optional_3?: Maybe<Scalars['String']>;
  contract_2_optional_4?: Maybe<Scalars['String']>;
  contract_2_price?: Maybe<Scalars['String']>;
  contract_2_url?: Maybe<Scalars['String']>;
  contract_3_discount_code?: Maybe<Scalars['String']>;
  contract_3_discount_price?: Maybe<Scalars['String']>;
  contract_3_name?: Maybe<Scalars['String']>;
  contract_3_optional_1?: Maybe<Scalars['String']>;
  contract_3_optional_2?: Maybe<Scalars['String']>;
  contract_3_optional_3?: Maybe<Scalars['String']>;
  contract_3_optional_4?: Maybe<Scalars['String']>;
  contract_3_price?: Maybe<Scalars['String']>;
  contract_3_url?: Maybe<Scalars['String']>;
  contract_4_discount_code?: Maybe<Scalars['String']>;
  contract_4_discount_price?: Maybe<Scalars['String']>;
  contract_4_name?: Maybe<Scalars['String']>;
  contract_4_optional_1?: Maybe<Scalars['String']>;
  contract_4_optional_2?: Maybe<Scalars['String']>;
  contract_4_optional_3?: Maybe<Scalars['String']>;
  contract_4_optional_4?: Maybe<Scalars['String']>;
  contract_4_price?: Maybe<Scalars['String']>;
  contract_4_url?: Maybe<Scalars['String']>;
  contract_5_discount_code?: Maybe<Scalars['String']>;
  contract_5_discount_price?: Maybe<Scalars['String']>;
  contract_5_name?: Maybe<Scalars['String']>;
  contract_5_optional_1?: Maybe<Scalars['String']>;
  contract_5_optional_2?: Maybe<Scalars['String']>;
  contract_5_optional_3?: Maybe<Scalars['String']>;
  contract_5_optional_4?: Maybe<Scalars['String']>;
  contract_5_price?: Maybe<Scalars['String']>;
  contract_5_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Timestamp']>;
  current_billing_plan?: Maybe<Scalars['String']>;
  email_sender?: Maybe<Scalars['String']>;
  email_sender_name?: Maybe<Scalars['String']>;
  email_signature?: Maybe<Scalars['String']>;
  external_token_present?: Maybe<Scalars['Boolean']>;
  facebook_url?: Maybe<Scalars['String']>;
  first_import_done?: Maybe<Scalars['Boolean']>;
  forced_forms?: Maybe<Scalars['Boolean']>;
  forced_zapier?: Maybe<Scalars['Boolean']>;
  groups?: Maybe<Array<Maybe<QLTeamGroup>>>;
  id: Scalars['ID'];
  instagram_handle?: Maybe<Scalars['String']>;
  is_dummy?: Maybe<Scalars['Boolean']>;
  is_free?: Maybe<Scalars['Boolean']>;
  is_on_trial?: Maybe<Scalars['Boolean']>;
  list_contracts_url?: Maybe<Scalars['String']>;
  list_packages_url?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<Maybe<QLLocation>>>;
  logo_url?: Maybe<Scalars['String']>;
  manager_name?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  outgoing_set?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<QLUser>;
  owner_id?: Maybe<Scalars['ID']>;
  package_1_discount_code?: Maybe<Scalars['String']>;
  package_1_discount_price?: Maybe<Scalars['String']>;
  package_1_name?: Maybe<Scalars['String']>;
  package_1_optional_1?: Maybe<Scalars['String']>;
  package_1_optional_2?: Maybe<Scalars['String']>;
  package_1_price?: Maybe<Scalars['String']>;
  package_1_url?: Maybe<Scalars['String']>;
  package_2_discount_code?: Maybe<Scalars['String']>;
  package_2_discount_price?: Maybe<Scalars['String']>;
  package_2_name?: Maybe<Scalars['String']>;
  package_2_optional_1?: Maybe<Scalars['String']>;
  package_2_optional_2?: Maybe<Scalars['String']>;
  package_2_price?: Maybe<Scalars['String']>;
  package_2_url?: Maybe<Scalars['String']>;
  package_3_discount_code?: Maybe<Scalars['String']>;
  package_3_discount_price?: Maybe<Scalars['String']>;
  package_3_name?: Maybe<Scalars['String']>;
  package_3_optional_1?: Maybe<Scalars['String']>;
  package_3_optional_2?: Maybe<Scalars['String']>;
  package_3_price?: Maybe<Scalars['String']>;
  package_3_url?: Maybe<Scalars['String']>;
  package_4_discount_code?: Maybe<Scalars['String']>;
  package_4_discount_price?: Maybe<Scalars['String']>;
  package_4_name?: Maybe<Scalars['String']>;
  package_4_optional_1?: Maybe<Scalars['String']>;
  package_4_optional_2?: Maybe<Scalars['String']>;
  package_4_price?: Maybe<Scalars['String']>;
  package_4_url?: Maybe<Scalars['String']>;
  package_5_discount_code?: Maybe<Scalars['String']>;
  package_5_discount_price?: Maybe<Scalars['String']>;
  package_5_name?: Maybe<Scalars['String']>;
  package_5_optional_1?: Maybe<Scalars['String']>;
  package_5_optional_2?: Maybe<Scalars['String']>;
  package_5_price?: Maybe<Scalars['String']>;
  package_5_url?: Maybe<Scalars['String']>;
  period_count_data?: Maybe<QLPeriodData>;
  period_count_type?: Maybe<QLPeriodCountType>;
  phone_forward?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  photo_url?: Maybe<Scalars['String']>;
  pm_last_four?: Maybe<Scalars['String']>;
  pm_type?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['Int']>;
  provider_clubready?: Maybe<Scalars['Boolean']>;
  provider_fitdegree?: Maybe<Scalars['Boolean']>;
  provider_mindbody?: Maybe<Scalars['Boolean']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_pike13?: Maybe<Scalars['Boolean']>;
  provider_type?: Maybe<QLProvidersEnum>;
  role?: Maybe<QLUserRoleEnum>;
  site_id?: Maybe<Scalars['String']>;
  sms_bundles?: Maybe<Array<Maybe<QLSmsBundle>>>;
  sms_sender?: Maybe<Scalars['String']>;
  stripe_id?: Maybe<Scalars['String']>;
  subscription_active?: Maybe<Scalars['Boolean']>;
  timezone?: Maybe<Scalars['String']>;
  trial_ends_at?: Maybe<Scalars['Timestamp']>;
  twitter_handle?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Timestamp']>;
  users?: Maybe<Array<Maybe<QLUser>>>;
  website?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type QLTeamGroup = {
  __typename?: 'TeamGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  users?: Maybe<Array<Maybe<QLUser>>>;
};

export type QLTeamSubscription = {
  __typename?: 'TeamSubscription';
  ends_at?: Maybe<Scalars['Timestamp']>;
  items?: Maybe<Array<Maybe<QLTeamSubscriptionItem>>>;
  quantity?: Maybe<Scalars['Int']>;
  status?: Maybe<QLSubscriptionStatus>;
  trial_ends_at?: Maybe<Scalars['Timestamp']>;
};

export type QLTeamSubscriptionItem = {
  __typename?: 'TeamSubscriptionItem';
  name?: Maybe<Scalars['String']>;
  plan?: Maybe<QLPlan>;
  quantity?: Maybe<Scalars['Int']>;
};

export type QLTemporaryMute = {
  __typename?: 'TemporaryMute';
  client?: Maybe<QLClient>;
  client_id: Scalars['ID'];
  id: Scalars['ID'];
  muted_at?: Maybe<Scalars['Timestamp']>;
  muted_by?: Maybe<QLUser>;
  muted_until?: Maybe<Scalars['Timestamp']>;
  unmuted_at?: Maybe<Scalars['Timestamp']>;
  unmuted_by?: Maybe<QLUser>;
};

export type QLTodo = {
  __typename?: 'Todo';
  assigned_tags?: Maybe<Array<Maybe<QLTag>>>;
  assigned_to?: Maybe<QLUser>;
  assigned_to_id?: Maybe<Scalars['ID']>;
  automation?: Maybe<QLAutomation>;
  automation_id?: Maybe<Scalars['ID']>;
  /** The client */
  client?: Maybe<QLClient>;
  client_id?: Maybe<Scalars['ID']>;
  completed_action_note?: Maybe<Scalars['String']>;
  completed_action_type?: Maybe<QLTodoCompletionTypeEnum>;
  completed_at?: Maybe<Scalars['Timestamp']>;
  completed_by?: Maybe<QLUser>;
  completed_by_id?: Maybe<Scalars['ID']>;
  created_at?: Maybe<Scalars['Timestamp']>;
  created_by?: Maybe<QLUser>;
  created_by_id?: Maybe<Scalars['ID']>;
  deleted_at?: Maybe<Scalars['Timestamp']>;
  deleted_by?: Maybe<QLUser>;
  deleted_by_id?: Maybe<Scalars['ID']>;
  /** The ID of the product */
  id: Scalars['ID'];
  is_closed?: Maybe<Scalars['Boolean']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  is_open?: Maybe<Scalars['Boolean']>;
  is_postponed?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  overdue_at?: Maybe<Scalars['Timestamp']>;
  postponed_to?: Maybe<Scalars['Timestamp']>;
  priority?: Maybe<QLTodoPriority>;
  subject?: Maybe<Scalars['String']>;
  /** The team */
  team?: Maybe<QLTeam>;
  team_group?: Maybe<QLTeamGroup>;
  team_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['Timestamp']>;
};

/** The completion type of a Todo */
export enum QLTodoCompletionTypeEnum {
  EMAIL = 'EMAIL',
  IN_PERSON = 'IN_PERSON',
  OTHER = 'OTHER',
  PHONE_CALL = 'PHONE_CALL',
  SMS = 'SMS'
}

/** A paginated list of Todo items. */
export type QLTodoPaginator = {
  __typename?: 'TodoPaginator';
  /** A list of Todo items. */
  data: Array<QLTodo>;
  /** Pagination information about the list of items. */
  paginatorInfo: QLPaginatorInfo;
};

/** Todo priority */
export enum QLTodoPriority {
  /** Low */
  LOW = 'LOW',
  /** Medium */
  MEDIUM = 'MEDIUM',
  /** None */
  NONE = 'NONE',
  /** Urgent */
  URGENT = 'URGENT'
}

/** Specify if you want to include or exclude trashed results from a query. */
export enum QLTrashed {
  /** Only return trashed results. */
  ONLY = 'ONLY',
  /** Return both trashed and non-trashed results. */
  WITH = 'WITH',
  /** Only return non-trashed results. */
  WITHOUT = 'WITHOUT'
}

export type QLUnmuteClientPayload = {
  __typename?: 'UnmuteClientPayload';
  message?: Maybe<Scalars['String']>;
  mute?: Maybe<QLTemporaryMute>;
  mutes?: Maybe<Array<QLTemporaryMute>>;
  success: Scalars['Boolean'];
};

/** Unsubscribe medium enum */
export enum QLUnsubscribeMediumEnum {
  /** Email */
  Email = 'Email',
  /** Sms */
  SMS = 'SMS'
}

export type QLUpdateTeamInput = {
  address?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  email_sender?: InputMaybe<Scalars['String']>;
  email_sender_name?: InputMaybe<Scalars['String']>;
  email_signature?: InputMaybe<Scalars['String']>;
  facebook_url?: InputMaybe<Scalars['String']>;
  instagram_handle?: InputMaybe<Scalars['String']>;
  manager_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone_forward?: InputMaybe<Scalars['String']>;
  sms_sender?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  twitter_handle?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type QLUpdateUserInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  photo?: InputMaybe<Scalars['Upload']>;
};

export type QLUser = {
  __typename?: 'User';
  created_at?: Maybe<Scalars['Timestamp']>;
  current_team?: Maybe<QLTeam>;
  current_team_id?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  last_read_announcements_at?: Maybe<Scalars['Timestamp']>;
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<QLUserPermission>>>;
  photo_url?: Maybe<Scalars['String']>;
  policy?: Maybe<QLUserPolicy>;
  role?: Maybe<QLUserRoleEnum>;
  teams?: Maybe<Array<Maybe<QLTeam>>>;
  updated_at?: Maybe<Scalars['Timestamp']>;
};

export type QLUserPermission = {
  __typename?: 'UserPermission';
  groups?: Maybe<Array<Maybe<QLTeamGroup>>>;
  name?: Maybe<Scalars['String']>;
};

export type QLUserPolicy = {
  __typename?: 'UserPolicy';
  add_tags?: Maybe<Scalars['Boolean']>;
  create_automations?: Maybe<Scalars['Boolean']>;
  create_email_templates?: Maybe<Scalars['Boolean']>;
  create_forms?: Maybe<Scalars['Boolean']>;
  edit_automations?: Maybe<Scalars['Boolean']>;
  edit_email_templates?: Maybe<Scalars['Boolean']>;
  edit_forms?: Maybe<Scalars['Boolean']>;
  export_clients?: Maybe<Scalars['Boolean']>;
  is_admin?: Maybe<Scalars['Boolean']>;
  is_main_owner?: Maybe<Scalars['Boolean']>;
  is_manager?: Maybe<Scalars['Boolean']>;
  is_owner?: Maybe<Scalars['Boolean']>;
  role?: Maybe<QLUserRoleEnum>;
  send_messages?: Maybe<Scalars['Boolean']>;
  staff_change?: Maybe<Scalars['Boolean']>;
  staff_invite?: Maybe<Scalars['Boolean']>;
  staff_remove?: Maybe<Scalars['Boolean']>;
  view_email_templates?: Maybe<Scalars['Boolean']>;
};

export enum QLUserRole {
  MEMBER = 'MEMBER',
  OWNER = 'OWNER'
}

export enum QLUserRoleEnum {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  MEMBER = 'MEMBER',
  OWNER = 'OWNER'
}

export type QLUserWithRole = {
  __typename?: 'UserWithRole';
  id: Scalars['ID'];
  role?: Maybe<QLUserRoleEnum>;
  user?: Maybe<QLUser>;
};

export type QLVirtualClassInfo = {
  __typename?: 'VirtualClassInfo';
  day_of_week?: Maybe<Scalars['Int']>;
  /** The ID of the virtual class info */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['Int']>;
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  virtual_data?: Maybe<QLClassVirtualData>;
  virtual_url?: Maybe<Scalars['String']>;
};

export type QLVisit = {
  __typename?: 'Visit';
  class?: Maybe<QLClassModel>;
  /** A date in timestamp format */
  class_end_time?: Maybe<Scalars['Timestamp']>;
  class_id?: Maybe<Scalars['ID']>;
  client?: Maybe<QLClient>;
  client_id?: Maybe<Scalars['ID']>;
  /** A date in timestamp format */
  created_at?: Maybe<Scalars['Timestamp']>;
  early_cancel?: Maybe<Scalars['Boolean']>;
  /** The ID of the visit */
  id: Scalars['ID'];
  late_cancelled?: Maybe<Scalars['Boolean']>;
  package?: Maybe<QLPackage>;
  package_id?: Maybe<Scalars['ID']>;
  signed_in?: Maybe<Scalars['Boolean']>;
  /** The team */
  team?: Maybe<QLTeam>;
  team_id?: Maybe<Scalars['ID']>;
  /** A date in timestamp format */
  updated_at?: Maybe<Scalars['Timestamp']>;
  web_signup?: Maybe<Scalars['Boolean']>;
};

/** A paginated list of Visit items. */
export type QLVisitPaginator = {
  __typename?: 'VisitPaginator';
  /** A list of Visit items. */
  data: Array<QLVisit>;
  /** Pagination information about the list of items. */
  paginatorInfo: QLPaginatorInfo;
};

export type QLLoginMutationVariables = Exact<{
  input?: InputMaybe<QLLoginInput>;
}>;


export type QLLoginMutation = { __typename?: 'Mutation', login: { __typename?: 'User', email?: string | null, current_team_id?: string | null, last_read_announcements_at?: any | null, id: string, name?: string | null, photo_url?: string | null, current_team?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null, policy?: { __typename?: 'UserPolicy', role?: QLUserRoleEnum | null, add_tags?: boolean | null, is_owner?: boolean | null, is_manager?: boolean | null, is_admin?: boolean | null, is_main_owner?: boolean | null, edit_automations?: boolean | null, create_automations?: boolean | null, edit_forms?: boolean | null, create_forms?: boolean | null, export_clients?: boolean | null, staff_invite?: boolean | null, staff_change?: boolean | null, staff_remove?: boolean | null, create_email_templates?: boolean | null, edit_email_templates?: boolean | null, view_email_templates?: boolean | null, send_messages?: boolean | null } | null, permissions?: Array<{ __typename?: 'UserPermission', name?: string | null } | null> | null, teams?: Array<{ __typename?: 'Team', role?: QLUserRoleEnum | null, phone_number?: string | null, phone_forward?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, sms_sender?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, twitter_handle?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, external_token_present?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null } | null> | null } };

export type QLLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type QLLogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'User', email?: string | null, current_team_id?: string | null, last_read_announcements_at?: any | null, id: string, name?: string | null, photo_url?: string | null, current_team?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null, policy?: { __typename?: 'UserPolicy', role?: QLUserRoleEnum | null, add_tags?: boolean | null, is_owner?: boolean | null, is_manager?: boolean | null, is_admin?: boolean | null, is_main_owner?: boolean | null, edit_automations?: boolean | null, create_automations?: boolean | null, edit_forms?: boolean | null, create_forms?: boolean | null, export_clients?: boolean | null, staff_invite?: boolean | null, staff_change?: boolean | null, staff_remove?: boolean | null, create_email_templates?: boolean | null, edit_email_templates?: boolean | null, view_email_templates?: boolean | null, send_messages?: boolean | null } | null, permissions?: Array<{ __typename?: 'UserPermission', name?: string | null } | null> | null, teams?: Array<{ __typename?: 'Team', role?: QLUserRoleEnum | null, phone_number?: string | null, phone_forward?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, sms_sender?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, twitter_handle?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, external_token_present?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null } | null> | null } | null };

export type QLReorderAutomationsMutationVariables = Exact<{
  order: Array<InputMaybe<QLAutomationReorderInput>> | InputMaybe<QLAutomationReorderInput>;
}>;


export type QLReorderAutomationsMutation = { __typename?: 'Mutation', ReorderAutomations?: Array<{ __typename?: 'Automation', id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null } | null> | null };

export type QLCreateAutomationMutationVariables = Exact<{
  automation: QLCreateAutomationInput;
}>;


export type QLCreateAutomationMutation = { __typename?: 'Mutation', CreateAutomation?: { __typename?: 'Automation', send_window_end_minutes?: number | null, send_window_start_minutes?: number | null, content?: string | null, reply_to?: string | null, subject?: string | null, tags?: Array<string | null> | null, tags_add?: boolean | null, todo_overdue_hours?: number | null, todo_postponed_hours?: number | null, todo_priority?: QLTodoPriority | null, todo_tags?: Array<string | null> | null, todo_assigned_to_id?: string | null, todo_team_group_id?: string | null, created_at?: any | null, id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null, email_content?: { __typename?: 'EmailTemplateContent', html?: string | null, json?: any | null } | null, todo_assigned_to?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, todo_team_group?: { __typename?: 'TeamGroup', id: string, name: string } | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, segment?: { __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null } | null } | null };

export type QLUpdateAutomationFullMutationVariables = Exact<{
  id: Scalars['ID'];
  automation: QLCreateAutomationInput;
}>;


export type QLUpdateAutomationFullMutation = { __typename?: 'Mutation', UpdateAutomationFull?: { __typename?: 'Automation', send_window_end_minutes?: number | null, send_window_start_minutes?: number | null, content?: string | null, reply_to?: string | null, subject?: string | null, tags?: Array<string | null> | null, tags_add?: boolean | null, todo_overdue_hours?: number | null, todo_postponed_hours?: number | null, todo_priority?: QLTodoPriority | null, todo_tags?: Array<string | null> | null, todo_assigned_to_id?: string | null, todo_team_group_id?: string | null, created_at?: any | null, id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null, email_content?: { __typename?: 'EmailTemplateContent', html?: string | null, json?: any | null } | null, todo_assigned_to?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, todo_team_group?: { __typename?: 'TeamGroup', id: string, name: string } | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, segment?: { __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null } | null } | null };

export type QLUpdateAutomationMutationVariables = Exact<{
  id: Scalars['ID'];
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  assigned_tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type QLUpdateAutomationMutation = { __typename?: 'Mutation', UpdateAutomation?: { __typename?: 'Automation', send_window_end_minutes?: number | null, send_window_start_minutes?: number | null, content?: string | null, reply_to?: string | null, subject?: string | null, tags?: Array<string | null> | null, tags_add?: boolean | null, todo_overdue_hours?: number | null, todo_postponed_hours?: number | null, todo_priority?: QLTodoPriority | null, todo_tags?: Array<string | null> | null, todo_assigned_to_id?: string | null, todo_team_group_id?: string | null, created_at?: any | null, id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null, email_content?: { __typename?: 'EmailTemplateContent', html?: string | null, json?: any | null } | null, todo_assigned_to?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, todo_team_group?: { __typename?: 'TeamGroup', id: string, name: string } | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, segment?: { __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null } | null } | null };

export type QLToggleAutomationActiveMutationVariables = Exact<{
  id: Scalars['ID'];
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type QLToggleAutomationActiveMutation = { __typename?: 'Mutation', ToggleAutomationActive?: { __typename?: 'Automation', send_window_end_minutes?: number | null, send_window_start_minutes?: number | null, content?: string | null, reply_to?: string | null, subject?: string | null, tags?: Array<string | null> | null, tags_add?: boolean | null, todo_overdue_hours?: number | null, todo_postponed_hours?: number | null, todo_priority?: QLTodoPriority | null, todo_tags?: Array<string | null> | null, todo_assigned_to_id?: string | null, todo_team_group_id?: string | null, created_at?: any | null, id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null, email_content?: { __typename?: 'EmailTemplateContent', html?: string | null, json?: any | null } | null, todo_assigned_to?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, todo_team_group?: { __typename?: 'TeamGroup', id: string, name: string } | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, segment?: { __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null } | null } | null };

export type QLExportAutomationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLExportAutomationMutation = { __typename?: 'Mutation', ExportAutomation?: { __typename?: 'ExportResult', status?: boolean | null } | null };

export type QLSendAutomationManuallyMutationVariables = Exact<{
  client_id: Scalars['ID'];
  automation_id: Scalars['ID'];
}>;


export type QLSendAutomationManuallyMutation = { __typename?: 'Mutation', SendAutomationManually?: { __typename?: 'SimpleResponse', ok?: boolean | null } | null };

export type QLCopyAutomationMutationVariables = Exact<{
  id: Scalars['ID'];
  destination_team_id: Scalars['ID'];
}>;


export type QLCopyAutomationMutation = { __typename?: 'Mutation', CopyAutomation?: { __typename?: 'Automation', id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null } | null };

export type QLCloneAutomationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLCloneAutomationMutation = { __typename?: 'Mutation', CloneAutomation?: { __typename?: 'Automation', id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null } | null };

export type QLBulkUpdateAutomationsMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  action: QLAutomationBulkActionEnum;
}>;


export type QLBulkUpdateAutomationsMutation = { __typename?: 'Mutation', BulkUpdateAutomations?: Array<{ __typename?: 'Automation', id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null } | null> | null };

export type QLCancelSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type QLCancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription?: { __typename?: 'TeamSubscription', quantity?: number | null, trial_ends_at?: any | null, ends_at?: any | null, status?: QLSubscriptionStatus | null, items?: Array<{ __typename?: 'TeamSubscriptionItem', name?: string | null, quantity?: number | null, plan?: { __typename?: 'Plan', id: string, name: string, price: number, trial_days?: number | null, active: boolean, interval?: QLPlanInterval | null, addon?: boolean | null, addon_type?: string | null } | null } | null> | null } | null };

export type QLResumeSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type QLResumeSubscriptionMutation = { __typename?: 'Mutation', resumeSubscription?: { __typename?: 'TeamSubscription', quantity?: number | null, trial_ends_at?: any | null, ends_at?: any | null, status?: QLSubscriptionStatus | null, items?: Array<{ __typename?: 'TeamSubscriptionItem', name?: string | null, quantity?: number | null, plan?: { __typename?: 'Plan', id: string, name: string, price: number, trial_days?: number | null, active: boolean, interval?: QLPlanInterval | null, addon?: boolean | null, addon_type?: string | null } | null } | null> | null } | null };

export type QLGeneratePaymentTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type QLGeneratePaymentTokenMutation = { __typename?: 'Mutation', generatePaymentToken: { __typename?: 'StripeIntent', client_secret: string } };

export type QLUpdatePaymentMethodMutationVariables = Exact<{
  payment_method: Scalars['String'];
}>;


export type QLUpdatePaymentMethodMutation = { __typename?: 'Mutation', updatePaymentMethod?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null };

export type QLStartSubscriptionMutationVariables = Exact<{
  plan: Scalars['String'];
  payment_method?: InputMaybe<Scalars['String']>;
  coupon?: InputMaybe<Scalars['String']>;
}>;


export type QLStartSubscriptionMutation = { __typename?: 'Mutation', startSubscription?: { __typename?: 'TeamSubscription', quantity?: number | null, trial_ends_at?: any | null, ends_at?: any | null, status?: QLSubscriptionStatus | null, items?: Array<{ __typename?: 'TeamSubscriptionItem', name?: string | null, quantity?: number | null, plan?: { __typename?: 'Plan', id: string, name: string, price: number, trial_days?: number | null, active: boolean, interval?: QLPlanInterval | null, addon?: boolean | null, addon_type?: string | null } | null } | null> | null } | null };

export type QLStartAddonMutationVariables = Exact<{
  addon: Scalars['String'];
}>;


export type QLStartAddonMutation = { __typename?: 'Mutation', startAddon?: { __typename?: 'TeamSubscription', quantity?: number | null, trial_ends_at?: any | null, ends_at?: any | null, status?: QLSubscriptionStatus | null, items?: Array<{ __typename?: 'TeamSubscriptionItem', name?: string | null, quantity?: number | null, plan?: { __typename?: 'Plan', id: string, name: string, price: number, trial_days?: number | null, active: boolean, interval?: QLPlanInterval | null, addon?: boolean | null, addon_type?: string | null } | null } | null> | null } | null };

export type QLStopAddonMutationVariables = Exact<{
  addon: Scalars['String'];
}>;


export type QLStopAddonMutation = { __typename?: 'Mutation', stopAddon?: { __typename?: 'TeamSubscription', quantity?: number | null, trial_ends_at?: any | null, ends_at?: any | null, status?: QLSubscriptionStatus | null, items?: Array<{ __typename?: 'TeamSubscriptionItem', name?: string | null, quantity?: number | null, plan?: { __typename?: 'Plan', id: string, name: string, price: number, trial_days?: number | null, active: boolean, interval?: QLPlanInterval | null, addon?: boolean | null, addon_type?: string | null } | null } | null> | null } | null };

export type QLAddCatalogToAutomationsMutationVariables = Exact<{
  catalog_id: Scalars['ID'];
  catalog_data: QLCatalogItemToAutomationInput;
}>;


export type QLAddCatalogToAutomationsMutation = { __typename?: 'Mutation', AddCatalogToAutomations?: { __typename?: 'Automation', tags_add?: boolean | null, id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, segment?: { __typename?: 'Segment', id: string, name: string } | null } | null };

export type QLSaveCatalogItemMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  catalogItem: QLCatalogItemInput;
}>;


export type QLSaveCatalogItemMutation = { __typename?: 'Mutation', SaveCatalogItem?: { __typename?: 'CatalogItem', long_description: string, id: string, name: string, description: string, category?: string | null, automation?: { __typename?: 'CatalogAutomation', name?: string | null, category_name?: string | null, description?: string | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, one_off?: boolean | null, start_at?: any | null, send_window_end_minutes?: number | null, send_window_start_minutes?: number | null, content?: string | null, reply_to?: string | null, subject?: string | null, tags?: Array<string | null> | null, tags_add?: boolean | null, todo_overdue_hours?: number | null, todo_postponed_hours?: number | null, todo_priority?: QLTodoPriority | null, todo_tags?: Array<string | null> | null, todo_assigned_to_id?: string | null, todo_team_group_id?: string | null, email_content?: { __typename?: 'EmailTemplateContent', html?: string | null, json?: any | null } | null, segment: { __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null } } | null, variable_fields?: Array<{ __typename?: 'CatalogItemVariable', id: string, field_type: QLOperatorTypeEnum, field_name: string, field_description: string }> | null } | null };

export type QLUpdateClassMutationVariables = Exact<{
  id: Scalars['ID'];
  is_virtual: Scalars['Boolean'];
  virtual_url?: InputMaybe<Scalars['String']>;
  virtual_data?: InputMaybe<QLClassVirtualDataInput>;
}>;


export type QLUpdateClassMutation = { __typename?: 'Mutation', UpdateClass?: { __typename?: 'ClassModel', virtual_url?: string | null, location_id?: string | null, staff_id?: string | null, id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null, virtual_data?: { __typename?: 'ClassVirtualData', virtual_id?: string | null, virtual_password?: string | null, virtual_info?: string | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null, staff?: { __typename?: 'Staff', id: string, first_name?: string | null, last_name?: string | null, name?: string | null } | null } | null };

export type QLMuteClientMutationVariables = Exact<{
  client_id: Scalars['ID'];
  muted_until: Scalars['Timestamp'];
}>;


export type QLMuteClientMutation = { __typename?: 'Mutation', muteClient: { __typename?: 'MuteClientPayload', success: boolean, message?: string | null, mute?: { __typename?: 'TemporaryMute', id: string, client_id: string, muted_until?: any | null, muted_by?: { __typename?: 'User', id: string } | null } | null } };

export type QLUnmuteClientMutationVariables = Exact<{
  client_id: Scalars['ID'];
}>;


export type QLUnmuteClientMutation = { __typename?: 'Mutation', unmuteClient: { __typename?: 'UnmuteClientPayload', success: boolean, message?: string | null, mutes?: Array<{ __typename?: 'TemporaryMute', id: string, client_id: string, unmuted_at?: any | null, unmuted_by?: { __typename?: 'User', id: string } | null }> | null } };

export type QLUpdateClientMutationVariables = Exact<{
  id: Scalars['ID'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  unsubscribed_email_at?: InputMaybe<Scalars['Int']>;
  unsubscribed_sms_at?: InputMaybe<Scalars['Int']>;
}>;


export type QLUpdateClientMutation = { __typename?: 'Mutation', UpdateClient?: { __typename?: 'Client', team_id?: string | null, last_appointment_at?: any | null, last_attendance_at?: any | null, address_line?: string | null, address_city?: string | null, address_state?: string | null, address_postal_code?: string | null, address_country?: string | null, ltv?: number | null, created_at?: any | null, updated_at?: any | null, creation_date?: any | null, birthday?: any | null, note_generic?: string | null, note_yellow?: string | null, note_red?: string | null, twitter?: string | null, twitter_bio?: string | null, twitter_followers?: number | null, twitter_following?: number | null, linkedin?: string | null, linkedin_bio?: string | null, linkedin_followers?: number | null, linkedin_following?: number | null, facebook?: string | null, instagram?: string | null, instagram_bio?: string | null, instagram_followers?: number | null, instagram_following?: number | null, username?: string | null, email?: string | null, mobile_phone?: string | null, phone_home?: string | null, phone_work?: string | null, phone_work_ext?: string | null, referred_by?: string | null, bio?: string | null, job_title?: string | null, job_organization?: string | null, emergency_contact_info_name?: string | null, emergency_contact_info_relationship?: string | null, emergency_contact_info_phone?: string | null, emergency_contact_info_email?: string | null, active?: boolean | null, email_opt_in?: boolean | null, liability_release?: boolean | null, is_company?: boolean | null, promotional_email_opt_in?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, lead_signed_up_id?: string | null, mbo_member_status?: QLMboMemberStatus | null, email_opt_in_reminder_at?: any | null, id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, home_location?: { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, next_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, last_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, current_package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null, referrer?: { __typename?: 'ClientReferrer', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, location?: string | null } | null, education?: Array<{ __typename?: 'ClientEducation', name?: string | null, end_year?: number | null, degree?: string | null } | null> | null, mbo_index_values?: Array<{ __typename?: 'MboIndexValue', name: string, id: string, mbo_index?: { __typename?: 'MboIndex', name: string, id: string } | null } | null> | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null };

export type QLCreateProspectMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  mobile_phone?: InputMaybe<Scalars['String']>;
  referred_by?: InputMaybe<Scalars['String']>;
}>;


export type QLCreateProspectMutation = { __typename?: 'Mutation', CreateProspect?: { __typename?: 'Client', id: string } | null };

export type QLUpdateLeadMutationVariables = Exact<{
  id: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  mobile_phone?: InputMaybe<Scalars['String']>;
  referred_by?: InputMaybe<Scalars['String']>;
  frozen?: InputMaybe<Scalars['Boolean']>;
}>;


export type QLUpdateLeadMutation = { __typename?: 'Mutation', UpdateLead?: { __typename?: 'Client', team_id?: string | null, last_appointment_at?: any | null, last_attendance_at?: any | null, address_line?: string | null, address_city?: string | null, address_state?: string | null, address_postal_code?: string | null, address_country?: string | null, ltv?: number | null, created_at?: any | null, updated_at?: any | null, creation_date?: any | null, birthday?: any | null, note_generic?: string | null, note_yellow?: string | null, note_red?: string | null, twitter?: string | null, twitter_bio?: string | null, twitter_followers?: number | null, twitter_following?: number | null, linkedin?: string | null, linkedin_bio?: string | null, linkedin_followers?: number | null, linkedin_following?: number | null, facebook?: string | null, instagram?: string | null, instagram_bio?: string | null, instagram_followers?: number | null, instagram_following?: number | null, username?: string | null, email?: string | null, mobile_phone?: string | null, phone_home?: string | null, phone_work?: string | null, phone_work_ext?: string | null, referred_by?: string | null, bio?: string | null, job_title?: string | null, job_organization?: string | null, emergency_contact_info_name?: string | null, emergency_contact_info_relationship?: string | null, emergency_contact_info_phone?: string | null, emergency_contact_info_email?: string | null, active?: boolean | null, email_opt_in?: boolean | null, liability_release?: boolean | null, is_company?: boolean | null, promotional_email_opt_in?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, lead_signed_up_id?: string | null, mbo_member_status?: QLMboMemberStatus | null, email_opt_in_reminder_at?: any | null, id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, home_location?: { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, next_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, last_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, current_package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null, referrer?: { __typename?: 'ClientReferrer', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, location?: string | null } | null, education?: Array<{ __typename?: 'ClientEducation', name?: string | null, end_year?: number | null, degree?: string | null } | null> | null, mbo_index_values?: Array<{ __typename?: 'MboIndexValue', name: string, id: string, mbo_index?: { __typename?: 'MboIndex', name: string, id: string } | null } | null> | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null };

export type QLExportClientsMutationVariables = Exact<{
  segment: QLSegmentInput;
}>;


export type QLExportClientsMutation = { __typename?: 'Mutation', ExportClients?: { __typename?: 'ExportResult', status?: boolean | null } | null };

export type QLSendEmailOptInReminderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLSendEmailOptInReminderMutation = { __typename?: 'Mutation', SendEmailOptInReminder?: { __typename?: 'Client', id: string, unsubscribed_email_at?: any | null, email_opt_in_reminder_at?: any | null, can_contact_by_email?: boolean | null } | null };

export type QLDeleteExcludedEventNameMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLDeleteExcludedEventNameMutation = { __typename?: 'Mutation', DeleteExcludedEventName?: { __typename?: 'ExcludedEventName', id: string, name?: string | null } | null };

export type QLCreateExcludedEventNameMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type QLCreateExcludedEventNameMutation = { __typename?: 'Mutation', CreateExcludedEventName?: { __typename?: 'ExcludedEventName', id: string, name?: string | null } | null };

export type QLUpdateTeamPeriodCountSettingsMutationVariables = Exact<{
  period_count_type: QLPeriodCountType;
  period_count_data: QLPeriodDataInput;
}>;


export type QLUpdateTeamPeriodCountSettingsMutation = { __typename?: 'Mutation', UpdateTeamPeriodCountSettings?: { __typename?: 'Team', id: string, period_count_type?: QLPeriodCountType | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null } | null };

export type QLDiscussionCreateMutationVariables = Exact<{
  client_id: Scalars['ID'];
  subject?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  is_email: Scalars['Boolean'];
}>;


export type QLDiscussionCreateMutation = { __typename?: 'Mutation', CreateDiscussion?: { __typename?: 'Discussion', id: string, subject?: string | null, team_has_responded?: boolean | null, sms?: boolean | null, email?: boolean | null, closed?: boolean | null, sent?: boolean | null, bounced?: boolean | null, delivered?: boolean | null, opened?: boolean | null, clicked?: boolean | null, team_id?: string | null, client_id?: string | null, automation_id?: string | null, last_contacted_at?: any | null, created_at?: any | null, updated_at?: any | null, messages?: Array<{ __typename?: 'Message', id: string, user_id?: string | null, automation_id?: string | null, from_client?: boolean | null, bounced?: boolean | null, sent?: boolean | null, delivered?: boolean | null, clicked?: boolean | null, opened?: boolean | null, subject?: string | null, message?: string | null, created_at?: any | null, error_code?: QLMessageErrorType | null, user?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null> | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, automation?: { __typename?: 'Automation', id: string, name: string, delivery_type?: QLAutomationDeliveryTypeEnum | null } | null, last_message?: { __typename?: 'Message', id: string, user_id?: string | null, automation_id?: string | null, from_client?: boolean | null, bounced?: boolean | null, sent?: boolean | null, delivered?: boolean | null, clicked?: boolean | null, opened?: boolean | null, subject?: string | null, message?: string | null, created_at?: any | null, error_code?: QLMessageErrorType | null, user?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null } | null };

export type QLCreateDiscussionEventMutationVariables = Exact<{
  client_id: Scalars['ID'];
  subject?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  is_email: Scalars['Boolean'];
}>;


export type QLCreateDiscussionEventMutation = { __typename?: 'Mutation', CreateDiscussionEvent?: { __typename?: 'Discussion', id: string, subject?: string | null, team_has_responded?: boolean | null, sms?: boolean | null, email?: boolean | null, closed?: boolean | null, sent?: boolean | null, bounced?: boolean | null, delivered?: boolean | null, opened?: boolean | null, clicked?: boolean | null, team_id?: string | null, client_id?: string | null, automation_id?: string | null, last_contacted_at?: any | null, created_at?: any | null, updated_at?: any | null, messages?: Array<{ __typename?: 'Message', id: string, user_id?: string | null, automation_id?: string | null, from_client?: boolean | null, bounced?: boolean | null, sent?: boolean | null, delivered?: boolean | null, clicked?: boolean | null, opened?: boolean | null, subject?: string | null, message?: string | null, created_at?: any | null, error_code?: QLMessageErrorType | null, user?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null> | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, automation?: { __typename?: 'Automation', id: string, name: string, delivery_type?: QLAutomationDeliveryTypeEnum | null } | null, last_message?: { __typename?: 'Message', id: string, user_id?: string | null, automation_id?: string | null, from_client?: boolean | null, bounced?: boolean | null, sent?: boolean | null, delivered?: boolean | null, clicked?: boolean | null, opened?: boolean | null, subject?: string | null, message?: string | null, created_at?: any | null, error_code?: QLMessageErrorType | null, user?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null } | null };

export type QLDiscussionAddMessageMutationVariables = Exact<{
  id: Scalars['ID'];
  message: Scalars['String'];
}>;


export type QLDiscussionAddMessageMutation = { __typename?: 'Mutation', DiscussionAddMessage?: { __typename?: 'Discussion', id: string, subject?: string | null, team_has_responded?: boolean | null, sms?: boolean | null, email?: boolean | null, closed?: boolean | null, sent?: boolean | null, bounced?: boolean | null, delivered?: boolean | null, opened?: boolean | null, clicked?: boolean | null, team_id?: string | null, client_id?: string | null, automation_id?: string | null, last_contacted_at?: any | null, created_at?: any | null, updated_at?: any | null, messages?: Array<{ __typename?: 'Message', id: string, user_id?: string | null, automation_id?: string | null, from_client?: boolean | null, bounced?: boolean | null, sent?: boolean | null, delivered?: boolean | null, clicked?: boolean | null, opened?: boolean | null, subject?: string | null, message?: string | null, created_at?: any | null, error_code?: QLMessageErrorType | null, user?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null> | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, automation?: { __typename?: 'Automation', id: string, name: string, delivery_type?: QLAutomationDeliveryTypeEnum | null } | null, last_message?: { __typename?: 'Message', id: string, user_id?: string | null, automation_id?: string | null, from_client?: boolean | null, bounced?: boolean | null, sent?: boolean | null, delivered?: boolean | null, clicked?: boolean | null, opened?: boolean | null, subject?: string | null, message?: string | null, created_at?: any | null, error_code?: QLMessageErrorType | null, user?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null } | null };

export type QLDiscussionUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  closed: Scalars['Boolean'];
}>;


export type QLDiscussionUpdateMutation = { __typename?: 'Mutation', UpdateDiscussion?: { __typename?: 'Discussion', id: string, subject?: string | null, team_has_responded?: boolean | null, sms?: boolean | null, email?: boolean | null, closed?: boolean | null, sent?: boolean | null, bounced?: boolean | null, delivered?: boolean | null, opened?: boolean | null, clicked?: boolean | null, team_id?: string | null, client_id?: string | null, automation_id?: string | null, last_contacted_at?: any | null, created_at?: any | null, updated_at?: any | null, messages?: Array<{ __typename?: 'Message', id: string, user_id?: string | null, automation_id?: string | null, from_client?: boolean | null, bounced?: boolean | null, sent?: boolean | null, delivered?: boolean | null, clicked?: boolean | null, opened?: boolean | null, subject?: string | null, message?: string | null, created_at?: any | null, error_code?: QLMessageErrorType | null, user?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null> | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, automation?: { __typename?: 'Automation', id: string, name: string, delivery_type?: QLAutomationDeliveryTypeEnum | null } | null, last_message?: { __typename?: 'Message', id: string, user_id?: string | null, automation_id?: string | null, from_client?: boolean | null, bounced?: boolean | null, sent?: boolean | null, delivered?: boolean | null, clicked?: boolean | null, opened?: boolean | null, subject?: string | null, message?: string | null, created_at?: any | null, error_code?: QLMessageErrorType | null, user?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null } | null };

export type QLEmailPreviewMutationVariables = Exact<{
  subject: Scalars['String'];
  body: Scalars['String'];
  client_id?: InputMaybe<Scalars['ID']>;
}>;


export type QLEmailPreviewMutation = { __typename?: 'Mutation', EmailPreview?: { __typename?: 'EmailPreview', html: string, subject: string } | null };

export type QLEmailPreviewSendMutationVariables = Exact<{
  subject: Scalars['String'];
  body: Scalars['String'];
  client_id?: InputMaybe<Scalars['ID']>;
}>;


export type QLEmailPreviewSendMutation = { __typename?: 'Mutation', EmailPreviewSend?: { __typename?: 'SimpleResponse', ok?: boolean | null } | null };

export type QLCreateEmailTemplateMutationVariables = Exact<{
  name: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
  email_content: QLEmailTemplateContentInput;
}>;


export type QLCreateEmailTemplateMutation = { __typename?: 'Mutation', CreateEmailTemplate?: { __typename?: 'EmailTemplate', id: string, subject?: string | null, automation_id?: string | null, brand_id?: string | null, category?: string | null, team_id?: string | null, name?: string | null, thumbnail?: string | null, updated_at?: any | null, email?: { __typename?: 'EmailTemplateContent', html?: string | null, json?: any | null } | null } | null };

export type QLUpdateEmailTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
  email_content: QLEmailTemplateContentInput;
}>;


export type QLUpdateEmailTemplateMutation = { __typename?: 'Mutation', UpdateEmailTemplate?: { __typename?: 'EmailTemplate', id: string, subject?: string | null, automation_id?: string | null, brand_id?: string | null, category?: string | null, team_id?: string | null, name?: string | null, thumbnail?: string | null, updated_at?: any | null, email?: { __typename?: 'EmailTemplateContent', html?: string | null, json?: any | null } | null } | null };

export type QLDeleteEmailTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLDeleteEmailTemplateMutation = { __typename?: 'Mutation', DeleteEmailTemplate?: { __typename?: 'EmailTemplate', id: string, subject?: string | null, automation_id?: string | null, brand_id?: string | null, category?: string | null, team_id?: string | null, name?: string | null, thumbnail?: string | null, updated_at?: any | null, email?: { __typename?: 'EmailTemplateContent', html?: string | null, json?: any | null } | null } | null };

export type QLCopyEmailTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  destination_team_id: Scalars['ID'];
}>;


export type QLCopyEmailTemplateMutation = { __typename?: 'Mutation', CopyEmailTemplate?: { __typename?: 'EmailTemplate', id: string } | null };

export type QLCreateFormMutationVariables = Exact<{
  form: QLCreateFormInput;
}>;


export type QLCreateFormMutation = { __typename?: 'Mutation', CreateForm?: { __typename?: 'Form', description?: string | null, title?: string | null, short_url?: string | null, archive_404?: boolean | null, archive_text?: string | null, send_to_mbo?: boolean | null, mbo_upload_lead?: boolean | null, mbo_update_client?: boolean | null, updated_at?: any | null, created_at?: any | null, id: string, name?: string | null, category?: string | null, allow_leads?: boolean | null, is_legal?: boolean | null, is_archived?: boolean | null, editable?: boolean | null, thank_you_message?: string | null, thank_you_url?: string | null, email_cc?: string | null, content?: Array<{ __typename?: 'FormField', id: string, kind?: QLFieldTypeEnum | null, description?: string | null, title?: string | null, optional?: boolean | null, options?: Array<string | null> | null, size?: number | null, content?: string | null, prefill?: string | null, mapping?: string | null } | null> | null } | null };

export type QLEditFormMutationVariables = Exact<{
  id: Scalars['ID'];
  form: QLEditFormInput;
}>;


export type QLEditFormMutation = { __typename?: 'Mutation', EditForm?: { __typename?: 'Form', description?: string | null, title?: string | null, short_url?: string | null, archive_404?: boolean | null, archive_text?: string | null, send_to_mbo?: boolean | null, mbo_upload_lead?: boolean | null, mbo_update_client?: boolean | null, updated_at?: any | null, created_at?: any | null, id: string, name?: string | null, category?: string | null, allow_leads?: boolean | null, is_legal?: boolean | null, is_archived?: boolean | null, editable?: boolean | null, thank_you_message?: string | null, thank_you_url?: string | null, email_cc?: string | null, content?: Array<{ __typename?: 'FormField', id: string, kind?: QLFieldTypeEnum | null, description?: string | null, title?: string | null, optional?: boolean | null, options?: Array<string | null> | null, size?: number | null, content?: string | null, prefill?: string | null, mapping?: string | null } | null> | null } | null };

export type QLExportFormMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLExportFormMutation = { __typename?: 'Mutation', ExportForm?: { __typename?: 'ExportResult', status?: boolean | null } | null };

export type QLArchiveFormMutationVariables = Exact<{
  id: Scalars['ID'];
  archive: Scalars['Boolean'];
}>;


export type QLArchiveFormMutation = { __typename?: 'Mutation', ArchiveForm?: { __typename?: 'Form', description?: string | null, title?: string | null, short_url?: string | null, archive_404?: boolean | null, archive_text?: string | null, send_to_mbo?: boolean | null, mbo_upload_lead?: boolean | null, mbo_update_client?: boolean | null, updated_at?: any | null, created_at?: any | null, id: string, name?: string | null, category?: string | null, allow_leads?: boolean | null, is_legal?: boolean | null, is_archived?: boolean | null, editable?: boolean | null, thank_you_message?: string | null, thank_you_url?: string | null, email_cc?: string | null, content?: Array<{ __typename?: 'FormField', id: string, kind?: QLFieldTypeEnum | null, description?: string | null, title?: string | null, optional?: boolean | null, options?: Array<string | null> | null, size?: number | null, content?: string | null, prefill?: string | null, mapping?: string | null } | null> | null } | null };

export type QLAddCatalogToFormsMutationVariables = Exact<{
  catalog_id: Scalars['ID'];
  form_name: Scalars['String'];
}>;


export type QLAddCatalogToFormsMutation = { __typename?: 'Mutation', AddCatalogToForms?: { __typename?: 'Form', description?: string | null, title?: string | null, short_url?: string | null, archive_404?: boolean | null, archive_text?: string | null, send_to_mbo?: boolean | null, mbo_upload_lead?: boolean | null, mbo_update_client?: boolean | null, updated_at?: any | null, created_at?: any | null, id: string, name?: string | null, category?: string | null, allow_leads?: boolean | null, is_legal?: boolean | null, is_archived?: boolean | null, editable?: boolean | null, thank_you_message?: string | null, thank_you_url?: string | null, email_cc?: string | null, content?: Array<{ __typename?: 'FormField', id: string, kind?: QLFieldTypeEnum | null, description?: string | null, title?: string | null, optional?: boolean | null, options?: Array<string | null> | null, size?: number | null, content?: string | null, prefill?: string | null, mapping?: string | null } | null> | null } | null };

export type QLDuplicateFormMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type QLDuplicateFormMutation = { __typename?: 'Mutation', DuplicateForm?: { __typename?: 'Form', description?: string | null, title?: string | null, short_url?: string | null, archive_404?: boolean | null, archive_text?: string | null, send_to_mbo?: boolean | null, mbo_upload_lead?: boolean | null, mbo_update_client?: boolean | null, updated_at?: any | null, created_at?: any | null, id: string, name?: string | null, category?: string | null, allow_leads?: boolean | null, is_legal?: boolean | null, is_archived?: boolean | null, editable?: boolean | null, thank_you_message?: string | null, thank_you_url?: string | null, email_cc?: string | null, content?: Array<{ __typename?: 'FormField', id: string, kind?: QLFieldTypeEnum | null, description?: string | null, title?: string | null, optional?: boolean | null, options?: Array<string | null> | null, size?: number | null, content?: string | null, prefill?: string | null, mapping?: string | null } | null> | null } | null };

export type QLCopyFormMutationVariables = Exact<{
  id: Scalars['ID'];
  destination_team_id?: InputMaybe<Scalars['ID']>;
}>;


export type QLCopyFormMutation = { __typename?: 'Mutation', CopyForm?: { __typename?: 'Form', description?: string | null, title?: string | null, short_url?: string | null, archive_404?: boolean | null, archive_text?: string | null, send_to_mbo?: boolean | null, mbo_upload_lead?: boolean | null, mbo_update_client?: boolean | null, updated_at?: any | null, created_at?: any | null, id: string, name?: string | null, category?: string | null, allow_leads?: boolean | null, is_legal?: boolean | null, is_archived?: boolean | null, editable?: boolean | null, thank_you_message?: string | null, thank_you_url?: string | null, email_cc?: string | null, content?: Array<{ __typename?: 'FormField', id: string, kind?: QLFieldTypeEnum | null, description?: string | null, title?: string | null, optional?: boolean | null, options?: Array<string | null> | null, size?: number | null, content?: string | null, prefill?: string | null, mapping?: string | null } | null> | null } | null };

export type QLInviteMutationVariables = Exact<{
  team_id: Scalars['ID'];
  email: Scalars['String'];
  role: QLUserRoleEnum;
}>;


export type QLInviteMutation = { __typename?: 'Mutation', invite?: { __typename?: 'Invitation', id: string, email: string, token: string, role: QLUserRoleEnum, created_at: any } | null };

export type QLInvitationAcceptMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type QLInvitationAcceptMutation = { __typename?: 'Mutation', invitation_accept?: { __typename?: 'Team', phone_number?: string | null, phone_forward?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, sms_sender?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, twitter_handle?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, external_token_present?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null } | null };

export type QLInvitationRefuseMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type QLInvitationRefuseMutation = { __typename?: 'Mutation', invitation_refuse?: { __typename?: 'Team', phone_number?: string | null, phone_forward?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, sms_sender?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, twitter_handle?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, external_token_present?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null } | null };

export type QLInvitationRejectMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLInvitationRejectMutation = { __typename?: 'Mutation', invitation_reject?: { __typename?: 'Invitation', id: string, email: string, token: string, role: QLUserRoleEnum, created_at: any } | null };

export type QLNoteTemplateCreateMutationVariables = Exact<{
  title: Scalars['String'];
  body: Scalars['String'];
}>;


export type QLNoteTemplateCreateMutation = { __typename?: 'Mutation', NoteTemplateCreate?: { __typename?: 'NoteTemplate', id: string, team_id?: string | null, title: string, body: string, created_at?: any | null, updated_at?: any | null } | null };

export type QLNoteTemplateUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  body: Scalars['String'];
}>;


export type QLNoteTemplateUpdateMutation = { __typename?: 'Mutation', NoteTemplateUpdate?: { __typename?: 'NoteTemplate', id: string, team_id?: string | null, title: string, body: string, created_at?: any | null, updated_at?: any | null } | null };

export type QLNoteTemplateDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLNoteTemplateDeleteMutation = { __typename?: 'Mutation', NoteTemplateDelete?: { __typename?: 'NoteTemplate', id: string, team_id?: string | null, title: string, body: string, created_at?: any | null, updated_at?: any | null } | null };

export type QLCreateNoteMutationVariables = Exact<{
  client_id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type QLCreateNoteMutation = { __typename?: 'Mutation', CreateNote?: { __typename?: 'ClientNote', id: string, archived_at?: any | null, created_at?: any | null, updated_at?: any | null, created_by_id?: string | null, note: string, note_model_id?: string | null, note_model_type?: string | null, team_id?: string | null, created_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null };

export type QLUpdateNoteMutationVariables = Exact<{
  id: Scalars['ID'];
  archived?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
}>;


export type QLUpdateNoteMutation = { __typename?: 'Mutation', UpdateNote?: { __typename?: 'ClientNote', id: string, archived_at?: any | null, created_at?: any | null, updated_at?: any | null, created_by_id?: string | null, note: string, note_model_id?: string | null, note_model_type?: string | null, team_id?: string | null, created_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null };

export type QLAnnouncementsUpdateReadMutationVariables = Exact<{ [key: string]: never; }>;


export type QLAnnouncementsUpdateReadMutation = { __typename?: 'Mutation', AnnouncementsUpdateRead?: { __typename?: 'User', id: string, last_read_announcements_at?: any | null } | null };

export type QLReadNotificationsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type QLReadNotificationsMutation = { __typename?: 'Mutation', ReadNotifications?: Array<{ __typename?: 'Notification', id: string, read: boolean } | null> | null };

export type QLExportClientsUnsubscribedMutationVariables = Exact<{
  medium: QLUnsubscribeMediumEnum;
}>;


export type QLExportClientsUnsubscribedMutation = { __typename?: 'Mutation', ExportClientsUnsubscribed?: { __typename?: 'ExportResult', status?: boolean | null } | null };

export type QLFitDegreeApiSetMutationVariables = Exact<{
  api_key: Scalars['String'];
}>;


export type QLFitDegreeApiSetMutation = { __typename?: 'Mutation', FitDegreeApiSet?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null };

export type QLMindBodyApiSetMutationVariables = Exact<{
  site_id: Scalars['String'];
}>;


export type QLMindBodyApiSetMutation = { __typename?: 'Mutation', MindBodyApiSet?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null };

export type QLMindBodyApiPrepareMutationVariables = Exact<{
  site_id?: InputMaybe<Scalars['String']>;
}>;


export type QLMindBodyApiPrepareMutation = { __typename?: 'Mutation', MindBodyApiPrepare?: { __typename?: 'MindBodyApiPrepareResult', authorization_link: string } | null };

export type QLPike13SetBusinessMutationVariables = Exact<{
  subdomain: Scalars['String'];
  id: Scalars['String'];
  timezone?: InputMaybe<Scalars['String']>;
}>;


export type QLPike13SetBusinessMutation = { __typename?: 'Mutation', Pike13SetBusiness?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null };

export type QLPike13GetBusinessesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLPike13GetBusinessesQuery = { __typename?: 'Query', Pike13GetBusinesses?: Array<{ __typename?: 'Pike13Business', id?: string | null, name?: string | null, subdomain?: string | null, timezone?: string | null } | null> | null };

export type QLPike13AuthUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type QLPike13AuthUrlQuery = { __typename?: 'Query', Pike13AuthUrl?: { __typename?: 'Pike13AuthLink', link: string } | null };

export type QLQuickResponseCreateMutationVariables = Exact<{
  title: Scalars['String'];
  content: Scalars['String'];
  team_id: Scalars['ID'];
}>;


export type QLQuickResponseCreateMutation = { __typename?: 'Mutation', QuickResponseCreate?: { __typename?: 'QuickResponse', id: string, team_id?: string | null, title: string, content: string, order: number } | null };

export type QLQuickResponseDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLQuickResponseDeleteMutation = { __typename?: 'Mutation', QuickResponseDelete?: { __typename?: 'QuickResponse', id: string, team_id?: string | null, title: string, content: string, order: number } | null };

export type QLQuickResponseUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  title: Scalars['String'];
  content: Scalars['String'];
}>;


export type QLQuickResponseUpdateMutation = { __typename?: 'Mutation', QuickResponseUpdate?: { __typename?: 'QuickResponse', id: string, team_id?: string | null, title: string, content: string, order: number } | null };

export type QLQuickResponseSaveOrderMutationVariables = Exact<{
  items: Array<QLQuickResponseOrderInput> | QLQuickResponseOrderInput;
}>;


export type QLQuickResponseSaveOrderMutation = { __typename?: 'Mutation', QuickResponseSaveOrder: Array<{ __typename?: 'QuickResponse', id: string, team_id?: string | null, title: string, content: string, order: number }> };

export type QLReorderSegmentMutationVariables = Exact<{
  id: Scalars['ID'];
  order: Scalars['Int'];
  archived: Scalars['Boolean'];
}>;


export type QLReorderSegmentMutation = { __typename?: 'Mutation', ReorderSegment?: { __typename?: 'Segment', id: string, name: string, order?: number | null, archived?: boolean | null, visible_dashboard?: boolean | null, is_event?: boolean | null } | null };

export type QLUpdateSegmentMutationVariables = Exact<{
  id: Scalars['ID'];
  data?: InputMaybe<QLSegmentInput>;
}>;


export type QLUpdateSegmentMutation = { __typename?: 'Mutation', UpdateSegment?: { __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null } | null };

export type QLCreateSegmentMutationVariables = Exact<{
  data?: InputMaybe<QLSegmentInput>;
}>;


export type QLCreateSegmentMutation = { __typename?: 'Mutation', CreateSegment?: { __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null } | null };

export type QLDeleteSegmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLDeleteSegmentMutation = { __typename?: 'Mutation', DeleteSegment?: { __typename?: 'Segment', id: string } | null };

export type QLCopySegmentMutationVariables = Exact<{
  id: Scalars['ID'];
  destination_team_id: Scalars['ID'];
}>;


export type QLCopySegmentMutation = { __typename?: 'Mutation', CopySegment?: { __typename?: 'Segment', id: string, name: string, order?: number | null, archived?: boolean | null, visible_dashboard?: boolean | null, is_event?: boolean | null } | null };

export type QLResetEventInsightSegmentOrdersMutationVariables = Exact<{
  first?: InputMaybe<Scalars['ID']>;
  second?: InputMaybe<Scalars['ID']>;
  third?: InputMaybe<Scalars['ID']>;
}>;


export type QLResetEventInsightSegmentOrdersMutation = { __typename?: 'Mutation', ResetEventInsightSegmentOrders?: Array<{ __typename?: 'Segment', id: string, name: string, order?: number | null, archived?: boolean | null, visible_dashboard?: boolean | null, is_event?: boolean | null } | null> | null };

export type QLSaveEventInsightSegmentsMutationVariables = Exact<{
  segments: Array<QLEventInsightSegmentInput> | QLEventInsightSegmentInput;
}>;


export type QLSaveEventInsightSegmentsMutation = { __typename?: 'Mutation', SaveEventInsightSegments: Array<{ __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null }> };

export type QLUpdateTeamMutationVariables = Exact<{
  input: QLUpdateTeamInput;
}>;


export type QLUpdateTeamMutation = { __typename?: 'Mutation', UpdateTeam?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null };

export type QLCreateTeamMutationVariables = Exact<{
  input: QLCreateTeamInput;
}>;


export type QLCreateTeamMutation = { __typename?: 'Mutation', CreateTeam?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null };

export type QLUpdateTeamProfileImageMutationVariables = Exact<{
  photo: Scalars['Upload'];
}>;


export type QLUpdateTeamProfileImageMutation = { __typename?: 'Mutation', UpdateTeamProfileImage?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null };

export type QLUpdateTeamLogoImageMutationVariables = Exact<{
  photo: Scalars['Upload'];
}>;


export type QLUpdateTeamLogoImageMutation = { __typename?: 'Mutation', UpdateTeamLogoImage?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null };

export type QLUpdateUserTeamGroupsMutationVariables = Exact<{
  id: Scalars['ID'];
  groups: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type QLUpdateUserTeamGroupsMutation = { __typename?: 'Mutation', UpdateUserTeamGroups?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null };

export type QLRoleChangeMutationVariables = Exact<{
  user_id: Scalars['ID'];
  role?: InputMaybe<QLUserRoleEnum>;
}>;


export type QLRoleChangeMutation = { __typename?: 'Mutation', RoleChange?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null };

export type QLCreateTodoMutationVariables = Exact<{
  client_id: Scalars['ID'];
  subject?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  priority_type?: InputMaybe<QLTodoPriority>;
  overdue_at?: InputMaybe<Scalars['Int']>;
  postponed_to?: InputMaybe<Scalars['Int']>;
  assigned_to_id?: InputMaybe<Scalars['ID']>;
  team_group_id?: InputMaybe<Scalars['ID']>;
}>;


export type QLCreateTodoMutation = { __typename?: 'Mutation', CreateTodo?: { __typename?: 'Todo', id: string, automation_id?: string | null, client_id?: string | null, completed_by_id?: string | null, created_by_id?: string | null, deleted_by_id?: string | null, assigned_to_id?: string | null, completed_action_note?: string | null, completed_action_type?: QLTodoCompletionTypeEnum | null, completed_at?: any | null, deleted_at?: any | null, postponed_to?: any | null, overdue_at?: any | null, updated_at?: any | null, created_at?: any | null, priority?: QLTodoPriority | null, is_closed?: boolean | null, is_deleted?: boolean | null, is_open?: boolean | null, is_postponed?: boolean | null, is_completed?: boolean | null, message?: string | null, subject?: string | null, client?: { __typename?: 'Client', team_id?: string | null, last_appointment_at?: any | null, last_attendance_at?: any | null, address_line?: string | null, address_city?: string | null, address_state?: string | null, address_postal_code?: string | null, address_country?: string | null, ltv?: number | null, created_at?: any | null, updated_at?: any | null, creation_date?: any | null, birthday?: any | null, note_generic?: string | null, note_yellow?: string | null, note_red?: string | null, twitter?: string | null, twitter_bio?: string | null, twitter_followers?: number | null, twitter_following?: number | null, linkedin?: string | null, linkedin_bio?: string | null, linkedin_followers?: number | null, linkedin_following?: number | null, facebook?: string | null, instagram?: string | null, instagram_bio?: string | null, instagram_followers?: number | null, instagram_following?: number | null, username?: string | null, email?: string | null, mobile_phone?: string | null, phone_home?: string | null, phone_work?: string | null, phone_work_ext?: string | null, referred_by?: string | null, bio?: string | null, job_title?: string | null, job_organization?: string | null, emergency_contact_info_name?: string | null, emergency_contact_info_relationship?: string | null, emergency_contact_info_phone?: string | null, emergency_contact_info_email?: string | null, active?: boolean | null, email_opt_in?: boolean | null, liability_release?: boolean | null, is_company?: boolean | null, promotional_email_opt_in?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, lead_signed_up_id?: string | null, mbo_member_status?: QLMboMemberStatus | null, email_opt_in_reminder_at?: any | null, id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, home_location?: { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, next_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, last_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, current_package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null, referrer?: { __typename?: 'ClientReferrer', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, location?: string | null } | null, education?: Array<{ __typename?: 'ClientEducation', name?: string | null, end_year?: number | null, degree?: string | null } | null> | null, mbo_index_values?: Array<{ __typename?: 'MboIndexValue', name: string, id: string, mbo_index?: { __typename?: 'MboIndex', name: string, id: string } | null } | null> | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, automation?: { __typename?: 'Automation', id: string, name: string } | null, completed_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, created_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, deleted_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, assigned_to?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, team_group?: { __typename?: 'TeamGroup', id: string, name: string } | null } | null };

export type QLEditTodoMutationVariables = Exact<{
  id: Scalars['ID'];
  subject?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  priority_type?: InputMaybe<QLTodoPriority>;
  overdue_at?: InputMaybe<Scalars['Int']>;
  postponed_to?: InputMaybe<Scalars['Int']>;
  assigned_to_id?: InputMaybe<Scalars['ID']>;
  team_group_id?: InputMaybe<Scalars['ID']>;
}>;


export type QLEditTodoMutation = { __typename?: 'Mutation', EditTodo?: { __typename?: 'Todo', id: string, automation_id?: string | null, client_id?: string | null, completed_by_id?: string | null, created_by_id?: string | null, deleted_by_id?: string | null, assigned_to_id?: string | null, completed_action_note?: string | null, completed_action_type?: QLTodoCompletionTypeEnum | null, completed_at?: any | null, deleted_at?: any | null, postponed_to?: any | null, overdue_at?: any | null, updated_at?: any | null, created_at?: any | null, priority?: QLTodoPriority | null, is_closed?: boolean | null, is_deleted?: boolean | null, is_open?: boolean | null, is_postponed?: boolean | null, is_completed?: boolean | null, message?: string | null, subject?: string | null, client?: { __typename?: 'Client', team_id?: string | null, last_appointment_at?: any | null, last_attendance_at?: any | null, address_line?: string | null, address_city?: string | null, address_state?: string | null, address_postal_code?: string | null, address_country?: string | null, ltv?: number | null, created_at?: any | null, updated_at?: any | null, creation_date?: any | null, birthday?: any | null, note_generic?: string | null, note_yellow?: string | null, note_red?: string | null, twitter?: string | null, twitter_bio?: string | null, twitter_followers?: number | null, twitter_following?: number | null, linkedin?: string | null, linkedin_bio?: string | null, linkedin_followers?: number | null, linkedin_following?: number | null, facebook?: string | null, instagram?: string | null, instagram_bio?: string | null, instagram_followers?: number | null, instagram_following?: number | null, username?: string | null, email?: string | null, mobile_phone?: string | null, phone_home?: string | null, phone_work?: string | null, phone_work_ext?: string | null, referred_by?: string | null, bio?: string | null, job_title?: string | null, job_organization?: string | null, emergency_contact_info_name?: string | null, emergency_contact_info_relationship?: string | null, emergency_contact_info_phone?: string | null, emergency_contact_info_email?: string | null, active?: boolean | null, email_opt_in?: boolean | null, liability_release?: boolean | null, is_company?: boolean | null, promotional_email_opt_in?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, lead_signed_up_id?: string | null, mbo_member_status?: QLMboMemberStatus | null, email_opt_in_reminder_at?: any | null, id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, home_location?: { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, next_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, last_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, current_package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null, referrer?: { __typename?: 'ClientReferrer', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, location?: string | null } | null, education?: Array<{ __typename?: 'ClientEducation', name?: string | null, end_year?: number | null, degree?: string | null } | null> | null, mbo_index_values?: Array<{ __typename?: 'MboIndexValue', name: string, id: string, mbo_index?: { __typename?: 'MboIndex', name: string, id: string } | null } | null> | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, automation?: { __typename?: 'Automation', id: string, name: string } | null, completed_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, created_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, deleted_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, assigned_to?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, team_group?: { __typename?: 'TeamGroup', id: string, name: string } | null } | null };

export type QLUpdateTodoMutationVariables = Exact<{
  id: Scalars['ID'];
  deleted?: InputMaybe<Scalars['Boolean']>;
  completed_action_type?: InputMaybe<QLTodoCompletionTypeEnum>;
  completed_action_note?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type QLUpdateTodoMutation = { __typename?: 'Mutation', UpdateTodo?: { __typename?: 'Todo', id: string, automation_id?: string | null, client_id?: string | null, completed_by_id?: string | null, created_by_id?: string | null, deleted_by_id?: string | null, assigned_to_id?: string | null, completed_action_note?: string | null, completed_action_type?: QLTodoCompletionTypeEnum | null, completed_at?: any | null, deleted_at?: any | null, postponed_to?: any | null, overdue_at?: any | null, updated_at?: any | null, created_at?: any | null, priority?: QLTodoPriority | null, is_closed?: boolean | null, is_deleted?: boolean | null, is_open?: boolean | null, is_postponed?: boolean | null, is_completed?: boolean | null, message?: string | null, subject?: string | null, client?: { __typename?: 'Client', team_id?: string | null, last_appointment_at?: any | null, last_attendance_at?: any | null, address_line?: string | null, address_city?: string | null, address_state?: string | null, address_postal_code?: string | null, address_country?: string | null, ltv?: number | null, created_at?: any | null, updated_at?: any | null, creation_date?: any | null, birthday?: any | null, note_generic?: string | null, note_yellow?: string | null, note_red?: string | null, twitter?: string | null, twitter_bio?: string | null, twitter_followers?: number | null, twitter_following?: number | null, linkedin?: string | null, linkedin_bio?: string | null, linkedin_followers?: number | null, linkedin_following?: number | null, facebook?: string | null, instagram?: string | null, instagram_bio?: string | null, instagram_followers?: number | null, instagram_following?: number | null, username?: string | null, email?: string | null, mobile_phone?: string | null, phone_home?: string | null, phone_work?: string | null, phone_work_ext?: string | null, referred_by?: string | null, bio?: string | null, job_title?: string | null, job_organization?: string | null, emergency_contact_info_name?: string | null, emergency_contact_info_relationship?: string | null, emergency_contact_info_phone?: string | null, emergency_contact_info_email?: string | null, active?: boolean | null, email_opt_in?: boolean | null, liability_release?: boolean | null, is_company?: boolean | null, promotional_email_opt_in?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, lead_signed_up_id?: string | null, mbo_member_status?: QLMboMemberStatus | null, email_opt_in_reminder_at?: any | null, id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, home_location?: { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, next_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, last_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, current_package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null, referrer?: { __typename?: 'ClientReferrer', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, location?: string | null } | null, education?: Array<{ __typename?: 'ClientEducation', name?: string | null, end_year?: number | null, degree?: string | null } | null> | null, mbo_index_values?: Array<{ __typename?: 'MboIndexValue', name: string, id: string, mbo_index?: { __typename?: 'MboIndex', name: string, id: string } | null } | null> | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, automation?: { __typename?: 'Automation', id: string, name: string } | null, completed_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, created_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, deleted_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, assigned_to?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, team_group?: { __typename?: 'TeamGroup', id: string, name: string } | null } | null };

export type QLBulkUpdateTodosMutationVariables = Exact<{
  automation_id?: InputMaybe<Scalars['ID']>;
  home_location_id?: InputMaybe<Scalars['ID']>;
  closed?: InputMaybe<Scalars['Boolean']>;
  manual?: InputMaybe<Scalars['Boolean']>;
  open?: InputMaybe<Scalars['Boolean']>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  scheduled?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['ID']>;
  assigned_to_id?: InputMaybe<Scalars['ID']>;
  team_group_id?: InputMaybe<Scalars['ID']>;
  action: Scalars['String'];
  created_after?: InputMaybe<Scalars['String']>;
  created_before?: InputMaybe<Scalars['String']>;
  overdue_after?: InputMaybe<Scalars['String']>;
  overdue_before?: InputMaybe<Scalars['String']>;
}>;


export type QLBulkUpdateTodosMutation = { __typename?: 'Mutation', BulkUpdateTodos?: { __typename?: 'SimpleResponse', ok?: boolean | null } | null };

export type QLChangePasswordMutationVariables = Exact<{
  input: QLChangePasswordInput;
}>;


export type QLChangePasswordMutation = { __typename?: 'Mutation', ChangePassword: { __typename?: 'SimpleResponse', ok?: boolean | null } };

export type QLUpdateUserMutationVariables = Exact<{
  input: QLUpdateUserInput;
}>;


export type QLUpdateUserMutation = { __typename?: 'Mutation', UpdateUser?: { __typename?: 'User', email?: string | null, id: string, name?: string | null, photo_url?: string | null } | null };

export type QLSwitchTeamMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLSwitchTeamMutation = { __typename?: 'Mutation', SwitchTeam?: { __typename?: 'Team', id: string } | null };

export type QLLeaveTeamMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLLeaveTeamMutation = { __typename?: 'Mutation', LeaveTeam?: { __typename?: 'User', email?: string | null, current_team_id?: string | null, last_read_announcements_at?: any | null, id: string, name?: string | null, photo_url?: string | null, current_team?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null, policy?: { __typename?: 'UserPolicy', role?: QLUserRoleEnum | null, add_tags?: boolean | null, is_owner?: boolean | null, is_manager?: boolean | null, is_admin?: boolean | null, is_main_owner?: boolean | null, edit_automations?: boolean | null, create_automations?: boolean | null, edit_forms?: boolean | null, create_forms?: boolean | null, export_clients?: boolean | null, staff_invite?: boolean | null, staff_change?: boolean | null, staff_remove?: boolean | null, create_email_templates?: boolean | null, edit_email_templates?: boolean | null, view_email_templates?: boolean | null, send_messages?: boolean | null } | null, permissions?: Array<{ __typename?: 'UserPermission', name?: string | null } | null> | null, teams?: Array<{ __typename?: 'Team', role?: QLUserRoleEnum | null, phone_number?: string | null, phone_forward?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, sms_sender?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, twitter_handle?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, external_token_present?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null } | null> | null } | null };

export type QLUpdateNotificationTokenMutationVariables = Exact<{
  token: Scalars['String'];
  device?: InputMaybe<Scalars['String']>;
  serial?: InputMaybe<Scalars['String']>;
}>;


export type QLUpdateNotificationTokenMutation = { __typename?: 'Mutation', UpdateNotificationToken?: { __typename?: 'NotificationToken', token: string } | null };

export type QLUpdateVirtualClassInfoMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  virtual_url: Scalars['String'];
  day_of_week?: InputMaybe<Scalars['Int']>;
  start_time?: InputMaybe<Scalars['Int']>;
  virtual_data?: InputMaybe<QLClassVirtualDataInput>;
}>;


export type QLUpdateVirtualClassInfoMutation = { __typename?: 'Mutation', UpdateVirtualClassInfo?: { __typename?: 'VirtualClassInfo', id: string, name?: string | null, day_of_week?: number | null, start_time?: number | null, virtual_url?: string | null, virtual_data?: { __typename?: 'ClassVirtualData', virtual_id?: string | null, virtual_password?: string | null, virtual_info?: string | null } | null } | null };

export type QLCreateVirtualClassInfoMutationVariables = Exact<{
  name: Scalars['String'];
  virtual_url: Scalars['String'];
  day_of_week?: InputMaybe<Scalars['Int']>;
  start_time?: InputMaybe<Scalars['Int']>;
  virtual_data?: InputMaybe<QLClassVirtualDataInput>;
}>;


export type QLCreateVirtualClassInfoMutation = { __typename?: 'Mutation', CreateVirtualClassInfo?: { __typename?: 'VirtualClassInfo', id: string, name?: string | null, day_of_week?: number | null, start_time?: number | null, virtual_url?: string | null, virtual_data?: { __typename?: 'ClassVirtualData', virtual_id?: string | null, virtual_password?: string | null, virtual_info?: string | null } | null } | null };

export type QLDeleteVirtualClassInfoMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLDeleteVirtualClassInfoMutation = { __typename?: 'Mutation', DeleteVirtualClassInfo?: { __typename?: 'VirtualClassInfo', id: string, name?: string | null, day_of_week?: number | null, start_time?: number | null, virtual_url?: string | null, virtual_data?: { __typename?: 'ClassVirtualData', virtual_id?: string | null, virtual_password?: string | null, virtual_info?: string | null } | null } | null };

export type QLCreateZapierTokenMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type QLCreateZapierTokenMutation = { __typename?: 'Mutation', CreateZapierToken?: { __typename?: 'AccessToken', id: string, name?: string | null, created_at?: any | null, plain_token?: string | null } | null };

export type QLDeleteZapierTokenMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLDeleteZapierTokenMutation = { __typename?: 'Mutation', DeleteZapierToken?: { __typename?: 'SimpleResponse', ok?: boolean | null } | null };

export type QLFragmentSmallAutomationFragment = { __typename?: 'Automation', id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null };

export type QLFragmentFullAutomationFragment = { __typename?: 'Automation', send_window_end_minutes?: number | null, send_window_start_minutes?: number | null, content?: string | null, reply_to?: string | null, subject?: string | null, tags?: Array<string | null> | null, tags_add?: boolean | null, todo_overdue_hours?: number | null, todo_postponed_hours?: number | null, todo_priority?: QLTodoPriority | null, todo_tags?: Array<string | null> | null, todo_assigned_to_id?: string | null, todo_team_group_id?: string | null, created_at?: any | null, id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null, email_content?: { __typename?: 'EmailTemplateContent', html?: string | null, json?: any | null } | null, todo_assigned_to?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, todo_team_group?: { __typename?: 'TeamGroup', id: string, name: string } | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, segment?: { __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null } | null };

export type QLFragmentAutomationIndexFragment = { __typename?: 'Automation', tags_add?: boolean | null, id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, segment?: { __typename?: 'Segment', id: string, name: string } | null };

export type QLAutomationsQuickListQueryVariables = Exact<{ [key: string]: never; }>;


export type QLAutomationsQuickListQuery = { __typename?: 'Query', automations: Array<{ __typename?: 'Automation', id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null }> };

export type QLAutomationsIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type QLAutomationsIndexQuery = { __typename?: 'Query', automations_index: Array<{ __typename?: 'Automation', tags_add?: boolean | null, id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, segment?: { __typename?: 'Segment', id: string, name: string } | null }> };

export type QLAutomationCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLAutomationCategoriesQuery = { __typename?: 'Query', automation_categories: Array<{ __typename?: 'AutomationCategory', name?: string | null }> };

export type QLAutomationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLAutomationQuery = { __typename?: 'Query', automation?: { __typename?: 'Automation', send_window_end_minutes?: number | null, send_window_start_minutes?: number | null, content?: string | null, reply_to?: string | null, subject?: string | null, tags?: Array<string | null> | null, tags_add?: boolean | null, todo_overdue_hours?: number | null, todo_postponed_hours?: number | null, todo_priority?: QLTodoPriority | null, todo_tags?: Array<string | null> | null, todo_assigned_to_id?: string | null, todo_team_group_id?: string | null, created_at?: any | null, id: string, name: string, active?: boolean | null, archived?: boolean | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, disabled?: boolean | null, one_off?: boolean | null, start_at?: any | null, category_name?: string | null, description?: string | null, order?: number | null, ever_ran?: boolean | null, email_content?: { __typename?: 'EmailTemplateContent', html?: string | null, json?: any | null } | null, todo_assigned_to?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, todo_team_group?: { __typename?: 'TeamGroup', id: string, name: string } | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, segment?: { __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null } | null } | null };

export type QLFragmentAutomationStatsEmailOrSmsFragment = { __typename?: 'AutomationStatsEmailOrSms', sent?: number | null, bounced?: number | null, delivered?: number | null, opened?: number | null, clicked?: number | null };

export type QLFragmentAutomationStatsTodoFragment = { __typename?: 'AutomationStatsTodo', created?: number | null, completed?: number | null, open?: number | null, postponed?: number | null, deleted?: number | null };

export type QLFragmentAutomationActionTagsFragment = { __typename?: 'AutomationAction', id: string, action?: string | null, created_at?: any | null, affected?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, related?: { __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null };

export type QLFragmentAutomationStatsTagFragment = { __typename?: 'AutomationStatsTag', created?: number | null };

export type QLAutomationStatEmailOrSmsQueryVariables = Exact<{
  input: QLAutomationStatInput;
}>;


export type QLAutomationStatEmailOrSmsQuery = { __typename?: 'Query', automation_stat_email_or_sms?: { __typename?: 'AutomationStatsEmailOrSms', sent?: number | null, bounced?: number | null, delivered?: number | null, opened?: number | null, clicked?: number | null } | null };

export type QLAutomationStatTodoQueryVariables = Exact<{
  input: QLAutomationStatInput;
}>;


export type QLAutomationStatTodoQuery = { __typename?: 'Query', automation_stat_todo?: { __typename?: 'AutomationStatsTodo', created?: number | null, completed?: number | null, open?: number | null, postponed?: number | null, deleted?: number | null } | null };

export type QLAutomationStatTagQueryVariables = Exact<{
  input: QLAutomationStatInput;
}>;


export type QLAutomationStatTagQuery = { __typename?: 'Query', automation_stat_tag?: { __typename?: 'AutomationStatsTag', created?: number | null } | null };

export type QLAutomationActionsQueryVariables = Exact<{
  id: Scalars['ID'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
  page: Scalars['Int'];
  first: Scalars['Int'];
}>;


export type QLAutomationActionsQuery = { __typename?: 'Query', automation_actions: { __typename?: 'AutomationActionPaginator', data: Array<{ __typename?: 'AutomationAction', id: string, action?: string | null, created_at?: any | null, affected?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, related?: { __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLFragmentPlanFragment = { __typename?: 'Plan', id: string, name: string, price: number, trial_days?: number | null, active: boolean, interval?: QLPlanInterval | null, addon?: boolean | null, addon_type?: string | null };

export type QLFragmentTeamSubscriptionItemFragment = { __typename?: 'TeamSubscriptionItem', name?: string | null, quantity?: number | null, plan?: { __typename?: 'Plan', id: string, name: string, price: number, trial_days?: number | null, active: boolean, interval?: QLPlanInterval | null, addon?: boolean | null, addon_type?: string | null } | null };

export type QLFragmentTeamSubscriptionFragment = { __typename?: 'TeamSubscription', quantity?: number | null, trial_ends_at?: any | null, ends_at?: any | null, status?: QLSubscriptionStatus | null, items?: Array<{ __typename?: 'TeamSubscriptionItem', name?: string | null, quantity?: number | null, plan?: { __typename?: 'Plan', id: string, name: string, price: number, trial_days?: number | null, active: boolean, interval?: QLPlanInterval | null, addon?: boolean | null, addon_type?: string | null } | null } | null> | null };

export type QLMySubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type QLMySubscriptionQuery = { __typename?: 'Query', my_subscription?: { __typename?: 'TeamSubscription', quantity?: number | null, trial_ends_at?: any | null, ends_at?: any | null, status?: QLSubscriptionStatus | null, items?: Array<{ __typename?: 'TeamSubscriptionItem', name?: string | null, quantity?: number | null, plan?: { __typename?: 'Plan', id: string, name: string, price: number, trial_days?: number | null, active: boolean, interval?: QLPlanInterval | null, addon?: boolean | null, addon_type?: string | null } | null } | null> | null } | null };

export type QLPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type QLPlansQuery = { __typename?: 'Query', plans?: Array<{ __typename?: 'Plan', id: string, name: string, price: number, trial_days?: number | null, active: boolean, interval?: QLPlanInterval | null, addon?: boolean | null, addon_type?: string | null } | null> | null };

export type QLAddonsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLAddonsQuery = { __typename?: 'Query', addons?: Array<{ __typename?: 'Plan', id: string, name: string, price: number, trial_days?: number | null, active: boolean, interval?: QLPlanInterval | null, addon?: boolean | null, addon_type?: string | null } | null> | null };

export type QLFragmentInvoiceFragment = { __typename?: 'Invoice', id?: string | null, date?: any | null, total?: number | null };

export type QLInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLInvoicesQuery = { __typename?: 'Query', invoices?: Array<{ __typename?: 'Invoice', id?: string | null, date?: any | null, total?: number | null } | null> | null };

export type QLCatalogItemIndexFragment = { __typename?: 'CatalogItem', id: string, name: string, description: string, category?: string | null };

export type QLCatalogItemVariableFragmentFragment = { __typename?: 'CatalogItemVariable', id: string, field_type: QLOperatorTypeEnum, field_name: string, field_description: string };

export type QLCatalogItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLCatalogItemsQuery = { __typename?: 'Query', catalog_items: Array<{ __typename?: 'CatalogItem', id: string, name: string, description: string, category?: string | null }> };

export type QLCatalogItemSingleFragmentFragment = { __typename?: 'CatalogItem', long_description: string, id: string, name: string, description: string, category?: string | null, automation?: { __typename?: 'CatalogAutomation', name?: string | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, todo_assigned_to_id?: string | null } | null, variable_fields?: Array<{ __typename?: 'CatalogItemVariable', id: string, field_type: QLOperatorTypeEnum, field_name: string, field_description: string }> | null };

export type QLCatalogItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLCatalogItemQuery = { __typename?: 'Query', catalog_item?: { __typename?: 'CatalogItem', long_description: string, id: string, name: string, description: string, category?: string | null, automation?: { __typename?: 'CatalogAutomation', name?: string | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, todo_assigned_to_id?: string | null } | null, variable_fields?: Array<{ __typename?: 'CatalogItemVariable', id: string, field_type: QLOperatorTypeEnum, field_name: string, field_description: string }> | null } | null };

export type QLCatalogItemFullFragmentFragment = { __typename?: 'CatalogItem', long_description: string, id: string, name: string, description: string, category?: string | null, automation?: { __typename?: 'CatalogAutomation', name?: string | null, category_name?: string | null, description?: string | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, one_off?: boolean | null, start_at?: any | null, send_window_end_minutes?: number | null, send_window_start_minutes?: number | null, content?: string | null, reply_to?: string | null, subject?: string | null, tags?: Array<string | null> | null, tags_add?: boolean | null, todo_overdue_hours?: number | null, todo_postponed_hours?: number | null, todo_priority?: QLTodoPriority | null, todo_tags?: Array<string | null> | null, todo_assigned_to_id?: string | null, todo_team_group_id?: string | null, email_content?: { __typename?: 'EmailTemplateContent', html?: string | null, json?: any | null } | null, segment: { __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null } } | null, variable_fields?: Array<{ __typename?: 'CatalogItemVariable', id: string, field_type: QLOperatorTypeEnum, field_name: string, field_description: string }> | null };

export type QLCatalogItemFullQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLCatalogItemFullQuery = { __typename?: 'Query', catalog_item?: { __typename?: 'CatalogItem', long_description: string, id: string, name: string, description: string, category?: string | null, automation?: { __typename?: 'CatalogAutomation', name?: string | null, category_name?: string | null, description?: string | null, delivery_type?: QLAutomationDeliveryTypeEnum | null, one_off?: boolean | null, start_at?: any | null, send_window_end_minutes?: number | null, send_window_start_minutes?: number | null, content?: string | null, reply_to?: string | null, subject?: string | null, tags?: Array<string | null> | null, tags_add?: boolean | null, todo_overdue_hours?: number | null, todo_postponed_hours?: number | null, todo_priority?: QLTodoPriority | null, todo_tags?: Array<string | null> | null, todo_assigned_to_id?: string | null, todo_team_group_id?: string | null, email_content?: { __typename?: 'EmailTemplateContent', html?: string | null, json?: any | null } | null, segment: { __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null } } | null, variable_fields?: Array<{ __typename?: 'CatalogItemVariable', id: string, field_type: QLOperatorTypeEnum, field_name: string, field_description: string }> | null } | null };

export type QLFragmentClassSmallFragment = { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null };

export type QLFragmentClassFullFragment = { __typename?: 'ClassModel', virtual_url?: string | null, location_id?: string | null, staff_id?: string | null, id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null, virtual_data?: { __typename?: 'ClassVirtualData', virtual_id?: string | null, virtual_password?: string | null, virtual_info?: string | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null, staff?: { __typename?: 'Staff', id: string, first_name?: string | null, last_name?: string | null, name?: string | null } | null };

export type QLEventNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLEventNamesQuery = { __typename?: 'Query', event_names?: Array<{ __typename?: 'ClassName', name?: string | null } | null> | null };

export type QLClassNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLClassNamesQuery = { __typename?: 'Query', class_names?: Array<{ __typename?: 'ClassName', name?: string | null } | null> | null };

export type QLAppointmentNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLAppointmentNamesQuery = { __typename?: 'Query', appointment_names?: Array<{ __typename?: 'AppointmentName', name?: string | null } | null> | null };

export type QLFragmentExcludedEventNameFragment = { __typename?: 'ExcludedEventName', id: string, name?: string | null };

export type QLExcludedEventNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLExcludedEventNamesQuery = { __typename?: 'Query', excluded_event_names: Array<{ __typename?: 'ExcludedEventName', id: string, name?: string | null }> };

export type QLCalendarClassFragmentFragment = { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null, visits?: Array<{ __typename?: 'Visit', id: string, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null } | null> | null };

export type QLCalendarQueryVariables = Exact<{
  location_id: Scalars['ID'];
  before?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Int']>;
}>;


export type QLCalendarQuery = { __typename?: 'Query', calendar: Array<{ __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null, visits?: Array<{ __typename?: 'Visit', id: string, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null } | null> | null }> };

export type QLClientsTodayQueryVariables = Exact<{
  location_id: Scalars['ID'];
}>;


export type QLClientsTodayQuery = { __typename?: 'Query', clients_today?: { __typename?: 'SimpleDataBoxValue', value?: number | null } | null };

export type QLClientsTodayFirstQueryVariables = Exact<{
  location_id: Scalars['ID'];
}>;


export type QLClientsTodayFirstQuery = { __typename?: 'Query', clients_today_first?: { __typename?: 'SimpleDataBoxValue', value?: number | null } | null };

export type QLNextClassFragmentFragment = { __typename?: 'ClassModel', staff_id?: string | null, id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null, staff?: { __typename?: 'Staff', id: string, first_name?: string | null, last_name?: string | null, name?: string | null } | null, visits?: Array<{ __typename?: 'Visit', id: string, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null } | null> | null };

export type QLNextClassQueryVariables = Exact<{
  location_id?: InputMaybe<Scalars['ID']>;
}>;


export type QLNextClassQuery = { __typename?: 'Query', next_class?: { __typename?: 'ClassModel', staff_id?: string | null, id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null, staff?: { __typename?: 'Staff', id: string, first_name?: string | null, last_name?: string | null, name?: string | null } | null, visits?: Array<{ __typename?: 'Visit', id: string, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null } | null> | null } | null };

export type QLSingleClassFragmentFragment = { __typename?: 'ClassModel', virtual_url?: string | null, location_id?: string | null, staff_id?: string | null, id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null, staff?: { __typename?: 'Staff', country?: string | null, email?: string | null, external_id?: string | null, ismale?: boolean | null, mobile_phone?: string | null, state?: string | null, id: string, first_name?: string | null, last_name?: string | null, name?: string | null } | null, visits?: Array<{ __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null } | null> | null, virtual_data?: { __typename?: 'ClassVirtualData', virtual_id?: string | null, virtual_password?: string | null, virtual_info?: string | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null };

export type QLSingleClassQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLSingleClassQuery = { __typename?: 'Query', single_class?: { __typename?: 'ClassModel', virtual_url?: string | null, location_id?: string | null, staff_id?: string | null, id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null, staff?: { __typename?: 'Staff', country?: string | null, email?: string | null, external_id?: string | null, ismale?: boolean | null, mobile_phone?: string | null, state?: string | null, id: string, first_name?: string | null, last_name?: string | null, name?: string | null } | null, visits?: Array<{ __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null } | null> | null, virtual_data?: { __typename?: 'ClassVirtualData', virtual_id?: string | null, virtual_password?: string | null, virtual_info?: string | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null } | null };

export type QLCalendarUpdateSingleClassQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLCalendarUpdateSingleClassQuery = { __typename?: 'Query', calendar_update_single_class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null, visits?: Array<{ __typename?: 'Visit', id: string, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null } | null> | null } | null };

export type QLClientMuteHistoryQueryVariables = Exact<{
  client_id: Scalars['ID'];
}>;


export type QLClientMuteHistoryQuery = { __typename?: 'Query', clientMuteHistory: { __typename?: 'ClientMuteHistoryPayload', success: boolean, mutes: Array<{ __typename?: 'TemporaryMute', id: string, client_id: string, muted_until?: any | null, muted_at?: any | null, unmuted_at?: any | null, muted_by?: { __typename?: 'User', id: string, name?: string | null } | null, unmuted_by?: { __typename?: 'User', id: string, name?: string | null } | null }> } };

export type QLCurrentlyMutedClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLCurrentlyMutedClientsQuery = { __typename?: 'Query', currentlyMutedClients: { __typename?: 'CurrentlyMutedClientsPayload', success: boolean, mutes: Array<{ __typename?: 'TemporaryMute', id: string, client_id: string, muted_until?: any | null, muted_at?: any | null, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, mobile_phone?: string | null } | null, muted_by?: { __typename?: 'User', id: string, name?: string | null } | null }> } };

export type QLClientSingleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLClientSingleQuery = { __typename?: 'Query', client?: { __typename?: 'Client', team_id?: string | null, last_appointment_at?: any | null, last_attendance_at?: any | null, address_line?: string | null, address_city?: string | null, address_state?: string | null, address_postal_code?: string | null, address_country?: string | null, ltv?: number | null, created_at?: any | null, updated_at?: any | null, creation_date?: any | null, birthday?: any | null, note_generic?: string | null, note_yellow?: string | null, note_red?: string | null, twitter?: string | null, twitter_bio?: string | null, twitter_followers?: number | null, twitter_following?: number | null, linkedin?: string | null, linkedin_bio?: string | null, linkedin_followers?: number | null, linkedin_following?: number | null, facebook?: string | null, instagram?: string | null, instagram_bio?: string | null, instagram_followers?: number | null, instagram_following?: number | null, username?: string | null, email?: string | null, mobile_phone?: string | null, phone_home?: string | null, phone_work?: string | null, phone_work_ext?: string | null, referred_by?: string | null, bio?: string | null, job_title?: string | null, job_organization?: string | null, emergency_contact_info_name?: string | null, emergency_contact_info_relationship?: string | null, emergency_contact_info_phone?: string | null, emergency_contact_info_email?: string | null, active?: boolean | null, email_opt_in?: boolean | null, liability_release?: boolean | null, is_company?: boolean | null, promotional_email_opt_in?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, lead_signed_up_id?: string | null, mbo_member_status?: QLMboMemberStatus | null, email_opt_in_reminder_at?: any | null, id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, referrer?: { __typename?: 'ClientReferrer', email?: string | null, last_name?: string | null, first_name?: string | null, location?: string | null, phone?: string | null } | null, mutes?: Array<{ __typename?: 'TemporaryMute', id: string, muted_at?: any | null, muted_until?: any | null, unmuted_at?: any | null, muted_by?: { __typename?: 'User', id: string, name?: string | null } | null, unmuted_by?: { __typename?: 'User', id: string, name?: string | null } | null } | null> | null, home_location?: { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, next_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, last_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, current_package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null, education?: Array<{ __typename?: 'ClientEducation', name?: string | null, end_year?: number | null, degree?: string | null } | null> | null, mbo_index_values?: Array<{ __typename?: 'MboIndexValue', name: string, id: string, mbo_index?: { __typename?: 'MboIndex', name: string, id: string } | null } | null> | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null };

export type QLClientClassTypeQueryVariables = Exact<{
  client_id: Scalars['ID'];
}>;


export type QLClientClassTypeQuery = { __typename?: 'Query', client_class_types?: Array<{ __typename?: 'ClientClassType', name: string, cc?: number | null } | null> | null };

export type QLClientClassTimesQueryVariables = Exact<{
  client_id: Scalars['ID'];
}>;


export type QLClientClassTimesQuery = { __typename?: 'Query', client_class_times?: Array<{ __typename?: 'ClientStartTime', start_minutes: number, cc?: number | null } | null> | null };

export type QLSalesQueryVariables = Exact<{
  client_id: Scalars['ID'];
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
}>;


export type QLSalesQuery = { __typename?: 'Query', sales: { __typename?: 'SalePaginator', data: Array<{ __typename?: 'Sale', id: string, client_id?: string | null, team_id?: string | null, sold_at?: any | null, price?: number | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLClientSalesQueryVariables = Exact<{
  client_id: Scalars['ID'];
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
}>;


export type QLClientSalesQuery = { __typename?: 'Query', sales: { __typename?: 'SalePaginator', data: Array<{ __typename?: 'Sale', id: string, sold_at?: any | null, price?: number | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLClientVisitsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  filter: QLClientVisitFilterEnum;
  type?: InputMaybe<QLClassType>;
  page?: InputMaybe<Scalars['Int']>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
}>;


export type QLClientVisitsQuery = { __typename?: 'Query', client_visits: { __typename?: 'VisitPaginator', data: Array<{ __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', virtual_url?: string | null, location_id?: string | null, staff_id?: string | null, id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null, virtual_data?: { __typename?: 'ClassVirtualData', virtual_id?: string | null, virtual_password?: string | null, virtual_info?: string | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null, staff?: { __typename?: 'Staff', id: string, first_name?: string | null, last_name?: string | null, name?: string | null } | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLClientProductsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
}>;


export type QLClientProductsQuery = { __typename?: 'Query', client_products: { __typename?: 'ClientProductPaginator', data: Array<{ __typename?: 'ClientProduct', sold_at?: any | null, sale?: { __typename?: 'Sale', id: string, sold_at?: any | null, price?: number | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLClientPackagesQueryVariables = Exact<{
  client_id: Scalars['ID'];
  status?: InputMaybe<QLPackageStatus>;
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
}>;


export type QLClientPackagesQuery = { __typename?: 'Query', packages: { __typename?: 'PackagePaginator', data: Array<{ __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLClientContractsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  status?: InputMaybe<QLContractStatus>;
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
}>;


export type QLClientContractsQuery = { __typename?: 'Query', contracts: { __typename?: 'ContractPaginator', data: Array<{ __typename?: 'Contract', id: string, client_id?: string | null, team_id?: string | null, price?: number | null, agreement_date?: any | null, end_date?: any | null, start_date?: any | null, status?: string | null, name?: string | null, is_active?: boolean | null, is_inactive?: boolean | null, is_suspended?: boolean | null, external_id?: string | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLClientStatsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLClientStatsQuery = { __typename?: 'Query', client_stats?: { __typename?: 'ClientStats', upcoming_events?: number | null } | null };

export type QLClientEngagementStatsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLClientEngagementStatsQuery = { __typename?: 'Query', client_engagement_stats?: { __typename?: 'ClientStats', total_engagements?: number | null, engagements_stats?: { __typename?: 'ClientEngagementStats', sms?: { __typename?: 'ClientEngagementDetailStats', total?: number | null, sent?: number | null, delivered?: number | null, bounced?: number | null, opened?: number | null, clicked?: number | null } | null, email?: { __typename?: 'ClientEngagementDetailStats', total?: number | null, sent?: number | null, delivered?: number | null, bounced?: number | null, opened?: number | null, clicked?: number | null } | null } | null } | null };

export type QLClientEngagementsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
}>;


export type QLClientEngagementsQuery = { __typename?: 'Query', client_engagements: { __typename?: 'DiscussionPaginator', data: Array<{ __typename?: 'Discussion', id: string, subject?: string | null, team_has_responded?: boolean | null, sms?: boolean | null, email?: boolean | null, closed?: boolean | null, sent?: boolean | null, bounced?: boolean | null, delivered?: boolean | null, opened?: boolean | null, clicked?: boolean | null, team_id?: string | null, client_id?: string | null, automation_id?: string | null, last_contacted_at?: any | null, created_at?: any | null, updated_at?: any | null, automation?: { __typename?: 'Automation', id: string, name: string, delivery_type?: QLAutomationDeliveryTypeEnum | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLClientEngagementsTimelineQueryVariables = Exact<{
  client_id: Scalars['ID'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
}>;


export type QLClientEngagementsTimelineQuery = { __typename?: 'Query', client_engagements_timeline: { __typename?: 'DiscussionPaginator', data: Array<{ __typename?: 'Discussion', created_at?: any | null, sms?: boolean | null, automation?: { __typename?: 'Automation', name: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLClientDiscussionsQueryVariables = Exact<{
  client_id: Scalars['ID'];
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
}>;


export type QLClientDiscussionsQuery = { __typename?: 'Query', discussions: { __typename?: 'DiscussionPaginator', data: Array<{ __typename?: 'Discussion', id: string, subject?: string | null, team_has_responded?: boolean | null, sms?: boolean | null, email?: boolean | null, closed?: boolean | null, sent?: boolean | null, bounced?: boolean | null, delivered?: boolean | null, opened?: boolean | null, clicked?: boolean | null, team_id?: string | null, client_id?: string | null, automation_id?: string | null, last_contacted_at?: any | null, created_at?: any | null, updated_at?: any | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, automation?: { __typename?: 'Automation', id: string, name: string, delivery_type?: QLAutomationDeliveryTypeEnum | null } | null, last_message?: { __typename?: 'Message', id: string, user_id?: string | null, automation_id?: string | null, from_client?: boolean | null, bounced?: boolean | null, sent?: boolean | null, delivered?: boolean | null, clicked?: boolean | null, opened?: boolean | null, subject?: string | null, message?: string | null, created_at?: any | null, error_code?: QLMessageErrorType | null, user?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLClientsSearchQueryVariables = Exact<{
  search: Scalars['String'];
  first: Scalars['Int'];
  onlyContactableViaEmail?: InputMaybe<Scalars['Boolean']>;
  onlyContactableViaSms?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type QLClientsSearchQuery = { __typename?: 'Query', clients_search: { __typename?: 'ClientPaginator', data: Array<{ __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLClientTodosQueryVariables = Exact<{
  client_id?: InputMaybe<Scalars['ID']>;
  open?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type QLClientTodosQuery = { __typename?: 'Query', todos: { __typename?: 'TodoPaginator', data: Array<{ __typename?: 'Todo', id: string, automation_id?: string | null, client_id?: string | null, completed_by_id?: string | null, created_by_id?: string | null, deleted_by_id?: string | null, assigned_to_id?: string | null, completed_action_note?: string | null, completed_action_type?: QLTodoCompletionTypeEnum | null, completed_at?: any | null, deleted_at?: any | null, postponed_to?: any | null, overdue_at?: any | null, updated_at?: any | null, created_at?: any | null, priority?: QLTodoPriority | null, is_closed?: boolean | null, is_deleted?: boolean | null, is_open?: boolean | null, is_postponed?: boolean | null, is_completed?: boolean | null, message?: string | null, subject?: string | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, automation?: { __typename?: 'Automation', id: string, name: string } | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, completed_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, created_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, deleted_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, assigned_to?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, team_group?: { __typename?: 'TeamGroup', id: string, name: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLFragmentClientIndexListFragment = { __typename?: 'Client', last_attendance_at?: any | null, id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, current_package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null, last_discussion?: { __typename?: 'Discussion', id: string, last_contacted_at?: any | null } | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null };

export type QLClientsListIndexQueryVariables = Exact<{
  segment: QLSegmentInput;
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy: Array<QLOrderByClause> | QLOrderByClause;
}>;


export type QLClientsListIndexQuery = { __typename?: 'Query', clients_list_index: { __typename?: 'ClientPaginator', data: Array<{ __typename?: 'Client', last_attendance_at?: any | null, id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, current_package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null, last_discussion?: { __typename?: 'Discussion', id: string, last_contacted_at?: any | null } | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLClientsListDashboardQueryVariables = Exact<{
  segment: QLSegmentInput;
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy: Array<QLOrderByClause> | QLOrderByClause;
}>;


export type QLClientsListDashboardQuery = { __typename?: 'Query', clients_list_dashboard: { __typename?: 'ClientPaginator', data: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, lead_completed?: boolean | null, total_club_counts?: number | null, total_period_counts?: number | null, mobile_phone?: string | null, last_attendance_at?: any | null, ltv?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null, next_event?: { __typename?: 'Visit', class?: { __typename?: 'ClassModel', start_time?: any | null } | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLFragmentClientMediaFragment = { __typename?: 'Media', id: string, type?: string | null, url?: string | null };

export type QLFragmentClientSmallFragment = { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null };

export type QLFragmentClientStatusFragment = { __typename?: 'Client', is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null };

export type QLFragmentClientCountsFragment = { __typename?: 'Client', total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null };

export type QLFragmentClientTooltipFragment = { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, lead_completed?: boolean | null, total_club_counts?: number | null, total_period_counts?: number | null, mobile_phone?: string | null, last_attendance_at?: any | null, ltv?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null, next_event?: { __typename?: 'Visit', class?: { __typename?: 'ClassModel', start_time?: any | null } | null } | null };

export type QLFragmentClientFullFragment = { __typename?: 'Client', team_id?: string | null, last_appointment_at?: any | null, last_attendance_at?: any | null, address_line?: string | null, address_city?: string | null, address_state?: string | null, address_postal_code?: string | null, address_country?: string | null, ltv?: number | null, created_at?: any | null, updated_at?: any | null, creation_date?: any | null, birthday?: any | null, note_generic?: string | null, note_yellow?: string | null, note_red?: string | null, twitter?: string | null, twitter_bio?: string | null, twitter_followers?: number | null, twitter_following?: number | null, linkedin?: string | null, linkedin_bio?: string | null, linkedin_followers?: number | null, linkedin_following?: number | null, facebook?: string | null, instagram?: string | null, instagram_bio?: string | null, instagram_followers?: number | null, instagram_following?: number | null, username?: string | null, email?: string | null, mobile_phone?: string | null, phone_home?: string | null, phone_work?: string | null, phone_work_ext?: string | null, referred_by?: string | null, bio?: string | null, job_title?: string | null, job_organization?: string | null, emergency_contact_info_name?: string | null, emergency_contact_info_relationship?: string | null, emergency_contact_info_phone?: string | null, emergency_contact_info_email?: string | null, active?: boolean | null, email_opt_in?: boolean | null, liability_release?: boolean | null, is_company?: boolean | null, promotional_email_opt_in?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, lead_signed_up_id?: string | null, mbo_member_status?: QLMboMemberStatus | null, email_opt_in_reminder_at?: any | null, id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, home_location?: { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, next_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, last_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, current_package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null, referrer?: { __typename?: 'ClientReferrer', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, location?: string | null } | null, education?: Array<{ __typename?: 'ClientEducation', name?: string | null, end_year?: number | null, degree?: string | null } | null> | null, mbo_index_values?: Array<{ __typename?: 'MboIndexValue', name: string, id: string, mbo_index?: { __typename?: 'MboIndex', name: string, id: string } | null } | null> | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null };

export type QLFragmentClientNoteFragment = { __typename?: 'ClientNote', id: string, archived_at?: any | null, created_at?: any | null, updated_at?: any | null, created_by_id?: string | null, note: string, note_model_id?: string | null, note_model_type?: string | null, team_id?: string | null, created_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null };

export type QLFragmentClientFullMutesTemporaryFieldsFragment = { __typename?: 'Client', team_id?: string | null, last_appointment_at?: any | null, last_attendance_at?: any | null, address_line?: string | null, address_city?: string | null, address_state?: string | null, address_postal_code?: string | null, address_country?: string | null, ltv?: number | null, created_at?: any | null, updated_at?: any | null, creation_date?: any | null, birthday?: any | null, note_generic?: string | null, note_yellow?: string | null, note_red?: string | null, twitter?: string | null, twitter_bio?: string | null, twitter_followers?: number | null, twitter_following?: number | null, linkedin?: string | null, linkedin_bio?: string | null, linkedin_followers?: number | null, linkedin_following?: number | null, facebook?: string | null, instagram?: string | null, instagram_bio?: string | null, instagram_followers?: number | null, instagram_following?: number | null, username?: string | null, email?: string | null, mobile_phone?: string | null, phone_home?: string | null, phone_work?: string | null, phone_work_ext?: string | null, referred_by?: string | null, bio?: string | null, job_title?: string | null, job_organization?: string | null, emergency_contact_info_name?: string | null, emergency_contact_info_relationship?: string | null, emergency_contact_info_phone?: string | null, emergency_contact_info_email?: string | null, active?: boolean | null, email_opt_in?: boolean | null, liability_release?: boolean | null, is_company?: boolean | null, promotional_email_opt_in?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, lead_signed_up_id?: string | null, mbo_member_status?: QLMboMemberStatus | null, email_opt_in_reminder_at?: any | null, id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, referrer?: { __typename?: 'ClientReferrer', email?: string | null, last_name?: string | null, first_name?: string | null, location?: string | null, phone?: string | null } | null, mutes?: Array<{ __typename?: 'TemporaryMute', id: string, muted_at?: any | null, muted_until?: any | null, unmuted_at?: any | null, muted_by?: { __typename?: 'User', id: string, name?: string | null } | null, unmuted_by?: { __typename?: 'User', id: string, name?: string | null } | null } | null> | null, home_location?: { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, next_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, last_event?: { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null } | null, current_package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null, education?: Array<{ __typename?: 'ClientEducation', name?: string | null, end_year?: number | null, degree?: string | null } | null> | null, mbo_index_values?: Array<{ __typename?: 'MboIndexValue', name: string, id: string, mbo_index?: { __typename?: 'MboIndex', name: string, id: string } | null } | null> | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null };

export type QLFragmentDiscussionBasicFragment = { __typename?: 'Discussion', id: string, subject?: string | null, team_has_responded?: boolean | null, sms?: boolean | null, email?: boolean | null, closed?: boolean | null, sent?: boolean | null, bounced?: boolean | null, delivered?: boolean | null, opened?: boolean | null, clicked?: boolean | null, team_id?: string | null, client_id?: string | null, automation_id?: string | null, last_contacted_at?: any | null, created_at?: any | null, updated_at?: any | null };

export type QLFragmentDiscussionFullFragment = { __typename?: 'Discussion', id: string, subject?: string | null, team_has_responded?: boolean | null, sms?: boolean | null, email?: boolean | null, closed?: boolean | null, sent?: boolean | null, bounced?: boolean | null, delivered?: boolean | null, opened?: boolean | null, clicked?: boolean | null, team_id?: string | null, client_id?: string | null, automation_id?: string | null, last_contacted_at?: any | null, created_at?: any | null, updated_at?: any | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, automation?: { __typename?: 'Automation', id: string, name: string, delivery_type?: QLAutomationDeliveryTypeEnum | null } | null, last_message?: { __typename?: 'Message', id: string, user_id?: string | null, automation_id?: string | null, from_client?: boolean | null, bounced?: boolean | null, sent?: boolean | null, delivered?: boolean | null, clicked?: boolean | null, opened?: boolean | null, subject?: string | null, message?: string | null, created_at?: any | null, error_code?: QLMessageErrorType | null, user?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null };

export type QLFragmentMessageFragment = { __typename?: 'Message', id: string, user_id?: string | null, automation_id?: string | null, from_client?: boolean | null, bounced?: boolean | null, sent?: boolean | null, delivered?: boolean | null, clicked?: boolean | null, opened?: boolean | null, subject?: string | null, message?: string | null, created_at?: any | null, error_code?: QLMessageErrorType | null, user?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null };

export type QLDiscussionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLDiscussionQuery = { __typename?: 'Query', discussion?: { __typename?: 'Discussion', id: string, subject?: string | null, team_has_responded?: boolean | null, sms?: boolean | null, email?: boolean | null, closed?: boolean | null, sent?: boolean | null, bounced?: boolean | null, delivered?: boolean | null, opened?: boolean | null, clicked?: boolean | null, team_id?: string | null, client_id?: string | null, automation_id?: string | null, last_contacted_at?: any | null, created_at?: any | null, updated_at?: any | null, messages?: Array<{ __typename?: 'Message', id: string, user_id?: string | null, automation_id?: string | null, from_client?: boolean | null, bounced?: boolean | null, sent?: boolean | null, delivered?: boolean | null, clicked?: boolean | null, opened?: boolean | null, subject?: string | null, message?: string | null, created_at?: any | null, error_code?: QLMessageErrorType | null, user?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null> | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, automation?: { __typename?: 'Automation', id: string, name: string, delivery_type?: QLAutomationDeliveryTypeEnum | null } | null, last_message?: { __typename?: 'Message', id: string, user_id?: string | null, automation_id?: string | null, from_client?: boolean | null, bounced?: boolean | null, sent?: boolean | null, delivered?: boolean | null, clicked?: boolean | null, opened?: boolean | null, subject?: string | null, message?: string | null, created_at?: any | null, error_code?: QLMessageErrorType | null, user?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null } | null };

export type QLDiscussionsQueryVariables = Exact<{
  automation_id?: InputMaybe<Scalars['ID']>;
  client_id?: InputMaybe<Scalars['ID']>;
  home_location_id?: InputMaybe<Scalars['ID']>;
  closed?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['Boolean']>;
  sms?: InputMaybe<Scalars['Boolean']>;
  team_has_responded?: InputMaybe<Scalars['Boolean']>;
  only_automations?: InputMaybe<Scalars['Boolean']>;
  last_contacted_at_from?: InputMaybe<Scalars['Timestamp']>;
  last_contacted_at_to?: InputMaybe<Scalars['Timestamp']>;
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
}>;


export type QLDiscussionsQuery = { __typename?: 'Query', discussions: { __typename?: 'DiscussionPaginator', data: Array<{ __typename?: 'Discussion', id: string, subject?: string | null, team_has_responded?: boolean | null, sms?: boolean | null, email?: boolean | null, closed?: boolean | null, sent?: boolean | null, bounced?: boolean | null, delivered?: boolean | null, opened?: boolean | null, clicked?: boolean | null, team_id?: string | null, client_id?: string | null, automation_id?: string | null, last_contacted_at?: any | null, created_at?: any | null, updated_at?: any | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, current_package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, automation?: { __typename?: 'Automation', id: string, name: string, delivery_type?: QLAutomationDeliveryTypeEnum | null } | null, last_message?: { __typename?: 'Message', id: string, user_id?: string | null, automation_id?: string | null, from_client?: boolean | null, bounced?: boolean | null, sent?: boolean | null, delivered?: boolean | null, clicked?: boolean | null, opened?: boolean | null, subject?: string | null, message?: string | null, created_at?: any | null, error_code?: QLMessageErrorType | null, user?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLFragmentDiscussionFromAutomationsFragment = { __typename?: 'Discussion', id: string, subject?: string | null, team_has_responded?: boolean | null, sms?: boolean | null, email?: boolean | null, closed?: boolean | null, sent?: boolean | null, bounced?: boolean | null, delivered?: boolean | null, opened?: boolean | null, clicked?: boolean | null, team_id?: string | null, client_id?: string | null, automation_id?: string | null, last_contacted_at?: any | null, created_at?: any | null, updated_at?: any | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null };

export type QLAutomationsDiscussionsQueryVariables = Exact<{
  automation_id?: InputMaybe<Scalars['ID']>;
  client_id?: InputMaybe<Scalars['ID']>;
  home_location_id?: InputMaybe<Scalars['ID']>;
  closed?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['Boolean']>;
  sms?: InputMaybe<Scalars['Boolean']>;
  bounced?: InputMaybe<Scalars['Boolean']>;
  clicked?: InputMaybe<Scalars['Boolean']>;
  delivered?: InputMaybe<Scalars['Boolean']>;
  opened?: InputMaybe<Scalars['Boolean']>;
  team_has_responded?: InputMaybe<Scalars['Boolean']>;
  only_automations?: InputMaybe<Scalars['Boolean']>;
  last_contacted_at_from?: InputMaybe<Scalars['Timestamp']>;
  last_contacted_at_to?: InputMaybe<Scalars['Timestamp']>;
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
}>;


export type QLAutomationsDiscussionsQuery = { __typename?: 'Query', automations_discussions: { __typename?: 'DiscussionPaginator', data: Array<{ __typename?: 'Discussion', id: string, subject?: string | null, team_has_responded?: boolean | null, sms?: boolean | null, email?: boolean | null, closed?: boolean | null, sent?: boolean | null, bounced?: boolean | null, delivered?: boolean | null, opened?: boolean | null, clicked?: boolean | null, team_id?: string | null, client_id?: string | null, automation_id?: string | null, last_contacted_at?: any | null, created_at?: any | null, updated_at?: any | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLFragrmentSmallEmailTemplateFragment = { __typename?: 'EmailTemplate', id: string, subject?: string | null, automation_id?: string | null, brand_id?: string | null, category?: string | null, team_id?: string | null, name?: string | null, thumbnail?: string | null, updated_at?: any | null };

export type QLFragrmentFullEmailTemplateFragment = { __typename?: 'EmailTemplate', id: string, subject?: string | null, automation_id?: string | null, brand_id?: string | null, category?: string | null, team_id?: string | null, name?: string | null, thumbnail?: string | null, updated_at?: any | null, email?: { __typename?: 'EmailTemplateContent', html?: string | null, json?: any | null } | null };

export type QLEmailTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLEmailTemplatesQuery = { __typename?: 'Query', email_templates: Array<{ __typename?: 'EmailTemplate', id: string, subject?: string | null, automation_id?: string | null, brand_id?: string | null, category?: string | null, team_id?: string | null, name?: string | null, thumbnail?: string | null, updated_at?: any | null }> };

export type QLEmailTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLEmailTemplateQuery = { __typename?: 'Query', email_template?: { __typename?: 'EmailTemplate', id: string, subject?: string | null, automation_id?: string | null, brand_id?: string | null, category?: string | null, team_id?: string | null, name?: string | null, thumbnail?: string | null, updated_at?: any | null, email?: { __typename?: 'EmailTemplateContent', html?: string | null, json?: any | null } | null } | null };

export type QLFormCatalogItemIndexFragment = { __typename?: 'FormCatalogItem', id: string, name: string, description?: string | null, category?: string | null };

export type QLFormCatalogItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLFormCatalogItemsQuery = { __typename?: 'Query', form_catalog_items: Array<{ __typename?: 'FormCatalogItem', id: string, name: string, description?: string | null, category?: string | null }> };

export type QLFormCatalogItemSingleFragmentFragment = { __typename?: 'FormCatalogItem', long_description?: string | null, form_name?: string | null, id: string, name: string, description?: string | null, category?: string | null };

export type QLFormCatalogItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLFormCatalogItemQuery = { __typename?: 'Query', form_catalog_item?: { __typename?: 'FormCatalogItem', long_description?: string | null, form_name?: string | null, id: string, name: string, description?: string | null, category?: string | null } | null };

export type QLFragmentFormSmallFragment = { __typename?: 'Form', id: string, name?: string | null, category?: string | null, allow_leads?: boolean | null, is_legal?: boolean | null, is_archived?: boolean | null, editable?: boolean | null, thank_you_message?: string | null, thank_you_url?: string | null, email_cc?: string | null };

export type QLFragmentFormBlockFragment = { __typename?: 'FormField', id: string, kind?: QLFieldTypeEnum | null, description?: string | null, title?: string | null, optional?: boolean | null, options?: Array<string | null> | null, size?: number | null, content?: string | null, prefill?: string | null, mapping?: string | null };

export type QLFragmentFormFullFragment = { __typename?: 'Form', description?: string | null, title?: string | null, short_url?: string | null, archive_404?: boolean | null, archive_text?: string | null, send_to_mbo?: boolean | null, mbo_upload_lead?: boolean | null, mbo_update_client?: boolean | null, updated_at?: any | null, created_at?: any | null, id: string, name?: string | null, category?: string | null, allow_leads?: boolean | null, is_legal?: boolean | null, is_archived?: boolean | null, editable?: boolean | null, thank_you_message?: string | null, thank_you_url?: string | null, email_cc?: string | null, content?: Array<{ __typename?: 'FormField', id: string, kind?: QLFieldTypeEnum | null, description?: string | null, title?: string | null, optional?: boolean | null, options?: Array<string | null> | null, size?: number | null, content?: string | null, prefill?: string | null, mapping?: string | null } | null> | null };

export type QLFormsIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type QLFormsIndexQuery = { __typename?: 'Query', forms_index: Array<{ __typename?: 'Form', id: string, name?: string | null, category?: string | null, allow_leads?: boolean | null, is_legal?: boolean | null, is_archived?: boolean | null, editable?: boolean | null, thank_you_message?: string | null, thank_you_url?: string | null, email_cc?: string | null }> };

export type QLFormCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLFormCategoriesQuery = { __typename?: 'Query', form_categories: Array<{ __typename?: 'FormCategory', name?: string | null }> };

export type QLFormQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLFormQuery = { __typename?: 'Query', form?: { __typename?: 'Form', description?: string | null, title?: string | null, short_url?: string | null, archive_404?: boolean | null, archive_text?: string | null, send_to_mbo?: boolean | null, mbo_upload_lead?: boolean | null, mbo_update_client?: boolean | null, updated_at?: any | null, created_at?: any | null, id: string, name?: string | null, category?: string | null, allow_leads?: boolean | null, is_legal?: boolean | null, is_archived?: boolean | null, editable?: boolean | null, thank_you_message?: string | null, thank_you_url?: string | null, email_cc?: string | null, content?: Array<{ __typename?: 'FormField', id: string, kind?: QLFieldTypeEnum | null, description?: string | null, title?: string | null, optional?: boolean | null, options?: Array<string | null> | null, size?: number | null, content?: string | null, prefill?: string | null, mapping?: string | null } | null> | null } | null };

export type QLFormStatCompletionTimesQueryVariables = Exact<{
  input: QLFormStatInput;
}>;


export type QLFormStatCompletionTimesQuery = { __typename?: 'Query', form_stat_completion_times?: { __typename?: 'FormStatsCompletionTimes', completed?: number | null } | null };

export type QLFormStatFirstCompletionQueryVariables = Exact<{
  input: QLFormStatInput;
}>;


export type QLFormStatFirstCompletionQuery = { __typename?: 'Query', form_stat_first_completion?: { __typename?: 'FormStatsFirstCompletion', first?: any | null } | null };

export type QLFormStatFieldQueryVariables = Exact<{
  input: QLFormStatInput;
  question_id: Scalars['ID'];
}>;


export type QLFormStatFieldQuery = { __typename?: 'Query', form_stat_field?: Array<{ __typename?: 'FormStatsSingleField', answer: string, cc: number } | null> | null };

export type QLFormStatHistoryQueryVariables = Exact<{
  input: QLFormStatInput;
}>;


export type QLFormStatHistoryQuery = { __typename?: 'Query', form_stat_history?: Array<{ __typename?: 'FormStatsHistoryItem', timestamp: any, cc: number } | null> | null };

export type QLFragmentFormInstanceFromHistoryFragment = { __typename?: 'FormInstance', id: string, pdf_url?: string | null, created_at?: any | null, client?: { __typename?: 'Client', email?: string | null, id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, mobile_phone?: string | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null };

export type QLFormInstancesHistoryQueryVariables = Exact<{
  form_id?: InputMaybe<Scalars['ID']>;
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
}>;


export type QLFormInstancesHistoryQuery = { __typename?: 'Query', form_instances_history: { __typename?: 'FormInstancePaginator', data: Array<{ __typename?: 'FormInstance', id: string, pdf_url?: string | null, created_at?: any | null, client?: { __typename?: 'Client', email?: string | null, id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, mobile_phone?: string | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLFragmentFormInstanceForClientsFragment = { __typename?: 'FormInstance', id: string, pdf_url?: string | null, created_at?: any | null, form_id?: string | null, form?: { __typename?: 'Form', id: string, name?: string | null, is_legal?: boolean | null, is_archived?: boolean | null, category?: string | null } | null };

export type QLFormInstancesForClientQueryVariables = Exact<{
  client_id?: InputMaybe<Scalars['ID']>;
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
}>;


export type QLFormInstancesForClientQuery = { __typename?: 'Query', form_instances_for_client: { __typename?: 'FormInstancePaginator', data: Array<{ __typename?: 'FormInstance', id: string, pdf_url?: string | null, created_at?: any | null, form_id?: string | null, form?: { __typename?: 'Form', id: string, name?: string | null, is_legal?: boolean | null, is_archived?: boolean | null, category?: string | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLFormInstancesClientDetailQueryVariables = Exact<{
  form_id?: InputMaybe<Scalars['ID']>;
  client_id?: InputMaybe<Scalars['ID']>;
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
}>;


export type QLFormInstancesClientDetailQuery = { __typename?: 'Query', form_instances_client_detail: { __typename?: 'FormInstancePaginator', data: Array<{ __typename?: 'FormInstance', id: string, pdf_url?: string | null, created_at?: any | null, form_id?: string | null, form?: { __typename?: 'Form', id: string, name?: string | null, is_legal?: boolean | null, is_archived?: boolean | null, category?: string | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLFragmentFormWithCountFragment = { __typename?: 'FormWithCount', id: string, category?: string | null, is_legal?: boolean | null, allow_leads?: boolean | null, is_archived?: boolean | null, name?: string | null, cc?: number | null, last_completion_at?: any | null };

export type QLFormInstancesRecapQueryVariables = Exact<{
  client_id: Scalars['ID'];
}>;


export type QLFormInstancesRecapQuery = { __typename?: 'Query', form_instances_recap?: Array<{ __typename?: 'FormWithCount', id: string, category?: string | null, is_legal?: boolean | null, allow_leads?: boolean | null, is_archived?: boolean | null, name?: string | null, cc?: number | null, last_completion_at?: any | null } | null> | null };

export type QLFormInstanceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLFormInstanceQuery = { __typename?: 'Query', form_instance?: { __typename?: 'FormInstance', ip_address?: string | null, id: string, pdf_url?: string | null, created_at?: any | null, form_id?: string | null, form?: { __typename?: 'Form', id: string, name?: string | null, is_legal?: boolean | null, is_archived?: boolean | null, category?: string | null, description?: string | null, title?: string | null, short_url?: string | null, archive_404?: boolean | null, archive_text?: string | null, send_to_mbo?: boolean | null, mbo_upload_lead?: boolean | null, mbo_update_client?: boolean | null, updated_at?: any | null, created_at?: any | null, allow_leads?: boolean | null, editable?: boolean | null, thank_you_message?: string | null, thank_you_url?: string | null, email_cc?: string | null, content?: Array<{ __typename?: 'FormField', id: string, kind?: QLFieldTypeEnum | null, description?: string | null, title?: string | null, optional?: boolean | null, options?: Array<string | null> | null, size?: number | null, content?: string | null, prefill?: string | null, mapping?: string | null } | null> | null } | null, responses?: Array<{ __typename?: 'FormInstanceResponse', id: string, question: string, answer?: string | null } | null> | null } | null };

export type QLPaginatorFragmentFragment = { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number };

export type QLFragmentInvitationSentFragment = { __typename?: 'Invitation', id: string, email: string, token: string, role: QLUserRoleEnum, created_at: any };

export type QLFragmentInvitationReceivedFragment = { __typename?: 'Invitation', id: string, email: string, token: string, role: QLUserRoleEnum, created_at: any, team?: { __typename?: 'Team', name: string, id: string, photo_url?: string | null } | null };

export type QLTeamPendingInvitationsQueryVariables = Exact<{
  team_id: Scalars['ID'];
}>;


export type QLTeamPendingInvitationsQuery = { __typename?: 'Query', team_pending_invitations?: Array<{ __typename?: 'Invitation', id: string, email: string, token: string, role: QLUserRoleEnum, created_at: any } | null> | null };

export type QLInvitationsPendingQueryVariables = Exact<{ [key: string]: never; }>;


export type QLInvitationsPendingQuery = { __typename?: 'Query', invitations_pending?: Array<{ __typename?: 'Invitation', id: string, email: string, token: string, role: QLUserRoleEnum, created_at: any, team?: { __typename?: 'Team', name: string, id: string, photo_url?: string | null } | null } | null> | null };

export type QLFragmentMboIndexValueFragment = { __typename?: 'MboIndexValue', id: string, name: string, external_id: number };

export type QLFragmentMboIndexFragment = { __typename?: 'MboIndex', id: string, name: string, values?: Array<{ __typename?: 'MboIndexValue', id: string, name: string, external_id: number } | null> | null };

export type QLMboIndexesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLMboIndexesQuery = { __typename?: 'Query', mbo_indexes?: Array<{ __typename?: 'MboIndex', id: string, name: string, values?: Array<{ __typename?: 'MboIndexValue', id: string, name: string, external_id: number } | null> | null } | null> | null };

export type QLNoteTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLNoteTemplatesQuery = { __typename?: 'Query', noteTemplates: { __typename?: 'NoteTemplatePaginator', data: Array<{ __typename?: 'NoteTemplate', id: string, team_id?: string | null, title: string, body: string, created_at?: any | null, updated_at?: any | null }> } };

export type QLFragmentNoteTemplateFragment = { __typename?: 'NoteTemplate', id: string, team_id?: string | null, title: string, body: string, created_at?: any | null, updated_at?: any | null };

export type QLClientNotesQueryVariables = Exact<{
  client_id?: InputMaybe<Scalars['ID']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type QLClientNotesQuery = { __typename?: 'Query', notes: { __typename?: 'ClientNotePaginator', data: Array<{ __typename?: 'ClientNote', id: string, archived_at?: any | null, created_at?: any | null, updated_at?: any | null, created_by_id?: string | null, note: string, note_model_id?: string | null, note_model_type?: string | null, team_id?: string | null, created_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLQuickAnnouncementsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLQuickAnnouncementsQuery = { __typename?: 'Query', announcements?: Array<{ __typename?: 'Announcement', id: string, created_at?: any | null } | null> | null };

export type QLAnnouncementsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLAnnouncementsQuery = { __typename?: 'Query', announcements?: Array<{ __typename?: 'Announcement', id: string, created_at?: any | null, body: string, parsed_body?: string | null, action_text?: string | null, action_url?: string | null, creator: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } } | null> | null };

export type QLQuickNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLQuickNotificationsQuery = { __typename?: 'Query', notifications?: Array<{ __typename?: 'Notification', id: string, read: boolean, created_at?: any | null } | null> | null };

export type QLNotificationFragmentFragment = { __typename?: 'Notification', id: string, read: boolean, created_at?: any | null, body: string, action_text?: string | null, action_url?: string | null, icon?: string | null, team?: { __typename?: 'Team', id: string, name: string, photo_url?: string | null } | null };

export type QLNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLNotificationsQuery = { __typename?: 'Query', notifications?: Array<{ __typename?: 'Notification', id: string, read: boolean, created_at?: any | null, body: string, action_text?: string | null, action_url?: string | null, icon?: string | null, team?: { __typename?: 'Team', id: string, name: string, photo_url?: string | null } | null } | null> | null };

export type QLClientsUnsubscribedStatsQueryVariables = Exact<{
  days: Scalars['Int'];
}>;


export type QLClientsUnsubscribedStatsQuery = { __typename?: 'Query', clients_unsubscribed_stats?: { __typename?: 'ClientsUnsubscribedStats', emails: number, emails_past: number, sms: number, sms_past: number } | null };

export type QLClientUnsubscribedFragmentFragment = { __typename?: 'Client', email?: string | null, mobile_phone?: string | null, last_attendance_at?: any | null, id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, last_discussion?: { __typename?: 'Discussion', id: string, last_contacted_at?: any | null } | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null };

export type QLClientsUnsubscribedQueryVariables = Exact<{
  medium: QLUnsubscribeMediumEnum;
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type QLClientsUnsubscribedQuery = { __typename?: 'Query', clients_unsubscribed: { __typename?: 'ClientPaginator', data: Array<{ __typename?: 'Client', email?: string | null, mobile_phone?: string | null, last_attendance_at?: any | null, id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, last_discussion?: { __typename?: 'Discussion', id: string, last_contacted_at?: any | null } | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLFragmentPackageInfoFragment = { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null };

export type QLPackageNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLPackageNamesQuery = { __typename?: 'Query', package_names?: Array<{ __typename?: 'PackageName', name?: string | null } | null> | null };

export type QLProductNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLProductNamesQuery = { __typename?: 'Query', product_names?: Array<{ __typename?: 'ProductName', name?: string | null } | null> | null };

export type QLContractNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLContractNamesQuery = { __typename?: 'Query', contract_names?: Array<{ __typename?: 'ContractName', name?: string | null } | null> | null };

export type QLPlaceholderFragmentFragment = { __typename?: 'Placeholder', name: string, value: string, placeholder?: string | null, group?: string | null, subgroup?: string | null };

export type QLPlaceholdersQueryVariables = Exact<{ [key: string]: never; }>;


export type QLPlaceholdersQuery = { __typename?: 'Query', placeholders?: Array<{ __typename?: 'Placeholder', name: string, value: string, placeholder?: string | null, group?: string | null, subgroup?: string | null } | null> | null };

export type QLQuickResponsesQueryVariables = Exact<{ [key: string]: never; }>;


export type QLQuickResponsesQuery = { __typename?: 'Query', quick_responses?: Array<{ __typename?: 'QuickResponse', id: string, team_id?: string | null, title: string, content: string, order: number } | null> | null };

export type QLFragmentQuickResponseFragment = { __typename?: 'QuickResponse', id: string, team_id?: string | null, title: string, content: string, order: number };

export type QLMeQueryVariables = Exact<{ [key: string]: never; }>;


export type QLMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', email?: string | null, current_team_id?: string | null, last_read_announcements_at?: any | null, id: string, name?: string | null, photo_url?: string | null, current_team?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null, policy?: { __typename?: 'UserPolicy', role?: QLUserRoleEnum | null, add_tags?: boolean | null, is_owner?: boolean | null, is_manager?: boolean | null, is_admin?: boolean | null, is_main_owner?: boolean | null, edit_automations?: boolean | null, create_automations?: boolean | null, edit_forms?: boolean | null, create_forms?: boolean | null, export_clients?: boolean | null, staff_invite?: boolean | null, staff_change?: boolean | null, staff_remove?: boolean | null, create_email_templates?: boolean | null, edit_email_templates?: boolean | null, view_email_templates?: boolean | null, send_messages?: boolean | null } | null, permissions?: Array<{ __typename?: 'UserPermission', name?: string | null } | null> | null, teams?: Array<{ __typename?: 'Team', role?: QLUserRoleEnum | null, phone_number?: string | null, phone_forward?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, sms_sender?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, twitter_handle?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, external_token_present?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null } | null> | null } | null };

export type QLFragmentSmallSegmentFragment = { __typename?: 'Segment', id: string, name: string, order?: number | null, archived?: boolean | null, visible_dashboard?: boolean | null, is_event?: boolean | null };

export type QLFragmentFullSegmentFragment = { __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null };

export type QLQuickSegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLQuickSegmentsQuery = { __typename?: 'Query', quick_segments: Array<{ __typename?: 'Segment', id: string, name: string, order?: number | null, archived?: boolean | null, visible_dashboard?: boolean | null, is_event?: boolean | null }> };

export type QLUsableSegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLUsableSegmentsQuery = { __typename?: 'Query', usable_segments: Array<{ __typename?: 'Segment', id: string, name: string, order?: number | null, archived?: boolean | null, visible_dashboard?: boolean | null, is_event?: boolean | null }> };

export type QLSegmentsQueryVariables = Exact<{
  only_deliverable_by_email?: InputMaybe<Scalars['Boolean']>;
  only_deliverable_by_sms?: InputMaybe<Scalars['Boolean']>;
  visible_dashboard?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  is_communication?: InputMaybe<Scalars['Boolean']>;
  is_event?: InputMaybe<Scalars['Boolean']>;
}>;


export type QLSegmentsQuery = { __typename?: 'Query', segments: Array<{ __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null }> };

export type QLDashboardSegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLDashboardSegmentsQuery = { __typename?: 'Query', dashboard_segments: Array<{ __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null }> };

export type QLInsightsUsableSegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLInsightsUsableSegmentsQuery = { __typename?: 'Query', insights_usable_segments: Array<{ __typename?: 'Segment', is_communication?: boolean | null, only_deliverable_by_sms?: boolean | null, only_deliverable_by_email?: boolean | null, visible_dashboard?: boolean | null, id: string, name: string, order?: number | null, archived?: boolean | null, is_event?: boolean | null, filters?: Array<{ __typename?: 'FilterGroup', operator_is_and?: boolean | null, uid?: string | null, filters?: Array<{ __typename?: 'Filter', options?: any | null, type?: string | null, uid?: string | null } | null> | null } | null> | null }> };

export type QLEventCalculateSegmentQueryVariables = Exact<{
  class_model_id: Scalars['ID'];
  segment: QLSegmentInput;
  page: Scalars['Int'];
  first: Scalars['Int'];
  orderBy: Array<QLOrderByClause> | QLOrderByClause;
}>;


export type QLEventCalculateSegmentQuery = { __typename?: 'Query', event_calculate_segment: { __typename?: 'ClientPaginator', data: Array<{ __typename?: 'Client', id: string }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLFragmentStaffFragment = { __typename?: 'Staff', id: string, first_name?: string | null, last_name?: string | null, name?: string | null };

export type QLFragmentStaffFullFragment = { __typename?: 'Staff', country?: string | null, email?: string | null, external_id?: string | null, ismale?: boolean | null, mobile_phone?: string | null, state?: string | null, id: string, first_name?: string | null, last_name?: string | null, name?: string | null };

export type QLStaffsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLStaffsQuery = { __typename?: 'Query', staffs: Array<{ __typename?: 'Staff', id: string, first_name?: string | null, last_name?: string | null, name?: string | null }> };

export type QLStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type QLStatusQuery = { __typename?: 'Query', status: { __typename?: 'Status', total_clients?: number | null, todos?: { __typename?: 'StatusTodos', open?: number | null, overdue?: number | null, postponed?: number | null } | null, discussions?: { __typename?: 'StatusDiscussions', open?: number | null, open_sms?: number | null } | null } };

export type QLAllTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLAllTagsQuery = { __typename?: 'Query', tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null };

export type QLFragmentAssignedTagFragment = { __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean };

export type QLBatchTagClientsMutationVariables = Exact<{
  clients: Array<QLBatchTagClientIdentifierInput> | QLBatchTagClientIdentifierInput;
  tagNames: Array<Scalars['String']> | Scalars['String'];
  action: QLTagAction;
}>;


export type QLBatchTagClientsMutation = { __typename?: 'Mutation', BatchTagClients?: { __typename?: 'BatchTagResult', success: boolean, message?: string | null, clientsTagged?: number | null, leadsCreated?: number | null } | null };

export type QLFragmentLocationInfoFragment = { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null };

export type QLCurrentTeamQueryVariables = Exact<{ [key: string]: never; }>;


export type QLCurrentTeamQuery = { __typename?: 'Query', current_team?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null };

export type QLCurrentTeamUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type QLCurrentTeamUsersQuery = { __typename?: 'Query', current_team?: { __typename?: 'Team', id: string, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null };

export type QLCurrentTeamGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLCurrentTeamGroupsQuery = { __typename?: 'Query', current_team?: { __typename?: 'Team', id: string, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null } | null };

export type QLTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLTeamsQuery = { __typename?: 'Query', teams?: Array<{ __typename?: 'Team', role?: QLUserRoleEnum | null, phone_number?: string | null, phone_forward?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, sms_sender?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, twitter_handle?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, external_token_present?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null } | null> | null };

export type QLFragmentTeamGroupsFragment = { __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null };

export type QLFragmentTeamSmallFragment = { __typename?: 'Team', id: string, name: string, photo_url?: string | null };

export type QLFragmentTeamFragment = { __typename?: 'Team', phone_number?: string | null, phone_forward?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, sms_sender?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, twitter_handle?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, external_token_present?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null };

export type QLFragmentTeamWithOwnerFragment = { __typename?: 'Team', role?: QLUserRoleEnum | null, phone_number?: string | null, phone_forward?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, sms_sender?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, twitter_handle?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, external_token_present?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null };

export type QLUserWithRoleFragmentFragment = { __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null };

export type QLCurrentTeamUsersFragment = { __typename?: 'Team', users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null };

export type QLFragmentSmsBundleFragment = { __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null };

export type QLFragmentCurrentTeamFragment = { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null };

export type QLFragmentTodoFragment = { __typename?: 'Todo', id: string, automation_id?: string | null, client_id?: string | null, completed_by_id?: string | null, created_by_id?: string | null, deleted_by_id?: string | null, assigned_to_id?: string | null, completed_action_note?: string | null, completed_action_type?: QLTodoCompletionTypeEnum | null, completed_at?: any | null, deleted_at?: any | null, postponed_to?: any | null, overdue_at?: any | null, updated_at?: any | null, created_at?: any | null, priority?: QLTodoPriority | null, is_closed?: boolean | null, is_deleted?: boolean | null, is_open?: boolean | null, is_postponed?: boolean | null, is_completed?: boolean | null, message?: string | null, subject?: string | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, automation?: { __typename?: 'Automation', id: string, name: string } | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, completed_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, created_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, deleted_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, assigned_to?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, team_group?: { __typename?: 'TeamGroup', id: string, name: string } | null };

export type QLTodoQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLTodoQuery = { __typename?: 'Query', todo?: { __typename?: 'Todo', id: string, automation_id?: string | null, client_id?: string | null, completed_by_id?: string | null, created_by_id?: string | null, deleted_by_id?: string | null, assigned_to_id?: string | null, completed_action_note?: string | null, completed_action_type?: QLTodoCompletionTypeEnum | null, completed_at?: any | null, deleted_at?: any | null, postponed_to?: any | null, overdue_at?: any | null, updated_at?: any | null, created_at?: any | null, priority?: QLTodoPriority | null, is_closed?: boolean | null, is_deleted?: boolean | null, is_open?: boolean | null, is_postponed?: boolean | null, is_completed?: boolean | null, message?: string | null, subject?: string | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, automation?: { __typename?: 'Automation', id: string, name: string } | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, completed_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, created_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, deleted_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, assigned_to?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, team_group?: { __typename?: 'TeamGroup', id: string, name: string } | null } | null };

export type QLTodosQueryVariables = Exact<{
  automation_id?: InputMaybe<Scalars['ID']>;
  client_id?: InputMaybe<Scalars['ID']>;
  home_location_id?: InputMaybe<Scalars['ID']>;
  closed?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  manual?: InputMaybe<Scalars['Boolean']>;
  open?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
  overdue?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  priority?: InputMaybe<Scalars['Int']>;
  scheduled?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['ID']>;
  assigned_to_id?: InputMaybe<Scalars['ID']>;
  team_group_id?: InputMaybe<Scalars['ID']>;
  created_after?: InputMaybe<Scalars['String']>;
  created_before?: InputMaybe<Scalars['String']>;
  overdue_after?: InputMaybe<Scalars['String']>;
  overdue_before?: InputMaybe<Scalars['String']>;
}>;


export type QLTodosQuery = { __typename?: 'Query', todos: { __typename?: 'TodoPaginator', data: Array<{ __typename?: 'Todo', id: string, automation_id?: string | null, client_id?: string | null, completed_by_id?: string | null, created_by_id?: string | null, deleted_by_id?: string | null, assigned_to_id?: string | null, completed_action_note?: string | null, completed_action_type?: QLTodoCompletionTypeEnum | null, completed_at?: any | null, deleted_at?: any | null, postponed_to?: any | null, overdue_at?: any | null, updated_at?: any | null, created_at?: any | null, priority?: QLTodoPriority | null, is_closed?: boolean | null, is_deleted?: boolean | null, is_open?: boolean | null, is_postponed?: boolean | null, is_completed?: boolean | null, message?: string | null, subject?: string | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, automation?: { __typename?: 'Automation', id: string, name: string } | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, completed_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, created_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, deleted_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, assigned_to?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, team_group?: { __typename?: 'TeamGroup', id: string, name: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLMyTodosQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<QLOrderByClause> | QLOrderByClause>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type QLMyTodosQuery = { __typename?: 'Query', my_todos: { __typename?: 'TodoPaginator', data: Array<{ __typename?: 'Todo', id: string, automation_id?: string | null, client_id?: string | null, completed_by_id?: string | null, created_by_id?: string | null, deleted_by_id?: string | null, assigned_to_id?: string | null, completed_action_note?: string | null, completed_action_type?: QLTodoCompletionTypeEnum | null, completed_at?: any | null, deleted_at?: any | null, postponed_to?: any | null, overdue_at?: any | null, updated_at?: any | null, created_at?: any | null, priority?: QLTodoPriority | null, is_closed?: boolean | null, is_deleted?: boolean | null, is_open?: boolean | null, is_postponed?: boolean | null, is_completed?: boolean | null, message?: string | null, subject?: string | null, assigned_tags?: Array<{ __typename?: 'Tag', id: string, kind?: QLTagKindEnum | null, name: string, archived: boolean } | null> | null, automation?: { __typename?: 'Automation', id: string, name: string } | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null, completed_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, created_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, deleted_by?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, assigned_to?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, team_group?: { __typename?: 'TeamGroup', id: string, name: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLMyTodosCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type QLMyTodosCountsQuery = { __typename?: 'Query', my_todos_counts: { __typename?: 'TodoPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type QLFragmentUserSmallFragment = { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null };

export type QLFragmentUserPoliciesFragment = { __typename?: 'UserPolicy', role?: QLUserRoleEnum | null, add_tags?: boolean | null, is_owner?: boolean | null, is_manager?: boolean | null, is_admin?: boolean | null, is_main_owner?: boolean | null, edit_automations?: boolean | null, create_automations?: boolean | null, edit_forms?: boolean | null, create_forms?: boolean | null, export_clients?: boolean | null, staff_invite?: boolean | null, staff_change?: boolean | null, staff_remove?: boolean | null, create_email_templates?: boolean | null, edit_email_templates?: boolean | null, view_email_templates?: boolean | null, send_messages?: boolean | null };

export type QLFragmentUserCurrentRoleFragment = { __typename?: 'CurrentRole', role?: QLUserRoleEnum | null, at_least?: { __typename?: 'RoleAtLeast', member?: boolean | null, manager?: boolean | null, admin?: boolean | null, owner?: boolean | null } | null };

export type QLFragmentUserMeFragment = { __typename?: 'User', email?: string | null, current_team_id?: string | null, last_read_announcements_at?: any | null, id: string, name?: string | null, photo_url?: string | null, current_team?: { __typename?: 'Team', address?: string | null, email_sender?: string | null, email_sender_name?: string | null, email_signature?: string | null, twitter_handle?: string | null, facebook_url?: string | null, instagram_handle?: string | null, sms_sender?: string | null, phone_forward?: string | null, manager_name?: string | null, website?: string | null, first_import_done?: boolean | null, period_count_type?: QLPeriodCountType | null, is_free?: boolean | null, trial_ends_at?: any | null, pm_type?: string | null, pm_last_four?: string | null, external_token_present?: boolean | null, api_set?: boolean | null, approved?: boolean | null, phone_number?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, groups?: Array<{ __typename?: 'TeamGroup', id: string, name: string, users?: Array<{ __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null> | null } | null> | null, period_count_data?: { __typename?: 'PeriodData', period: QLPeriodCountType, value: number } | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, sms_bundles?: Array<{ __typename?: 'SmsBundle', id: string, units?: number | null, units_left?: number | null, is_purchased?: boolean | null, expired?: boolean | null, expired_at?: any | null, created_at?: any | null, starts_at?: any | null } | null> | null, addons?: Array<{ __typename?: 'Addon', name?: string | null, active?: boolean | null, cancellable?: boolean | null } | null> | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null, users?: Array<{ __typename?: 'User', email?: string | null, role?: QLUserRoleEnum | null, id: string, name?: string | null, photo_url?: string | null } | null> | null } | null, policy?: { __typename?: 'UserPolicy', role?: QLUserRoleEnum | null, add_tags?: boolean | null, is_owner?: boolean | null, is_manager?: boolean | null, is_admin?: boolean | null, is_main_owner?: boolean | null, edit_automations?: boolean | null, create_automations?: boolean | null, edit_forms?: boolean | null, create_forms?: boolean | null, export_clients?: boolean | null, staff_invite?: boolean | null, staff_change?: boolean | null, staff_remove?: boolean | null, create_email_templates?: boolean | null, edit_email_templates?: boolean | null, view_email_templates?: boolean | null, send_messages?: boolean | null } | null, permissions?: Array<{ __typename?: 'UserPermission', name?: string | null } | null> | null, teams?: Array<{ __typename?: 'Team', role?: QLUserRoleEnum | null, phone_number?: string | null, phone_forward?: string | null, provider_clubready?: boolean | null, provider_mindbody?: boolean | null, provider_pike13?: boolean | null, provider_fitdegree?: boolean | null, provider_name?: string | null, site_id?: string | null, sms_sender?: string | null, stripe_id?: string | null, subscription_active?: boolean | null, timezone?: string | null, twitter_handle?: string | null, zip?: string | null, owner_id?: string | null, color?: string | null, logo_url?: string | null, outgoing_set?: boolean | null, provider?: number | null, provider_type?: QLProvidersEnum | null, can_create_automations?: boolean | null, external_token_present?: boolean | null, is_on_trial?: boolean | null, addon_forms?: boolean | null, id: string, name: string, photo_url?: string | null, owner?: { __typename?: 'User', id: string, name?: string | null, photo_url?: string | null } | null, locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null> | null } | null> | null };

export type QLFragmentVirtualClassInfoFragment = { __typename?: 'VirtualClassInfo', id: string, name?: string | null, day_of_week?: number | null, start_time?: number | null, virtual_url?: string | null, virtual_data?: { __typename?: 'ClassVirtualData', virtual_id?: string | null, virtual_password?: string | null, virtual_info?: string | null } | null };

export type QLVirtualClassesInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type QLVirtualClassesInfoQuery = { __typename?: 'Query', virtual_classes_info: Array<{ __typename?: 'VirtualClassInfo', id: string, name?: string | null, day_of_week?: number | null, start_time?: number | null, virtual_url?: string | null, virtual_data?: { __typename?: 'ClassVirtualData', virtual_id?: string | null, virtual_password?: string | null, virtual_info?: string | null } | null }> };

export type QLVirtualClassQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QLVirtualClassQuery = { __typename?: 'Query', virtual_class?: { __typename?: 'VirtualClassInfo', id: string, name?: string | null, day_of_week?: number | null, start_time?: number | null, virtual_url?: string | null, virtual_data?: { __typename?: 'ClassVirtualData', virtual_id?: string | null, virtual_password?: string | null, virtual_info?: string | null } | null } | null };

export type QLFragmentVisitBasicInfoFragment = { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null };

export type QLFragmentVisitFullFragment = { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', virtual_url?: string | null, location_id?: string | null, staff_id?: string | null, id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null, virtual_data?: { __typename?: 'ClassVirtualData', virtual_id?: string | null, virtual_password?: string | null, virtual_info?: string | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null, timezone?: string | null, address_city?: string | null, address_line?: string | null, address_postal_code?: string | null, address_state?: string | null, latitude?: number | null, longitude?: number | null, external_id?: string | null, team_id?: string | null } | null, staff?: { __typename?: 'Staff', id: string, first_name?: string | null, last_name?: string | null, name?: string | null } | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null };

export type QLFragmentVisitSmallFragment = { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, class?: { __typename?: 'ClassModel', id: string, name?: string | null, start_time?: any | null, end_time?: any | null, cancelled?: boolean | null, is_virtual?: boolean | null, event_type?: QLClassType | null } | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null };

export type QLFragmentVisitWithClientAndPackageFragment = { __typename?: 'Visit', id: string, class_id?: string | null, client_id?: string | null, class_end_time?: any | null, signed_in?: boolean | null, late_cancelled?: boolean | null, early_cancel?: boolean | null, package_id?: string | null, package?: { __typename?: 'Package', id: string, name?: string | null, external_id?: string | null, team_id?: string | null, active?: boolean | null, active_at?: any | null, cancelled?: boolean | null, client_id?: string | null, contract_expires_at?: any | null, created_at?: any | null, current?: boolean | null, days_difference?: number | null, expires_at?: any | null, has_rolling_activation?: boolean | null, is_rolling_active?: boolean | null, payment_at?: any | null, qta?: number | null, remaining?: number | null, updated_at?: any | null, last_used_at?: any | null } | null, client?: { __typename?: 'Client', id: string, external_id?: string | null, first_name?: string | null, last_name?: string | null, unsubscribed_email_at?: any | null, unsubscribed_sms_at?: any | null, unsubscribed_sms_text?: boolean | null, can_contact_by_email?: boolean | null, can_contact_by_sms?: boolean | null, home_location_id?: string | null, lead_completed?: boolean | null, email?: string | null, mobile_phone?: string | null, total_open_discussions?: number | null, total_sales?: number | null, total_visits?: number | null, total_todos?: number | null, total_notes?: number | null, total_appointments?: number | null, total_club_counts?: number | null, total_period_counts?: number | null, total_form_instances?: number | null, is_lead?: boolean | null, active?: boolean | null, is_prospect?: boolean | null, frozen?: boolean | null, photos?: Array<{ __typename?: 'Media', id: string, type?: string | null, url?: string | null } | null> | null } | null };

export type QLZapierTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type QLZapierTokensQuery = { __typename?: 'Query', zapier_tokens?: Array<{ __typename?: 'AccessToken', id: string, name?: string | null, created_at?: any | null } | null> | null };

export const FragmentSmallAutomationFragmentDoc = gql`
    fragment FRAGMENT_SMALL_AUTOMATION on Automation {
  id
  name
  active
  archived
  delivery_type
  disabled
  one_off
  start_at
  category_name
  description
  order
  ever_ran
}
    `;
export const FragmentUserSmallFragmentDoc = gql`
    fragment FRAGMENT_USER_SMALL on User {
  id
  name
  photo_url
}
    `;
export const FragmentAssignedTagFragmentDoc = gql`
    fragment FRAGMENT_ASSIGNED_TAG on Tag {
  id
  kind
  name
  archived
}
    `;
export const FragmentSmallSegmentFragmentDoc = gql`
    fragment FRAGMENT_SMALL_SEGMENT on Segment {
  id
  name
  order
  archived
  visible_dashboard
  is_event
}
    `;
export const FragmentFullSegmentFragmentDoc = gql`
    fragment FRAGMENT_FULL_SEGMENT on Segment {
  ...FRAGMENT_SMALL_SEGMENT
  is_communication
  only_deliverable_by_sms
  only_deliverable_by_email
  visible_dashboard
  filters {
    operator_is_and
    uid
    filters {
      options
      type
      uid
    }
  }
}
    ${FragmentSmallSegmentFragmentDoc}`;
export const FragmentFullAutomationFragmentDoc = gql`
    fragment FRAGMENT_FULL_AUTOMATION on Automation {
  ...FRAGMENT_SMALL_AUTOMATION
  send_window_end_minutes
  send_window_start_minutes
  content
  email_content {
    html
    json
  }
  reply_to
  subject
  tags
  tags_add
  todo_overdue_hours
  todo_postponed_hours
  todo_priority
  todo_tags
  todo_assigned_to_id
  todo_assigned_to {
    ...FRAGMENT_USER_SMALL
  }
  todo_team_group_id
  todo_team_group {
    id
    name
  }
  assigned_tags {
    ...FRAGMENT_ASSIGNED_TAG
  }
  segment {
    ...FRAGMENT_FULL_SEGMENT
  }
  created_at
}
    ${FragmentSmallAutomationFragmentDoc}
${FragmentUserSmallFragmentDoc}
${FragmentAssignedTagFragmentDoc}
${FragmentFullSegmentFragmentDoc}`;
export const FragmentAutomationIndexFragmentDoc = gql`
    fragment FRAGMENT_AUTOMATION_INDEX on Automation {
  ...FRAGMENT_SMALL_AUTOMATION
  tags_add
  assigned_tags {
    ...FRAGMENT_ASSIGNED_TAG
  }
  segment {
    id
    name
  }
}
    ${FragmentSmallAutomationFragmentDoc}
${FragmentAssignedTagFragmentDoc}`;
export const FragmentAutomationStatsEmailOrSmsFragmentDoc = gql`
    fragment FRAGMENT_AUTOMATION_STATS_EMAIL_OR_SMS on AutomationStatsEmailOrSms {
  sent
  bounced
  delivered
  opened
  clicked
}
    `;
export const FragmentAutomationStatsTodoFragmentDoc = gql`
    fragment FRAGMENT_AUTOMATION_STATS_TODO on AutomationStatsTodo {
  created
  completed
  open
  postponed
  deleted
}
    `;
export const FragmentClientStatusFragmentDoc = gql`
    fragment FRAGMENT_CLIENT_STATUS on Client {
  is_lead
  active
  is_prospect
  frozen
}
    `;
export const FragmentClientMediaFragmentDoc = gql`
    fragment FRAGMENT_CLIENT_MEDIA on Media {
  id
  type
  url
}
    `;
export const FragmentClientSmallFragmentDoc = gql`
    fragment FRAGMENT_CLIENT_SMALL on Client {
  id
  external_id
  first_name
  last_name
  unsubscribed_email_at
  unsubscribed_sms_at
  unsubscribed_sms_text
  can_contact_by_email
  can_contact_by_sms
  home_location_id
  ...FRAGMENT_CLIENT_STATUS
  lead_completed
  email
  mobile_phone
  photos {
    ...FRAGMENT_CLIENT_MEDIA
  }
}
    ${FragmentClientStatusFragmentDoc}
${FragmentClientMediaFragmentDoc}`;
export const FragmentAutomationActionTagsFragmentDoc = gql`
    fragment FRAGMENT_AUTOMATION_ACTION_TAGS on AutomationAction {
  id
  action
  created_at
  affected {
    ...FRAGMENT_CLIENT_SMALL
  }
  related {
    ...FRAGMENT_ASSIGNED_TAG
  }
}
    ${FragmentClientSmallFragmentDoc}
${FragmentAssignedTagFragmentDoc}`;
export const FragmentAutomationStatsTagFragmentDoc = gql`
    fragment FRAGMENT_AUTOMATION_STATS_TAG on AutomationStatsTag {
  created
}
    `;
export const FragmentPlanFragmentDoc = gql`
    fragment FragmentPlan on Plan {
  id
  name
  price
  trial_days
  active
  interval
  addon
  addon_type
}
    `;
export const FragmentTeamSubscriptionItemFragmentDoc = gql`
    fragment FragmentTeamSubscriptionItem on TeamSubscriptionItem {
  name
  quantity
  plan {
    ...FragmentPlan
  }
}
    ${FragmentPlanFragmentDoc}`;
export const FragmentTeamSubscriptionFragmentDoc = gql`
    fragment FragmentTeamSubscription on TeamSubscription {
  quantity
  trial_ends_at
  ends_at
  status
  items {
    ...FragmentTeamSubscriptionItem
  }
}
    ${FragmentTeamSubscriptionItemFragmentDoc}`;
export const FragmentInvoiceFragmentDoc = gql`
    fragment FragmentInvoice on Invoice {
  id
  date
  total
}
    `;
export const CatalogItemIndexFragmentDoc = gql`
    fragment CATALOG_ITEM_INDEX on CatalogItem {
  id
  name
  description
  category
}
    `;
export const CatalogItemVariableFragmentFragmentDoc = gql`
    fragment CatalogItemVariableFragment on CatalogItemVariable {
  id
  field_type
  field_name
  field_description
}
    `;
export const CatalogItemSingleFragmentFragmentDoc = gql`
    fragment CatalogItemSingleFragment on CatalogItem {
  ...CATALOG_ITEM_INDEX
  long_description
  automation {
    name
    delivery_type
    todo_assigned_to_id
  }
  variable_fields {
    ...CatalogItemVariableFragment
  }
}
    ${CatalogItemIndexFragmentDoc}
${CatalogItemVariableFragmentFragmentDoc}`;
export const CatalogItemFullFragmentFragmentDoc = gql`
    fragment CatalogItemFullFragment on CatalogItem {
  ...CatalogItemSingleFragment
  automation {
    name
    category_name
    description
    delivery_type
    one_off
    start_at
    send_window_end_minutes
    send_window_start_minutes
    content
    one_off
    email_content {
      html
      json
    }
    reply_to
    subject
    tags
    tags_add
    todo_overdue_hours
    todo_postponed_hours
    todo_priority
    todo_tags
    todo_assigned_to_id
    todo_team_group_id
    segment {
      ...FRAGMENT_FULL_SEGMENT
    }
  }
}
    ${CatalogItemSingleFragmentFragmentDoc}
${FragmentFullSegmentFragmentDoc}`;
export const FragmentExcludedEventNameFragmentDoc = gql`
    fragment FRAGMENT_EXCLUDED_EVENT_NAME on ExcludedEventName {
  id
  name
}
    `;
export const FragmentClassSmallFragmentDoc = gql`
    fragment FRAGMENT_CLASS_SMALL on ClassModel {
  id
  name
  start_time
  end_time
  cancelled
  is_virtual
  event_type
}
    `;
export const CalendarClassFragmentFragmentDoc = gql`
    fragment calendarClassFragment on ClassModel {
  ...FRAGMENT_CLASS_SMALL
  visits {
    id
    signed_in
    late_cancelled
    early_cancel
  }
}
    ${FragmentClassSmallFragmentDoc}`;
export const FragmentStaffFragmentDoc = gql`
    fragment FRAGMENT_STAFF on Staff {
  id
  first_name
  last_name
  name
}
    `;
export const NextClassFragmentFragmentDoc = gql`
    fragment nextClassFragment on ClassModel {
  ...calendarClassFragment
  staff_id
  staff {
    ...FRAGMENT_STAFF
  }
}
    ${CalendarClassFragmentFragmentDoc}
${FragmentStaffFragmentDoc}`;
export const FragmentLocationInfoFragmentDoc = gql`
    fragment FRAGMENT_LOCATION_INFO on Location {
  id
  name
  timezone
  address_city
  address_line
  address_postal_code
  address_state
  latitude
  longitude
  external_id
  team_id
}
    `;
export const FragmentClassFullFragmentDoc = gql`
    fragment FRAGMENT_CLASS_FULL on ClassModel {
  ...FRAGMENT_CLASS_SMALL
  virtual_url
  virtual_data {
    virtual_id
    virtual_password
    virtual_info
  }
  location_id
  location {
    ...FRAGMENT_LOCATION_INFO
  }
  staff_id
  staff {
    ...FRAGMENT_STAFF
  }
}
    ${FragmentClassSmallFragmentDoc}
${FragmentLocationInfoFragmentDoc}
${FragmentStaffFragmentDoc}`;
export const FragmentStaffFullFragmentDoc = gql`
    fragment FRAGMENT_STAFF_FULL on Staff {
  ...FRAGMENT_STAFF
  country
  email
  external_id
  ismale
  mobile_phone
  state
}
    ${FragmentStaffFragmentDoc}`;
export const FragmentVisitBasicInfoFragmentDoc = gql`
    fragment FRAGMENT_VISIT_BASIC_INFO on Visit {
  id
  class_id
  client_id
  class_end_time
  signed_in
  late_cancelled
  early_cancel
  package_id
}
    `;
export const FragmentPackageInfoFragmentDoc = gql`
    fragment FRAGMENT_PACKAGE_INFO on Package {
  id
  name
  external_id
  team_id
  active
  active_at
  cancelled
  client_id
  contract_expires_at
  created_at
  current
  days_difference
  expires_at
  external_id
  has_rolling_activation
  is_rolling_active
  payment_at
  qta
  remaining
  updated_at
  last_used_at
}
    `;
export const FragmentClientCountsFragmentDoc = gql`
    fragment FRAGMENT_CLIENT_COUNTS on Client {
  total_open_discussions
  total_sales
  total_visits
  total_todos
  total_notes
  total_appointments
  total_club_counts
  total_period_counts
  total_form_instances
}
    `;
export const FragmentVisitWithClientAndPackageFragmentDoc = gql`
    fragment FRAGMENT_VISIT_WITH_CLIENT_AND_PACKAGE on Visit {
  ...FRAGMENT_VISIT_BASIC_INFO
  package {
    ...FRAGMENT_PACKAGE_INFO
  }
  client {
    ...FRAGMENT_CLIENT_SMALL
    ...FRAGMENT_CLIENT_COUNTS
  }
}
    ${FragmentVisitBasicInfoFragmentDoc}
${FragmentPackageInfoFragmentDoc}
${FragmentClientSmallFragmentDoc}
${FragmentClientCountsFragmentDoc}`;
export const SingleClassFragmentFragmentDoc = gql`
    fragment singleClassFragment on ClassModel {
  ...FRAGMENT_CLASS_FULL
  staff {
    ...FRAGMENT_STAFF_FULL
  }
  visits {
    ...FRAGMENT_VISIT_WITH_CLIENT_AND_PACKAGE
  }
}
    ${FragmentClassFullFragmentDoc}
${FragmentStaffFullFragmentDoc}
${FragmentVisitWithClientAndPackageFragmentDoc}`;
export const FragmentClientIndexListFragmentDoc = gql`
    fragment FRAGMENT_CLIENT_INDEX_LIST on Client {
  ...FRAGMENT_CLIENT_SMALL
  ...FRAGMENT_CLIENT_COUNTS
  last_attendance_at
  current_package {
    ...FRAGMENT_PACKAGE_INFO
  }
  last_discussion {
    id
    last_contacted_at
  }
}
    ${FragmentClientSmallFragmentDoc}
${FragmentClientCountsFragmentDoc}
${FragmentPackageInfoFragmentDoc}`;
export const FragmentClientTooltipFragmentDoc = gql`
    fragment FRAGMENT_CLIENT_TOOLTIP on Client {
  id
  first_name
  last_name
  ...FRAGMENT_CLIENT_STATUS
  lead_completed
  photos {
    ...FRAGMENT_CLIENT_MEDIA
  }
  total_club_counts
  total_period_counts
  mobile_phone
  last_attendance_at
  next_event {
    class {
      start_time
    }
  }
  ltv
}
    ${FragmentClientStatusFragmentDoc}
${FragmentClientMediaFragmentDoc}`;
export const FragmentClientNoteFragmentDoc = gql`
    fragment FRAGMENT_CLIENT_NOTE on ClientNote {
  id
  archived_at
  created_at
  updated_at
  created_by_id
  created_by {
    ...FRAGMENT_USER_SMALL
  }
  note
  note_model_id
  note_model_type
  team_id
}
    ${FragmentUserSmallFragmentDoc}`;
export const FragmentVisitSmallFragmentDoc = gql`
    fragment FRAGMENT_VISIT_SMALL on Visit {
  ...FRAGMENT_VISIT_BASIC_INFO
  class {
    ...FRAGMENT_CLASS_SMALL
  }
  package {
    ...FRAGMENT_PACKAGE_INFO
  }
}
    ${FragmentVisitBasicInfoFragmentDoc}
${FragmentClassSmallFragmentDoc}
${FragmentPackageInfoFragmentDoc}`;
export const FragmentClientFullFragmentDoc = gql`
    fragment FRAGMENT_CLIENT_FULL on Client {
  ...FRAGMENT_CLIENT_SMALL
  home_location {
    ...FRAGMENT_LOCATION_INFO
  }
  team_id
  tags {
    ...FRAGMENT_ASSIGNED_TAG
  }
  next_event {
    ...FRAGMENT_VISIT_SMALL
  }
  last_event {
    ...FRAGMENT_VISIT_SMALL
  }
  last_appointment_at
  last_attendance_at
  current_package {
    ...FRAGMENT_PACKAGE_INFO
  }
  address_line
  address_city
  address_state
  address_postal_code
  address_country
  ltv
  created_at
  updated_at
  creation_date
  birthday
  note_generic
  note_yellow
  note_red
  twitter
  twitter_bio
  twitter_followers
  twitter_following
  linkedin
  linkedin_bio
  linkedin_followers
  linkedin_following
  facebook
  instagram
  instagram_bio
  instagram_followers
  instagram_following
  username
  email
  mobile_phone
  phone_home
  phone_work
  phone_work_ext
  referred_by
  referrer {
    first_name
    last_name
    email
    phone
    location
  }
  bio
  job_title
  job_organization
  education {
    name
    end_year
    degree
  }
  emergency_contact_info_name
  emergency_contact_info_relationship
  emergency_contact_info_phone
  emergency_contact_info_email
  active
  email_opt_in
  liability_release
  is_company
  promotional_email_opt_in
  is_prospect
  frozen
  lead_signed_up_id
  mbo_index_values {
    name
    id
    mbo_index {
      name
      id
    }
  }
  mbo_member_status
  email_opt_in_reminder_at
  ...FRAGMENT_CLIENT_COUNTS
}
    ${FragmentClientSmallFragmentDoc}
${FragmentLocationInfoFragmentDoc}
${FragmentAssignedTagFragmentDoc}
${FragmentVisitSmallFragmentDoc}
${FragmentPackageInfoFragmentDoc}
${FragmentClientCountsFragmentDoc}`;
export const FragmentClientFullMutesTemporaryFieldsFragmentDoc = gql`
    fragment FRAGMENT_CLIENT_FULL_MUTES_TEMPORARY_FIELDS on Client {
  ...FRAGMENT_CLIENT_FULL
  referrer {
    email
    last_name
    first_name
    location
    phone
  }
  mutes {
    id
    muted_at
    muted_by {
      id
      name
    }
    muted_until
    unmuted_at
    unmuted_by {
      id
      name
    }
  }
}
    ${FragmentClientFullFragmentDoc}`;
export const FragmentDiscussionBasicFragmentDoc = gql`
    fragment FRAGMENT_DISCUSSION_BASIC on Discussion {
  id
  subject
  team_has_responded
  sms
  email
  closed
  sent
  bounced
  delivered
  opened
  clicked
  team_id
  client_id
  automation_id
  last_contacted_at
  created_at
  updated_at
}
    `;
export const FragmentMessageFragmentDoc = gql`
    fragment FRAGMENT_MESSAGE on Message {
  id
  user_id
  automation_id
  from_client
  bounced
  sent
  delivered
  clicked
  opened
  subject
  message
  created_at
  user {
    ...FRAGMENT_USER_SMALL
  }
  error_code
}
    ${FragmentUserSmallFragmentDoc}`;
export const FragmentDiscussionFullFragmentDoc = gql`
    fragment FRAGMENT_DISCUSSION_FULL on Discussion {
  ...FRAGMENT_DISCUSSION_BASIC
  client {
    ...FRAGMENT_CLIENT_SMALL
    ...FRAGMENT_CLIENT_COUNTS
  }
  automation {
    id
    name
    delivery_type
  }
  last_message {
    ...FRAGMENT_MESSAGE
  }
}
    ${FragmentDiscussionBasicFragmentDoc}
${FragmentClientSmallFragmentDoc}
${FragmentClientCountsFragmentDoc}
${FragmentMessageFragmentDoc}`;
export const FragmentDiscussionFromAutomationsFragmentDoc = gql`
    fragment FRAGMENT_DISCUSSION_FROM_AUTOMATIONS on Discussion {
  id
  subject
  team_has_responded
  sms
  email
  closed
  sent
  bounced
  delivered
  opened
  clicked
  team_id
  client_id
  automation_id
  last_contacted_at
  created_at
  updated_at
  client {
    ...FRAGMENT_CLIENT_SMALL
  }
}
    ${FragmentClientSmallFragmentDoc}`;
export const FragrmentSmallEmailTemplateFragmentDoc = gql`
    fragment FRAGRMENT_SMALL_EMAIL_TEMPLATE on EmailTemplate {
  id
  subject
  automation_id
  brand_id
  category
  team_id
  name
  thumbnail
  updated_at
}
    `;
export const FragrmentFullEmailTemplateFragmentDoc = gql`
    fragment FRAGRMENT_FULL_EMAIL_TEMPLATE on EmailTemplate {
  ...FRAGRMENT_SMALL_EMAIL_TEMPLATE
  email {
    html
    json
  }
}
    ${FragrmentSmallEmailTemplateFragmentDoc}`;
export const FormCatalogItemIndexFragmentDoc = gql`
    fragment FORM_CATALOG_ITEM_INDEX on FormCatalogItem {
  id
  name
  description
  category
}
    `;
export const FormCatalogItemSingleFragmentFragmentDoc = gql`
    fragment FormCatalogItemSingleFragment on FormCatalogItem {
  ...FORM_CATALOG_ITEM_INDEX
  long_description
  form_name
}
    ${FormCatalogItemIndexFragmentDoc}`;
export const FragmentFormSmallFragmentDoc = gql`
    fragment FRAGMENT_FORM_SMALL on Form {
  id
  name
  category
  allow_leads
  is_legal
  is_archived
  editable
  thank_you_message
  thank_you_url
  email_cc
}
    `;
export const FragmentFormBlockFragmentDoc = gql`
    fragment FRAGMENT_FORM_BLOCK on FormField {
  id
  kind
  description
  title
  optional
  options
  size
  content
  prefill
  mapping
}
    `;
export const FragmentFormFullFragmentDoc = gql`
    fragment FRAGMENT_FORM_FULL on Form {
  ...FRAGMENT_FORM_SMALL
  description
  title
  short_url
  content {
    ...FRAGMENT_FORM_BLOCK
  }
  archive_404
  archive_text
  send_to_mbo
  mbo_upload_lead
  mbo_update_client
  updated_at
  created_at
}
    ${FragmentFormSmallFragmentDoc}
${FragmentFormBlockFragmentDoc}`;
export const FragmentFormInstanceFromHistoryFragmentDoc = gql`
    fragment FRAGMENT_FORM_INSTANCE_FROM_HISTORY on FormInstance {
  id
  pdf_url
  created_at
  client {
    ...FRAGMENT_CLIENT_SMALL
    email
  }
}
    ${FragmentClientSmallFragmentDoc}`;
export const FragmentFormInstanceForClientsFragmentDoc = gql`
    fragment FRAGMENT_FORM_INSTANCE_FOR_CLIENTS on FormInstance {
  id
  pdf_url
  created_at
  form_id
  form {
    id
    name
    is_legal
    is_archived
    category
  }
}
    `;
export const FragmentFormWithCountFragmentDoc = gql`
    fragment FRAGMENT_FORM_WITH_COUNT on FormWithCount {
  id
  category
  is_legal
  allow_leads
  is_archived
  name
  cc
  last_completion_at
}
    `;
export const PaginatorFragmentFragmentDoc = gql`
    fragment PaginatorFragment on PaginatorInfo {
  count
  currentPage
  firstItem
  hasMorePages
  lastItem
  lastPage
  perPage
  total
}
    `;
export const FragmentInvitationSentFragmentDoc = gql`
    fragment FRAGMENT_INVITATION_SENT on Invitation {
  id
  email
  token
  role
  created_at
}
    `;
export const FragmentInvitationReceivedFragmentDoc = gql`
    fragment FRAGMENT_INVITATION_RECEIVED on Invitation {
  ...FRAGMENT_INVITATION_SENT
  team {
    name
    id
    photo_url
  }
}
    ${FragmentInvitationSentFragmentDoc}`;
export const FragmentMboIndexValueFragmentDoc = gql`
    fragment Fragment_Mbo_Index_Value on MboIndexValue {
  id
  name
  external_id
}
    `;
export const FragmentMboIndexFragmentDoc = gql`
    fragment Fragment_Mbo_Index on MboIndex {
  id
  name
  values {
    ...Fragment_Mbo_Index_Value
  }
}
    ${FragmentMboIndexValueFragmentDoc}`;
export const FragmentNoteTemplateFragmentDoc = gql`
    fragment FRAGMENT_NOTE_TEMPLATE on NoteTemplate {
  id
  team_id
  title
  body
  created_at
  updated_at
}
    `;
export const FragmentTeamSmallFragmentDoc = gql`
    fragment FRAGMENT_TEAM_SMALL on Team {
  id
  name
  photo_url
}
    `;
export const NotificationFragmentFragmentDoc = gql`
    fragment NotificationFragment on Notification {
  id
  read
  created_at
  body
  action_text
  action_url
  icon
  team {
    ...FRAGMENT_TEAM_SMALL
  }
}
    ${FragmentTeamSmallFragmentDoc}`;
export const ClientUnsubscribedFragmentFragmentDoc = gql`
    fragment ClientUnsubscribedFragment on Client {
  ...FRAGMENT_CLIENT_SMALL
  email
  mobile_phone
  last_attendance_at
  last_discussion {
    id
    last_contacted_at
  }
}
    ${FragmentClientSmallFragmentDoc}`;
export const PlaceholderFragmentFragmentDoc = gql`
    fragment PlaceholderFragment on Placeholder {
  name
  value
  placeholder
  group
  subgroup
}
    `;
export const FragmentQuickResponseFragmentDoc = gql`
    fragment FRAGMENT_QUICK_RESPONSE on QuickResponse {
  id
  team_id
  title
  content
  order
}
    `;
export const FragmentTodoFragmentDoc = gql`
    fragment FRAGMENT_TODO on Todo {
  id
  assigned_tags {
    ...FRAGMENT_ASSIGNED_TAG
  }
  automation_id
  automation {
    id
    name
  }
  client_id
  client {
    ...FRAGMENT_CLIENT_SMALL
  }
  completed_by_id
  completed_by {
    ...FRAGMENT_USER_SMALL
  }
  created_by_id
  created_by {
    ...FRAGMENT_USER_SMALL
  }
  deleted_by_id
  deleted_by {
    ...FRAGMENT_USER_SMALL
  }
  assigned_to_id
  assigned_to {
    ...FRAGMENT_USER_SMALL
  }
  completed_action_note
  completed_action_type
  completed_at
  deleted_at
  postponed_to
  overdue_at
  updated_at
  created_at
  priority
  is_closed
  is_deleted
  is_open
  is_postponed
  is_completed
  message
  subject
  team_group {
    id
    name
  }
}
    ${FragmentAssignedTagFragmentDoc}
${FragmentClientSmallFragmentDoc}
${FragmentUserSmallFragmentDoc}`;
export const FragmentUserCurrentRoleFragmentDoc = gql`
    fragment Fragment_User_Current_Role on CurrentRole {
  role
  at_least {
    member
    manager
    admin
    owner
  }
}
    `;
export const FragmentTeamFragmentDoc = gql`
    fragment FRAGMENT_TEAM on Team {
  ...FRAGMENT_TEAM_SMALL
  phone_number
  phone_forward
  provider_clubready
  provider_mindbody
  provider_pike13
  provider_fitdegree
  provider_name
  site_id
  sms_sender
  stripe_id
  subscription_active
  timezone
  twitter_handle
  zip
  owner_id
  color
  logo_url
  locations {
    ...FRAGMENT_LOCATION_INFO
  }
  outgoing_set
  provider
  provider_type
  can_create_automations
  external_token_present
  is_on_trial
  addon_forms
}
    ${FragmentTeamSmallFragmentDoc}
${FragmentLocationInfoFragmentDoc}`;
export const UserWithRoleFragmentFragmentDoc = gql`
    fragment UserWithRoleFragment on User {
  ...FRAGMENT_USER_SMALL
  email
  role
}
    ${FragmentUserSmallFragmentDoc}`;
export const CurrentTeamUsersFragmentDoc = gql`
    fragment CurrentTeamUsers on Team {
  users {
    ...UserWithRoleFragment
  }
}
    ${UserWithRoleFragmentFragmentDoc}`;
export const FragmentTeamGroupsFragmentDoc = gql`
    fragment FRAGMENT_TEAM_GROUPS on TeamGroup {
  id
  name
  users {
    ...FRAGMENT_USER_SMALL
  }
}
    ${FragmentUserSmallFragmentDoc}`;
export const FragmentSmsBundleFragmentDoc = gql`
    fragment FRAGMENT_SMS_BUNDLE on SmsBundle {
  id
  units
  units_left
  is_purchased
  expired
  expired_at
  created_at
  starts_at
}
    `;
export const FragmentCurrentTeamFragmentDoc = gql`
    fragment FRAGMENT_CURRENT_TEAM on Team {
  ...FRAGMENT_TEAM
  address
  email_sender
  email_sender_name
  email_signature
  twitter_handle
  facebook_url
  instagram_handle
  sms_sender
  phone_forward
  manager_name
  website
  first_import_done
  ...CurrentTeamUsers
  groups {
    ...FRAGMENT_TEAM_GROUPS
  }
  period_count_type
  period_count_data {
    period
    value
  }
  is_free
  trial_ends_at
  pm_type
  pm_last_four
  owner {
    ...FRAGMENT_USER_SMALL
  }
  external_token_present
  api_set
  approved
  sms_bundles {
    ...FRAGMENT_SMS_BUNDLE
  }
  addons {
    name
    active
    cancellable
  }
}
    ${FragmentTeamFragmentDoc}
${CurrentTeamUsersFragmentDoc}
${FragmentTeamGroupsFragmentDoc}
${FragmentUserSmallFragmentDoc}
${FragmentSmsBundleFragmentDoc}`;
export const FragmentUserPoliciesFragmentDoc = gql`
    fragment Fragment_User_Policies on UserPolicy {
  role
  add_tags
  is_owner
  is_manager
  is_admin
  is_main_owner
  edit_automations
  create_automations
  edit_forms
  create_forms
  export_clients
  staff_invite
  staff_change
  staff_remove
  create_email_templates
  edit_email_templates
  view_email_templates
  send_messages
}
    `;
export const FragmentTeamWithOwnerFragmentDoc = gql`
    fragment FRAGMENT_TEAM_WITH_OWNER on Team {
  ...FRAGMENT_TEAM
  owner {
    ...FRAGMENT_USER_SMALL
  }
  role
}
    ${FragmentTeamFragmentDoc}
${FragmentUserSmallFragmentDoc}`;
export const FragmentUserMeFragmentDoc = gql`
    fragment FRAGMENT_USER_ME on User {
  ...FRAGMENT_USER_SMALL
  email
  current_team_id
  current_team {
    ...FRAGMENT_CURRENT_TEAM
  }
  last_read_announcements_at
  policy @client {
    ...Fragment_User_Policies
  }
  permissions {
    name
  }
  teams {
    ...FRAGMENT_TEAM_WITH_OWNER
  }
}
    ${FragmentUserSmallFragmentDoc}
${FragmentCurrentTeamFragmentDoc}
${FragmentUserPoliciesFragmentDoc}
${FragmentTeamWithOwnerFragmentDoc}`;
export const FragmentVirtualClassInfoFragmentDoc = gql`
    fragment FRAGMENT_VIRTUAL_CLASS_INFO on VirtualClassInfo {
  id
  name
  day_of_week
  start_time
  virtual_url
  virtual_data {
    virtual_id
    virtual_password
    virtual_info
  }
}
    `;
export const FragmentVisitFullFragmentDoc = gql`
    fragment FRAGMENT_VISIT_FULL on Visit {
  ...FRAGMENT_VISIT_SMALL
  class {
    ...FRAGMENT_CLASS_FULL
  }
}
    ${FragmentVisitSmallFragmentDoc}
${FragmentClassFullFragmentDoc}`;
export const LoginDocument = gql`
    mutation login($input: LoginInput) {
  login(input: $input) {
    ...FRAGMENT_USER_ME
  }
}
    ${FragmentUserMeFragmentDoc}`;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLoginMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(options: VueApolloComposable.UseMutationOptions<QLLoginMutation, QLLoginMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLLoginMutation, QLLoginMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLLoginMutation, QLLoginMutationVariables>(LoginDocument, options);
}
export type LoginMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLLoginMutation, QLLoginMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout {
    ...FRAGMENT_USER_ME
  }
}
    ${FragmentUserMeFragmentDoc}`;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLogoutMutation();
 */
export function useLogoutMutation(options: VueApolloComposable.UseMutationOptions<QLLogoutMutation, QLLogoutMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLLogoutMutation, QLLogoutMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLLogoutMutation, QLLogoutMutationVariables>(LogoutDocument, options);
}
export type LogoutMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLLogoutMutation, QLLogoutMutationVariables>;
export const ReorderAutomationsDocument = gql`
    mutation ReorderAutomations($order: [AutomationReorderInput]!) {
  ReorderAutomations(order: $order) {
    ...FRAGMENT_SMALL_AUTOMATION
  }
}
    ${FragmentSmallAutomationFragmentDoc}`;

/**
 * __useReorderAutomationsMutation__
 *
 * To run a mutation, you first call `useReorderAutomationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReorderAutomationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReorderAutomationsMutation({
 *   variables: {
 *     order: // value for 'order'
 *   },
 * });
 */
export function useReorderAutomationsMutation(options: VueApolloComposable.UseMutationOptions<QLReorderAutomationsMutation, QLReorderAutomationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLReorderAutomationsMutation, QLReorderAutomationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLReorderAutomationsMutation, QLReorderAutomationsMutationVariables>(ReorderAutomationsDocument, options);
}
export type ReorderAutomationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLReorderAutomationsMutation, QLReorderAutomationsMutationVariables>;
export const CreateAutomationDocument = gql`
    mutation CreateAutomation($automation: CreateAutomationInput!) {
  CreateAutomation(automation: $automation) {
    ...FRAGMENT_FULL_AUTOMATION
  }
}
    ${FragmentFullAutomationFragmentDoc}`;

/**
 * __useCreateAutomationMutation__
 *
 * To run a mutation, you first call `useCreateAutomationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAutomationMutation({
 *   variables: {
 *     automation: // value for 'automation'
 *   },
 * });
 */
export function useCreateAutomationMutation(options: VueApolloComposable.UseMutationOptions<QLCreateAutomationMutation, QLCreateAutomationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCreateAutomationMutation, QLCreateAutomationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCreateAutomationMutation, QLCreateAutomationMutationVariables>(CreateAutomationDocument, options);
}
export type CreateAutomationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCreateAutomationMutation, QLCreateAutomationMutationVariables>;
export const UpdateAutomationFullDocument = gql`
    mutation UpdateAutomationFull($id: ID!, $automation: CreateAutomationInput!) {
  UpdateAutomationFull(id: $id, automation: $automation) {
    ...FRAGMENT_FULL_AUTOMATION
  }
}
    ${FragmentFullAutomationFragmentDoc}`;

/**
 * __useUpdateAutomationFullMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationFullMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationFullMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAutomationFullMutation({
 *   variables: {
 *     id: // value for 'id'
 *     automation: // value for 'automation'
 *   },
 * });
 */
export function useUpdateAutomationFullMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateAutomationFullMutation, QLUpdateAutomationFullMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateAutomationFullMutation, QLUpdateAutomationFullMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateAutomationFullMutation, QLUpdateAutomationFullMutationVariables>(UpdateAutomationFullDocument, options);
}
export type UpdateAutomationFullMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateAutomationFullMutation, QLUpdateAutomationFullMutationVariables>;
export const UpdateAutomationDocument = gql`
    mutation UpdateAutomation($id: ID!, $active: Boolean, $archived: Boolean, $assigned_tags: [String]) {
  UpdateAutomation(
    id: $id
    active: $active
    archived: $archived
    assigned_tags: $assigned_tags
  ) {
    ...FRAGMENT_FULL_AUTOMATION
  }
}
    ${FragmentFullAutomationFragmentDoc}`;

/**
 * __useUpdateAutomationMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAutomationMutation({
 *   variables: {
 *     id: // value for 'id'
 *     active: // value for 'active'
 *     archived: // value for 'archived'
 *     assigned_tags: // value for 'assigned_tags'
 *   },
 * });
 */
export function useUpdateAutomationMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateAutomationMutation, QLUpdateAutomationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateAutomationMutation, QLUpdateAutomationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateAutomationMutation, QLUpdateAutomationMutationVariables>(UpdateAutomationDocument, options);
}
export type UpdateAutomationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateAutomationMutation, QLUpdateAutomationMutationVariables>;
export const ToggleAutomationActiveDocument = gql`
    mutation ToggleAutomationActive($id: ID!, $active: Boolean) {
  ToggleAutomationActive: UpdateAutomation(id: $id, active: $active) {
    ...FRAGMENT_FULL_AUTOMATION
  }
}
    ${FragmentFullAutomationFragmentDoc}`;

/**
 * __useToggleAutomationActiveMutation__
 *
 * To run a mutation, you first call `useToggleAutomationActiveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useToggleAutomationActiveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useToggleAutomationActiveMutation({
 *   variables: {
 *     id: // value for 'id'
 *     active: // value for 'active'
 *   },
 * });
 */
export function useToggleAutomationActiveMutation(options: VueApolloComposable.UseMutationOptions<QLToggleAutomationActiveMutation, QLToggleAutomationActiveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLToggleAutomationActiveMutation, QLToggleAutomationActiveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLToggleAutomationActiveMutation, QLToggleAutomationActiveMutationVariables>(ToggleAutomationActiveDocument, options);
}
export type ToggleAutomationActiveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLToggleAutomationActiveMutation, QLToggleAutomationActiveMutationVariables>;
export const ExportAutomationDocument = gql`
    mutation ExportAutomation($id: ID!) {
  ExportAutomation(id: $id) {
    status
  }
}
    `;

/**
 * __useExportAutomationMutation__
 *
 * To run a mutation, you first call `useExportAutomationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExportAutomationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExportAutomationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useExportAutomationMutation(options: VueApolloComposable.UseMutationOptions<QLExportAutomationMutation, QLExportAutomationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLExportAutomationMutation, QLExportAutomationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLExportAutomationMutation, QLExportAutomationMutationVariables>(ExportAutomationDocument, options);
}
export type ExportAutomationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLExportAutomationMutation, QLExportAutomationMutationVariables>;
export const SendAutomationManuallyDocument = gql`
    mutation SendAutomationManually($client_id: ID!, $automation_id: ID!) {
  SendAutomationManually(client_id: $client_id, automation_id: $automation_id) {
    ok
  }
}
    `;

/**
 * __useSendAutomationManuallyMutation__
 *
 * To run a mutation, you first call `useSendAutomationManuallyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendAutomationManuallyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendAutomationManuallyMutation({
 *   variables: {
 *     client_id: // value for 'client_id'
 *     automation_id: // value for 'automation_id'
 *   },
 * });
 */
export function useSendAutomationManuallyMutation(options: VueApolloComposable.UseMutationOptions<QLSendAutomationManuallyMutation, QLSendAutomationManuallyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLSendAutomationManuallyMutation, QLSendAutomationManuallyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLSendAutomationManuallyMutation, QLSendAutomationManuallyMutationVariables>(SendAutomationManuallyDocument, options);
}
export type SendAutomationManuallyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLSendAutomationManuallyMutation, QLSendAutomationManuallyMutationVariables>;
export const CopyAutomationDocument = gql`
    mutation CopyAutomation($id: ID!, $destination_team_id: ID!) {
  CopyAutomation(id: $id, destination_team_id: $destination_team_id) {
    ...FRAGMENT_SMALL_AUTOMATION
  }
}
    ${FragmentSmallAutomationFragmentDoc}`;

/**
 * __useCopyAutomationMutation__
 *
 * To run a mutation, you first call `useCopyAutomationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCopyAutomationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCopyAutomationMutation({
 *   variables: {
 *     id: // value for 'id'
 *     destination_team_id: // value for 'destination_team_id'
 *   },
 * });
 */
export function useCopyAutomationMutation(options: VueApolloComposable.UseMutationOptions<QLCopyAutomationMutation, QLCopyAutomationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCopyAutomationMutation, QLCopyAutomationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCopyAutomationMutation, QLCopyAutomationMutationVariables>(CopyAutomationDocument, options);
}
export type CopyAutomationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCopyAutomationMutation, QLCopyAutomationMutationVariables>;
export const CloneAutomationDocument = gql`
    mutation CloneAutomation($id: ID!) {
  CloneAutomation(id: $id) {
    ...FRAGMENT_SMALL_AUTOMATION
  }
}
    ${FragmentSmallAutomationFragmentDoc}`;

/**
 * __useCloneAutomationMutation__
 *
 * To run a mutation, you first call `useCloneAutomationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCloneAutomationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCloneAutomationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCloneAutomationMutation(options: VueApolloComposable.UseMutationOptions<QLCloneAutomationMutation, QLCloneAutomationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCloneAutomationMutation, QLCloneAutomationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCloneAutomationMutation, QLCloneAutomationMutationVariables>(CloneAutomationDocument, options);
}
export type CloneAutomationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCloneAutomationMutation, QLCloneAutomationMutationVariables>;
export const BulkUpdateAutomationsDocument = gql`
    mutation BulkUpdateAutomations($ids: [ID]!, $action: AutomationBulkActionEnum!) {
  BulkUpdateAutomations(ids: $ids, action: $action) {
    ...FRAGMENT_SMALL_AUTOMATION
  }
}
    ${FragmentSmallAutomationFragmentDoc}`;

/**
 * __useBulkUpdateAutomationsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateAutomationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateAutomationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkUpdateAutomationsMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *     action: // value for 'action'
 *   },
 * });
 */
export function useBulkUpdateAutomationsMutation(options: VueApolloComposable.UseMutationOptions<QLBulkUpdateAutomationsMutation, QLBulkUpdateAutomationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLBulkUpdateAutomationsMutation, QLBulkUpdateAutomationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLBulkUpdateAutomationsMutation, QLBulkUpdateAutomationsMutationVariables>(BulkUpdateAutomationsDocument, options);
}
export type BulkUpdateAutomationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLBulkUpdateAutomationsMutation, QLBulkUpdateAutomationsMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation cancelSubscription {
  cancelSubscription {
    ...FragmentTeamSubscription
  }
}
    ${FragmentTeamSubscriptionFragmentDoc}`;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelSubscriptionMutation();
 */
export function useCancelSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<QLCancelSubscriptionMutation, QLCancelSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCancelSubscriptionMutation, QLCancelSubscriptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCancelSubscriptionMutation, QLCancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
}
export type CancelSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCancelSubscriptionMutation, QLCancelSubscriptionMutationVariables>;
export const ResumeSubscriptionDocument = gql`
    mutation resumeSubscription {
  resumeSubscription {
    ...FragmentTeamSubscription
  }
}
    ${FragmentTeamSubscriptionFragmentDoc}`;

/**
 * __useResumeSubscriptionMutation__
 *
 * To run a mutation, you first call `useResumeSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResumeSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResumeSubscriptionMutation();
 */
export function useResumeSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<QLResumeSubscriptionMutation, QLResumeSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLResumeSubscriptionMutation, QLResumeSubscriptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLResumeSubscriptionMutation, QLResumeSubscriptionMutationVariables>(ResumeSubscriptionDocument, options);
}
export type ResumeSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLResumeSubscriptionMutation, QLResumeSubscriptionMutationVariables>;
export const GeneratePaymentTokenDocument = gql`
    mutation generatePaymentToken {
  generatePaymentToken {
    client_secret
  }
}
    `;

/**
 * __useGeneratePaymentTokenMutation__
 *
 * To run a mutation, you first call `useGeneratePaymentTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePaymentTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGeneratePaymentTokenMutation();
 */
export function useGeneratePaymentTokenMutation(options: VueApolloComposable.UseMutationOptions<QLGeneratePaymentTokenMutation, QLGeneratePaymentTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLGeneratePaymentTokenMutation, QLGeneratePaymentTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLGeneratePaymentTokenMutation, QLGeneratePaymentTokenMutationVariables>(GeneratePaymentTokenDocument, options);
}
export type GeneratePaymentTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLGeneratePaymentTokenMutation, QLGeneratePaymentTokenMutationVariables>;
export const UpdatePaymentMethodDocument = gql`
    mutation updatePaymentMethod($payment_method: String!) {
  updatePaymentMethod(payment_method: $payment_method) {
    ...FRAGMENT_CURRENT_TEAM
  }
}
    ${FragmentCurrentTeamFragmentDoc}`;

/**
 * __useUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePaymentMethodMutation({
 *   variables: {
 *     payment_method: // value for 'payment_method'
 *   },
 * });
 */
export function useUpdatePaymentMethodMutation(options: VueApolloComposable.UseMutationOptions<QLUpdatePaymentMethodMutation, QLUpdatePaymentMethodMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdatePaymentMethodMutation, QLUpdatePaymentMethodMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdatePaymentMethodMutation, QLUpdatePaymentMethodMutationVariables>(UpdatePaymentMethodDocument, options);
}
export type UpdatePaymentMethodMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdatePaymentMethodMutation, QLUpdatePaymentMethodMutationVariables>;
export const StartSubscriptionDocument = gql`
    mutation startSubscription($plan: String!, $payment_method: String, $coupon: String) {
  startSubscription(plan: $plan, payment_method: $payment_method, coupon: $coupon) {
    ...FragmentTeamSubscription
  }
}
    ${FragmentTeamSubscriptionFragmentDoc}`;

/**
 * __useStartSubscriptionMutation__
 *
 * To run a mutation, you first call `useStartSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartSubscriptionMutation({
 *   variables: {
 *     plan: // value for 'plan'
 *     payment_method: // value for 'payment_method'
 *     coupon: // value for 'coupon'
 *   },
 * });
 */
export function useStartSubscriptionMutation(options: VueApolloComposable.UseMutationOptions<QLStartSubscriptionMutation, QLStartSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLStartSubscriptionMutation, QLStartSubscriptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLStartSubscriptionMutation, QLStartSubscriptionMutationVariables>(StartSubscriptionDocument, options);
}
export type StartSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLStartSubscriptionMutation, QLStartSubscriptionMutationVariables>;
export const StartAddonDocument = gql`
    mutation startAddon($addon: String!) {
  startAddon(addon: $addon) {
    ...FragmentTeamSubscription
  }
}
    ${FragmentTeamSubscriptionFragmentDoc}`;

/**
 * __useStartAddonMutation__
 *
 * To run a mutation, you first call `useStartAddonMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartAddonMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartAddonMutation({
 *   variables: {
 *     addon: // value for 'addon'
 *   },
 * });
 */
export function useStartAddonMutation(options: VueApolloComposable.UseMutationOptions<QLStartAddonMutation, QLStartAddonMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLStartAddonMutation, QLStartAddonMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLStartAddonMutation, QLStartAddonMutationVariables>(StartAddonDocument, options);
}
export type StartAddonMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLStartAddonMutation, QLStartAddonMutationVariables>;
export const StopAddonDocument = gql`
    mutation stopAddon($addon: String!) {
  stopAddon(addon: $addon) {
    ...FragmentTeamSubscription
  }
}
    ${FragmentTeamSubscriptionFragmentDoc}`;

/**
 * __useStopAddonMutation__
 *
 * To run a mutation, you first call `useStopAddonMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStopAddonMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStopAddonMutation({
 *   variables: {
 *     addon: // value for 'addon'
 *   },
 * });
 */
export function useStopAddonMutation(options: VueApolloComposable.UseMutationOptions<QLStopAddonMutation, QLStopAddonMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLStopAddonMutation, QLStopAddonMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLStopAddonMutation, QLStopAddonMutationVariables>(StopAddonDocument, options);
}
export type StopAddonMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLStopAddonMutation, QLStopAddonMutationVariables>;
export const AddCatalogToAutomationsDocument = gql`
    mutation AddCatalogToAutomations($catalog_id: ID!, $catalog_data: CatalogItemToAutomationInput!) {
  AddCatalogToAutomations(catalog_id: $catalog_id, catalog_data: $catalog_data) {
    ...FRAGMENT_AUTOMATION_INDEX
  }
}
    ${FragmentAutomationIndexFragmentDoc}`;

/**
 * __useAddCatalogToAutomationsMutation__
 *
 * To run a mutation, you first call `useAddCatalogToAutomationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCatalogToAutomationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCatalogToAutomationsMutation({
 *   variables: {
 *     catalog_id: // value for 'catalog_id'
 *     catalog_data: // value for 'catalog_data'
 *   },
 * });
 */
export function useAddCatalogToAutomationsMutation(options: VueApolloComposable.UseMutationOptions<QLAddCatalogToAutomationsMutation, QLAddCatalogToAutomationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLAddCatalogToAutomationsMutation, QLAddCatalogToAutomationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLAddCatalogToAutomationsMutation, QLAddCatalogToAutomationsMutationVariables>(AddCatalogToAutomationsDocument, options);
}
export type AddCatalogToAutomationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLAddCatalogToAutomationsMutation, QLAddCatalogToAutomationsMutationVariables>;
export const SaveCatalogItemDocument = gql`
    mutation SaveCatalogItem($id: ID, $catalogItem: CatalogItemInput!) {
  SaveCatalogItem(id: $id, catalogItem: $catalogItem) {
    ...CatalogItemFullFragment
  }
}
    ${CatalogItemFullFragmentFragmentDoc}`;

/**
 * __useSaveCatalogItemMutation__
 *
 * To run a mutation, you first call `useSaveCatalogItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveCatalogItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveCatalogItemMutation({
 *   variables: {
 *     id: // value for 'id'
 *     catalogItem: // value for 'catalogItem'
 *   },
 * });
 */
export function useSaveCatalogItemMutation(options: VueApolloComposable.UseMutationOptions<QLSaveCatalogItemMutation, QLSaveCatalogItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLSaveCatalogItemMutation, QLSaveCatalogItemMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLSaveCatalogItemMutation, QLSaveCatalogItemMutationVariables>(SaveCatalogItemDocument, options);
}
export type SaveCatalogItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLSaveCatalogItemMutation, QLSaveCatalogItemMutationVariables>;
export const UpdateClassDocument = gql`
    mutation UpdateClass($id: ID!, $is_virtual: Boolean!, $virtual_url: String, $virtual_data: ClassVirtualDataInput) {
  UpdateClass(
    id: $id
    is_virtual: $is_virtual
    virtual_url: $virtual_url
    virtual_data: $virtual_data
  ) {
    ...FRAGMENT_CLASS_FULL
  }
}
    ${FragmentClassFullFragmentDoc}`;

/**
 * __useUpdateClassMutation__
 *
 * To run a mutation, you first call `useUpdateClassMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateClassMutation({
 *   variables: {
 *     id: // value for 'id'
 *     is_virtual: // value for 'is_virtual'
 *     virtual_url: // value for 'virtual_url'
 *     virtual_data: // value for 'virtual_data'
 *   },
 * });
 */
export function useUpdateClassMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateClassMutation, QLUpdateClassMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateClassMutation, QLUpdateClassMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateClassMutation, QLUpdateClassMutationVariables>(UpdateClassDocument, options);
}
export type UpdateClassMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateClassMutation, QLUpdateClassMutationVariables>;
export const MuteClientDocument = gql`
    mutation muteClient($client_id: ID!, $muted_until: Timestamp!) {
  muteClient(client_id: $client_id, muted_until: $muted_until) {
    success
    message
    mute {
      id
      client_id
      muted_until
      muted_by {
        id
      }
    }
  }
}
    `;

/**
 * __useMuteClientMutation__
 *
 * To run a mutation, you first call `useMuteClientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMuteClientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMuteClientMutation({
 *   variables: {
 *     client_id: // value for 'client_id'
 *     muted_until: // value for 'muted_until'
 *   },
 * });
 */
export function useMuteClientMutation(options: VueApolloComposable.UseMutationOptions<QLMuteClientMutation, QLMuteClientMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLMuteClientMutation, QLMuteClientMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLMuteClientMutation, QLMuteClientMutationVariables>(MuteClientDocument, options);
}
export type MuteClientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLMuteClientMutation, QLMuteClientMutationVariables>;
export const UnmuteClientDocument = gql`
    mutation unmuteClient($client_id: ID!) {
  unmuteClient(client_id: $client_id) {
    success
    message
    mutes {
      id
      client_id
      unmuted_at
      unmuted_by {
        id
      }
    }
  }
}
    `;

/**
 * __useUnmuteClientMutation__
 *
 * To run a mutation, you first call `useUnmuteClientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnmuteClientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnmuteClientMutation({
 *   variables: {
 *     client_id: // value for 'client_id'
 *   },
 * });
 */
export function useUnmuteClientMutation(options: VueApolloComposable.UseMutationOptions<QLUnmuteClientMutation, QLUnmuteClientMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUnmuteClientMutation, QLUnmuteClientMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUnmuteClientMutation, QLUnmuteClientMutationVariables>(UnmuteClientDocument, options);
}
export type UnmuteClientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUnmuteClientMutation, QLUnmuteClientMutationVariables>;
export const UpdateClientDocument = gql`
    mutation UpdateClient($id: ID!, $tags: [String], $unsubscribed_email_at: Int, $unsubscribed_sms_at: Int) {
  UpdateClient(
    id: $id
    tags: $tags
    unsubscribed_email_at: $unsubscribed_email_at
    unsubscribed_sms_at: $unsubscribed_sms_at
  ) {
    ...FRAGMENT_CLIENT_FULL
  }
}
    ${FragmentClientFullFragmentDoc}`;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateClientMutation({
 *   variables: {
 *     id: // value for 'id'
 *     tags: // value for 'tags'
 *     unsubscribed_email_at: // value for 'unsubscribed_email_at'
 *     unsubscribed_sms_at: // value for 'unsubscribed_sms_at'
 *   },
 * });
 */
export function useUpdateClientMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateClientMutation, QLUpdateClientMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateClientMutation, QLUpdateClientMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateClientMutation, QLUpdateClientMutationVariables>(UpdateClientDocument, options);
}
export type UpdateClientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateClientMutation, QLUpdateClientMutationVariables>;
export const CreateProspectDocument = gql`
    mutation CreateProspect($email: String, $first_name: String, $last_name: String, $mobile_phone: String, $referred_by: String) {
  CreateProspect(
    email: $email
    first_name: $first_name
    last_name: $last_name
    mobile_phone: $mobile_phone
    referred_by: $referred_by
  ) {
    id
  }
}
    `;

/**
 * __useCreateProspectMutation__
 *
 * To run a mutation, you first call `useCreateProspectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateProspectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateProspectMutation({
 *   variables: {
 *     email: // value for 'email'
 *     first_name: // value for 'first_name'
 *     last_name: // value for 'last_name'
 *     mobile_phone: // value for 'mobile_phone'
 *     referred_by: // value for 'referred_by'
 *   },
 * });
 */
export function useCreateProspectMutation(options: VueApolloComposable.UseMutationOptions<QLCreateProspectMutation, QLCreateProspectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCreateProspectMutation, QLCreateProspectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCreateProspectMutation, QLCreateProspectMutationVariables>(CreateProspectDocument, options);
}
export type CreateProspectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCreateProspectMutation, QLCreateProspectMutationVariables>;
export const UpdateLeadDocument = gql`
    mutation UpdateLead($id: ID!, $email: String, $first_name: String, $last_name: String, $mobile_phone: String, $referred_by: String, $frozen: Boolean) {
  UpdateLead(
    id: $id
    email: $email
    first_name: $first_name
    last_name: $last_name
    mobile_phone: $mobile_phone
    referred_by: $referred_by
    frozen: $frozen
  ) {
    ...FRAGMENT_CLIENT_FULL
  }
}
    ${FragmentClientFullFragmentDoc}`;

/**
 * __useUpdateLeadMutation__
 *
 * To run a mutation, you first call `useUpdateLeadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateLeadMutation({
 *   variables: {
 *     id: // value for 'id'
 *     email: // value for 'email'
 *     first_name: // value for 'first_name'
 *     last_name: // value for 'last_name'
 *     mobile_phone: // value for 'mobile_phone'
 *     referred_by: // value for 'referred_by'
 *     frozen: // value for 'frozen'
 *   },
 * });
 */
export function useUpdateLeadMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateLeadMutation, QLUpdateLeadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateLeadMutation, QLUpdateLeadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateLeadMutation, QLUpdateLeadMutationVariables>(UpdateLeadDocument, options);
}
export type UpdateLeadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateLeadMutation, QLUpdateLeadMutationVariables>;
export const ExportClientsDocument = gql`
    mutation ExportClients($segment: SegmentInput!) {
  ExportClients(segment: $segment) {
    status
  }
}
    `;

/**
 * __useExportClientsMutation__
 *
 * To run a mutation, you first call `useExportClientsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExportClientsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExportClientsMutation({
 *   variables: {
 *     segment: // value for 'segment'
 *   },
 * });
 */
export function useExportClientsMutation(options: VueApolloComposable.UseMutationOptions<QLExportClientsMutation, QLExportClientsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLExportClientsMutation, QLExportClientsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLExportClientsMutation, QLExportClientsMutationVariables>(ExportClientsDocument, options);
}
export type ExportClientsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLExportClientsMutation, QLExportClientsMutationVariables>;
export const SendEmailOptInReminderDocument = gql`
    mutation SendEmailOptInReminder($id: ID!) {
  SendEmailOptInReminder(id: $id) {
    id
    unsubscribed_email_at
    email_opt_in_reminder_at
    can_contact_by_email
  }
}
    `;

/**
 * __useSendEmailOptInReminderMutation__
 *
 * To run a mutation, you first call `useSendEmailOptInReminderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailOptInReminderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendEmailOptInReminderMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSendEmailOptInReminderMutation(options: VueApolloComposable.UseMutationOptions<QLSendEmailOptInReminderMutation, QLSendEmailOptInReminderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLSendEmailOptInReminderMutation, QLSendEmailOptInReminderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLSendEmailOptInReminderMutation, QLSendEmailOptInReminderMutationVariables>(SendEmailOptInReminderDocument, options);
}
export type SendEmailOptInReminderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLSendEmailOptInReminderMutation, QLSendEmailOptInReminderMutationVariables>;
export const DeleteExcludedEventNameDocument = gql`
    mutation DeleteExcludedEventName($id: ID!) {
  DeleteExcludedEventName(id: $id) {
    ...FRAGMENT_EXCLUDED_EVENT_NAME
  }
}
    ${FragmentExcludedEventNameFragmentDoc}`;

/**
 * __useDeleteExcludedEventNameMutation__
 *
 * To run a mutation, you first call `useDeleteExcludedEventNameMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExcludedEventNameMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteExcludedEventNameMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExcludedEventNameMutation(options: VueApolloComposable.UseMutationOptions<QLDeleteExcludedEventNameMutation, QLDeleteExcludedEventNameMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLDeleteExcludedEventNameMutation, QLDeleteExcludedEventNameMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLDeleteExcludedEventNameMutation, QLDeleteExcludedEventNameMutationVariables>(DeleteExcludedEventNameDocument, options);
}
export type DeleteExcludedEventNameMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLDeleteExcludedEventNameMutation, QLDeleteExcludedEventNameMutationVariables>;
export const CreateExcludedEventNameDocument = gql`
    mutation CreateExcludedEventName($name: String!) {
  CreateExcludedEventName(name: $name) {
    ...FRAGMENT_EXCLUDED_EVENT_NAME
  }
}
    ${FragmentExcludedEventNameFragmentDoc}`;

/**
 * __useCreateExcludedEventNameMutation__
 *
 * To run a mutation, you first call `useCreateExcludedEventNameMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateExcludedEventNameMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateExcludedEventNameMutation({
 *   variables: {
 *     name: // value for 'name'
 *   },
 * });
 */
export function useCreateExcludedEventNameMutation(options: VueApolloComposable.UseMutationOptions<QLCreateExcludedEventNameMutation, QLCreateExcludedEventNameMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCreateExcludedEventNameMutation, QLCreateExcludedEventNameMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCreateExcludedEventNameMutation, QLCreateExcludedEventNameMutationVariables>(CreateExcludedEventNameDocument, options);
}
export type CreateExcludedEventNameMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCreateExcludedEventNameMutation, QLCreateExcludedEventNameMutationVariables>;
export const UpdateTeamPeriodCountSettingsDocument = gql`
    mutation UpdateTeamPeriodCountSettings($period_count_type: PeriodCountType!, $period_count_data: PeriodDataInput!) {
  UpdateTeamPeriodCountSettings(
    period_count_type: $period_count_type
    period_count_data: $period_count_data
  ) {
    id
    period_count_type
    period_count_data {
      period
      value
    }
  }
}
    `;

/**
 * __useUpdateTeamPeriodCountSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTeamPeriodCountSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamPeriodCountSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTeamPeriodCountSettingsMutation({
 *   variables: {
 *     period_count_type: // value for 'period_count_type'
 *     period_count_data: // value for 'period_count_data'
 *   },
 * });
 */
export function useUpdateTeamPeriodCountSettingsMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateTeamPeriodCountSettingsMutation, QLUpdateTeamPeriodCountSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateTeamPeriodCountSettingsMutation, QLUpdateTeamPeriodCountSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateTeamPeriodCountSettingsMutation, QLUpdateTeamPeriodCountSettingsMutationVariables>(UpdateTeamPeriodCountSettingsDocument, options);
}
export type UpdateTeamPeriodCountSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateTeamPeriodCountSettingsMutation, QLUpdateTeamPeriodCountSettingsMutationVariables>;
export const DiscussionCreateDocument = gql`
    mutation DiscussionCreate($client_id: ID!, $subject: String, $message: String!, $is_email: Boolean!) {
  CreateDiscussion(
    client_id: $client_id
    subject: $subject
    message: $message
    is_email: $is_email
  ) {
    ...FRAGMENT_DISCUSSION_FULL
    messages {
      ...FRAGMENT_MESSAGE
    }
  }
}
    ${FragmentDiscussionFullFragmentDoc}
${FragmentMessageFragmentDoc}`;

/**
 * __useDiscussionCreateMutation__
 *
 * To run a mutation, you first call `useDiscussionCreateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDiscussionCreateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDiscussionCreateMutation({
 *   variables: {
 *     client_id: // value for 'client_id'
 *     subject: // value for 'subject'
 *     message: // value for 'message'
 *     is_email: // value for 'is_email'
 *   },
 * });
 */
export function useDiscussionCreateMutation(options: VueApolloComposable.UseMutationOptions<QLDiscussionCreateMutation, QLDiscussionCreateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLDiscussionCreateMutation, QLDiscussionCreateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLDiscussionCreateMutation, QLDiscussionCreateMutationVariables>(DiscussionCreateDocument, options);
}
export type DiscussionCreateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLDiscussionCreateMutation, QLDiscussionCreateMutationVariables>;
export const CreateDiscussionEventDocument = gql`
    mutation CreateDiscussionEvent($client_id: ID!, $subject: String, $message: String!, $is_email: Boolean!) {
  CreateDiscussionEvent(
    client_id: $client_id
    subject: $subject
    message: $message
    is_email: $is_email
  ) {
    ...FRAGMENT_DISCUSSION_FULL
    messages {
      ...FRAGMENT_MESSAGE
    }
  }
}
    ${FragmentDiscussionFullFragmentDoc}
${FragmentMessageFragmentDoc}`;

/**
 * __useCreateDiscussionEventMutation__
 *
 * To run a mutation, you first call `useCreateDiscussionEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscussionEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDiscussionEventMutation({
 *   variables: {
 *     client_id: // value for 'client_id'
 *     subject: // value for 'subject'
 *     message: // value for 'message'
 *     is_email: // value for 'is_email'
 *   },
 * });
 */
export function useCreateDiscussionEventMutation(options: VueApolloComposable.UseMutationOptions<QLCreateDiscussionEventMutation, QLCreateDiscussionEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCreateDiscussionEventMutation, QLCreateDiscussionEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCreateDiscussionEventMutation, QLCreateDiscussionEventMutationVariables>(CreateDiscussionEventDocument, options);
}
export type CreateDiscussionEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCreateDiscussionEventMutation, QLCreateDiscussionEventMutationVariables>;
export const DiscussionAddMessageDocument = gql`
    mutation DiscussionAddMessage($id: ID!, $message: String!) {
  DiscussionAddMessage(id: $id, message: $message) {
    ...FRAGMENT_DISCUSSION_FULL
    messages {
      ...FRAGMENT_MESSAGE
    }
  }
}
    ${FragmentDiscussionFullFragmentDoc}
${FragmentMessageFragmentDoc}`;

/**
 * __useDiscussionAddMessageMutation__
 *
 * To run a mutation, you first call `useDiscussionAddMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDiscussionAddMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDiscussionAddMessageMutation({
 *   variables: {
 *     id: // value for 'id'
 *     message: // value for 'message'
 *   },
 * });
 */
export function useDiscussionAddMessageMutation(options: VueApolloComposable.UseMutationOptions<QLDiscussionAddMessageMutation, QLDiscussionAddMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLDiscussionAddMessageMutation, QLDiscussionAddMessageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLDiscussionAddMessageMutation, QLDiscussionAddMessageMutationVariables>(DiscussionAddMessageDocument, options);
}
export type DiscussionAddMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLDiscussionAddMessageMutation, QLDiscussionAddMessageMutationVariables>;
export const DiscussionUpdateDocument = gql`
    mutation DiscussionUpdate($id: ID!, $closed: Boolean!) {
  UpdateDiscussion(id: $id, closed: $closed) {
    ...FRAGMENT_DISCUSSION_FULL
    messages {
      ...FRAGMENT_MESSAGE
    }
  }
}
    ${FragmentDiscussionFullFragmentDoc}
${FragmentMessageFragmentDoc}`;

/**
 * __useDiscussionUpdateMutation__
 *
 * To run a mutation, you first call `useDiscussionUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDiscussionUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDiscussionUpdateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     closed: // value for 'closed'
 *   },
 * });
 */
export function useDiscussionUpdateMutation(options: VueApolloComposable.UseMutationOptions<QLDiscussionUpdateMutation, QLDiscussionUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLDiscussionUpdateMutation, QLDiscussionUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLDiscussionUpdateMutation, QLDiscussionUpdateMutationVariables>(DiscussionUpdateDocument, options);
}
export type DiscussionUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLDiscussionUpdateMutation, QLDiscussionUpdateMutationVariables>;
export const EmailPreviewDocument = gql`
    mutation EmailPreview($subject: String!, $body: String!, $client_id: ID) {
  EmailPreview(subject: $subject, body: $body, client_id: $client_id) {
    html
    subject
  }
}
    `;

/**
 * __useEmailPreviewMutation__
 *
 * To run a mutation, you first call `useEmailPreviewMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEmailPreviewMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEmailPreviewMutation({
 *   variables: {
 *     subject: // value for 'subject'
 *     body: // value for 'body'
 *     client_id: // value for 'client_id'
 *   },
 * });
 */
export function useEmailPreviewMutation(options: VueApolloComposable.UseMutationOptions<QLEmailPreviewMutation, QLEmailPreviewMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLEmailPreviewMutation, QLEmailPreviewMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLEmailPreviewMutation, QLEmailPreviewMutationVariables>(EmailPreviewDocument, options);
}
export type EmailPreviewMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLEmailPreviewMutation, QLEmailPreviewMutationVariables>;
export const EmailPreviewSendDocument = gql`
    mutation EmailPreviewSend($subject: String!, $body: String!, $client_id: ID) {
  EmailPreviewSend(subject: $subject, body: $body, client_id: $client_id) {
    ok
  }
}
    `;

/**
 * __useEmailPreviewSendMutation__
 *
 * To run a mutation, you first call `useEmailPreviewSendMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEmailPreviewSendMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEmailPreviewSendMutation({
 *   variables: {
 *     subject: // value for 'subject'
 *     body: // value for 'body'
 *     client_id: // value for 'client_id'
 *   },
 * });
 */
export function useEmailPreviewSendMutation(options: VueApolloComposable.UseMutationOptions<QLEmailPreviewSendMutation, QLEmailPreviewSendMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLEmailPreviewSendMutation, QLEmailPreviewSendMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLEmailPreviewSendMutation, QLEmailPreviewSendMutationVariables>(EmailPreviewSendDocument, options);
}
export type EmailPreviewSendMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLEmailPreviewSendMutation, QLEmailPreviewSendMutationVariables>;
export const CreateEmailTemplateDocument = gql`
    mutation CreateEmailTemplate($name: String!, $subject: String, $email_content: EmailTemplateContentInput!) {
  CreateEmailTemplate(
    name: $name
    subject: $subject
    email_content: $email_content
  ) {
    ...FRAGRMENT_FULL_EMAIL_TEMPLATE
  }
}
    ${FragrmentFullEmailTemplateFragmentDoc}`;

/**
 * __useCreateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useCreateEmailTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateEmailTemplateMutation({
 *   variables: {
 *     name: // value for 'name'
 *     subject: // value for 'subject'
 *     email_content: // value for 'email_content'
 *   },
 * });
 */
export function useCreateEmailTemplateMutation(options: VueApolloComposable.UseMutationOptions<QLCreateEmailTemplateMutation, QLCreateEmailTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCreateEmailTemplateMutation, QLCreateEmailTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCreateEmailTemplateMutation, QLCreateEmailTemplateMutationVariables>(CreateEmailTemplateDocument, options);
}
export type CreateEmailTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCreateEmailTemplateMutation, QLCreateEmailTemplateMutationVariables>;
export const UpdateEmailTemplateDocument = gql`
    mutation UpdateEmailTemplate($id: ID!, $name: String!, $subject: String, $email_content: EmailTemplateContentInput!) {
  UpdateEmailTemplate(
    id: $id
    name: $name
    subject: $subject
    email_content: $email_content
  ) {
    ...FRAGRMENT_FULL_EMAIL_TEMPLATE
  }
}
    ${FragrmentFullEmailTemplateFragmentDoc}`;

/**
 * __useUpdateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateEmailTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEmailTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     name: // value for 'name'
 *     subject: // value for 'subject'
 *     email_content: // value for 'email_content'
 *   },
 * });
 */
export function useUpdateEmailTemplateMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateEmailTemplateMutation, QLUpdateEmailTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateEmailTemplateMutation, QLUpdateEmailTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateEmailTemplateMutation, QLUpdateEmailTemplateMutationVariables>(UpdateEmailTemplateDocument, options);
}
export type UpdateEmailTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateEmailTemplateMutation, QLUpdateEmailTemplateMutationVariables>;
export const DeleteEmailTemplateDocument = gql`
    mutation DeleteEmailTemplate($id: ID!) {
  DeleteEmailTemplate(id: $id) {
    ...FRAGRMENT_FULL_EMAIL_TEMPLATE
  }
}
    ${FragrmentFullEmailTemplateFragmentDoc}`;

/**
 * __useDeleteEmailTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteEmailTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteEmailTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmailTemplateMutation(options: VueApolloComposable.UseMutationOptions<QLDeleteEmailTemplateMutation, QLDeleteEmailTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLDeleteEmailTemplateMutation, QLDeleteEmailTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLDeleteEmailTemplateMutation, QLDeleteEmailTemplateMutationVariables>(DeleteEmailTemplateDocument, options);
}
export type DeleteEmailTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLDeleteEmailTemplateMutation, QLDeleteEmailTemplateMutationVariables>;
export const CopyEmailTemplateDocument = gql`
    mutation CopyEmailTemplate($id: ID!, $destination_team_id: ID!) {
  CopyEmailTemplate(id: $id, destination_team_id: $destination_team_id) {
    id
  }
}
    `;

/**
 * __useCopyEmailTemplateMutation__
 *
 * To run a mutation, you first call `useCopyEmailTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCopyEmailTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCopyEmailTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     destination_team_id: // value for 'destination_team_id'
 *   },
 * });
 */
export function useCopyEmailTemplateMutation(options: VueApolloComposable.UseMutationOptions<QLCopyEmailTemplateMutation, QLCopyEmailTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCopyEmailTemplateMutation, QLCopyEmailTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCopyEmailTemplateMutation, QLCopyEmailTemplateMutationVariables>(CopyEmailTemplateDocument, options);
}
export type CopyEmailTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCopyEmailTemplateMutation, QLCopyEmailTemplateMutationVariables>;
export const CreateFormDocument = gql`
    mutation CreateForm($form: CreateFormInput!) {
  CreateForm(form: $form) {
    ...FRAGMENT_FORM_FULL
  }
}
    ${FragmentFormFullFragmentDoc}`;

/**
 * __useCreateFormMutation__
 *
 * To run a mutation, you first call `useCreateFormMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateFormMutation({
 *   variables: {
 *     form: // value for 'form'
 *   },
 * });
 */
export function useCreateFormMutation(options: VueApolloComposable.UseMutationOptions<QLCreateFormMutation, QLCreateFormMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCreateFormMutation, QLCreateFormMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCreateFormMutation, QLCreateFormMutationVariables>(CreateFormDocument, options);
}
export type CreateFormMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCreateFormMutation, QLCreateFormMutationVariables>;
export const EditFormDocument = gql`
    mutation EditForm($id: ID!, $form: EditFormInput!) {
  EditForm(id: $id, form: $form) {
    ...FRAGMENT_FORM_FULL
  }
}
    ${FragmentFormFullFragmentDoc}`;

/**
 * __useEditFormMutation__
 *
 * To run a mutation, you first call `useEditFormMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditFormMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditFormMutation({
 *   variables: {
 *     id: // value for 'id'
 *     form: // value for 'form'
 *   },
 * });
 */
export function useEditFormMutation(options: VueApolloComposable.UseMutationOptions<QLEditFormMutation, QLEditFormMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLEditFormMutation, QLEditFormMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLEditFormMutation, QLEditFormMutationVariables>(EditFormDocument, options);
}
export type EditFormMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLEditFormMutation, QLEditFormMutationVariables>;
export const ExportFormDocument = gql`
    mutation ExportForm($id: ID!) {
  ExportForm(id: $id) {
    status
  }
}
    `;

/**
 * __useExportFormMutation__
 *
 * To run a mutation, you first call `useExportFormMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExportFormMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExportFormMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useExportFormMutation(options: VueApolloComposable.UseMutationOptions<QLExportFormMutation, QLExportFormMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLExportFormMutation, QLExportFormMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLExportFormMutation, QLExportFormMutationVariables>(ExportFormDocument, options);
}
export type ExportFormMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLExportFormMutation, QLExportFormMutationVariables>;
export const ArchiveFormDocument = gql`
    mutation ArchiveForm($id: ID!, $archive: Boolean!) {
  ArchiveForm(id: $id, archive: $archive) {
    ...FRAGMENT_FORM_FULL
  }
}
    ${FragmentFormFullFragmentDoc}`;

/**
 * __useArchiveFormMutation__
 *
 * To run a mutation, you first call `useArchiveFormMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFormMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useArchiveFormMutation({
 *   variables: {
 *     id: // value for 'id'
 *     archive: // value for 'archive'
 *   },
 * });
 */
export function useArchiveFormMutation(options: VueApolloComposable.UseMutationOptions<QLArchiveFormMutation, QLArchiveFormMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLArchiveFormMutation, QLArchiveFormMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLArchiveFormMutation, QLArchiveFormMutationVariables>(ArchiveFormDocument, options);
}
export type ArchiveFormMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLArchiveFormMutation, QLArchiveFormMutationVariables>;
export const AddCatalogToFormsDocument = gql`
    mutation AddCatalogToForms($catalog_id: ID!, $form_name: String!) {
  AddCatalogToForms(catalog_id: $catalog_id, form_name: $form_name) {
    ...FRAGMENT_FORM_FULL
  }
}
    ${FragmentFormFullFragmentDoc}`;

/**
 * __useAddCatalogToFormsMutation__
 *
 * To run a mutation, you first call `useAddCatalogToFormsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCatalogToFormsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCatalogToFormsMutation({
 *   variables: {
 *     catalog_id: // value for 'catalog_id'
 *     form_name: // value for 'form_name'
 *   },
 * });
 */
export function useAddCatalogToFormsMutation(options: VueApolloComposable.UseMutationOptions<QLAddCatalogToFormsMutation, QLAddCatalogToFormsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLAddCatalogToFormsMutation, QLAddCatalogToFormsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLAddCatalogToFormsMutation, QLAddCatalogToFormsMutationVariables>(AddCatalogToFormsDocument, options);
}
export type AddCatalogToFormsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLAddCatalogToFormsMutation, QLAddCatalogToFormsMutationVariables>;
export const DuplicateFormDocument = gql`
    mutation DuplicateForm($id: ID!, $name: String!) {
  DuplicateForm(id: $id, name: $name) {
    ...FRAGMENT_FORM_FULL
  }
}
    ${FragmentFormFullFragmentDoc}`;

/**
 * __useDuplicateFormMutation__
 *
 * To run a mutation, you first call `useDuplicateFormMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateFormMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDuplicateFormMutation({
 *   variables: {
 *     id: // value for 'id'
 *     name: // value for 'name'
 *   },
 * });
 */
export function useDuplicateFormMutation(options: VueApolloComposable.UseMutationOptions<QLDuplicateFormMutation, QLDuplicateFormMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLDuplicateFormMutation, QLDuplicateFormMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLDuplicateFormMutation, QLDuplicateFormMutationVariables>(DuplicateFormDocument, options);
}
export type DuplicateFormMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLDuplicateFormMutation, QLDuplicateFormMutationVariables>;
export const CopyFormDocument = gql`
    mutation CopyForm($id: ID!, $destination_team_id: ID) {
  CopyForm(id: $id, destination_team_id: $destination_team_id) {
    ...FRAGMENT_FORM_FULL
  }
}
    ${FragmentFormFullFragmentDoc}`;

/**
 * __useCopyFormMutation__
 *
 * To run a mutation, you first call `useCopyFormMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCopyFormMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCopyFormMutation({
 *   variables: {
 *     id: // value for 'id'
 *     destination_team_id: // value for 'destination_team_id'
 *   },
 * });
 */
export function useCopyFormMutation(options: VueApolloComposable.UseMutationOptions<QLCopyFormMutation, QLCopyFormMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCopyFormMutation, QLCopyFormMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCopyFormMutation, QLCopyFormMutationVariables>(CopyFormDocument, options);
}
export type CopyFormMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCopyFormMutation, QLCopyFormMutationVariables>;
export const InviteDocument = gql`
    mutation invite($team_id: ID!, $email: String!, $role: UserRoleEnum!) {
  invite(team_id: $team_id, email: $email, role: $role) {
    ...FRAGMENT_INVITATION_SENT
  }
}
    ${FragmentInvitationSentFragmentDoc}`;

/**
 * __useInviteMutation__
 *
 * To run a mutation, you first call `useInviteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInviteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInviteMutation({
 *   variables: {
 *     team_id: // value for 'team_id'
 *     email: // value for 'email'
 *     role: // value for 'role'
 *   },
 * });
 */
export function useInviteMutation(options: VueApolloComposable.UseMutationOptions<QLInviteMutation, QLInviteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLInviteMutation, QLInviteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLInviteMutation, QLInviteMutationVariables>(InviteDocument, options);
}
export type InviteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLInviteMutation, QLInviteMutationVariables>;
export const InvitationAcceptDocument = gql`
    mutation invitation_accept($token: String!) {
  invitation_accept(token: $token) {
    ...FRAGMENT_TEAM
  }
}
    ${FragmentTeamFragmentDoc}`;

/**
 * __useInvitationAcceptMutation__
 *
 * To run a mutation, you first call `useInvitationAcceptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInvitationAcceptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInvitationAcceptMutation({
 *   variables: {
 *     token: // value for 'token'
 *   },
 * });
 */
export function useInvitationAcceptMutation(options: VueApolloComposable.UseMutationOptions<QLInvitationAcceptMutation, QLInvitationAcceptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLInvitationAcceptMutation, QLInvitationAcceptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLInvitationAcceptMutation, QLInvitationAcceptMutationVariables>(InvitationAcceptDocument, options);
}
export type InvitationAcceptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLInvitationAcceptMutation, QLInvitationAcceptMutationVariables>;
export const InvitationRefuseDocument = gql`
    mutation invitation_refuse($token: String!) {
  invitation_refuse(token: $token) {
    ...FRAGMENT_TEAM
  }
}
    ${FragmentTeamFragmentDoc}`;

/**
 * __useInvitationRefuseMutation__
 *
 * To run a mutation, you first call `useInvitationRefuseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInvitationRefuseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInvitationRefuseMutation({
 *   variables: {
 *     token: // value for 'token'
 *   },
 * });
 */
export function useInvitationRefuseMutation(options: VueApolloComposable.UseMutationOptions<QLInvitationRefuseMutation, QLInvitationRefuseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLInvitationRefuseMutation, QLInvitationRefuseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLInvitationRefuseMutation, QLInvitationRefuseMutationVariables>(InvitationRefuseDocument, options);
}
export type InvitationRefuseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLInvitationRefuseMutation, QLInvitationRefuseMutationVariables>;
export const InvitationRejectDocument = gql`
    mutation invitation_reject($id: ID!) {
  invitation_reject(id: $id) {
    ...FRAGMENT_INVITATION_SENT
  }
}
    ${FragmentInvitationSentFragmentDoc}`;

/**
 * __useInvitationRejectMutation__
 *
 * To run a mutation, you first call `useInvitationRejectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInvitationRejectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInvitationRejectMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useInvitationRejectMutation(options: VueApolloComposable.UseMutationOptions<QLInvitationRejectMutation, QLInvitationRejectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLInvitationRejectMutation, QLInvitationRejectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLInvitationRejectMutation, QLInvitationRejectMutationVariables>(InvitationRejectDocument, options);
}
export type InvitationRejectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLInvitationRejectMutation, QLInvitationRejectMutationVariables>;
export const NoteTemplateCreateDocument = gql`
    mutation NoteTemplateCreate($title: String!, $body: String!) {
  NoteTemplateCreate(title: $title, body: $body) {
    ...FRAGMENT_NOTE_TEMPLATE
  }
}
    ${FragmentNoteTemplateFragmentDoc}`;

/**
 * __useNoteTemplateCreateMutation__
 *
 * To run a mutation, you first call `useNoteTemplateCreateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useNoteTemplateCreateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useNoteTemplateCreateMutation({
 *   variables: {
 *     title: // value for 'title'
 *     body: // value for 'body'
 *   },
 * });
 */
export function useNoteTemplateCreateMutation(options: VueApolloComposable.UseMutationOptions<QLNoteTemplateCreateMutation, QLNoteTemplateCreateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLNoteTemplateCreateMutation, QLNoteTemplateCreateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLNoteTemplateCreateMutation, QLNoteTemplateCreateMutationVariables>(NoteTemplateCreateDocument, options);
}
export type NoteTemplateCreateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLNoteTemplateCreateMutation, QLNoteTemplateCreateMutationVariables>;
export const NoteTemplateUpdateDocument = gql`
    mutation NoteTemplateUpdate($id: ID!, $title: String!, $body: String!) {
  NoteTemplateUpdate(id: $id, title: $title, body: $body) {
    ...FRAGMENT_NOTE_TEMPLATE
  }
}
    ${FragmentNoteTemplateFragmentDoc}`;

/**
 * __useNoteTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useNoteTemplateUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useNoteTemplateUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useNoteTemplateUpdateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     title: // value for 'title'
 *     body: // value for 'body'
 *   },
 * });
 */
export function useNoteTemplateUpdateMutation(options: VueApolloComposable.UseMutationOptions<QLNoteTemplateUpdateMutation, QLNoteTemplateUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLNoteTemplateUpdateMutation, QLNoteTemplateUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLNoteTemplateUpdateMutation, QLNoteTemplateUpdateMutationVariables>(NoteTemplateUpdateDocument, options);
}
export type NoteTemplateUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLNoteTemplateUpdateMutation, QLNoteTemplateUpdateMutationVariables>;
export const NoteTemplateDeleteDocument = gql`
    mutation NoteTemplateDelete($id: ID!) {
  NoteTemplateDelete(id: $id) {
    ...FRAGMENT_NOTE_TEMPLATE
  }
}
    ${FragmentNoteTemplateFragmentDoc}`;

/**
 * __useNoteTemplateDeleteMutation__
 *
 * To run a mutation, you first call `useNoteTemplateDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useNoteTemplateDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useNoteTemplateDeleteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useNoteTemplateDeleteMutation(options: VueApolloComposable.UseMutationOptions<QLNoteTemplateDeleteMutation, QLNoteTemplateDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLNoteTemplateDeleteMutation, QLNoteTemplateDeleteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLNoteTemplateDeleteMutation, QLNoteTemplateDeleteMutationVariables>(NoteTemplateDeleteDocument, options);
}
export type NoteTemplateDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLNoteTemplateDeleteMutation, QLNoteTemplateDeleteMutationVariables>;
export const CreateNoteDocument = gql`
    mutation CreateNote($client_id: ID!, $note: String) {
  CreateNote(client_id: $client_id, note: $note) {
    ...FRAGMENT_CLIENT_NOTE
  }
}
    ${FragmentClientNoteFragmentDoc}`;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateNoteMutation({
 *   variables: {
 *     client_id: // value for 'client_id'
 *     note: // value for 'note'
 *   },
 * });
 */
export function useCreateNoteMutation(options: VueApolloComposable.UseMutationOptions<QLCreateNoteMutation, QLCreateNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCreateNoteMutation, QLCreateNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCreateNoteMutation, QLCreateNoteMutationVariables>(CreateNoteDocument, options);
}
export type CreateNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCreateNoteMutation, QLCreateNoteMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation UpdateNote($id: ID!, $archived: Boolean, $note: String) {
  UpdateNote(id: $id, archived: $archived, note: $note) {
    ...FRAGMENT_CLIENT_NOTE
  }
}
    ${FragmentClientNoteFragmentDoc}`;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateNoteMutation({
 *   variables: {
 *     id: // value for 'id'
 *     archived: // value for 'archived'
 *     note: // value for 'note'
 *   },
 * });
 */
export function useUpdateNoteMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateNoteMutation, QLUpdateNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateNoteMutation, QLUpdateNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateNoteMutation, QLUpdateNoteMutationVariables>(UpdateNoteDocument, options);
}
export type UpdateNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateNoteMutation, QLUpdateNoteMutationVariables>;
export const AnnouncementsUpdateReadDocument = gql`
    mutation AnnouncementsUpdateRead {
  AnnouncementsUpdateRead {
    id
    last_read_announcements_at
  }
}
    `;

/**
 * __useAnnouncementsUpdateReadMutation__
 *
 * To run a mutation, you first call `useAnnouncementsUpdateReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementsUpdateReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAnnouncementsUpdateReadMutation();
 */
export function useAnnouncementsUpdateReadMutation(options: VueApolloComposable.UseMutationOptions<QLAnnouncementsUpdateReadMutation, QLAnnouncementsUpdateReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLAnnouncementsUpdateReadMutation, QLAnnouncementsUpdateReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLAnnouncementsUpdateReadMutation, QLAnnouncementsUpdateReadMutationVariables>(AnnouncementsUpdateReadDocument, options);
}
export type AnnouncementsUpdateReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLAnnouncementsUpdateReadMutation, QLAnnouncementsUpdateReadMutationVariables>;
export const ReadNotificationsDocument = gql`
    mutation ReadNotifications($ids: [ID!]) {
  ReadNotifications(ids: $ids) {
    id
    read
  }
}
    `;

/**
 * __useReadNotificationsMutation__
 *
 * To run a mutation, you first call `useReadNotificationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReadNotificationsMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useReadNotificationsMutation(options: VueApolloComposable.UseMutationOptions<QLReadNotificationsMutation, QLReadNotificationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLReadNotificationsMutation, QLReadNotificationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLReadNotificationsMutation, QLReadNotificationsMutationVariables>(ReadNotificationsDocument, options);
}
export type ReadNotificationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLReadNotificationsMutation, QLReadNotificationsMutationVariables>;
export const ExportClientsUnsubscribedDocument = gql`
    mutation ExportClientsUnsubscribed($medium: UnsubscribeMediumEnum!) {
  ExportClientsUnsubscribed(medium: $medium) {
    status
  }
}
    `;

/**
 * __useExportClientsUnsubscribedMutation__
 *
 * To run a mutation, you first call `useExportClientsUnsubscribedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExportClientsUnsubscribedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExportClientsUnsubscribedMutation({
 *   variables: {
 *     medium: // value for 'medium'
 *   },
 * });
 */
export function useExportClientsUnsubscribedMutation(options: VueApolloComposable.UseMutationOptions<QLExportClientsUnsubscribedMutation, QLExportClientsUnsubscribedMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLExportClientsUnsubscribedMutation, QLExportClientsUnsubscribedMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLExportClientsUnsubscribedMutation, QLExportClientsUnsubscribedMutationVariables>(ExportClientsUnsubscribedDocument, options);
}
export type ExportClientsUnsubscribedMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLExportClientsUnsubscribedMutation, QLExportClientsUnsubscribedMutationVariables>;
export const FitDegreeApiSetDocument = gql`
    mutation FitDegreeApiSet($api_key: String!) {
  FitDegreeApiSet(api_key: $api_key) {
    ...FRAGMENT_CURRENT_TEAM
  }
}
    ${FragmentCurrentTeamFragmentDoc}`;

/**
 * __useFitDegreeApiSetMutation__
 *
 * To run a mutation, you first call `useFitDegreeApiSetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFitDegreeApiSetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFitDegreeApiSetMutation({
 *   variables: {
 *     api_key: // value for 'api_key'
 *   },
 * });
 */
export function useFitDegreeApiSetMutation(options: VueApolloComposable.UseMutationOptions<QLFitDegreeApiSetMutation, QLFitDegreeApiSetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLFitDegreeApiSetMutation, QLFitDegreeApiSetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLFitDegreeApiSetMutation, QLFitDegreeApiSetMutationVariables>(FitDegreeApiSetDocument, options);
}
export type FitDegreeApiSetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLFitDegreeApiSetMutation, QLFitDegreeApiSetMutationVariables>;
export const MindBodyApiSetDocument = gql`
    mutation MindBodyApiSet($site_id: String!) {
  MindBodyApiSet(site_id: $site_id) {
    ...FRAGMENT_CURRENT_TEAM
  }
}
    ${FragmentCurrentTeamFragmentDoc}`;

/**
 * __useMindBodyApiSetMutation__
 *
 * To run a mutation, you first call `useMindBodyApiSetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMindBodyApiSetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMindBodyApiSetMutation({
 *   variables: {
 *     site_id: // value for 'site_id'
 *   },
 * });
 */
export function useMindBodyApiSetMutation(options: VueApolloComposable.UseMutationOptions<QLMindBodyApiSetMutation, QLMindBodyApiSetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLMindBodyApiSetMutation, QLMindBodyApiSetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLMindBodyApiSetMutation, QLMindBodyApiSetMutationVariables>(MindBodyApiSetDocument, options);
}
export type MindBodyApiSetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLMindBodyApiSetMutation, QLMindBodyApiSetMutationVariables>;
export const MindBodyApiPrepareDocument = gql`
    mutation MindBodyApiPrepare($site_id: String) {
  MindBodyApiPrepare(site_id: $site_id) {
    authorization_link
  }
}
    `;

/**
 * __useMindBodyApiPrepareMutation__
 *
 * To run a mutation, you first call `useMindBodyApiPrepareMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMindBodyApiPrepareMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMindBodyApiPrepareMutation({
 *   variables: {
 *     site_id: // value for 'site_id'
 *   },
 * });
 */
export function useMindBodyApiPrepareMutation(options: VueApolloComposable.UseMutationOptions<QLMindBodyApiPrepareMutation, QLMindBodyApiPrepareMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLMindBodyApiPrepareMutation, QLMindBodyApiPrepareMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLMindBodyApiPrepareMutation, QLMindBodyApiPrepareMutationVariables>(MindBodyApiPrepareDocument, options);
}
export type MindBodyApiPrepareMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLMindBodyApiPrepareMutation, QLMindBodyApiPrepareMutationVariables>;
export const Pike13SetBusinessDocument = gql`
    mutation Pike13SetBusiness($subdomain: String!, $id: String!, $timezone: String) {
  Pike13SetBusiness(subdomain: $subdomain, id: $id, timezone: $timezone) {
    ...FRAGMENT_CURRENT_TEAM
  }
}
    ${FragmentCurrentTeamFragmentDoc}`;

/**
 * __usePike13SetBusinessMutation__
 *
 * To run a mutation, you first call `usePike13SetBusinessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePike13SetBusinessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePike13SetBusinessMutation({
 *   variables: {
 *     subdomain: // value for 'subdomain'
 *     id: // value for 'id'
 *     timezone: // value for 'timezone'
 *   },
 * });
 */
export function usePike13SetBusinessMutation(options: VueApolloComposable.UseMutationOptions<QLPike13SetBusinessMutation, QLPike13SetBusinessMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLPike13SetBusinessMutation, QLPike13SetBusinessMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLPike13SetBusinessMutation, QLPike13SetBusinessMutationVariables>(Pike13SetBusinessDocument, options);
}
export type Pike13SetBusinessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLPike13SetBusinessMutation, QLPike13SetBusinessMutationVariables>;
export const Pike13GetBusinessesDocument = gql`
    query Pike13GetBusinesses {
  Pike13GetBusinesses {
    id
    name
    subdomain
    timezone
  }
}
    `;

/**
 * __usePike13GetBusinessesQuery__
 *
 * To run a query within a Vue component, call `usePike13GetBusinessesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePike13GetBusinessesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePike13GetBusinessesQuery();
 */
export function usePike13GetBusinessesQuery(options: VueApolloComposable.UseQueryOptions<QLPike13GetBusinessesQuery, QLPike13GetBusinessesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLPike13GetBusinessesQuery, QLPike13GetBusinessesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLPike13GetBusinessesQuery, QLPike13GetBusinessesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLPike13GetBusinessesQuery, QLPike13GetBusinessesQueryVariables>(Pike13GetBusinessesDocument, {}, options);
}
export function usePike13GetBusinessesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLPike13GetBusinessesQuery, QLPike13GetBusinessesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLPike13GetBusinessesQuery, QLPike13GetBusinessesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLPike13GetBusinessesQuery, QLPike13GetBusinessesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLPike13GetBusinessesQuery, QLPike13GetBusinessesQueryVariables>(Pike13GetBusinessesDocument, {}, options);
}
export type Pike13GetBusinessesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLPike13GetBusinessesQuery, QLPike13GetBusinessesQueryVariables>;
export const Pike13AuthUrlDocument = gql`
    query Pike13AuthUrl {
  Pike13AuthUrl {
    link
  }
}
    `;

/**
 * __usePike13AuthUrlQuery__
 *
 * To run a query within a Vue component, call `usePike13AuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePike13AuthUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePike13AuthUrlQuery();
 */
export function usePike13AuthUrlQuery(options: VueApolloComposable.UseQueryOptions<QLPike13AuthUrlQuery, QLPike13AuthUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLPike13AuthUrlQuery, QLPike13AuthUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLPike13AuthUrlQuery, QLPike13AuthUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLPike13AuthUrlQuery, QLPike13AuthUrlQueryVariables>(Pike13AuthUrlDocument, {}, options);
}
export function usePike13AuthUrlLazyQuery(options: VueApolloComposable.UseQueryOptions<QLPike13AuthUrlQuery, QLPike13AuthUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLPike13AuthUrlQuery, QLPike13AuthUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLPike13AuthUrlQuery, QLPike13AuthUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLPike13AuthUrlQuery, QLPike13AuthUrlQueryVariables>(Pike13AuthUrlDocument, {}, options);
}
export type Pike13AuthUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLPike13AuthUrlQuery, QLPike13AuthUrlQueryVariables>;
export const QuickResponseCreateDocument = gql`
    mutation QuickResponseCreate($title: String!, $content: String!, $team_id: ID!) {
  QuickResponseCreate(title: $title, content: $content, team_id: $team_id) {
    ...FRAGMENT_QUICK_RESPONSE
  }
}
    ${FragmentQuickResponseFragmentDoc}`;

/**
 * __useQuickResponseCreateMutation__
 *
 * To run a mutation, you first call `useQuickResponseCreateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useQuickResponseCreateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useQuickResponseCreateMutation({
 *   variables: {
 *     title: // value for 'title'
 *     content: // value for 'content'
 *     team_id: // value for 'team_id'
 *   },
 * });
 */
export function useQuickResponseCreateMutation(options: VueApolloComposable.UseMutationOptions<QLQuickResponseCreateMutation, QLQuickResponseCreateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLQuickResponseCreateMutation, QLQuickResponseCreateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLQuickResponseCreateMutation, QLQuickResponseCreateMutationVariables>(QuickResponseCreateDocument, options);
}
export type QuickResponseCreateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLQuickResponseCreateMutation, QLQuickResponseCreateMutationVariables>;
export const QuickResponseDeleteDocument = gql`
    mutation QuickResponseDelete($id: ID!) {
  QuickResponseDelete(id: $id) {
    ...FRAGMENT_QUICK_RESPONSE
  }
}
    ${FragmentQuickResponseFragmentDoc}`;

/**
 * __useQuickResponseDeleteMutation__
 *
 * To run a mutation, you first call `useQuickResponseDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useQuickResponseDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useQuickResponseDeleteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useQuickResponseDeleteMutation(options: VueApolloComposable.UseMutationOptions<QLQuickResponseDeleteMutation, QLQuickResponseDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLQuickResponseDeleteMutation, QLQuickResponseDeleteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLQuickResponseDeleteMutation, QLQuickResponseDeleteMutationVariables>(QuickResponseDeleteDocument, options);
}
export type QuickResponseDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLQuickResponseDeleteMutation, QLQuickResponseDeleteMutationVariables>;
export const QuickResponseUpdateDocument = gql`
    mutation QuickResponseUpdate($id: ID!, $title: String!, $content: String!) {
  QuickResponseUpdate(id: $id, title: $title, content: $content) {
    ...FRAGMENT_QUICK_RESPONSE
  }
}
    ${FragmentQuickResponseFragmentDoc}`;

/**
 * __useQuickResponseUpdateMutation__
 *
 * To run a mutation, you first call `useQuickResponseUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useQuickResponseUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useQuickResponseUpdateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     title: // value for 'title'
 *     content: // value for 'content'
 *   },
 * });
 */
export function useQuickResponseUpdateMutation(options: VueApolloComposable.UseMutationOptions<QLQuickResponseUpdateMutation, QLQuickResponseUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLQuickResponseUpdateMutation, QLQuickResponseUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLQuickResponseUpdateMutation, QLQuickResponseUpdateMutationVariables>(QuickResponseUpdateDocument, options);
}
export type QuickResponseUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLQuickResponseUpdateMutation, QLQuickResponseUpdateMutationVariables>;
export const QuickResponseSaveOrderDocument = gql`
    mutation QuickResponseSaveOrder($items: [QuickResponseOrderInput!]!) {
  QuickResponseSaveOrder(items: $items) {
    ...FRAGMENT_QUICK_RESPONSE
  }
}
    ${FragmentQuickResponseFragmentDoc}`;

/**
 * __useQuickResponseSaveOrderMutation__
 *
 * To run a mutation, you first call `useQuickResponseSaveOrderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useQuickResponseSaveOrderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useQuickResponseSaveOrderMutation({
 *   variables: {
 *     items: // value for 'items'
 *   },
 * });
 */
export function useQuickResponseSaveOrderMutation(options: VueApolloComposable.UseMutationOptions<QLQuickResponseSaveOrderMutation, QLQuickResponseSaveOrderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLQuickResponseSaveOrderMutation, QLQuickResponseSaveOrderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLQuickResponseSaveOrderMutation, QLQuickResponseSaveOrderMutationVariables>(QuickResponseSaveOrderDocument, options);
}
export type QuickResponseSaveOrderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLQuickResponseSaveOrderMutation, QLQuickResponseSaveOrderMutationVariables>;
export const ReorderSegmentDocument = gql`
    mutation ReorderSegment($id: ID!, $order: Int!, $archived: Boolean!) {
  ReorderSegment(id: $id, order: $order, archived: $archived) {
    ...FRAGMENT_SMALL_SEGMENT
  }
}
    ${FragmentSmallSegmentFragmentDoc}`;

/**
 * __useReorderSegmentMutation__
 *
 * To run a mutation, you first call `useReorderSegmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReorderSegmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReorderSegmentMutation({
 *   variables: {
 *     id: // value for 'id'
 *     order: // value for 'order'
 *     archived: // value for 'archived'
 *   },
 * });
 */
export function useReorderSegmentMutation(options: VueApolloComposable.UseMutationOptions<QLReorderSegmentMutation, QLReorderSegmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLReorderSegmentMutation, QLReorderSegmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLReorderSegmentMutation, QLReorderSegmentMutationVariables>(ReorderSegmentDocument, options);
}
export type ReorderSegmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLReorderSegmentMutation, QLReorderSegmentMutationVariables>;
export const UpdateSegmentDocument = gql`
    mutation UpdateSegment($id: ID!, $data: SegmentInput) {
  UpdateSegment(id: $id, data: $data) {
    ...FRAGMENT_FULL_SEGMENT
  }
}
    ${FragmentFullSegmentFragmentDoc}`;

/**
 * __useUpdateSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateSegmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSegmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSegmentMutation({
 *   variables: {
 *     id: // value for 'id'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSegmentMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateSegmentMutation, QLUpdateSegmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateSegmentMutation, QLUpdateSegmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateSegmentMutation, QLUpdateSegmentMutationVariables>(UpdateSegmentDocument, options);
}
export type UpdateSegmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateSegmentMutation, QLUpdateSegmentMutationVariables>;
export const CreateSegmentDocument = gql`
    mutation CreateSegment($data: SegmentInput) {
  CreateSegment(data: $data) {
    ...FRAGMENT_FULL_SEGMENT
  }
}
    ${FragmentFullSegmentFragmentDoc}`;

/**
 * __useCreateSegmentMutation__
 *
 * To run a mutation, you first call `useCreateSegmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSegmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSegmentMutation({
 *   variables: {
 *     data: // value for 'data'
 *   },
 * });
 */
export function useCreateSegmentMutation(options: VueApolloComposable.UseMutationOptions<QLCreateSegmentMutation, QLCreateSegmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCreateSegmentMutation, QLCreateSegmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCreateSegmentMutation, QLCreateSegmentMutationVariables>(CreateSegmentDocument, options);
}
export type CreateSegmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCreateSegmentMutation, QLCreateSegmentMutationVariables>;
export const DeleteSegmentDocument = gql`
    mutation DeleteSegment($id: ID!) {
  DeleteSegment(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteSegmentMutation__
 *
 * To run a mutation, you first call `useDeleteSegmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSegmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSegmentMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSegmentMutation(options: VueApolloComposable.UseMutationOptions<QLDeleteSegmentMutation, QLDeleteSegmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLDeleteSegmentMutation, QLDeleteSegmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLDeleteSegmentMutation, QLDeleteSegmentMutationVariables>(DeleteSegmentDocument, options);
}
export type DeleteSegmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLDeleteSegmentMutation, QLDeleteSegmentMutationVariables>;
export const CopySegmentDocument = gql`
    mutation CopySegment($id: ID!, $destination_team_id: ID!) {
  CopySegment(id: $id, destination_team_id: $destination_team_id) {
    ...FRAGMENT_SMALL_SEGMENT
  }
}
    ${FragmentSmallSegmentFragmentDoc}`;

/**
 * __useCopySegmentMutation__
 *
 * To run a mutation, you first call `useCopySegmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCopySegmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCopySegmentMutation({
 *   variables: {
 *     id: // value for 'id'
 *     destination_team_id: // value for 'destination_team_id'
 *   },
 * });
 */
export function useCopySegmentMutation(options: VueApolloComposable.UseMutationOptions<QLCopySegmentMutation, QLCopySegmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCopySegmentMutation, QLCopySegmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCopySegmentMutation, QLCopySegmentMutationVariables>(CopySegmentDocument, options);
}
export type CopySegmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCopySegmentMutation, QLCopySegmentMutationVariables>;
export const ResetEventInsightSegmentOrdersDocument = gql`
    mutation ResetEventInsightSegmentOrders($first: ID, $second: ID, $third: ID) {
  ResetEventInsightSegmentOrders(first: $first, second: $second, third: $third) {
    ...FRAGMENT_SMALL_SEGMENT
  }
}
    ${FragmentSmallSegmentFragmentDoc}`;

/**
 * __useResetEventInsightSegmentOrdersMutation__
 *
 * To run a mutation, you first call `useResetEventInsightSegmentOrdersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetEventInsightSegmentOrdersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetEventInsightSegmentOrdersMutation({
 *   variables: {
 *     first: // value for 'first'
 *     second: // value for 'second'
 *     third: // value for 'third'
 *   },
 * });
 */
export function useResetEventInsightSegmentOrdersMutation(options: VueApolloComposable.UseMutationOptions<QLResetEventInsightSegmentOrdersMutation, QLResetEventInsightSegmentOrdersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLResetEventInsightSegmentOrdersMutation, QLResetEventInsightSegmentOrdersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLResetEventInsightSegmentOrdersMutation, QLResetEventInsightSegmentOrdersMutationVariables>(ResetEventInsightSegmentOrdersDocument, options);
}
export type ResetEventInsightSegmentOrdersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLResetEventInsightSegmentOrdersMutation, QLResetEventInsightSegmentOrdersMutationVariables>;
export const SaveEventInsightSegmentsDocument = gql`
    mutation SaveEventInsightSegments($segments: [EventInsightSegmentInput!]!) {
  SaveEventInsightSegments(segments: $segments) {
    ...FRAGMENT_FULL_SEGMENT
  }
}
    ${FragmentFullSegmentFragmentDoc}`;

/**
 * __useSaveEventInsightSegmentsMutation__
 *
 * To run a mutation, you first call `useSaveEventInsightSegmentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveEventInsightSegmentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveEventInsightSegmentsMutation({
 *   variables: {
 *     segments: // value for 'segments'
 *   },
 * });
 */
export function useSaveEventInsightSegmentsMutation(options: VueApolloComposable.UseMutationOptions<QLSaveEventInsightSegmentsMutation, QLSaveEventInsightSegmentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLSaveEventInsightSegmentsMutation, QLSaveEventInsightSegmentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLSaveEventInsightSegmentsMutation, QLSaveEventInsightSegmentsMutationVariables>(SaveEventInsightSegmentsDocument, options);
}
export type SaveEventInsightSegmentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLSaveEventInsightSegmentsMutation, QLSaveEventInsightSegmentsMutationVariables>;
export const UpdateTeamDocument = gql`
    mutation UpdateTeam($input: UpdateTeamInput!) {
  UpdateTeam(input: $input) {
    ...FRAGMENT_CURRENT_TEAM
  }
}
    ${FragmentCurrentTeamFragmentDoc}`;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTeamMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateTeamMutation, QLUpdateTeamMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateTeamMutation, QLUpdateTeamMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateTeamMutation, QLUpdateTeamMutationVariables>(UpdateTeamDocument, options);
}
export type UpdateTeamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateTeamMutation, QLUpdateTeamMutationVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($input: CreateTeamInput!) {
  CreateTeam(input: $input) {
    ...FRAGMENT_CURRENT_TEAM
  }
}
    ${FragmentCurrentTeamFragmentDoc}`;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTeamMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(options: VueApolloComposable.UseMutationOptions<QLCreateTeamMutation, QLCreateTeamMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCreateTeamMutation, QLCreateTeamMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCreateTeamMutation, QLCreateTeamMutationVariables>(CreateTeamDocument, options);
}
export type CreateTeamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCreateTeamMutation, QLCreateTeamMutationVariables>;
export const UpdateTeamProfileImageDocument = gql`
    mutation UpdateTeamProfileImage($photo: Upload!) {
  UpdateTeamProfileImage(photo: $photo) {
    ...FRAGMENT_CURRENT_TEAM
  }
}
    ${FragmentCurrentTeamFragmentDoc}`;

/**
 * __useUpdateTeamProfileImageMutation__
 *
 * To run a mutation, you first call `useUpdateTeamProfileImageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamProfileImageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTeamProfileImageMutation({
 *   variables: {
 *     photo: // value for 'photo'
 *   },
 * });
 */
export function useUpdateTeamProfileImageMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateTeamProfileImageMutation, QLUpdateTeamProfileImageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateTeamProfileImageMutation, QLUpdateTeamProfileImageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateTeamProfileImageMutation, QLUpdateTeamProfileImageMutationVariables>(UpdateTeamProfileImageDocument, options);
}
export type UpdateTeamProfileImageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateTeamProfileImageMutation, QLUpdateTeamProfileImageMutationVariables>;
export const UpdateTeamLogoImageDocument = gql`
    mutation UpdateTeamLogoImage($photo: Upload!) {
  UpdateTeamLogoImage(photo: $photo) {
    ...FRAGMENT_CURRENT_TEAM
  }
}
    ${FragmentCurrentTeamFragmentDoc}`;

/**
 * __useUpdateTeamLogoImageMutation__
 *
 * To run a mutation, you first call `useUpdateTeamLogoImageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamLogoImageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTeamLogoImageMutation({
 *   variables: {
 *     photo: // value for 'photo'
 *   },
 * });
 */
export function useUpdateTeamLogoImageMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateTeamLogoImageMutation, QLUpdateTeamLogoImageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateTeamLogoImageMutation, QLUpdateTeamLogoImageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateTeamLogoImageMutation, QLUpdateTeamLogoImageMutationVariables>(UpdateTeamLogoImageDocument, options);
}
export type UpdateTeamLogoImageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateTeamLogoImageMutation, QLUpdateTeamLogoImageMutationVariables>;
export const UpdateUserTeamGroupsDocument = gql`
    mutation UpdateUserTeamGroups($id: ID!, $groups: [String]!) {
  UpdateUserTeamGroups(id: $id, groups: $groups) {
    ...FRAGMENT_CURRENT_TEAM
  }
}
    ${FragmentCurrentTeamFragmentDoc}`;

/**
 * __useUpdateUserTeamGroupsMutation__
 *
 * To run a mutation, you first call `useUpdateUserTeamGroupsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTeamGroupsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserTeamGroupsMutation({
 *   variables: {
 *     id: // value for 'id'
 *     groups: // value for 'groups'
 *   },
 * });
 */
export function useUpdateUserTeamGroupsMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateUserTeamGroupsMutation, QLUpdateUserTeamGroupsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateUserTeamGroupsMutation, QLUpdateUserTeamGroupsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateUserTeamGroupsMutation, QLUpdateUserTeamGroupsMutationVariables>(UpdateUserTeamGroupsDocument, options);
}
export type UpdateUserTeamGroupsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateUserTeamGroupsMutation, QLUpdateUserTeamGroupsMutationVariables>;
export const RoleChangeDocument = gql`
    mutation RoleChange($user_id: ID!, $role: UserRoleEnum) {
  RoleChange(user_id: $user_id, role: $role) {
    ...FRAGMENT_CURRENT_TEAM
  }
}
    ${FragmentCurrentTeamFragmentDoc}`;

/**
 * __useRoleChangeMutation__
 *
 * To run a mutation, you first call `useRoleChangeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRoleChangeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRoleChangeMutation({
 *   variables: {
 *     user_id: // value for 'user_id'
 *     role: // value for 'role'
 *   },
 * });
 */
export function useRoleChangeMutation(options: VueApolloComposable.UseMutationOptions<QLRoleChangeMutation, QLRoleChangeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLRoleChangeMutation, QLRoleChangeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLRoleChangeMutation, QLRoleChangeMutationVariables>(RoleChangeDocument, options);
}
export type RoleChangeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLRoleChangeMutation, QLRoleChangeMutationVariables>;
export const CreateTodoDocument = gql`
    mutation CreateTodo($client_id: ID!, $subject: String, $message: String, $priority_type: TodoPriority, $overdue_at: Int, $postponed_to: Int, $assigned_to_id: ID, $team_group_id: ID) {
  CreateTodo(
    client_id: $client_id
    subject: $subject
    message: $message
    priority_type: $priority_type
    overdue_at: $overdue_at
    postponed_to: $postponed_to
    assigned_to_id: $assigned_to_id
    team_group_id: $team_group_id
  ) {
    ...FRAGMENT_TODO
    client {
      ...FRAGMENT_CLIENT_FULL
    }
  }
}
    ${FragmentTodoFragmentDoc}
${FragmentClientFullFragmentDoc}`;

/**
 * __useCreateTodoMutation__
 *
 * To run a mutation, you first call `useCreateTodoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTodoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTodoMutation({
 *   variables: {
 *     client_id: // value for 'client_id'
 *     subject: // value for 'subject'
 *     message: // value for 'message'
 *     priority_type: // value for 'priority_type'
 *     overdue_at: // value for 'overdue_at'
 *     postponed_to: // value for 'postponed_to'
 *     assigned_to_id: // value for 'assigned_to_id'
 *     team_group_id: // value for 'team_group_id'
 *   },
 * });
 */
export function useCreateTodoMutation(options: VueApolloComposable.UseMutationOptions<QLCreateTodoMutation, QLCreateTodoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCreateTodoMutation, QLCreateTodoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCreateTodoMutation, QLCreateTodoMutationVariables>(CreateTodoDocument, options);
}
export type CreateTodoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCreateTodoMutation, QLCreateTodoMutationVariables>;
export const EditTodoDocument = gql`
    mutation EditTodo($id: ID!, $subject: String, $message: String, $priority_type: TodoPriority, $overdue_at: Int, $postponed_to: Int, $assigned_to_id: ID, $team_group_id: ID) {
  EditTodo(
    id: $id
    subject: $subject
    message: $message
    priority_type: $priority_type
    overdue_at: $overdue_at
    postponed_to: $postponed_to
    assigned_to_id: $assigned_to_id
    team_group_id: $team_group_id
  ) {
    ...FRAGMENT_TODO
    client {
      ...FRAGMENT_CLIENT_FULL
    }
  }
}
    ${FragmentTodoFragmentDoc}
${FragmentClientFullFragmentDoc}`;

/**
 * __useEditTodoMutation__
 *
 * To run a mutation, you first call `useEditTodoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditTodoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditTodoMutation({
 *   variables: {
 *     id: // value for 'id'
 *     subject: // value for 'subject'
 *     message: // value for 'message'
 *     priority_type: // value for 'priority_type'
 *     overdue_at: // value for 'overdue_at'
 *     postponed_to: // value for 'postponed_to'
 *     assigned_to_id: // value for 'assigned_to_id'
 *     team_group_id: // value for 'team_group_id'
 *   },
 * });
 */
export function useEditTodoMutation(options: VueApolloComposable.UseMutationOptions<QLEditTodoMutation, QLEditTodoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLEditTodoMutation, QLEditTodoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLEditTodoMutation, QLEditTodoMutationVariables>(EditTodoDocument, options);
}
export type EditTodoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLEditTodoMutation, QLEditTodoMutationVariables>;
export const UpdateTodoDocument = gql`
    mutation UpdateTodo($id: ID!, $deleted: Boolean, $completed_action_type: TodoCompletionTypeEnum, $completed_action_note: String, $tags: [String]) {
  UpdateTodo(
    completed_action_type: $completed_action_type
    id: $id
    deleted: $deleted
    completed_action_note: $completed_action_note
    tags: $tags
  ) {
    ...FRAGMENT_TODO
    client {
      ...FRAGMENT_CLIENT_FULL
    }
  }
}
    ${FragmentTodoFragmentDoc}
${FragmentClientFullFragmentDoc}`;

/**
 * __useUpdateTodoMutation__
 *
 * To run a mutation, you first call `useUpdateTodoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTodoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTodoMutation({
 *   variables: {
 *     id: // value for 'id'
 *     deleted: // value for 'deleted'
 *     completed_action_type: // value for 'completed_action_type'
 *     completed_action_note: // value for 'completed_action_note'
 *     tags: // value for 'tags'
 *   },
 * });
 */
export function useUpdateTodoMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateTodoMutation, QLUpdateTodoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateTodoMutation, QLUpdateTodoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateTodoMutation, QLUpdateTodoMutationVariables>(UpdateTodoDocument, options);
}
export type UpdateTodoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateTodoMutation, QLUpdateTodoMutationVariables>;
export const BulkUpdateTodosDocument = gql`
    mutation BulkUpdateTodos($automation_id: ID, $home_location_id: ID, $closed: Boolean, $manual: Boolean, $open: Boolean, $overdue: Boolean, $priority: Int, $scheduled: Boolean, $tag: ID, $assigned_to_id: ID, $team_group_id: ID, $action: String!, $created_after: String, $created_before: String, $overdue_after: String, $overdue_before: String) {
  BulkUpdateTodos(
    automation_id: $automation_id
    home_location_id: $home_location_id
    closed: $closed
    manual: $manual
    open: $open
    overdue: $overdue
    priority: $priority
    tag: $tag
    scheduled: $scheduled
    assigned_to_id: $assigned_to_id
    team_group_id: $team_group_id
    action: $action
    created_after: $created_after
    created_before: $created_before
    overdue_after: $overdue_after
    overdue_before: $overdue_before
  ) {
    ok
  }
}
    `;

/**
 * __useBulkUpdateTodosMutation__
 *
 * To run a mutation, you first call `useBulkUpdateTodosMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateTodosMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkUpdateTodosMutation({
 *   variables: {
 *     automation_id: // value for 'automation_id'
 *     home_location_id: // value for 'home_location_id'
 *     closed: // value for 'closed'
 *     manual: // value for 'manual'
 *     open: // value for 'open'
 *     overdue: // value for 'overdue'
 *     priority: // value for 'priority'
 *     scheduled: // value for 'scheduled'
 *     tag: // value for 'tag'
 *     assigned_to_id: // value for 'assigned_to_id'
 *     team_group_id: // value for 'team_group_id'
 *     action: // value for 'action'
 *     created_after: // value for 'created_after'
 *     created_before: // value for 'created_before'
 *     overdue_after: // value for 'overdue_after'
 *     overdue_before: // value for 'overdue_before'
 *   },
 * });
 */
export function useBulkUpdateTodosMutation(options: VueApolloComposable.UseMutationOptions<QLBulkUpdateTodosMutation, QLBulkUpdateTodosMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLBulkUpdateTodosMutation, QLBulkUpdateTodosMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLBulkUpdateTodosMutation, QLBulkUpdateTodosMutationVariables>(BulkUpdateTodosDocument, options);
}
export type BulkUpdateTodosMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLBulkUpdateTodosMutation, QLBulkUpdateTodosMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($input: ChangePasswordInput!) {
  ChangePassword(input: $input) {
    ok
  }
}
    `;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangePasswordMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(options: VueApolloComposable.UseMutationOptions<QLChangePasswordMutation, QLChangePasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLChangePasswordMutation, QLChangePasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLChangePasswordMutation, QLChangePasswordMutationVariables>(ChangePasswordDocument, options);
}
export type ChangePasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLChangePasswordMutation, QLChangePasswordMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  UpdateUser(input: $input) {
    ...FRAGMENT_USER_SMALL
    email
  }
}
    ${FragmentUserSmallFragmentDoc}`;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateUserMutation, QLUpdateUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateUserMutation, QLUpdateUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateUserMutation, QLUpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateUserMutation, QLUpdateUserMutationVariables>;
export const SwitchTeamDocument = gql`
    mutation SwitchTeam($id: ID!) {
  SwitchTeam(id: $id) {
    id
  }
}
    `;

/**
 * __useSwitchTeamMutation__
 *
 * To run a mutation, you first call `useSwitchTeamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSwitchTeamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSwitchTeamMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSwitchTeamMutation(options: VueApolloComposable.UseMutationOptions<QLSwitchTeamMutation, QLSwitchTeamMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLSwitchTeamMutation, QLSwitchTeamMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLSwitchTeamMutation, QLSwitchTeamMutationVariables>(SwitchTeamDocument, options);
}
export type SwitchTeamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLSwitchTeamMutation, QLSwitchTeamMutationVariables>;
export const LeaveTeamDocument = gql`
    mutation LeaveTeam($id: ID!) {
  LeaveTeam(id: $id) {
    ...FRAGMENT_USER_ME
  }
}
    ${FragmentUserMeFragmentDoc}`;

/**
 * __useLeaveTeamMutation__
 *
 * To run a mutation, you first call `useLeaveTeamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLeaveTeamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLeaveTeamMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useLeaveTeamMutation(options: VueApolloComposable.UseMutationOptions<QLLeaveTeamMutation, QLLeaveTeamMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLLeaveTeamMutation, QLLeaveTeamMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLLeaveTeamMutation, QLLeaveTeamMutationVariables>(LeaveTeamDocument, options);
}
export type LeaveTeamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLLeaveTeamMutation, QLLeaveTeamMutationVariables>;
export const UpdateNotificationTokenDocument = gql`
    mutation UpdateNotificationToken($token: String!, $device: String, $serial: String) {
  UpdateNotificationToken(token: $token, device: $device, serial: $serial) {
    token
  }
}
    `;

/**
 * __useUpdateNotificationTokenMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateNotificationTokenMutation({
 *   variables: {
 *     token: // value for 'token'
 *     device: // value for 'device'
 *     serial: // value for 'serial'
 *   },
 * });
 */
export function useUpdateNotificationTokenMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateNotificationTokenMutation, QLUpdateNotificationTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateNotificationTokenMutation, QLUpdateNotificationTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateNotificationTokenMutation, QLUpdateNotificationTokenMutationVariables>(UpdateNotificationTokenDocument, options);
}
export type UpdateNotificationTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateNotificationTokenMutation, QLUpdateNotificationTokenMutationVariables>;
export const UpdateVirtualClassInfoDocument = gql`
    mutation UpdateVirtualClassInfo($id: ID!, $name: String!, $virtual_url: String!, $day_of_week: Int, $start_time: Int, $virtual_data: ClassVirtualDataInput) {
  UpdateVirtualClassInfo(
    id: $id
    name: $name
    virtual_url: $virtual_url
    day_of_week: $day_of_week
    start_time: $start_time
    virtual_data: $virtual_data
  ) {
    ...FRAGMENT_VIRTUAL_CLASS_INFO
  }
}
    ${FragmentVirtualClassInfoFragmentDoc}`;

/**
 * __useUpdateVirtualClassInfoMutation__
 *
 * To run a mutation, you first call `useUpdateVirtualClassInfoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVirtualClassInfoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateVirtualClassInfoMutation({
 *   variables: {
 *     id: // value for 'id'
 *     name: // value for 'name'
 *     virtual_url: // value for 'virtual_url'
 *     day_of_week: // value for 'day_of_week'
 *     start_time: // value for 'start_time'
 *     virtual_data: // value for 'virtual_data'
 *   },
 * });
 */
export function useUpdateVirtualClassInfoMutation(options: VueApolloComposable.UseMutationOptions<QLUpdateVirtualClassInfoMutation, QLUpdateVirtualClassInfoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLUpdateVirtualClassInfoMutation, QLUpdateVirtualClassInfoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLUpdateVirtualClassInfoMutation, QLUpdateVirtualClassInfoMutationVariables>(UpdateVirtualClassInfoDocument, options);
}
export type UpdateVirtualClassInfoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLUpdateVirtualClassInfoMutation, QLUpdateVirtualClassInfoMutationVariables>;
export const CreateVirtualClassInfoDocument = gql`
    mutation CreateVirtualClassInfo($name: String!, $virtual_url: String!, $day_of_week: Int, $start_time: Int, $virtual_data: ClassVirtualDataInput) {
  CreateVirtualClassInfo(
    name: $name
    virtual_url: $virtual_url
    day_of_week: $day_of_week
    start_time: $start_time
    virtual_data: $virtual_data
  ) {
    ...FRAGMENT_VIRTUAL_CLASS_INFO
  }
}
    ${FragmentVirtualClassInfoFragmentDoc}`;

/**
 * __useCreateVirtualClassInfoMutation__
 *
 * To run a mutation, you first call `useCreateVirtualClassInfoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateVirtualClassInfoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateVirtualClassInfoMutation({
 *   variables: {
 *     name: // value for 'name'
 *     virtual_url: // value for 'virtual_url'
 *     day_of_week: // value for 'day_of_week'
 *     start_time: // value for 'start_time'
 *     virtual_data: // value for 'virtual_data'
 *   },
 * });
 */
export function useCreateVirtualClassInfoMutation(options: VueApolloComposable.UseMutationOptions<QLCreateVirtualClassInfoMutation, QLCreateVirtualClassInfoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCreateVirtualClassInfoMutation, QLCreateVirtualClassInfoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCreateVirtualClassInfoMutation, QLCreateVirtualClassInfoMutationVariables>(CreateVirtualClassInfoDocument, options);
}
export type CreateVirtualClassInfoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCreateVirtualClassInfoMutation, QLCreateVirtualClassInfoMutationVariables>;
export const DeleteVirtualClassInfoDocument = gql`
    mutation DeleteVirtualClassInfo($id: ID!) {
  DeleteVirtualClassInfo(id: $id) {
    ...FRAGMENT_VIRTUAL_CLASS_INFO
  }
}
    ${FragmentVirtualClassInfoFragmentDoc}`;

/**
 * __useDeleteVirtualClassInfoMutation__
 *
 * To run a mutation, you first call `useDeleteVirtualClassInfoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVirtualClassInfoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteVirtualClassInfoMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVirtualClassInfoMutation(options: VueApolloComposable.UseMutationOptions<QLDeleteVirtualClassInfoMutation, QLDeleteVirtualClassInfoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLDeleteVirtualClassInfoMutation, QLDeleteVirtualClassInfoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLDeleteVirtualClassInfoMutation, QLDeleteVirtualClassInfoMutationVariables>(DeleteVirtualClassInfoDocument, options);
}
export type DeleteVirtualClassInfoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLDeleteVirtualClassInfoMutation, QLDeleteVirtualClassInfoMutationVariables>;
export const CreateZapierTokenDocument = gql`
    mutation CreateZapierToken($name: String!) {
  CreateZapierToken(name: $name) {
    id
    name
    created_at
    plain_token
  }
}
    `;

/**
 * __useCreateZapierTokenMutation__
 *
 * To run a mutation, you first call `useCreateZapierTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateZapierTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateZapierTokenMutation({
 *   variables: {
 *     name: // value for 'name'
 *   },
 * });
 */
export function useCreateZapierTokenMutation(options: VueApolloComposable.UseMutationOptions<QLCreateZapierTokenMutation, QLCreateZapierTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLCreateZapierTokenMutation, QLCreateZapierTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLCreateZapierTokenMutation, QLCreateZapierTokenMutationVariables>(CreateZapierTokenDocument, options);
}
export type CreateZapierTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLCreateZapierTokenMutation, QLCreateZapierTokenMutationVariables>;
export const DeleteZapierTokenDocument = gql`
    mutation DeleteZapierToken($id: ID!) {
  DeleteZapierToken(id: $id) {
    ok
  }
}
    `;

/**
 * __useDeleteZapierTokenMutation__
 *
 * To run a mutation, you first call `useDeleteZapierTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteZapierTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteZapierTokenMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteZapierTokenMutation(options: VueApolloComposable.UseMutationOptions<QLDeleteZapierTokenMutation, QLDeleteZapierTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLDeleteZapierTokenMutation, QLDeleteZapierTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLDeleteZapierTokenMutation, QLDeleteZapierTokenMutationVariables>(DeleteZapierTokenDocument, options);
}
export type DeleteZapierTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLDeleteZapierTokenMutation, QLDeleteZapierTokenMutationVariables>;
export const AutomationsQuickListDocument = gql`
    query automations_quick_list {
  automations {
    ...FRAGMENT_SMALL_AUTOMATION
  }
}
    ${FragmentSmallAutomationFragmentDoc}`;

/**
 * __useAutomationsQuickListQuery__
 *
 * To run a query within a Vue component, call `useAutomationsQuickListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationsQuickListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAutomationsQuickListQuery();
 */
export function useAutomationsQuickListQuery(options: VueApolloComposable.UseQueryOptions<QLAutomationsQuickListQuery, QLAutomationsQuickListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationsQuickListQuery, QLAutomationsQuickListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationsQuickListQuery, QLAutomationsQuickListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLAutomationsQuickListQuery, QLAutomationsQuickListQueryVariables>(AutomationsQuickListDocument, {}, options);
}
export function useAutomationsQuickListLazyQuery(options: VueApolloComposable.UseQueryOptions<QLAutomationsQuickListQuery, QLAutomationsQuickListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationsQuickListQuery, QLAutomationsQuickListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationsQuickListQuery, QLAutomationsQuickListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLAutomationsQuickListQuery, QLAutomationsQuickListQueryVariables>(AutomationsQuickListDocument, {}, options);
}
export type AutomationsQuickListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLAutomationsQuickListQuery, QLAutomationsQuickListQueryVariables>;
export const AutomationsIndexDocument = gql`
    query automations_index {
  automations_index: automations {
    ...FRAGMENT_AUTOMATION_INDEX
  }
}
    ${FragmentAutomationIndexFragmentDoc}`;

/**
 * __useAutomationsIndexQuery__
 *
 * To run a query within a Vue component, call `useAutomationsIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationsIndexQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAutomationsIndexQuery();
 */
export function useAutomationsIndexQuery(options: VueApolloComposable.UseQueryOptions<QLAutomationsIndexQuery, QLAutomationsIndexQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationsIndexQuery, QLAutomationsIndexQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationsIndexQuery, QLAutomationsIndexQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLAutomationsIndexQuery, QLAutomationsIndexQueryVariables>(AutomationsIndexDocument, {}, options);
}
export function useAutomationsIndexLazyQuery(options: VueApolloComposable.UseQueryOptions<QLAutomationsIndexQuery, QLAutomationsIndexQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationsIndexQuery, QLAutomationsIndexQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationsIndexQuery, QLAutomationsIndexQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLAutomationsIndexQuery, QLAutomationsIndexQueryVariables>(AutomationsIndexDocument, {}, options);
}
export type AutomationsIndexQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLAutomationsIndexQuery, QLAutomationsIndexQueryVariables>;
export const AutomationCategoriesDocument = gql`
    query automation_categories {
  automation_categories {
    name
  }
}
    `;

/**
 * __useAutomationCategoriesQuery__
 *
 * To run a query within a Vue component, call `useAutomationCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAutomationCategoriesQuery();
 */
export function useAutomationCategoriesQuery(options: VueApolloComposable.UseQueryOptions<QLAutomationCategoriesQuery, QLAutomationCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationCategoriesQuery, QLAutomationCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationCategoriesQuery, QLAutomationCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLAutomationCategoriesQuery, QLAutomationCategoriesQueryVariables>(AutomationCategoriesDocument, {}, options);
}
export function useAutomationCategoriesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLAutomationCategoriesQuery, QLAutomationCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationCategoriesQuery, QLAutomationCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationCategoriesQuery, QLAutomationCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLAutomationCategoriesQuery, QLAutomationCategoriesQueryVariables>(AutomationCategoriesDocument, {}, options);
}
export type AutomationCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLAutomationCategoriesQuery, QLAutomationCategoriesQueryVariables>;
export const AutomationDocument = gql`
    query automation($id: ID!) {
  automation(id: $id) {
    ...FRAGMENT_FULL_AUTOMATION
  }
}
    ${FragmentFullAutomationFragmentDoc}`;

/**
 * __useAutomationQuery__
 *
 * To run a query within a Vue component, call `useAutomationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAutomationQuery({
 *   id: // value for 'id'
 * });
 */
export function useAutomationQuery(variables: QLAutomationQueryVariables | VueCompositionApi.Ref<QLAutomationQueryVariables> | ReactiveFunction<QLAutomationQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLAutomationQuery, QLAutomationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationQuery, QLAutomationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationQuery, QLAutomationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLAutomationQuery, QLAutomationQueryVariables>(AutomationDocument, variables, options);
}
export function useAutomationLazyQuery(variables: QLAutomationQueryVariables | VueCompositionApi.Ref<QLAutomationQueryVariables> | ReactiveFunction<QLAutomationQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLAutomationQuery, QLAutomationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationQuery, QLAutomationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationQuery, QLAutomationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLAutomationQuery, QLAutomationQueryVariables>(AutomationDocument, variables, options);
}
export type AutomationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLAutomationQuery, QLAutomationQueryVariables>;
export const AutomationStatEmailOrSmsDocument = gql`
    query automation_stat_email_or_sms($input: AutomationStatInput!) {
  automation_stat_email_or_sms(input: $input) {
    ...FRAGMENT_AUTOMATION_STATS_EMAIL_OR_SMS
  }
}
    ${FragmentAutomationStatsEmailOrSmsFragmentDoc}`;

/**
 * __useAutomationStatEmailOrSmsQuery__
 *
 * To run a query within a Vue component, call `useAutomationStatEmailOrSmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationStatEmailOrSmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAutomationStatEmailOrSmsQuery({
 *   input: // value for 'input'
 * });
 */
export function useAutomationStatEmailOrSmsQuery(variables: QLAutomationStatEmailOrSmsQueryVariables | VueCompositionApi.Ref<QLAutomationStatEmailOrSmsQueryVariables> | ReactiveFunction<QLAutomationStatEmailOrSmsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLAutomationStatEmailOrSmsQuery, QLAutomationStatEmailOrSmsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationStatEmailOrSmsQuery, QLAutomationStatEmailOrSmsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationStatEmailOrSmsQuery, QLAutomationStatEmailOrSmsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLAutomationStatEmailOrSmsQuery, QLAutomationStatEmailOrSmsQueryVariables>(AutomationStatEmailOrSmsDocument, variables, options);
}
export function useAutomationStatEmailOrSmsLazyQuery(variables: QLAutomationStatEmailOrSmsQueryVariables | VueCompositionApi.Ref<QLAutomationStatEmailOrSmsQueryVariables> | ReactiveFunction<QLAutomationStatEmailOrSmsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLAutomationStatEmailOrSmsQuery, QLAutomationStatEmailOrSmsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationStatEmailOrSmsQuery, QLAutomationStatEmailOrSmsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationStatEmailOrSmsQuery, QLAutomationStatEmailOrSmsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLAutomationStatEmailOrSmsQuery, QLAutomationStatEmailOrSmsQueryVariables>(AutomationStatEmailOrSmsDocument, variables, options);
}
export type AutomationStatEmailOrSmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLAutomationStatEmailOrSmsQuery, QLAutomationStatEmailOrSmsQueryVariables>;
export const AutomationStatTodoDocument = gql`
    query automation_stat_todo($input: AutomationStatInput!) {
  automation_stat_todo(input: $input) {
    ...FRAGMENT_AUTOMATION_STATS_TODO
  }
}
    ${FragmentAutomationStatsTodoFragmentDoc}`;

/**
 * __useAutomationStatTodoQuery__
 *
 * To run a query within a Vue component, call `useAutomationStatTodoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationStatTodoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAutomationStatTodoQuery({
 *   input: // value for 'input'
 * });
 */
export function useAutomationStatTodoQuery(variables: QLAutomationStatTodoQueryVariables | VueCompositionApi.Ref<QLAutomationStatTodoQueryVariables> | ReactiveFunction<QLAutomationStatTodoQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLAutomationStatTodoQuery, QLAutomationStatTodoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationStatTodoQuery, QLAutomationStatTodoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationStatTodoQuery, QLAutomationStatTodoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLAutomationStatTodoQuery, QLAutomationStatTodoQueryVariables>(AutomationStatTodoDocument, variables, options);
}
export function useAutomationStatTodoLazyQuery(variables: QLAutomationStatTodoQueryVariables | VueCompositionApi.Ref<QLAutomationStatTodoQueryVariables> | ReactiveFunction<QLAutomationStatTodoQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLAutomationStatTodoQuery, QLAutomationStatTodoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationStatTodoQuery, QLAutomationStatTodoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationStatTodoQuery, QLAutomationStatTodoQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLAutomationStatTodoQuery, QLAutomationStatTodoQueryVariables>(AutomationStatTodoDocument, variables, options);
}
export type AutomationStatTodoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLAutomationStatTodoQuery, QLAutomationStatTodoQueryVariables>;
export const AutomationStatTagDocument = gql`
    query automation_stat_tag($input: AutomationStatInput!) {
  automation_stat_tag(input: $input) {
    ...FRAGMENT_AUTOMATION_STATS_TAG
  }
}
    ${FragmentAutomationStatsTagFragmentDoc}`;

/**
 * __useAutomationStatTagQuery__
 *
 * To run a query within a Vue component, call `useAutomationStatTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationStatTagQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAutomationStatTagQuery({
 *   input: // value for 'input'
 * });
 */
export function useAutomationStatTagQuery(variables: QLAutomationStatTagQueryVariables | VueCompositionApi.Ref<QLAutomationStatTagQueryVariables> | ReactiveFunction<QLAutomationStatTagQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLAutomationStatTagQuery, QLAutomationStatTagQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationStatTagQuery, QLAutomationStatTagQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationStatTagQuery, QLAutomationStatTagQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLAutomationStatTagQuery, QLAutomationStatTagQueryVariables>(AutomationStatTagDocument, variables, options);
}
export function useAutomationStatTagLazyQuery(variables: QLAutomationStatTagQueryVariables | VueCompositionApi.Ref<QLAutomationStatTagQueryVariables> | ReactiveFunction<QLAutomationStatTagQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLAutomationStatTagQuery, QLAutomationStatTagQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationStatTagQuery, QLAutomationStatTagQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationStatTagQuery, QLAutomationStatTagQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLAutomationStatTagQuery, QLAutomationStatTagQueryVariables>(AutomationStatTagDocument, variables, options);
}
export type AutomationStatTagQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLAutomationStatTagQuery, QLAutomationStatTagQueryVariables>;
export const AutomationActionsDocument = gql`
    query automation_actions($id: ID!, $orderBy: [OrderByClause!], $page: Int!, $first: Int!) {
  automation_actions(id: $id, orderBy: $orderBy, page: $page, first: $first) {
    data {
      ...FRAGMENT_AUTOMATION_ACTION_TAGS
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentAutomationActionTagsFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useAutomationActionsQuery__
 *
 * To run a query within a Vue component, call `useAutomationActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationActionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAutomationActionsQuery({
 *   id: // value for 'id'
 *   orderBy: // value for 'orderBy'
 *   page: // value for 'page'
 *   first: // value for 'first'
 * });
 */
export function useAutomationActionsQuery(variables: QLAutomationActionsQueryVariables | VueCompositionApi.Ref<QLAutomationActionsQueryVariables> | ReactiveFunction<QLAutomationActionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLAutomationActionsQuery, QLAutomationActionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationActionsQuery, QLAutomationActionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationActionsQuery, QLAutomationActionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLAutomationActionsQuery, QLAutomationActionsQueryVariables>(AutomationActionsDocument, variables, options);
}
export function useAutomationActionsLazyQuery(variables: QLAutomationActionsQueryVariables | VueCompositionApi.Ref<QLAutomationActionsQueryVariables> | ReactiveFunction<QLAutomationActionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLAutomationActionsQuery, QLAutomationActionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationActionsQuery, QLAutomationActionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationActionsQuery, QLAutomationActionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLAutomationActionsQuery, QLAutomationActionsQueryVariables>(AutomationActionsDocument, variables, options);
}
export type AutomationActionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLAutomationActionsQuery, QLAutomationActionsQueryVariables>;
export const MySubscriptionDocument = gql`
    query my_subscription {
  my_subscription {
    ...FragmentTeamSubscription
  }
}
    ${FragmentTeamSubscriptionFragmentDoc}`;

/**
 * __useMySubscriptionQuery__
 *
 * To run a query within a Vue component, call `useMySubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySubscriptionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMySubscriptionQuery();
 */
export function useMySubscriptionQuery(options: VueApolloComposable.UseQueryOptions<QLMySubscriptionQuery, QLMySubscriptionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLMySubscriptionQuery, QLMySubscriptionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLMySubscriptionQuery, QLMySubscriptionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLMySubscriptionQuery, QLMySubscriptionQueryVariables>(MySubscriptionDocument, {}, options);
}
export function useMySubscriptionLazyQuery(options: VueApolloComposable.UseQueryOptions<QLMySubscriptionQuery, QLMySubscriptionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLMySubscriptionQuery, QLMySubscriptionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLMySubscriptionQuery, QLMySubscriptionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLMySubscriptionQuery, QLMySubscriptionQueryVariables>(MySubscriptionDocument, {}, options);
}
export type MySubscriptionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLMySubscriptionQuery, QLMySubscriptionQueryVariables>;
export const PlansDocument = gql`
    query plans {
  plans {
    ...FragmentPlan
  }
}
    ${FragmentPlanFragmentDoc}`;

/**
 * __usePlansQuery__
 *
 * To run a query within a Vue component, call `usePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlansQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePlansQuery();
 */
export function usePlansQuery(options: VueApolloComposable.UseQueryOptions<QLPlansQuery, QLPlansQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLPlansQuery, QLPlansQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLPlansQuery, QLPlansQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLPlansQuery, QLPlansQueryVariables>(PlansDocument, {}, options);
}
export function usePlansLazyQuery(options: VueApolloComposable.UseQueryOptions<QLPlansQuery, QLPlansQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLPlansQuery, QLPlansQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLPlansQuery, QLPlansQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLPlansQuery, QLPlansQueryVariables>(PlansDocument, {}, options);
}
export type PlansQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLPlansQuery, QLPlansQueryVariables>;
export const AddonsDocument = gql`
    query addons {
  addons {
    ...FragmentPlan
  }
}
    ${FragmentPlanFragmentDoc}`;

/**
 * __useAddonsQuery__
 *
 * To run a query within a Vue component, call `useAddonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddonsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAddonsQuery();
 */
export function useAddonsQuery(options: VueApolloComposable.UseQueryOptions<QLAddonsQuery, QLAddonsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAddonsQuery, QLAddonsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAddonsQuery, QLAddonsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLAddonsQuery, QLAddonsQueryVariables>(AddonsDocument, {}, options);
}
export function useAddonsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLAddonsQuery, QLAddonsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAddonsQuery, QLAddonsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAddonsQuery, QLAddonsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLAddonsQuery, QLAddonsQueryVariables>(AddonsDocument, {}, options);
}
export type AddonsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLAddonsQuery, QLAddonsQueryVariables>;
export const InvoicesDocument = gql`
    query invoices {
  invoices {
    id
    date
    total
  }
}
    `;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a Vue component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInvoicesQuery();
 */
export function useInvoicesQuery(options: VueApolloComposable.UseQueryOptions<QLInvoicesQuery, QLInvoicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLInvoicesQuery, QLInvoicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLInvoicesQuery, QLInvoicesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLInvoicesQuery, QLInvoicesQueryVariables>(InvoicesDocument, {}, options);
}
export function useInvoicesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLInvoicesQuery, QLInvoicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLInvoicesQuery, QLInvoicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLInvoicesQuery, QLInvoicesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLInvoicesQuery, QLInvoicesQueryVariables>(InvoicesDocument, {}, options);
}
export type InvoicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLInvoicesQuery, QLInvoicesQueryVariables>;
export const CatalogItemsDocument = gql`
    query catalog_items {
  catalog_items {
    ...CATALOG_ITEM_INDEX
  }
}
    ${CatalogItemIndexFragmentDoc}`;

/**
 * __useCatalogItemsQuery__
 *
 * To run a query within a Vue component, call `useCatalogItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCatalogItemsQuery();
 */
export function useCatalogItemsQuery(options: VueApolloComposable.UseQueryOptions<QLCatalogItemsQuery, QLCatalogItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCatalogItemsQuery, QLCatalogItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCatalogItemsQuery, QLCatalogItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLCatalogItemsQuery, QLCatalogItemsQueryVariables>(CatalogItemsDocument, {}, options);
}
export function useCatalogItemsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLCatalogItemsQuery, QLCatalogItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCatalogItemsQuery, QLCatalogItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCatalogItemsQuery, QLCatalogItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLCatalogItemsQuery, QLCatalogItemsQueryVariables>(CatalogItemsDocument, {}, options);
}
export type CatalogItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLCatalogItemsQuery, QLCatalogItemsQueryVariables>;
export const CatalogItemDocument = gql`
    query catalog_item($id: ID!) {
  catalog_item(id: $id) {
    ...CatalogItemSingleFragment
  }
}
    ${CatalogItemSingleFragmentFragmentDoc}`;

/**
 * __useCatalogItemQuery__
 *
 * To run a query within a Vue component, call `useCatalogItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogItemQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCatalogItemQuery({
 *   id: // value for 'id'
 * });
 */
export function useCatalogItemQuery(variables: QLCatalogItemQueryVariables | VueCompositionApi.Ref<QLCatalogItemQueryVariables> | ReactiveFunction<QLCatalogItemQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLCatalogItemQuery, QLCatalogItemQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCatalogItemQuery, QLCatalogItemQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCatalogItemQuery, QLCatalogItemQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLCatalogItemQuery, QLCatalogItemQueryVariables>(CatalogItemDocument, variables, options);
}
export function useCatalogItemLazyQuery(variables: QLCatalogItemQueryVariables | VueCompositionApi.Ref<QLCatalogItemQueryVariables> | ReactiveFunction<QLCatalogItemQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLCatalogItemQuery, QLCatalogItemQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCatalogItemQuery, QLCatalogItemQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCatalogItemQuery, QLCatalogItemQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLCatalogItemQuery, QLCatalogItemQueryVariables>(CatalogItemDocument, variables, options);
}
export type CatalogItemQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLCatalogItemQuery, QLCatalogItemQueryVariables>;
export const CatalogItemFullDocument = gql`
    query catalog_item_full($id: ID!) {
  catalog_item(id: $id) {
    ...CatalogItemFullFragment
  }
}
    ${CatalogItemFullFragmentFragmentDoc}`;

/**
 * __useCatalogItemFullQuery__
 *
 * To run a query within a Vue component, call `useCatalogItemFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogItemFullQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCatalogItemFullQuery({
 *   id: // value for 'id'
 * });
 */
export function useCatalogItemFullQuery(variables: QLCatalogItemFullQueryVariables | VueCompositionApi.Ref<QLCatalogItemFullQueryVariables> | ReactiveFunction<QLCatalogItemFullQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLCatalogItemFullQuery, QLCatalogItemFullQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCatalogItemFullQuery, QLCatalogItemFullQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCatalogItemFullQuery, QLCatalogItemFullQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLCatalogItemFullQuery, QLCatalogItemFullQueryVariables>(CatalogItemFullDocument, variables, options);
}
export function useCatalogItemFullLazyQuery(variables: QLCatalogItemFullQueryVariables | VueCompositionApi.Ref<QLCatalogItemFullQueryVariables> | ReactiveFunction<QLCatalogItemFullQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLCatalogItemFullQuery, QLCatalogItemFullQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCatalogItemFullQuery, QLCatalogItemFullQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCatalogItemFullQuery, QLCatalogItemFullQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLCatalogItemFullQuery, QLCatalogItemFullQueryVariables>(CatalogItemFullDocument, variables, options);
}
export type CatalogItemFullQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLCatalogItemFullQuery, QLCatalogItemFullQueryVariables>;
export const EventNamesDocument = gql`
    query event_names {
  event_names {
    name
  }
}
    `;

/**
 * __useEventNamesQuery__
 *
 * To run a query within a Vue component, call `useEventNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEventNamesQuery();
 */
export function useEventNamesQuery(options: VueApolloComposable.UseQueryOptions<QLEventNamesQuery, QLEventNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLEventNamesQuery, QLEventNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLEventNamesQuery, QLEventNamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLEventNamesQuery, QLEventNamesQueryVariables>(EventNamesDocument, {}, options);
}
export function useEventNamesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLEventNamesQuery, QLEventNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLEventNamesQuery, QLEventNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLEventNamesQuery, QLEventNamesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLEventNamesQuery, QLEventNamesQueryVariables>(EventNamesDocument, {}, options);
}
export type EventNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLEventNamesQuery, QLEventNamesQueryVariables>;
export const ClassNamesDocument = gql`
    query class_names {
  class_names {
    name
  }
}
    `;

/**
 * __useClassNamesQuery__
 *
 * To run a query within a Vue component, call `useClassNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClassNamesQuery();
 */
export function useClassNamesQuery(options: VueApolloComposable.UseQueryOptions<QLClassNamesQuery, QLClassNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClassNamesQuery, QLClassNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClassNamesQuery, QLClassNamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClassNamesQuery, QLClassNamesQueryVariables>(ClassNamesDocument, {}, options);
}
export function useClassNamesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLClassNamesQuery, QLClassNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClassNamesQuery, QLClassNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClassNamesQuery, QLClassNamesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClassNamesQuery, QLClassNamesQueryVariables>(ClassNamesDocument, {}, options);
}
export type ClassNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClassNamesQuery, QLClassNamesQueryVariables>;
export const AppointmentNamesDocument = gql`
    query appointment_names {
  appointment_names {
    name
  }
}
    `;

/**
 * __useAppointmentNamesQuery__
 *
 * To run a query within a Vue component, call `useAppointmentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAppointmentNamesQuery();
 */
export function useAppointmentNamesQuery(options: VueApolloComposable.UseQueryOptions<QLAppointmentNamesQuery, QLAppointmentNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAppointmentNamesQuery, QLAppointmentNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAppointmentNamesQuery, QLAppointmentNamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLAppointmentNamesQuery, QLAppointmentNamesQueryVariables>(AppointmentNamesDocument, {}, options);
}
export function useAppointmentNamesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLAppointmentNamesQuery, QLAppointmentNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAppointmentNamesQuery, QLAppointmentNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAppointmentNamesQuery, QLAppointmentNamesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLAppointmentNamesQuery, QLAppointmentNamesQueryVariables>(AppointmentNamesDocument, {}, options);
}
export type AppointmentNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLAppointmentNamesQuery, QLAppointmentNamesQueryVariables>;
export const ExcludedEventNamesDocument = gql`
    query excluded_event_names {
  excluded_event_names {
    ...FRAGMENT_EXCLUDED_EVENT_NAME
  }
}
    ${FragmentExcludedEventNameFragmentDoc}`;

/**
 * __useExcludedEventNamesQuery__
 *
 * To run a query within a Vue component, call `useExcludedEventNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExcludedEventNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExcludedEventNamesQuery();
 */
export function useExcludedEventNamesQuery(options: VueApolloComposable.UseQueryOptions<QLExcludedEventNamesQuery, QLExcludedEventNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLExcludedEventNamesQuery, QLExcludedEventNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLExcludedEventNamesQuery, QLExcludedEventNamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLExcludedEventNamesQuery, QLExcludedEventNamesQueryVariables>(ExcludedEventNamesDocument, {}, options);
}
export function useExcludedEventNamesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLExcludedEventNamesQuery, QLExcludedEventNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLExcludedEventNamesQuery, QLExcludedEventNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLExcludedEventNamesQuery, QLExcludedEventNamesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLExcludedEventNamesQuery, QLExcludedEventNamesQueryVariables>(ExcludedEventNamesDocument, {}, options);
}
export type ExcludedEventNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLExcludedEventNamesQuery, QLExcludedEventNamesQueryVariables>;
export const CalendarDocument = gql`
    query calendar($location_id: ID!, $before: Int, $after: Int) {
  calendar: classes(location_id: $location_id, before: $before, after: $after) {
    ...calendarClassFragment
  }
}
    ${CalendarClassFragmentFragmentDoc}`;

/**
 * __useCalendarQuery__
 *
 * To run a query within a Vue component, call `useCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCalendarQuery({
 *   location_id: // value for 'location_id'
 *   before: // value for 'before'
 *   after: // value for 'after'
 * });
 */
export function useCalendarQuery(variables: QLCalendarQueryVariables | VueCompositionApi.Ref<QLCalendarQueryVariables> | ReactiveFunction<QLCalendarQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLCalendarQuery, QLCalendarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCalendarQuery, QLCalendarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCalendarQuery, QLCalendarQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLCalendarQuery, QLCalendarQueryVariables>(CalendarDocument, variables, options);
}
export function useCalendarLazyQuery(variables: QLCalendarQueryVariables | VueCompositionApi.Ref<QLCalendarQueryVariables> | ReactiveFunction<QLCalendarQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLCalendarQuery, QLCalendarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCalendarQuery, QLCalendarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCalendarQuery, QLCalendarQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLCalendarQuery, QLCalendarQueryVariables>(CalendarDocument, variables, options);
}
export type CalendarQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLCalendarQuery, QLCalendarQueryVariables>;
export const ClientsTodayDocument = gql`
    query clients_today($location_id: ID!) {
  clients_today(location_id: $location_id) {
    value
  }
}
    `;

/**
 * __useClientsTodayQuery__
 *
 * To run a query within a Vue component, call `useClientsTodayQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsTodayQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientsTodayQuery({
 *   location_id: // value for 'location_id'
 * });
 */
export function useClientsTodayQuery(variables: QLClientsTodayQueryVariables | VueCompositionApi.Ref<QLClientsTodayQueryVariables> | ReactiveFunction<QLClientsTodayQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientsTodayQuery, QLClientsTodayQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientsTodayQuery, QLClientsTodayQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientsTodayQuery, QLClientsTodayQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientsTodayQuery, QLClientsTodayQueryVariables>(ClientsTodayDocument, variables, options);
}
export function useClientsTodayLazyQuery(variables: QLClientsTodayQueryVariables | VueCompositionApi.Ref<QLClientsTodayQueryVariables> | ReactiveFunction<QLClientsTodayQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientsTodayQuery, QLClientsTodayQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientsTodayQuery, QLClientsTodayQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientsTodayQuery, QLClientsTodayQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientsTodayQuery, QLClientsTodayQueryVariables>(ClientsTodayDocument, variables, options);
}
export type ClientsTodayQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientsTodayQuery, QLClientsTodayQueryVariables>;
export const ClientsTodayFirstDocument = gql`
    query clients_today_first($location_id: ID!) {
  clients_today_first(location_id: $location_id) {
    value
  }
}
    `;

/**
 * __useClientsTodayFirstQuery__
 *
 * To run a query within a Vue component, call `useClientsTodayFirstQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsTodayFirstQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientsTodayFirstQuery({
 *   location_id: // value for 'location_id'
 * });
 */
export function useClientsTodayFirstQuery(variables: QLClientsTodayFirstQueryVariables | VueCompositionApi.Ref<QLClientsTodayFirstQueryVariables> | ReactiveFunction<QLClientsTodayFirstQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientsTodayFirstQuery, QLClientsTodayFirstQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientsTodayFirstQuery, QLClientsTodayFirstQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientsTodayFirstQuery, QLClientsTodayFirstQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientsTodayFirstQuery, QLClientsTodayFirstQueryVariables>(ClientsTodayFirstDocument, variables, options);
}
export function useClientsTodayFirstLazyQuery(variables: QLClientsTodayFirstQueryVariables | VueCompositionApi.Ref<QLClientsTodayFirstQueryVariables> | ReactiveFunction<QLClientsTodayFirstQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientsTodayFirstQuery, QLClientsTodayFirstQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientsTodayFirstQuery, QLClientsTodayFirstQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientsTodayFirstQuery, QLClientsTodayFirstQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientsTodayFirstQuery, QLClientsTodayFirstQueryVariables>(ClientsTodayFirstDocument, variables, options);
}
export type ClientsTodayFirstQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientsTodayFirstQuery, QLClientsTodayFirstQueryVariables>;
export const NextClassDocument = gql`
    query next_class($location_id: ID) {
  next_class(location_id: $location_id) {
    ...nextClassFragment
  }
}
    ${NextClassFragmentFragmentDoc}`;

/**
 * __useNextClassQuery__
 *
 * To run a query within a Vue component, call `useNextClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextClassQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNextClassQuery({
 *   location_id: // value for 'location_id'
 * });
 */
export function useNextClassQuery(variables: QLNextClassQueryVariables | VueCompositionApi.Ref<QLNextClassQueryVariables> | ReactiveFunction<QLNextClassQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<QLNextClassQuery, QLNextClassQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLNextClassQuery, QLNextClassQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLNextClassQuery, QLNextClassQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLNextClassQuery, QLNextClassQueryVariables>(NextClassDocument, variables, options);
}
export function useNextClassLazyQuery(variables: QLNextClassQueryVariables | VueCompositionApi.Ref<QLNextClassQueryVariables> | ReactiveFunction<QLNextClassQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<QLNextClassQuery, QLNextClassQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLNextClassQuery, QLNextClassQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLNextClassQuery, QLNextClassQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLNextClassQuery, QLNextClassQueryVariables>(NextClassDocument, variables, options);
}
export type NextClassQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLNextClassQuery, QLNextClassQueryVariables>;
export const SingleClassDocument = gql`
    query single_class($id: ID!) {
  single_class(id: $id) {
    ...singleClassFragment
  }
}
    ${SingleClassFragmentFragmentDoc}`;

/**
 * __useSingleClassQuery__
 *
 * To run a query within a Vue component, call `useSingleClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleClassQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSingleClassQuery({
 *   id: // value for 'id'
 * });
 */
export function useSingleClassQuery(variables: QLSingleClassQueryVariables | VueCompositionApi.Ref<QLSingleClassQueryVariables> | ReactiveFunction<QLSingleClassQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLSingleClassQuery, QLSingleClassQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLSingleClassQuery, QLSingleClassQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLSingleClassQuery, QLSingleClassQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLSingleClassQuery, QLSingleClassQueryVariables>(SingleClassDocument, variables, options);
}
export function useSingleClassLazyQuery(variables: QLSingleClassQueryVariables | VueCompositionApi.Ref<QLSingleClassQueryVariables> | ReactiveFunction<QLSingleClassQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLSingleClassQuery, QLSingleClassQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLSingleClassQuery, QLSingleClassQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLSingleClassQuery, QLSingleClassQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLSingleClassQuery, QLSingleClassQueryVariables>(SingleClassDocument, variables, options);
}
export type SingleClassQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLSingleClassQuery, QLSingleClassQueryVariables>;
export const CalendarUpdateSingleClassDocument = gql`
    query calendar_update_single_class($id: ID!) {
  calendar_update_single_class: single_class(id: $id) {
    ...calendarClassFragment
  }
}
    ${CalendarClassFragmentFragmentDoc}`;

/**
 * __useCalendarUpdateSingleClassQuery__
 *
 * To run a query within a Vue component, call `useCalendarUpdateSingleClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarUpdateSingleClassQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCalendarUpdateSingleClassQuery({
 *   id: // value for 'id'
 * });
 */
export function useCalendarUpdateSingleClassQuery(variables: QLCalendarUpdateSingleClassQueryVariables | VueCompositionApi.Ref<QLCalendarUpdateSingleClassQueryVariables> | ReactiveFunction<QLCalendarUpdateSingleClassQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLCalendarUpdateSingleClassQuery, QLCalendarUpdateSingleClassQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCalendarUpdateSingleClassQuery, QLCalendarUpdateSingleClassQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCalendarUpdateSingleClassQuery, QLCalendarUpdateSingleClassQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLCalendarUpdateSingleClassQuery, QLCalendarUpdateSingleClassQueryVariables>(CalendarUpdateSingleClassDocument, variables, options);
}
export function useCalendarUpdateSingleClassLazyQuery(variables: QLCalendarUpdateSingleClassQueryVariables | VueCompositionApi.Ref<QLCalendarUpdateSingleClassQueryVariables> | ReactiveFunction<QLCalendarUpdateSingleClassQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLCalendarUpdateSingleClassQuery, QLCalendarUpdateSingleClassQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCalendarUpdateSingleClassQuery, QLCalendarUpdateSingleClassQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCalendarUpdateSingleClassQuery, QLCalendarUpdateSingleClassQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLCalendarUpdateSingleClassQuery, QLCalendarUpdateSingleClassQueryVariables>(CalendarUpdateSingleClassDocument, variables, options);
}
export type CalendarUpdateSingleClassQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLCalendarUpdateSingleClassQuery, QLCalendarUpdateSingleClassQueryVariables>;
export const ClientMuteHistoryDocument = gql`
    query clientMuteHistory($client_id: ID!) {
  clientMuteHistory(client_id: $client_id) {
    success
    mutes {
      id
      client_id
      muted_until
      muted_at
      unmuted_at
      muted_by {
        id
        name
      }
      unmuted_by {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useClientMuteHistoryQuery__
 *
 * To run a query within a Vue component, call `useClientMuteHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientMuteHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientMuteHistoryQuery({
 *   client_id: // value for 'client_id'
 * });
 */
export function useClientMuteHistoryQuery(variables: QLClientMuteHistoryQueryVariables | VueCompositionApi.Ref<QLClientMuteHistoryQueryVariables> | ReactiveFunction<QLClientMuteHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientMuteHistoryQuery, QLClientMuteHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientMuteHistoryQuery, QLClientMuteHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientMuteHistoryQuery, QLClientMuteHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientMuteHistoryQuery, QLClientMuteHistoryQueryVariables>(ClientMuteHistoryDocument, variables, options);
}
export function useClientMuteHistoryLazyQuery(variables: QLClientMuteHistoryQueryVariables | VueCompositionApi.Ref<QLClientMuteHistoryQueryVariables> | ReactiveFunction<QLClientMuteHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientMuteHistoryQuery, QLClientMuteHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientMuteHistoryQuery, QLClientMuteHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientMuteHistoryQuery, QLClientMuteHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientMuteHistoryQuery, QLClientMuteHistoryQueryVariables>(ClientMuteHistoryDocument, variables, options);
}
export type ClientMuteHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientMuteHistoryQuery, QLClientMuteHistoryQueryVariables>;
export const CurrentlyMutedClientsDocument = gql`
    query currentlyMutedClients {
  currentlyMutedClients {
    success
    mutes {
      id
      client_id
      muted_until
      muted_at
      client {
        id
        first_name
        last_name
        email
        mobile_phone
      }
      muted_by {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCurrentlyMutedClientsQuery__
 *
 * To run a query within a Vue component, call `useCurrentlyMutedClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentlyMutedClientsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCurrentlyMutedClientsQuery();
 */
export function useCurrentlyMutedClientsQuery(options: VueApolloComposable.UseQueryOptions<QLCurrentlyMutedClientsQuery, QLCurrentlyMutedClientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCurrentlyMutedClientsQuery, QLCurrentlyMutedClientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCurrentlyMutedClientsQuery, QLCurrentlyMutedClientsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLCurrentlyMutedClientsQuery, QLCurrentlyMutedClientsQueryVariables>(CurrentlyMutedClientsDocument, {}, options);
}
export function useCurrentlyMutedClientsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLCurrentlyMutedClientsQuery, QLCurrentlyMutedClientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCurrentlyMutedClientsQuery, QLCurrentlyMutedClientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCurrentlyMutedClientsQuery, QLCurrentlyMutedClientsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLCurrentlyMutedClientsQuery, QLCurrentlyMutedClientsQueryVariables>(CurrentlyMutedClientsDocument, {}, options);
}
export type CurrentlyMutedClientsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLCurrentlyMutedClientsQuery, QLCurrentlyMutedClientsQueryVariables>;
export const ClientSingleDocument = gql`
    query client_single($id: ID!) {
  client(id: $id) {
    ...FRAGMENT_CLIENT_FULL_MUTES_TEMPORARY_FIELDS
  }
}
    ${FragmentClientFullMutesTemporaryFieldsFragmentDoc}`;

/**
 * __useClientSingleQuery__
 *
 * To run a query within a Vue component, call `useClientSingleQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientSingleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientSingleQuery({
 *   id: // value for 'id'
 * });
 */
export function useClientSingleQuery(variables: QLClientSingleQueryVariables | VueCompositionApi.Ref<QLClientSingleQueryVariables> | ReactiveFunction<QLClientSingleQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientSingleQuery, QLClientSingleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientSingleQuery, QLClientSingleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientSingleQuery, QLClientSingleQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientSingleQuery, QLClientSingleQueryVariables>(ClientSingleDocument, variables, options);
}
export function useClientSingleLazyQuery(variables: QLClientSingleQueryVariables | VueCompositionApi.Ref<QLClientSingleQueryVariables> | ReactiveFunction<QLClientSingleQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientSingleQuery, QLClientSingleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientSingleQuery, QLClientSingleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientSingleQuery, QLClientSingleQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientSingleQuery, QLClientSingleQueryVariables>(ClientSingleDocument, variables, options);
}
export type ClientSingleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientSingleQuery, QLClientSingleQueryVariables>;
export const ClientClassTypeDocument = gql`
    query client_class_type($client_id: ID!) {
  client_class_types(id: $client_id) {
    name
    cc
  }
}
    `;

/**
 * __useClientClassTypeQuery__
 *
 * To run a query within a Vue component, call `useClientClassTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientClassTypeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientClassTypeQuery({
 *   client_id: // value for 'client_id'
 * });
 */
export function useClientClassTypeQuery(variables: QLClientClassTypeQueryVariables | VueCompositionApi.Ref<QLClientClassTypeQueryVariables> | ReactiveFunction<QLClientClassTypeQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientClassTypeQuery, QLClientClassTypeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientClassTypeQuery, QLClientClassTypeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientClassTypeQuery, QLClientClassTypeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientClassTypeQuery, QLClientClassTypeQueryVariables>(ClientClassTypeDocument, variables, options);
}
export function useClientClassTypeLazyQuery(variables: QLClientClassTypeQueryVariables | VueCompositionApi.Ref<QLClientClassTypeQueryVariables> | ReactiveFunction<QLClientClassTypeQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientClassTypeQuery, QLClientClassTypeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientClassTypeQuery, QLClientClassTypeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientClassTypeQuery, QLClientClassTypeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientClassTypeQuery, QLClientClassTypeQueryVariables>(ClientClassTypeDocument, variables, options);
}
export type ClientClassTypeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientClassTypeQuery, QLClientClassTypeQueryVariables>;
export const ClientClassTimesDocument = gql`
    query client_class_times($client_id: ID!) {
  client_class_times(id: $client_id) {
    start_minutes
    cc
  }
}
    `;

/**
 * __useClientClassTimesQuery__
 *
 * To run a query within a Vue component, call `useClientClassTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientClassTimesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientClassTimesQuery({
 *   client_id: // value for 'client_id'
 * });
 */
export function useClientClassTimesQuery(variables: QLClientClassTimesQueryVariables | VueCompositionApi.Ref<QLClientClassTimesQueryVariables> | ReactiveFunction<QLClientClassTimesQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientClassTimesQuery, QLClientClassTimesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientClassTimesQuery, QLClientClassTimesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientClassTimesQuery, QLClientClassTimesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientClassTimesQuery, QLClientClassTimesQueryVariables>(ClientClassTimesDocument, variables, options);
}
export function useClientClassTimesLazyQuery(variables: QLClientClassTimesQueryVariables | VueCompositionApi.Ref<QLClientClassTimesQueryVariables> | ReactiveFunction<QLClientClassTimesQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientClassTimesQuery, QLClientClassTimesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientClassTimesQuery, QLClientClassTimesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientClassTimesQuery, QLClientClassTimesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientClassTimesQuery, QLClientClassTimesQueryVariables>(ClientClassTimesDocument, variables, options);
}
export type ClientClassTimesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientClassTimesQuery, QLClientClassTimesQueryVariables>;
export const SalesDocument = gql`
    query sales($client_id: ID!, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]) {
  sales(client_id: $client_id, page: $page, first: $first, orderBy: $orderBy) {
    data {
      id
      client_id
      team_id
      sold_at
      price
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${PaginatorFragmentFragmentDoc}`;

/**
 * __useSalesQuery__
 *
 * To run a query within a Vue component, call `useSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSalesQuery({
 *   client_id: // value for 'client_id'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useSalesQuery(variables: QLSalesQueryVariables | VueCompositionApi.Ref<QLSalesQueryVariables> | ReactiveFunction<QLSalesQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLSalesQuery, QLSalesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLSalesQuery, QLSalesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLSalesQuery, QLSalesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLSalesQuery, QLSalesQueryVariables>(SalesDocument, variables, options);
}
export function useSalesLazyQuery(variables: QLSalesQueryVariables | VueCompositionApi.Ref<QLSalesQueryVariables> | ReactiveFunction<QLSalesQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLSalesQuery, QLSalesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLSalesQuery, QLSalesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLSalesQuery, QLSalesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLSalesQuery, QLSalesQueryVariables>(SalesDocument, variables, options);
}
export type SalesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLSalesQuery, QLSalesQueryVariables>;
export const ClientSalesDocument = gql`
    query client_sales($client_id: ID!, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]) {
  sales(client_id: $client_id, page: $page, first: $first, orderBy: $orderBy) {
    data {
      id
      sold_at
      price
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${PaginatorFragmentFragmentDoc}`;

/**
 * __useClientSalesQuery__
 *
 * To run a query within a Vue component, call `useClientSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientSalesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientSalesQuery({
 *   client_id: // value for 'client_id'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useClientSalesQuery(variables: QLClientSalesQueryVariables | VueCompositionApi.Ref<QLClientSalesQueryVariables> | ReactiveFunction<QLClientSalesQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientSalesQuery, QLClientSalesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientSalesQuery, QLClientSalesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientSalesQuery, QLClientSalesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientSalesQuery, QLClientSalesQueryVariables>(ClientSalesDocument, variables, options);
}
export function useClientSalesLazyQuery(variables: QLClientSalesQueryVariables | VueCompositionApi.Ref<QLClientSalesQueryVariables> | ReactiveFunction<QLClientSalesQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientSalesQuery, QLClientSalesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientSalesQuery, QLClientSalesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientSalesQuery, QLClientSalesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientSalesQuery, QLClientSalesQueryVariables>(ClientSalesDocument, variables, options);
}
export type ClientSalesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientSalesQuery, QLClientSalesQueryVariables>;
export const ClientVisitsDocument = gql`
    query client_visits($client_id: ID!, $filter: ClientVisitFilterEnum!, $type: ClassType, $page: Int, $first: Int!, $orderBy: [OrderByClause!]) {
  client_visits(
    client_id: $client_id
    filter: $filter
    type: $type
    page: $page
    first: $first
    orderBy: $orderBy
  ) {
    data {
      ...FRAGMENT_VISIT_FULL
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentVisitFullFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useClientVisitsQuery__
 *
 * To run a query within a Vue component, call `useClientVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientVisitsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientVisitsQuery({
 *   client_id: // value for 'client_id'
 *   filter: // value for 'filter'
 *   type: // value for 'type'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useClientVisitsQuery(variables: QLClientVisitsQueryVariables | VueCompositionApi.Ref<QLClientVisitsQueryVariables> | ReactiveFunction<QLClientVisitsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientVisitsQuery, QLClientVisitsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientVisitsQuery, QLClientVisitsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientVisitsQuery, QLClientVisitsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientVisitsQuery, QLClientVisitsQueryVariables>(ClientVisitsDocument, variables, options);
}
export function useClientVisitsLazyQuery(variables: QLClientVisitsQueryVariables | VueCompositionApi.Ref<QLClientVisitsQueryVariables> | ReactiveFunction<QLClientVisitsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientVisitsQuery, QLClientVisitsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientVisitsQuery, QLClientVisitsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientVisitsQuery, QLClientVisitsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientVisitsQuery, QLClientVisitsQueryVariables>(ClientVisitsDocument, variables, options);
}
export type ClientVisitsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientVisitsQuery, QLClientVisitsQueryVariables>;
export const ClientProductsDocument = gql`
    query client_products($client_id: ID!, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]) {
  client_products(
    client_id: $client_id
    page: $page
    first: $first
    orderBy: $orderBy
  ) {
    data {
      sale {
        id
        sold_at
        price
      }
      product {
        id
        name
      }
      sold_at
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${PaginatorFragmentFragmentDoc}`;

/**
 * __useClientProductsQuery__
 *
 * To run a query within a Vue component, call `useClientProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientProductsQuery({
 *   client_id: // value for 'client_id'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useClientProductsQuery(variables: QLClientProductsQueryVariables | VueCompositionApi.Ref<QLClientProductsQueryVariables> | ReactiveFunction<QLClientProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientProductsQuery, QLClientProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientProductsQuery, QLClientProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientProductsQuery, QLClientProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientProductsQuery, QLClientProductsQueryVariables>(ClientProductsDocument, variables, options);
}
export function useClientProductsLazyQuery(variables: QLClientProductsQueryVariables | VueCompositionApi.Ref<QLClientProductsQueryVariables> | ReactiveFunction<QLClientProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientProductsQuery, QLClientProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientProductsQuery, QLClientProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientProductsQuery, QLClientProductsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientProductsQuery, QLClientProductsQueryVariables>(ClientProductsDocument, variables, options);
}
export type ClientProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientProductsQuery, QLClientProductsQueryVariables>;
export const ClientPackagesDocument = gql`
    query client_packages($client_id: ID!, $status: PackageStatus, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]) {
  packages(
    client_id: $client_id
    status: $status
    page: $page
    first: $first
    orderBy: $orderBy
  ) {
    data {
      ...FRAGMENT_PACKAGE_INFO
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentPackageInfoFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useClientPackagesQuery__
 *
 * To run a query within a Vue component, call `useClientPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientPackagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientPackagesQuery({
 *   client_id: // value for 'client_id'
 *   status: // value for 'status'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useClientPackagesQuery(variables: QLClientPackagesQueryVariables | VueCompositionApi.Ref<QLClientPackagesQueryVariables> | ReactiveFunction<QLClientPackagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientPackagesQuery, QLClientPackagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientPackagesQuery, QLClientPackagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientPackagesQuery, QLClientPackagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientPackagesQuery, QLClientPackagesQueryVariables>(ClientPackagesDocument, variables, options);
}
export function useClientPackagesLazyQuery(variables: QLClientPackagesQueryVariables | VueCompositionApi.Ref<QLClientPackagesQueryVariables> | ReactiveFunction<QLClientPackagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientPackagesQuery, QLClientPackagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientPackagesQuery, QLClientPackagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientPackagesQuery, QLClientPackagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientPackagesQuery, QLClientPackagesQueryVariables>(ClientPackagesDocument, variables, options);
}
export type ClientPackagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientPackagesQuery, QLClientPackagesQueryVariables>;
export const ClientContractsDocument = gql`
    query client_contracts($client_id: ID!, $status: ContractStatus, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]) {
  contracts(
    client_id: $client_id
    status: $status
    page: $page
    first: $first
    orderBy: $orderBy
  ) {
    data {
      id
      client_id
      team_id
      price
      agreement_date
      end_date
      start_date
      status
      price
      name
      is_active
      is_inactive
      is_suspended
      external_id
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${PaginatorFragmentFragmentDoc}`;

/**
 * __useClientContractsQuery__
 *
 * To run a query within a Vue component, call `useClientContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientContractsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientContractsQuery({
 *   client_id: // value for 'client_id'
 *   status: // value for 'status'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useClientContractsQuery(variables: QLClientContractsQueryVariables | VueCompositionApi.Ref<QLClientContractsQueryVariables> | ReactiveFunction<QLClientContractsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientContractsQuery, QLClientContractsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientContractsQuery, QLClientContractsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientContractsQuery, QLClientContractsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientContractsQuery, QLClientContractsQueryVariables>(ClientContractsDocument, variables, options);
}
export function useClientContractsLazyQuery(variables: QLClientContractsQueryVariables | VueCompositionApi.Ref<QLClientContractsQueryVariables> | ReactiveFunction<QLClientContractsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientContractsQuery, QLClientContractsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientContractsQuery, QLClientContractsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientContractsQuery, QLClientContractsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientContractsQuery, QLClientContractsQueryVariables>(ClientContractsDocument, variables, options);
}
export type ClientContractsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientContractsQuery, QLClientContractsQueryVariables>;
export const ClientStatsDocument = gql`
    query client_stats($id: ID!) {
  client_stats(id: $id) {
    upcoming_events
  }
}
    `;

/**
 * __useClientStatsQuery__
 *
 * To run a query within a Vue component, call `useClientStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientStatsQuery({
 *   id: // value for 'id'
 * });
 */
export function useClientStatsQuery(variables: QLClientStatsQueryVariables | VueCompositionApi.Ref<QLClientStatsQueryVariables> | ReactiveFunction<QLClientStatsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientStatsQuery, QLClientStatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientStatsQuery, QLClientStatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientStatsQuery, QLClientStatsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientStatsQuery, QLClientStatsQueryVariables>(ClientStatsDocument, variables, options);
}
export function useClientStatsLazyQuery(variables: QLClientStatsQueryVariables | VueCompositionApi.Ref<QLClientStatsQueryVariables> | ReactiveFunction<QLClientStatsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientStatsQuery, QLClientStatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientStatsQuery, QLClientStatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientStatsQuery, QLClientStatsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientStatsQuery, QLClientStatsQueryVariables>(ClientStatsDocument, variables, options);
}
export type ClientStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientStatsQuery, QLClientStatsQueryVariables>;
export const ClientEngagementStatsDocument = gql`
    query client_engagement_stats($id: ID!) {
  client_engagement_stats: client_stats(id: $id) {
    total_engagements
    engagements_stats {
      sms {
        total
        sent
        delivered
        bounced
        opened
        clicked
      }
      email {
        total
        sent
        delivered
        bounced
        opened
        clicked
      }
    }
  }
}
    `;

/**
 * __useClientEngagementStatsQuery__
 *
 * To run a query within a Vue component, call `useClientEngagementStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientEngagementStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientEngagementStatsQuery({
 *   id: // value for 'id'
 * });
 */
export function useClientEngagementStatsQuery(variables: QLClientEngagementStatsQueryVariables | VueCompositionApi.Ref<QLClientEngagementStatsQueryVariables> | ReactiveFunction<QLClientEngagementStatsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientEngagementStatsQuery, QLClientEngagementStatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientEngagementStatsQuery, QLClientEngagementStatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientEngagementStatsQuery, QLClientEngagementStatsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientEngagementStatsQuery, QLClientEngagementStatsQueryVariables>(ClientEngagementStatsDocument, variables, options);
}
export function useClientEngagementStatsLazyQuery(variables: QLClientEngagementStatsQueryVariables | VueCompositionApi.Ref<QLClientEngagementStatsQueryVariables> | ReactiveFunction<QLClientEngagementStatsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientEngagementStatsQuery, QLClientEngagementStatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientEngagementStatsQuery, QLClientEngagementStatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientEngagementStatsQuery, QLClientEngagementStatsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientEngagementStatsQuery, QLClientEngagementStatsQueryVariables>(ClientEngagementStatsDocument, variables, options);
}
export type ClientEngagementStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientEngagementStatsQuery, QLClientEngagementStatsQueryVariables>;
export const ClientEngagementsDocument = gql`
    query client_engagements($client_id: ID!, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]) {
  client_engagements: discussions(
    client_id: $client_id
    page: $page
    first: $first
    orderBy: $orderBy
    only_automations: true
  ) {
    data {
      ...FRAGMENT_DISCUSSION_BASIC
      automation {
        id
        name
        delivery_type
      }
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentDiscussionBasicFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useClientEngagementsQuery__
 *
 * To run a query within a Vue component, call `useClientEngagementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientEngagementsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientEngagementsQuery({
 *   client_id: // value for 'client_id'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useClientEngagementsQuery(variables: QLClientEngagementsQueryVariables | VueCompositionApi.Ref<QLClientEngagementsQueryVariables> | ReactiveFunction<QLClientEngagementsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientEngagementsQuery, QLClientEngagementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientEngagementsQuery, QLClientEngagementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientEngagementsQuery, QLClientEngagementsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientEngagementsQuery, QLClientEngagementsQueryVariables>(ClientEngagementsDocument, variables, options);
}
export function useClientEngagementsLazyQuery(variables: QLClientEngagementsQueryVariables | VueCompositionApi.Ref<QLClientEngagementsQueryVariables> | ReactiveFunction<QLClientEngagementsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientEngagementsQuery, QLClientEngagementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientEngagementsQuery, QLClientEngagementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientEngagementsQuery, QLClientEngagementsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientEngagementsQuery, QLClientEngagementsQueryVariables>(ClientEngagementsDocument, variables, options);
}
export type ClientEngagementsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientEngagementsQuery, QLClientEngagementsQueryVariables>;
export const ClientEngagementsTimelineDocument = gql`
    query client_engagements_timeline($client_id: ID!, $orderBy: [OrderByClause!]) {
  client_engagements_timeline: discussions(
    client_id: $client_id
    page: 1
    first: 1000
    orderBy: $orderBy
    only_automations: true
  ) {
    data {
      created_at
      sms
      automation {
        name
      }
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${PaginatorFragmentFragmentDoc}`;

/**
 * __useClientEngagementsTimelineQuery__
 *
 * To run a query within a Vue component, call `useClientEngagementsTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientEngagementsTimelineQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientEngagementsTimelineQuery({
 *   client_id: // value for 'client_id'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useClientEngagementsTimelineQuery(variables: QLClientEngagementsTimelineQueryVariables | VueCompositionApi.Ref<QLClientEngagementsTimelineQueryVariables> | ReactiveFunction<QLClientEngagementsTimelineQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientEngagementsTimelineQuery, QLClientEngagementsTimelineQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientEngagementsTimelineQuery, QLClientEngagementsTimelineQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientEngagementsTimelineQuery, QLClientEngagementsTimelineQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientEngagementsTimelineQuery, QLClientEngagementsTimelineQueryVariables>(ClientEngagementsTimelineDocument, variables, options);
}
export function useClientEngagementsTimelineLazyQuery(variables: QLClientEngagementsTimelineQueryVariables | VueCompositionApi.Ref<QLClientEngagementsTimelineQueryVariables> | ReactiveFunction<QLClientEngagementsTimelineQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientEngagementsTimelineQuery, QLClientEngagementsTimelineQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientEngagementsTimelineQuery, QLClientEngagementsTimelineQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientEngagementsTimelineQuery, QLClientEngagementsTimelineQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientEngagementsTimelineQuery, QLClientEngagementsTimelineQueryVariables>(ClientEngagementsTimelineDocument, variables, options);
}
export type ClientEngagementsTimelineQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientEngagementsTimelineQuery, QLClientEngagementsTimelineQueryVariables>;
export const ClientDiscussionsDocument = gql`
    query client_discussions($client_id: ID!, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]) {
  discussions(
    client_id: $client_id
    page: $page
    first: $first
    orderBy: $orderBy
  ) {
    data {
      ...FRAGMENT_DISCUSSION_FULL
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentDiscussionFullFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useClientDiscussionsQuery__
 *
 * To run a query within a Vue component, call `useClientDiscussionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDiscussionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientDiscussionsQuery({
 *   client_id: // value for 'client_id'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useClientDiscussionsQuery(variables: QLClientDiscussionsQueryVariables | VueCompositionApi.Ref<QLClientDiscussionsQueryVariables> | ReactiveFunction<QLClientDiscussionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientDiscussionsQuery, QLClientDiscussionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientDiscussionsQuery, QLClientDiscussionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientDiscussionsQuery, QLClientDiscussionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientDiscussionsQuery, QLClientDiscussionsQueryVariables>(ClientDiscussionsDocument, variables, options);
}
export function useClientDiscussionsLazyQuery(variables: QLClientDiscussionsQueryVariables | VueCompositionApi.Ref<QLClientDiscussionsQueryVariables> | ReactiveFunction<QLClientDiscussionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientDiscussionsQuery, QLClientDiscussionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientDiscussionsQuery, QLClientDiscussionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientDiscussionsQuery, QLClientDiscussionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientDiscussionsQuery, QLClientDiscussionsQueryVariables>(ClientDiscussionsDocument, variables, options);
}
export type ClientDiscussionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientDiscussionsQuery, QLClientDiscussionsQueryVariables>;
export const ClientsSearchDocument = gql`
    query clients_search($search: String!, $first: Int!, $onlyContactableViaEmail: Boolean, $onlyContactableViaSms: Boolean, $page: Int) {
  clients_search(
    search: $search
    first: $first
    page: $page
    onlyContactableViaEmail: $onlyContactableViaEmail
    onlyContactableViaSms: $onlyContactableViaSms
  ) {
    data {
      ...FRAGMENT_CLIENT_SMALL
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentClientSmallFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useClientsSearchQuery__
 *
 * To run a query within a Vue component, call `useClientsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsSearchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientsSearchQuery({
 *   search: // value for 'search'
 *   first: // value for 'first'
 *   onlyContactableViaEmail: // value for 'onlyContactableViaEmail'
 *   onlyContactableViaSms: // value for 'onlyContactableViaSms'
 *   page: // value for 'page'
 * });
 */
export function useClientsSearchQuery(variables: QLClientsSearchQueryVariables | VueCompositionApi.Ref<QLClientsSearchQueryVariables> | ReactiveFunction<QLClientsSearchQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientsSearchQuery, QLClientsSearchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientsSearchQuery, QLClientsSearchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientsSearchQuery, QLClientsSearchQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientsSearchQuery, QLClientsSearchQueryVariables>(ClientsSearchDocument, variables, options);
}
export function useClientsSearchLazyQuery(variables: QLClientsSearchQueryVariables | VueCompositionApi.Ref<QLClientsSearchQueryVariables> | ReactiveFunction<QLClientsSearchQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientsSearchQuery, QLClientsSearchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientsSearchQuery, QLClientsSearchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientsSearchQuery, QLClientsSearchQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientsSearchQuery, QLClientsSearchQueryVariables>(ClientsSearchDocument, variables, options);
}
export type ClientsSearchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientsSearchQuery, QLClientsSearchQueryVariables>;
export const ClientTodosDocument = gql`
    query client_todos($client_id: ID, $open: Boolean, $first: Int!, $orderBy: [OrderByClause!], $page: Int) {
  todos(
    client_id: $client_id
    page: $page
    first: $first
    open: $open
    orderBy: $orderBy
  ) {
    data {
      ...FRAGMENT_TODO
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentTodoFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useClientTodosQuery__
 *
 * To run a query within a Vue component, call `useClientTodosQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientTodosQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientTodosQuery({
 *   client_id: // value for 'client_id'
 *   open: // value for 'open'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 *   page: // value for 'page'
 * });
 */
export function useClientTodosQuery(variables: QLClientTodosQueryVariables | VueCompositionApi.Ref<QLClientTodosQueryVariables> | ReactiveFunction<QLClientTodosQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientTodosQuery, QLClientTodosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientTodosQuery, QLClientTodosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientTodosQuery, QLClientTodosQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientTodosQuery, QLClientTodosQueryVariables>(ClientTodosDocument, variables, options);
}
export function useClientTodosLazyQuery(variables: QLClientTodosQueryVariables | VueCompositionApi.Ref<QLClientTodosQueryVariables> | ReactiveFunction<QLClientTodosQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientTodosQuery, QLClientTodosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientTodosQuery, QLClientTodosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientTodosQuery, QLClientTodosQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientTodosQuery, QLClientTodosQueryVariables>(ClientTodosDocument, variables, options);
}
export type ClientTodosQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientTodosQuery, QLClientTodosQueryVariables>;
export const ClientsListIndexDocument = gql`
    query clients_list_index($segment: SegmentInput!, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]!) {
  clients_list_index: clients_list(
    segment: $segment
    page: $page
    first: $first
    orderBy: $orderBy
  ) {
    data {
      ...FRAGMENT_CLIENT_INDEX_LIST
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentClientIndexListFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useClientsListIndexQuery__
 *
 * To run a query within a Vue component, call `useClientsListIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsListIndexQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientsListIndexQuery({
 *   segment: // value for 'segment'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useClientsListIndexQuery(variables: QLClientsListIndexQueryVariables | VueCompositionApi.Ref<QLClientsListIndexQueryVariables> | ReactiveFunction<QLClientsListIndexQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientsListIndexQuery, QLClientsListIndexQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientsListIndexQuery, QLClientsListIndexQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientsListIndexQuery, QLClientsListIndexQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientsListIndexQuery, QLClientsListIndexQueryVariables>(ClientsListIndexDocument, variables, options);
}
export function useClientsListIndexLazyQuery(variables: QLClientsListIndexQueryVariables | VueCompositionApi.Ref<QLClientsListIndexQueryVariables> | ReactiveFunction<QLClientsListIndexQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientsListIndexQuery, QLClientsListIndexQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientsListIndexQuery, QLClientsListIndexQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientsListIndexQuery, QLClientsListIndexQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientsListIndexQuery, QLClientsListIndexQueryVariables>(ClientsListIndexDocument, variables, options);
}
export type ClientsListIndexQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientsListIndexQuery, QLClientsListIndexQueryVariables>;
export const ClientsListDashboardDocument = gql`
    query clients_list_dashboard($segment: SegmentInput!, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]!) {
  clients_list_dashboard: clients_list(
    segment: $segment
    page: $page
    first: $first
    orderBy: $orderBy
  ) {
    data {
      ...FRAGMENT_CLIENT_TOOLTIP
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentClientTooltipFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useClientsListDashboardQuery__
 *
 * To run a query within a Vue component, call `useClientsListDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsListDashboardQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientsListDashboardQuery({
 *   segment: // value for 'segment'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useClientsListDashboardQuery(variables: QLClientsListDashboardQueryVariables | VueCompositionApi.Ref<QLClientsListDashboardQueryVariables> | ReactiveFunction<QLClientsListDashboardQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientsListDashboardQuery, QLClientsListDashboardQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientsListDashboardQuery, QLClientsListDashboardQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientsListDashboardQuery, QLClientsListDashboardQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientsListDashboardQuery, QLClientsListDashboardQueryVariables>(ClientsListDashboardDocument, variables, options);
}
export function useClientsListDashboardLazyQuery(variables: QLClientsListDashboardQueryVariables | VueCompositionApi.Ref<QLClientsListDashboardQueryVariables> | ReactiveFunction<QLClientsListDashboardQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientsListDashboardQuery, QLClientsListDashboardQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientsListDashboardQuery, QLClientsListDashboardQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientsListDashboardQuery, QLClientsListDashboardQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientsListDashboardQuery, QLClientsListDashboardQueryVariables>(ClientsListDashboardDocument, variables, options);
}
export type ClientsListDashboardQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientsListDashboardQuery, QLClientsListDashboardQueryVariables>;
export const DiscussionDocument = gql`
    query discussion($id: ID!) {
  discussion(id: $id) {
    ...FRAGMENT_DISCUSSION_FULL
    messages {
      ...FRAGMENT_MESSAGE
    }
  }
}
    ${FragmentDiscussionFullFragmentDoc}
${FragmentMessageFragmentDoc}`;

/**
 * __useDiscussionQuery__
 *
 * To run a query within a Vue component, call `useDiscussionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscussionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDiscussionQuery({
 *   id: // value for 'id'
 * });
 */
export function useDiscussionQuery(variables: QLDiscussionQueryVariables | VueCompositionApi.Ref<QLDiscussionQueryVariables> | ReactiveFunction<QLDiscussionQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLDiscussionQuery, QLDiscussionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLDiscussionQuery, QLDiscussionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLDiscussionQuery, QLDiscussionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLDiscussionQuery, QLDiscussionQueryVariables>(DiscussionDocument, variables, options);
}
export function useDiscussionLazyQuery(variables: QLDiscussionQueryVariables | VueCompositionApi.Ref<QLDiscussionQueryVariables> | ReactiveFunction<QLDiscussionQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLDiscussionQuery, QLDiscussionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLDiscussionQuery, QLDiscussionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLDiscussionQuery, QLDiscussionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLDiscussionQuery, QLDiscussionQueryVariables>(DiscussionDocument, variables, options);
}
export type DiscussionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLDiscussionQuery, QLDiscussionQueryVariables>;
export const DiscussionsDocument = gql`
    query discussions($automation_id: ID, $client_id: ID, $home_location_id: ID, $closed: Boolean, $email: Boolean, $sms: Boolean, $team_has_responded: Boolean, $only_automations: Boolean, $last_contacted_at_from: Timestamp, $last_contacted_at_to: Timestamp, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]) {
  discussions(
    automation_id: $automation_id
    client_id: $client_id
    home_location_id: $home_location_id
    closed: $closed
    email: $email
    sms: $sms
    team_has_responded: $team_has_responded
    only_automations: $only_automations
    last_contacted_at_from: $last_contacted_at_from
    last_contacted_at_to: $last_contacted_at_to
    page: $page
    first: $first
    orderBy: $orderBy
  ) {
    data {
      ...FRAGMENT_DISCUSSION_FULL
      client {
        current_package {
          ...FRAGMENT_PACKAGE_INFO
        }
      }
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentDiscussionFullFragmentDoc}
${FragmentPackageInfoFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useDiscussionsQuery__
 *
 * To run a query within a Vue component, call `useDiscussionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscussionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDiscussionsQuery({
 *   automation_id: // value for 'automation_id'
 *   client_id: // value for 'client_id'
 *   home_location_id: // value for 'home_location_id'
 *   closed: // value for 'closed'
 *   email: // value for 'email'
 *   sms: // value for 'sms'
 *   team_has_responded: // value for 'team_has_responded'
 *   only_automations: // value for 'only_automations'
 *   last_contacted_at_from: // value for 'last_contacted_at_from'
 *   last_contacted_at_to: // value for 'last_contacted_at_to'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useDiscussionsQuery(variables: QLDiscussionsQueryVariables | VueCompositionApi.Ref<QLDiscussionsQueryVariables> | ReactiveFunction<QLDiscussionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLDiscussionsQuery, QLDiscussionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLDiscussionsQuery, QLDiscussionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLDiscussionsQuery, QLDiscussionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLDiscussionsQuery, QLDiscussionsQueryVariables>(DiscussionsDocument, variables, options);
}
export function useDiscussionsLazyQuery(variables: QLDiscussionsQueryVariables | VueCompositionApi.Ref<QLDiscussionsQueryVariables> | ReactiveFunction<QLDiscussionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLDiscussionsQuery, QLDiscussionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLDiscussionsQuery, QLDiscussionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLDiscussionsQuery, QLDiscussionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLDiscussionsQuery, QLDiscussionsQueryVariables>(DiscussionsDocument, variables, options);
}
export type DiscussionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLDiscussionsQuery, QLDiscussionsQueryVariables>;
export const AutomationsDiscussionsDocument = gql`
    query automations_discussions($automation_id: ID, $client_id: ID, $home_location_id: ID, $closed: Boolean, $email: Boolean, $sms: Boolean, $bounced: Boolean, $clicked: Boolean, $delivered: Boolean, $opened: Boolean, $team_has_responded: Boolean, $only_automations: Boolean, $last_contacted_at_from: Timestamp, $last_contacted_at_to: Timestamp, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]) {
  automations_discussions: discussions(
    automation_id: $automation_id
    client_id: $client_id
    home_location_id: $home_location_id
    closed: $closed
    email: $email
    sms: $sms
    bounced: $bounced
    clicked: $clicked
    delivered: $delivered
    opened: $opened
    team_has_responded: $team_has_responded
    only_automations: $only_automations
    last_contacted_at_from: $last_contacted_at_from
    last_contacted_at_to: $last_contacted_at_to
    page: $page
    first: $first
    orderBy: $orderBy
  ) {
    data {
      ...FRAGMENT_DISCUSSION_FROM_AUTOMATIONS
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentDiscussionFromAutomationsFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useAutomationsDiscussionsQuery__
 *
 * To run a query within a Vue component, call `useAutomationsDiscussionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationsDiscussionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAutomationsDiscussionsQuery({
 *   automation_id: // value for 'automation_id'
 *   client_id: // value for 'client_id'
 *   home_location_id: // value for 'home_location_id'
 *   closed: // value for 'closed'
 *   email: // value for 'email'
 *   sms: // value for 'sms'
 *   bounced: // value for 'bounced'
 *   clicked: // value for 'clicked'
 *   delivered: // value for 'delivered'
 *   opened: // value for 'opened'
 *   team_has_responded: // value for 'team_has_responded'
 *   only_automations: // value for 'only_automations'
 *   last_contacted_at_from: // value for 'last_contacted_at_from'
 *   last_contacted_at_to: // value for 'last_contacted_at_to'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useAutomationsDiscussionsQuery(variables: QLAutomationsDiscussionsQueryVariables | VueCompositionApi.Ref<QLAutomationsDiscussionsQueryVariables> | ReactiveFunction<QLAutomationsDiscussionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLAutomationsDiscussionsQuery, QLAutomationsDiscussionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationsDiscussionsQuery, QLAutomationsDiscussionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationsDiscussionsQuery, QLAutomationsDiscussionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLAutomationsDiscussionsQuery, QLAutomationsDiscussionsQueryVariables>(AutomationsDiscussionsDocument, variables, options);
}
export function useAutomationsDiscussionsLazyQuery(variables: QLAutomationsDiscussionsQueryVariables | VueCompositionApi.Ref<QLAutomationsDiscussionsQueryVariables> | ReactiveFunction<QLAutomationsDiscussionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLAutomationsDiscussionsQuery, QLAutomationsDiscussionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAutomationsDiscussionsQuery, QLAutomationsDiscussionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAutomationsDiscussionsQuery, QLAutomationsDiscussionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLAutomationsDiscussionsQuery, QLAutomationsDiscussionsQueryVariables>(AutomationsDiscussionsDocument, variables, options);
}
export type AutomationsDiscussionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLAutomationsDiscussionsQuery, QLAutomationsDiscussionsQueryVariables>;
export const EmailTemplatesDocument = gql`
    query email_templates {
  email_templates {
    ...FRAGRMENT_SMALL_EMAIL_TEMPLATE
  }
}
    ${FragrmentSmallEmailTemplateFragmentDoc}`;

/**
 * __useEmailTemplatesQuery__
 *
 * To run a query within a Vue component, call `useEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEmailTemplatesQuery();
 */
export function useEmailTemplatesQuery(options: VueApolloComposable.UseQueryOptions<QLEmailTemplatesQuery, QLEmailTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLEmailTemplatesQuery, QLEmailTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLEmailTemplatesQuery, QLEmailTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLEmailTemplatesQuery, QLEmailTemplatesQueryVariables>(EmailTemplatesDocument, {}, options);
}
export function useEmailTemplatesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLEmailTemplatesQuery, QLEmailTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLEmailTemplatesQuery, QLEmailTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLEmailTemplatesQuery, QLEmailTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLEmailTemplatesQuery, QLEmailTemplatesQueryVariables>(EmailTemplatesDocument, {}, options);
}
export type EmailTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLEmailTemplatesQuery, QLEmailTemplatesQueryVariables>;
export const EmailTemplateDocument = gql`
    query email_template($id: ID!) {
  email_template(id: $id) {
    ...FRAGRMENT_FULL_EMAIL_TEMPLATE
  }
}
    ${FragrmentFullEmailTemplateFragmentDoc}`;

/**
 * __useEmailTemplateQuery__
 *
 * To run a query within a Vue component, call `useEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEmailTemplateQuery({
 *   id: // value for 'id'
 * });
 */
export function useEmailTemplateQuery(variables: QLEmailTemplateQueryVariables | VueCompositionApi.Ref<QLEmailTemplateQueryVariables> | ReactiveFunction<QLEmailTemplateQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLEmailTemplateQuery, QLEmailTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLEmailTemplateQuery, QLEmailTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLEmailTemplateQuery, QLEmailTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLEmailTemplateQuery, QLEmailTemplateQueryVariables>(EmailTemplateDocument, variables, options);
}
export function useEmailTemplateLazyQuery(variables: QLEmailTemplateQueryVariables | VueCompositionApi.Ref<QLEmailTemplateQueryVariables> | ReactiveFunction<QLEmailTemplateQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLEmailTemplateQuery, QLEmailTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLEmailTemplateQuery, QLEmailTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLEmailTemplateQuery, QLEmailTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLEmailTemplateQuery, QLEmailTemplateQueryVariables>(EmailTemplateDocument, variables, options);
}
export type EmailTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLEmailTemplateQuery, QLEmailTemplateQueryVariables>;
export const FormCatalogItemsDocument = gql`
    query form_catalog_items {
  form_catalog_items {
    ...FORM_CATALOG_ITEM_INDEX
  }
}
    ${FormCatalogItemIndexFragmentDoc}`;

/**
 * __useFormCatalogItemsQuery__
 *
 * To run a query within a Vue component, call `useFormCatalogItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormCatalogItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormCatalogItemsQuery();
 */
export function useFormCatalogItemsQuery(options: VueApolloComposable.UseQueryOptions<QLFormCatalogItemsQuery, QLFormCatalogItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormCatalogItemsQuery, QLFormCatalogItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormCatalogItemsQuery, QLFormCatalogItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLFormCatalogItemsQuery, QLFormCatalogItemsQueryVariables>(FormCatalogItemsDocument, {}, options);
}
export function useFormCatalogItemsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLFormCatalogItemsQuery, QLFormCatalogItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormCatalogItemsQuery, QLFormCatalogItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormCatalogItemsQuery, QLFormCatalogItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLFormCatalogItemsQuery, QLFormCatalogItemsQueryVariables>(FormCatalogItemsDocument, {}, options);
}
export type FormCatalogItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLFormCatalogItemsQuery, QLFormCatalogItemsQueryVariables>;
export const FormCatalogItemDocument = gql`
    query form_catalog_item($id: ID!) {
  form_catalog_item(id: $id) {
    ...FormCatalogItemSingleFragment
  }
}
    ${FormCatalogItemSingleFragmentFragmentDoc}`;

/**
 * __useFormCatalogItemQuery__
 *
 * To run a query within a Vue component, call `useFormCatalogItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormCatalogItemQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormCatalogItemQuery({
 *   id: // value for 'id'
 * });
 */
export function useFormCatalogItemQuery(variables: QLFormCatalogItemQueryVariables | VueCompositionApi.Ref<QLFormCatalogItemQueryVariables> | ReactiveFunction<QLFormCatalogItemQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormCatalogItemQuery, QLFormCatalogItemQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormCatalogItemQuery, QLFormCatalogItemQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormCatalogItemQuery, QLFormCatalogItemQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLFormCatalogItemQuery, QLFormCatalogItemQueryVariables>(FormCatalogItemDocument, variables, options);
}
export function useFormCatalogItemLazyQuery(variables: QLFormCatalogItemQueryVariables | VueCompositionApi.Ref<QLFormCatalogItemQueryVariables> | ReactiveFunction<QLFormCatalogItemQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormCatalogItemQuery, QLFormCatalogItemQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormCatalogItemQuery, QLFormCatalogItemQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormCatalogItemQuery, QLFormCatalogItemQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLFormCatalogItemQuery, QLFormCatalogItemQueryVariables>(FormCatalogItemDocument, variables, options);
}
export type FormCatalogItemQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLFormCatalogItemQuery, QLFormCatalogItemQueryVariables>;
export const FormsIndexDocument = gql`
    query forms_index {
  forms_index: forms {
    ...FRAGMENT_FORM_SMALL
  }
}
    ${FragmentFormSmallFragmentDoc}`;

/**
 * __useFormsIndexQuery__
 *
 * To run a query within a Vue component, call `useFormsIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormsIndexQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormsIndexQuery();
 */
export function useFormsIndexQuery(options: VueApolloComposable.UseQueryOptions<QLFormsIndexQuery, QLFormsIndexQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormsIndexQuery, QLFormsIndexQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormsIndexQuery, QLFormsIndexQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLFormsIndexQuery, QLFormsIndexQueryVariables>(FormsIndexDocument, {}, options);
}
export function useFormsIndexLazyQuery(options: VueApolloComposable.UseQueryOptions<QLFormsIndexQuery, QLFormsIndexQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormsIndexQuery, QLFormsIndexQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormsIndexQuery, QLFormsIndexQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLFormsIndexQuery, QLFormsIndexQueryVariables>(FormsIndexDocument, {}, options);
}
export type FormsIndexQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLFormsIndexQuery, QLFormsIndexQueryVariables>;
export const FormCategoriesDocument = gql`
    query form_categories {
  form_categories {
    name
  }
}
    `;

/**
 * __useFormCategoriesQuery__
 *
 * To run a query within a Vue component, call `useFormCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormCategoriesQuery();
 */
export function useFormCategoriesQuery(options: VueApolloComposable.UseQueryOptions<QLFormCategoriesQuery, QLFormCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormCategoriesQuery, QLFormCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormCategoriesQuery, QLFormCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLFormCategoriesQuery, QLFormCategoriesQueryVariables>(FormCategoriesDocument, {}, options);
}
export function useFormCategoriesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLFormCategoriesQuery, QLFormCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormCategoriesQuery, QLFormCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormCategoriesQuery, QLFormCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLFormCategoriesQuery, QLFormCategoriesQueryVariables>(FormCategoriesDocument, {}, options);
}
export type FormCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLFormCategoriesQuery, QLFormCategoriesQueryVariables>;
export const FormDocument = gql`
    query form($id: ID!) {
  form(id: $id) {
    ...FRAGMENT_FORM_FULL
  }
}
    ${FragmentFormFullFragmentDoc}`;

/**
 * __useFormQuery__
 *
 * To run a query within a Vue component, call `useFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormQuery({
 *   id: // value for 'id'
 * });
 */
export function useFormQuery(variables: QLFormQueryVariables | VueCompositionApi.Ref<QLFormQueryVariables> | ReactiveFunction<QLFormQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormQuery, QLFormQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormQuery, QLFormQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormQuery, QLFormQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLFormQuery, QLFormQueryVariables>(FormDocument, variables, options);
}
export function useFormLazyQuery(variables: QLFormQueryVariables | VueCompositionApi.Ref<QLFormQueryVariables> | ReactiveFunction<QLFormQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormQuery, QLFormQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormQuery, QLFormQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormQuery, QLFormQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLFormQuery, QLFormQueryVariables>(FormDocument, variables, options);
}
export type FormQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLFormQuery, QLFormQueryVariables>;
export const FormStatCompletionTimesDocument = gql`
    query form_stat_completion_times($input: FormStatInput!) {
  form_stat_completion_times(input: $input) {
    completed
  }
}
    `;

/**
 * __useFormStatCompletionTimesQuery__
 *
 * To run a query within a Vue component, call `useFormStatCompletionTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormStatCompletionTimesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormStatCompletionTimesQuery({
 *   input: // value for 'input'
 * });
 */
export function useFormStatCompletionTimesQuery(variables: QLFormStatCompletionTimesQueryVariables | VueCompositionApi.Ref<QLFormStatCompletionTimesQueryVariables> | ReactiveFunction<QLFormStatCompletionTimesQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormStatCompletionTimesQuery, QLFormStatCompletionTimesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormStatCompletionTimesQuery, QLFormStatCompletionTimesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormStatCompletionTimesQuery, QLFormStatCompletionTimesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLFormStatCompletionTimesQuery, QLFormStatCompletionTimesQueryVariables>(FormStatCompletionTimesDocument, variables, options);
}
export function useFormStatCompletionTimesLazyQuery(variables: QLFormStatCompletionTimesQueryVariables | VueCompositionApi.Ref<QLFormStatCompletionTimesQueryVariables> | ReactiveFunction<QLFormStatCompletionTimesQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormStatCompletionTimesQuery, QLFormStatCompletionTimesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormStatCompletionTimesQuery, QLFormStatCompletionTimesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormStatCompletionTimesQuery, QLFormStatCompletionTimesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLFormStatCompletionTimesQuery, QLFormStatCompletionTimesQueryVariables>(FormStatCompletionTimesDocument, variables, options);
}
export type FormStatCompletionTimesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLFormStatCompletionTimesQuery, QLFormStatCompletionTimesQueryVariables>;
export const FormStatFirstCompletionDocument = gql`
    query form_stat_first_completion($input: FormStatInput!) {
  form_stat_first_completion(input: $input) {
    first
  }
}
    `;

/**
 * __useFormStatFirstCompletionQuery__
 *
 * To run a query within a Vue component, call `useFormStatFirstCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormStatFirstCompletionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormStatFirstCompletionQuery({
 *   input: // value for 'input'
 * });
 */
export function useFormStatFirstCompletionQuery(variables: QLFormStatFirstCompletionQueryVariables | VueCompositionApi.Ref<QLFormStatFirstCompletionQueryVariables> | ReactiveFunction<QLFormStatFirstCompletionQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormStatFirstCompletionQuery, QLFormStatFirstCompletionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormStatFirstCompletionQuery, QLFormStatFirstCompletionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormStatFirstCompletionQuery, QLFormStatFirstCompletionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLFormStatFirstCompletionQuery, QLFormStatFirstCompletionQueryVariables>(FormStatFirstCompletionDocument, variables, options);
}
export function useFormStatFirstCompletionLazyQuery(variables: QLFormStatFirstCompletionQueryVariables | VueCompositionApi.Ref<QLFormStatFirstCompletionQueryVariables> | ReactiveFunction<QLFormStatFirstCompletionQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormStatFirstCompletionQuery, QLFormStatFirstCompletionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormStatFirstCompletionQuery, QLFormStatFirstCompletionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormStatFirstCompletionQuery, QLFormStatFirstCompletionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLFormStatFirstCompletionQuery, QLFormStatFirstCompletionQueryVariables>(FormStatFirstCompletionDocument, variables, options);
}
export type FormStatFirstCompletionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLFormStatFirstCompletionQuery, QLFormStatFirstCompletionQueryVariables>;
export const FormStatFieldDocument = gql`
    query form_stat_field($input: FormStatInput!, $question_id: ID!) {
  form_stat_field(input: $input, question_id: $question_id) {
    answer
    cc
  }
}
    `;

/**
 * __useFormStatFieldQuery__
 *
 * To run a query within a Vue component, call `useFormStatFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormStatFieldQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormStatFieldQuery({
 *   input: // value for 'input'
 *   question_id: // value for 'question_id'
 * });
 */
export function useFormStatFieldQuery(variables: QLFormStatFieldQueryVariables | VueCompositionApi.Ref<QLFormStatFieldQueryVariables> | ReactiveFunction<QLFormStatFieldQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormStatFieldQuery, QLFormStatFieldQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormStatFieldQuery, QLFormStatFieldQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormStatFieldQuery, QLFormStatFieldQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLFormStatFieldQuery, QLFormStatFieldQueryVariables>(FormStatFieldDocument, variables, options);
}
export function useFormStatFieldLazyQuery(variables: QLFormStatFieldQueryVariables | VueCompositionApi.Ref<QLFormStatFieldQueryVariables> | ReactiveFunction<QLFormStatFieldQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormStatFieldQuery, QLFormStatFieldQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormStatFieldQuery, QLFormStatFieldQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormStatFieldQuery, QLFormStatFieldQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLFormStatFieldQuery, QLFormStatFieldQueryVariables>(FormStatFieldDocument, variables, options);
}
export type FormStatFieldQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLFormStatFieldQuery, QLFormStatFieldQueryVariables>;
export const FormStatHistoryDocument = gql`
    query form_stat_history($input: FormStatInput!) {
  form_stat_history(input: $input) {
    timestamp
    cc
  }
}
    `;

/**
 * __useFormStatHistoryQuery__
 *
 * To run a query within a Vue component, call `useFormStatHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormStatHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormStatHistoryQuery({
 *   input: // value for 'input'
 * });
 */
export function useFormStatHistoryQuery(variables: QLFormStatHistoryQueryVariables | VueCompositionApi.Ref<QLFormStatHistoryQueryVariables> | ReactiveFunction<QLFormStatHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormStatHistoryQuery, QLFormStatHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormStatHistoryQuery, QLFormStatHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormStatHistoryQuery, QLFormStatHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLFormStatHistoryQuery, QLFormStatHistoryQueryVariables>(FormStatHistoryDocument, variables, options);
}
export function useFormStatHistoryLazyQuery(variables: QLFormStatHistoryQueryVariables | VueCompositionApi.Ref<QLFormStatHistoryQueryVariables> | ReactiveFunction<QLFormStatHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormStatHistoryQuery, QLFormStatHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormStatHistoryQuery, QLFormStatHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormStatHistoryQuery, QLFormStatHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLFormStatHistoryQuery, QLFormStatHistoryQueryVariables>(FormStatHistoryDocument, variables, options);
}
export type FormStatHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLFormStatHistoryQuery, QLFormStatHistoryQueryVariables>;
export const FormInstancesHistoryDocument = gql`
    query form_instances_history($form_id: ID, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]) {
  form_instances_history: form_instances(
    form_id: $form_id
    page: $page
    first: $first
    orderBy: $orderBy
  ) {
    data {
      ...FRAGMENT_FORM_INSTANCE_FROM_HISTORY
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentFormInstanceFromHistoryFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useFormInstancesHistoryQuery__
 *
 * To run a query within a Vue component, call `useFormInstancesHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormInstancesHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormInstancesHistoryQuery({
 *   form_id: // value for 'form_id'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useFormInstancesHistoryQuery(variables: QLFormInstancesHistoryQueryVariables | VueCompositionApi.Ref<QLFormInstancesHistoryQueryVariables> | ReactiveFunction<QLFormInstancesHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormInstancesHistoryQuery, QLFormInstancesHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormInstancesHistoryQuery, QLFormInstancesHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormInstancesHistoryQuery, QLFormInstancesHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLFormInstancesHistoryQuery, QLFormInstancesHistoryQueryVariables>(FormInstancesHistoryDocument, variables, options);
}
export function useFormInstancesHistoryLazyQuery(variables: QLFormInstancesHistoryQueryVariables | VueCompositionApi.Ref<QLFormInstancesHistoryQueryVariables> | ReactiveFunction<QLFormInstancesHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormInstancesHistoryQuery, QLFormInstancesHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormInstancesHistoryQuery, QLFormInstancesHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormInstancesHistoryQuery, QLFormInstancesHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLFormInstancesHistoryQuery, QLFormInstancesHistoryQueryVariables>(FormInstancesHistoryDocument, variables, options);
}
export type FormInstancesHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLFormInstancesHistoryQuery, QLFormInstancesHistoryQueryVariables>;
export const FormInstancesForClientDocument = gql`
    query form_instances_for_client($client_id: ID, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]) {
  form_instances_for_client: form_instances(
    client_id: $client_id
    page: $page
    first: $first
    orderBy: $orderBy
  ) {
    data {
      ...FRAGMENT_FORM_INSTANCE_FOR_CLIENTS
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentFormInstanceForClientsFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useFormInstancesForClientQuery__
 *
 * To run a query within a Vue component, call `useFormInstancesForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormInstancesForClientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormInstancesForClientQuery({
 *   client_id: // value for 'client_id'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useFormInstancesForClientQuery(variables: QLFormInstancesForClientQueryVariables | VueCompositionApi.Ref<QLFormInstancesForClientQueryVariables> | ReactiveFunction<QLFormInstancesForClientQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormInstancesForClientQuery, QLFormInstancesForClientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormInstancesForClientQuery, QLFormInstancesForClientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormInstancesForClientQuery, QLFormInstancesForClientQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLFormInstancesForClientQuery, QLFormInstancesForClientQueryVariables>(FormInstancesForClientDocument, variables, options);
}
export function useFormInstancesForClientLazyQuery(variables: QLFormInstancesForClientQueryVariables | VueCompositionApi.Ref<QLFormInstancesForClientQueryVariables> | ReactiveFunction<QLFormInstancesForClientQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormInstancesForClientQuery, QLFormInstancesForClientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormInstancesForClientQuery, QLFormInstancesForClientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormInstancesForClientQuery, QLFormInstancesForClientQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLFormInstancesForClientQuery, QLFormInstancesForClientQueryVariables>(FormInstancesForClientDocument, variables, options);
}
export type FormInstancesForClientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLFormInstancesForClientQuery, QLFormInstancesForClientQueryVariables>;
export const FormInstancesClientDetailDocument = gql`
    query form_instances_client_detail($form_id: ID, $client_id: ID, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]) {
  form_instances_client_detail: form_instances(
    form_id: $form_id
    client_id: $client_id
    page: $page
    first: $first
    orderBy: $orderBy
  ) {
    data {
      ...FRAGMENT_FORM_INSTANCE_FOR_CLIENTS
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentFormInstanceForClientsFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useFormInstancesClientDetailQuery__
 *
 * To run a query within a Vue component, call `useFormInstancesClientDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormInstancesClientDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormInstancesClientDetailQuery({
 *   form_id: // value for 'form_id'
 *   client_id: // value for 'client_id'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useFormInstancesClientDetailQuery(variables: QLFormInstancesClientDetailQueryVariables | VueCompositionApi.Ref<QLFormInstancesClientDetailQueryVariables> | ReactiveFunction<QLFormInstancesClientDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormInstancesClientDetailQuery, QLFormInstancesClientDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormInstancesClientDetailQuery, QLFormInstancesClientDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormInstancesClientDetailQuery, QLFormInstancesClientDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLFormInstancesClientDetailQuery, QLFormInstancesClientDetailQueryVariables>(FormInstancesClientDetailDocument, variables, options);
}
export function useFormInstancesClientDetailLazyQuery(variables: QLFormInstancesClientDetailQueryVariables | VueCompositionApi.Ref<QLFormInstancesClientDetailQueryVariables> | ReactiveFunction<QLFormInstancesClientDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormInstancesClientDetailQuery, QLFormInstancesClientDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormInstancesClientDetailQuery, QLFormInstancesClientDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormInstancesClientDetailQuery, QLFormInstancesClientDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLFormInstancesClientDetailQuery, QLFormInstancesClientDetailQueryVariables>(FormInstancesClientDetailDocument, variables, options);
}
export type FormInstancesClientDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLFormInstancesClientDetailQuery, QLFormInstancesClientDetailQueryVariables>;
export const FormInstancesRecapDocument = gql`
    query form_instances_recap($client_id: ID!) {
  form_instances_recap(client_id: $client_id) {
    ...FRAGMENT_FORM_WITH_COUNT
  }
}
    ${FragmentFormWithCountFragmentDoc}`;

/**
 * __useFormInstancesRecapQuery__
 *
 * To run a query within a Vue component, call `useFormInstancesRecapQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormInstancesRecapQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormInstancesRecapQuery({
 *   client_id: // value for 'client_id'
 * });
 */
export function useFormInstancesRecapQuery(variables: QLFormInstancesRecapQueryVariables | VueCompositionApi.Ref<QLFormInstancesRecapQueryVariables> | ReactiveFunction<QLFormInstancesRecapQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormInstancesRecapQuery, QLFormInstancesRecapQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormInstancesRecapQuery, QLFormInstancesRecapQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormInstancesRecapQuery, QLFormInstancesRecapQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLFormInstancesRecapQuery, QLFormInstancesRecapQueryVariables>(FormInstancesRecapDocument, variables, options);
}
export function useFormInstancesRecapLazyQuery(variables: QLFormInstancesRecapQueryVariables | VueCompositionApi.Ref<QLFormInstancesRecapQueryVariables> | ReactiveFunction<QLFormInstancesRecapQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormInstancesRecapQuery, QLFormInstancesRecapQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormInstancesRecapQuery, QLFormInstancesRecapQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormInstancesRecapQuery, QLFormInstancesRecapQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLFormInstancesRecapQuery, QLFormInstancesRecapQueryVariables>(FormInstancesRecapDocument, variables, options);
}
export type FormInstancesRecapQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLFormInstancesRecapQuery, QLFormInstancesRecapQueryVariables>;
export const FormInstanceDocument = gql`
    query form_instance($id: ID!) {
  form_instance(id: $id) {
    ...FRAGMENT_FORM_INSTANCE_FOR_CLIENTS
    ip_address
    form {
      ...FRAGMENT_FORM_FULL
    }
    responses {
      id
      question
      answer
    }
  }
}
    ${FragmentFormInstanceForClientsFragmentDoc}
${FragmentFormFullFragmentDoc}`;

/**
 * __useFormInstanceQuery__
 *
 * To run a query within a Vue component, call `useFormInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormInstanceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormInstanceQuery({
 *   id: // value for 'id'
 * });
 */
export function useFormInstanceQuery(variables: QLFormInstanceQueryVariables | VueCompositionApi.Ref<QLFormInstanceQueryVariables> | ReactiveFunction<QLFormInstanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormInstanceQuery, QLFormInstanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormInstanceQuery, QLFormInstanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormInstanceQuery, QLFormInstanceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLFormInstanceQuery, QLFormInstanceQueryVariables>(FormInstanceDocument, variables, options);
}
export function useFormInstanceLazyQuery(variables: QLFormInstanceQueryVariables | VueCompositionApi.Ref<QLFormInstanceQueryVariables> | ReactiveFunction<QLFormInstanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLFormInstanceQuery, QLFormInstanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLFormInstanceQuery, QLFormInstanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLFormInstanceQuery, QLFormInstanceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLFormInstanceQuery, QLFormInstanceQueryVariables>(FormInstanceDocument, variables, options);
}
export type FormInstanceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLFormInstanceQuery, QLFormInstanceQueryVariables>;
export const TeamPendingInvitationsDocument = gql`
    query team_pending_invitations($team_id: ID!) {
  team_pending_invitations(team_id: $team_id) {
    ...FRAGMENT_INVITATION_SENT
  }
}
    ${FragmentInvitationSentFragmentDoc}`;

/**
 * __useTeamPendingInvitationsQuery__
 *
 * To run a query within a Vue component, call `useTeamPendingInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPendingInvitationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTeamPendingInvitationsQuery({
 *   team_id: // value for 'team_id'
 * });
 */
export function useTeamPendingInvitationsQuery(variables: QLTeamPendingInvitationsQueryVariables | VueCompositionApi.Ref<QLTeamPendingInvitationsQueryVariables> | ReactiveFunction<QLTeamPendingInvitationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLTeamPendingInvitationsQuery, QLTeamPendingInvitationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLTeamPendingInvitationsQuery, QLTeamPendingInvitationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLTeamPendingInvitationsQuery, QLTeamPendingInvitationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLTeamPendingInvitationsQuery, QLTeamPendingInvitationsQueryVariables>(TeamPendingInvitationsDocument, variables, options);
}
export function useTeamPendingInvitationsLazyQuery(variables: QLTeamPendingInvitationsQueryVariables | VueCompositionApi.Ref<QLTeamPendingInvitationsQueryVariables> | ReactiveFunction<QLTeamPendingInvitationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLTeamPendingInvitationsQuery, QLTeamPendingInvitationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLTeamPendingInvitationsQuery, QLTeamPendingInvitationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLTeamPendingInvitationsQuery, QLTeamPendingInvitationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLTeamPendingInvitationsQuery, QLTeamPendingInvitationsQueryVariables>(TeamPendingInvitationsDocument, variables, options);
}
export type TeamPendingInvitationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLTeamPendingInvitationsQuery, QLTeamPendingInvitationsQueryVariables>;
export const InvitationsPendingDocument = gql`
    query invitations_pending {
  invitations_pending {
    ...FRAGMENT_INVITATION_RECEIVED
  }
}
    ${FragmentInvitationReceivedFragmentDoc}`;

/**
 * __useInvitationsPendingQuery__
 *
 * To run a query within a Vue component, call `useInvitationsPendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsPendingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInvitationsPendingQuery();
 */
export function useInvitationsPendingQuery(options: VueApolloComposable.UseQueryOptions<QLInvitationsPendingQuery, QLInvitationsPendingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLInvitationsPendingQuery, QLInvitationsPendingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLInvitationsPendingQuery, QLInvitationsPendingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLInvitationsPendingQuery, QLInvitationsPendingQueryVariables>(InvitationsPendingDocument, {}, options);
}
export function useInvitationsPendingLazyQuery(options: VueApolloComposable.UseQueryOptions<QLInvitationsPendingQuery, QLInvitationsPendingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLInvitationsPendingQuery, QLInvitationsPendingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLInvitationsPendingQuery, QLInvitationsPendingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLInvitationsPendingQuery, QLInvitationsPendingQueryVariables>(InvitationsPendingDocument, {}, options);
}
export type InvitationsPendingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLInvitationsPendingQuery, QLInvitationsPendingQueryVariables>;
export const MboIndexesDocument = gql`
    query mbo_indexes {
  mbo_indexes {
    ...Fragment_Mbo_Index
  }
}
    ${FragmentMboIndexFragmentDoc}`;

/**
 * __useMboIndexesQuery__
 *
 * To run a query within a Vue component, call `useMboIndexesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMboIndexesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMboIndexesQuery();
 */
export function useMboIndexesQuery(options: VueApolloComposable.UseQueryOptions<QLMboIndexesQuery, QLMboIndexesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLMboIndexesQuery, QLMboIndexesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLMboIndexesQuery, QLMboIndexesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLMboIndexesQuery, QLMboIndexesQueryVariables>(MboIndexesDocument, {}, options);
}
export function useMboIndexesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLMboIndexesQuery, QLMboIndexesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLMboIndexesQuery, QLMboIndexesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLMboIndexesQuery, QLMboIndexesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLMboIndexesQuery, QLMboIndexesQueryVariables>(MboIndexesDocument, {}, options);
}
export type MboIndexesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLMboIndexesQuery, QLMboIndexesQueryVariables>;
export const NoteTemplatesDocument = gql`
    query noteTemplates {
  noteTemplates(first: 100) {
    data {
      ...FRAGMENT_NOTE_TEMPLATE
    }
  }
}
    ${FragmentNoteTemplateFragmentDoc}`;

/**
 * __useNoteTemplatesQuery__
 *
 * To run a query within a Vue component, call `useNoteTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNoteTemplatesQuery();
 */
export function useNoteTemplatesQuery(options: VueApolloComposable.UseQueryOptions<QLNoteTemplatesQuery, QLNoteTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLNoteTemplatesQuery, QLNoteTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLNoteTemplatesQuery, QLNoteTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLNoteTemplatesQuery, QLNoteTemplatesQueryVariables>(NoteTemplatesDocument, {}, options);
}
export function useNoteTemplatesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLNoteTemplatesQuery, QLNoteTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLNoteTemplatesQuery, QLNoteTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLNoteTemplatesQuery, QLNoteTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLNoteTemplatesQuery, QLNoteTemplatesQueryVariables>(NoteTemplatesDocument, {}, options);
}
export type NoteTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLNoteTemplatesQuery, QLNoteTemplatesQueryVariables>;
export const ClientNotesDocument = gql`
    query client_notes($client_id: ID, $archived: Boolean, $first: Int!, $orderBy: [OrderByClause!], $page: Int) {
  notes(
    client_id: $client_id
    archived: $archived
    first: $first
    page: $page
    orderBy: $orderBy
  ) {
    data {
      ...FRAGMENT_CLIENT_NOTE
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentClientNoteFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useClientNotesQuery__
 *
 * To run a query within a Vue component, call `useClientNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientNotesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientNotesQuery({
 *   client_id: // value for 'client_id'
 *   archived: // value for 'archived'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 *   page: // value for 'page'
 * });
 */
export function useClientNotesQuery(variables: QLClientNotesQueryVariables | VueCompositionApi.Ref<QLClientNotesQueryVariables> | ReactiveFunction<QLClientNotesQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientNotesQuery, QLClientNotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientNotesQuery, QLClientNotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientNotesQuery, QLClientNotesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientNotesQuery, QLClientNotesQueryVariables>(ClientNotesDocument, variables, options);
}
export function useClientNotesLazyQuery(variables: QLClientNotesQueryVariables | VueCompositionApi.Ref<QLClientNotesQueryVariables> | ReactiveFunction<QLClientNotesQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientNotesQuery, QLClientNotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientNotesQuery, QLClientNotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientNotesQuery, QLClientNotesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientNotesQuery, QLClientNotesQueryVariables>(ClientNotesDocument, variables, options);
}
export type ClientNotesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientNotesQuery, QLClientNotesQueryVariables>;
export const QuickAnnouncementsDocument = gql`
    query quick_announcements {
  announcements {
    id
    created_at
  }
}
    `;

/**
 * __useQuickAnnouncementsQuery__
 *
 * To run a query within a Vue component, call `useQuickAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickAnnouncementsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuickAnnouncementsQuery();
 */
export function useQuickAnnouncementsQuery(options: VueApolloComposable.UseQueryOptions<QLQuickAnnouncementsQuery, QLQuickAnnouncementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLQuickAnnouncementsQuery, QLQuickAnnouncementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLQuickAnnouncementsQuery, QLQuickAnnouncementsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLQuickAnnouncementsQuery, QLQuickAnnouncementsQueryVariables>(QuickAnnouncementsDocument, {}, options);
}
export function useQuickAnnouncementsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLQuickAnnouncementsQuery, QLQuickAnnouncementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLQuickAnnouncementsQuery, QLQuickAnnouncementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLQuickAnnouncementsQuery, QLQuickAnnouncementsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLQuickAnnouncementsQuery, QLQuickAnnouncementsQueryVariables>(QuickAnnouncementsDocument, {}, options);
}
export type QuickAnnouncementsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLQuickAnnouncementsQuery, QLQuickAnnouncementsQueryVariables>;
export const AnnouncementsDocument = gql`
    query announcements {
  announcements {
    id
    created_at
    body
    parsed_body
    action_text
    action_url
    creator {
      ...FRAGMENT_USER_SMALL
    }
  }
}
    ${FragmentUserSmallFragmentDoc}`;

/**
 * __useAnnouncementsQuery__
 *
 * To run a query within a Vue component, call `useAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAnnouncementsQuery();
 */
export function useAnnouncementsQuery(options: VueApolloComposable.UseQueryOptions<QLAnnouncementsQuery, QLAnnouncementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAnnouncementsQuery, QLAnnouncementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAnnouncementsQuery, QLAnnouncementsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLAnnouncementsQuery, QLAnnouncementsQueryVariables>(AnnouncementsDocument, {}, options);
}
export function useAnnouncementsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLAnnouncementsQuery, QLAnnouncementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAnnouncementsQuery, QLAnnouncementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAnnouncementsQuery, QLAnnouncementsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLAnnouncementsQuery, QLAnnouncementsQueryVariables>(AnnouncementsDocument, {}, options);
}
export type AnnouncementsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLAnnouncementsQuery, QLAnnouncementsQueryVariables>;
export const QuickNotificationsDocument = gql`
    query quick_notifications {
  notifications {
    id
    read
    created_at
  }
}
    `;

/**
 * __useQuickNotificationsQuery__
 *
 * To run a query within a Vue component, call `useQuickNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickNotificationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuickNotificationsQuery();
 */
export function useQuickNotificationsQuery(options: VueApolloComposable.UseQueryOptions<QLQuickNotificationsQuery, QLQuickNotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLQuickNotificationsQuery, QLQuickNotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLQuickNotificationsQuery, QLQuickNotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLQuickNotificationsQuery, QLQuickNotificationsQueryVariables>(QuickNotificationsDocument, {}, options);
}
export function useQuickNotificationsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLQuickNotificationsQuery, QLQuickNotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLQuickNotificationsQuery, QLQuickNotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLQuickNotificationsQuery, QLQuickNotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLQuickNotificationsQuery, QLQuickNotificationsQueryVariables>(QuickNotificationsDocument, {}, options);
}
export type QuickNotificationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLQuickNotificationsQuery, QLQuickNotificationsQueryVariables>;
export const NotificationsDocument = gql`
    query notifications {
  notifications {
    ...NotificationFragment
  }
}
    ${NotificationFragmentFragmentDoc}`;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a Vue component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNotificationsQuery();
 */
export function useNotificationsQuery(options: VueApolloComposable.UseQueryOptions<QLNotificationsQuery, QLNotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLNotificationsQuery, QLNotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLNotificationsQuery, QLNotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLNotificationsQuery, QLNotificationsQueryVariables>(NotificationsDocument, {}, options);
}
export function useNotificationsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLNotificationsQuery, QLNotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLNotificationsQuery, QLNotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLNotificationsQuery, QLNotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLNotificationsQuery, QLNotificationsQueryVariables>(NotificationsDocument, {}, options);
}
export type NotificationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLNotificationsQuery, QLNotificationsQueryVariables>;
export const ClientsUnsubscribedStatsDocument = gql`
    query clients_unsubscribed_stats($days: Int!) {
  clients_unsubscribed_stats(days: $days) {
    emails
    emails_past
    sms
    sms_past
  }
}
    `;

/**
 * __useClientsUnsubscribedStatsQuery__
 *
 * To run a query within a Vue component, call `useClientsUnsubscribedStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsUnsubscribedStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientsUnsubscribedStatsQuery({
 *   days: // value for 'days'
 * });
 */
export function useClientsUnsubscribedStatsQuery(variables: QLClientsUnsubscribedStatsQueryVariables | VueCompositionApi.Ref<QLClientsUnsubscribedStatsQueryVariables> | ReactiveFunction<QLClientsUnsubscribedStatsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientsUnsubscribedStatsQuery, QLClientsUnsubscribedStatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientsUnsubscribedStatsQuery, QLClientsUnsubscribedStatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientsUnsubscribedStatsQuery, QLClientsUnsubscribedStatsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientsUnsubscribedStatsQuery, QLClientsUnsubscribedStatsQueryVariables>(ClientsUnsubscribedStatsDocument, variables, options);
}
export function useClientsUnsubscribedStatsLazyQuery(variables: QLClientsUnsubscribedStatsQueryVariables | VueCompositionApi.Ref<QLClientsUnsubscribedStatsQueryVariables> | ReactiveFunction<QLClientsUnsubscribedStatsQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientsUnsubscribedStatsQuery, QLClientsUnsubscribedStatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientsUnsubscribedStatsQuery, QLClientsUnsubscribedStatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientsUnsubscribedStatsQuery, QLClientsUnsubscribedStatsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientsUnsubscribedStatsQuery, QLClientsUnsubscribedStatsQueryVariables>(ClientsUnsubscribedStatsDocument, variables, options);
}
export type ClientsUnsubscribedStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientsUnsubscribedStatsQuery, QLClientsUnsubscribedStatsQueryVariables>;
export const ClientsUnsubscribedDocument = gql`
    query clients_unsubscribed($medium: UnsubscribeMediumEnum!, $orderBy: [OrderByClause!], $first: Int!, $page: Int) {
  clients_unsubscribed(
    medium: $medium
    orderBy: $orderBy
    first: $first
    page: $page
  ) {
    data {
      ...ClientUnsubscribedFragment
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${ClientUnsubscribedFragmentFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useClientsUnsubscribedQuery__
 *
 * To run a query within a Vue component, call `useClientsUnsubscribedQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsUnsubscribedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientsUnsubscribedQuery({
 *   medium: // value for 'medium'
 *   orderBy: // value for 'orderBy'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useClientsUnsubscribedQuery(variables: QLClientsUnsubscribedQueryVariables | VueCompositionApi.Ref<QLClientsUnsubscribedQueryVariables> | ReactiveFunction<QLClientsUnsubscribedQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientsUnsubscribedQuery, QLClientsUnsubscribedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientsUnsubscribedQuery, QLClientsUnsubscribedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientsUnsubscribedQuery, QLClientsUnsubscribedQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLClientsUnsubscribedQuery, QLClientsUnsubscribedQueryVariables>(ClientsUnsubscribedDocument, variables, options);
}
export function useClientsUnsubscribedLazyQuery(variables: QLClientsUnsubscribedQueryVariables | VueCompositionApi.Ref<QLClientsUnsubscribedQueryVariables> | ReactiveFunction<QLClientsUnsubscribedQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLClientsUnsubscribedQuery, QLClientsUnsubscribedQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLClientsUnsubscribedQuery, QLClientsUnsubscribedQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLClientsUnsubscribedQuery, QLClientsUnsubscribedQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLClientsUnsubscribedQuery, QLClientsUnsubscribedQueryVariables>(ClientsUnsubscribedDocument, variables, options);
}
export type ClientsUnsubscribedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLClientsUnsubscribedQuery, QLClientsUnsubscribedQueryVariables>;
export const PackageNamesDocument = gql`
    query package_names {
  package_names {
    name
  }
}
    `;

/**
 * __usePackageNamesQuery__
 *
 * To run a query within a Vue component, call `usePackageNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePackageNamesQuery();
 */
export function usePackageNamesQuery(options: VueApolloComposable.UseQueryOptions<QLPackageNamesQuery, QLPackageNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLPackageNamesQuery, QLPackageNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLPackageNamesQuery, QLPackageNamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLPackageNamesQuery, QLPackageNamesQueryVariables>(PackageNamesDocument, {}, options);
}
export function usePackageNamesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLPackageNamesQuery, QLPackageNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLPackageNamesQuery, QLPackageNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLPackageNamesQuery, QLPackageNamesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLPackageNamesQuery, QLPackageNamesQueryVariables>(PackageNamesDocument, {}, options);
}
export type PackageNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLPackageNamesQuery, QLPackageNamesQueryVariables>;
export const ProductNamesDocument = gql`
    query product_names {
  product_names {
    name
  }
}
    `;

/**
 * __useProductNamesQuery__
 *
 * To run a query within a Vue component, call `useProductNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProductNamesQuery();
 */
export function useProductNamesQuery(options: VueApolloComposable.UseQueryOptions<QLProductNamesQuery, QLProductNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLProductNamesQuery, QLProductNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLProductNamesQuery, QLProductNamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLProductNamesQuery, QLProductNamesQueryVariables>(ProductNamesDocument, {}, options);
}
export function useProductNamesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLProductNamesQuery, QLProductNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLProductNamesQuery, QLProductNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLProductNamesQuery, QLProductNamesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLProductNamesQuery, QLProductNamesQueryVariables>(ProductNamesDocument, {}, options);
}
export type ProductNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLProductNamesQuery, QLProductNamesQueryVariables>;
export const ContractNamesDocument = gql`
    query contract_names {
  contract_names {
    name
  }
}
    `;

/**
 * __useContractNamesQuery__
 *
 * To run a query within a Vue component, call `useContractNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContractNamesQuery();
 */
export function useContractNamesQuery(options: VueApolloComposable.UseQueryOptions<QLContractNamesQuery, QLContractNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLContractNamesQuery, QLContractNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLContractNamesQuery, QLContractNamesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLContractNamesQuery, QLContractNamesQueryVariables>(ContractNamesDocument, {}, options);
}
export function useContractNamesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLContractNamesQuery, QLContractNamesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLContractNamesQuery, QLContractNamesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLContractNamesQuery, QLContractNamesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLContractNamesQuery, QLContractNamesQueryVariables>(ContractNamesDocument, {}, options);
}
export type ContractNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLContractNamesQuery, QLContractNamesQueryVariables>;
export const PlaceholdersDocument = gql`
    query placeholders {
  placeholders {
    ...PlaceholderFragment
  }
}
    ${PlaceholderFragmentFragmentDoc}`;

/**
 * __usePlaceholdersQuery__
 *
 * To run a query within a Vue component, call `usePlaceholdersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceholdersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePlaceholdersQuery();
 */
export function usePlaceholdersQuery(options: VueApolloComposable.UseQueryOptions<QLPlaceholdersQuery, QLPlaceholdersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLPlaceholdersQuery, QLPlaceholdersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLPlaceholdersQuery, QLPlaceholdersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLPlaceholdersQuery, QLPlaceholdersQueryVariables>(PlaceholdersDocument, {}, options);
}
export function usePlaceholdersLazyQuery(options: VueApolloComposable.UseQueryOptions<QLPlaceholdersQuery, QLPlaceholdersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLPlaceholdersQuery, QLPlaceholdersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLPlaceholdersQuery, QLPlaceholdersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLPlaceholdersQuery, QLPlaceholdersQueryVariables>(PlaceholdersDocument, {}, options);
}
export type PlaceholdersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLPlaceholdersQuery, QLPlaceholdersQueryVariables>;
export const QuickResponsesDocument = gql`
    query quick_responses {
  quick_responses {
    ...FRAGMENT_QUICK_RESPONSE
  }
}
    ${FragmentQuickResponseFragmentDoc}`;

/**
 * __useQuickResponsesQuery__
 *
 * To run a query within a Vue component, call `useQuickResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickResponsesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuickResponsesQuery();
 */
export function useQuickResponsesQuery(options: VueApolloComposable.UseQueryOptions<QLQuickResponsesQuery, QLQuickResponsesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLQuickResponsesQuery, QLQuickResponsesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLQuickResponsesQuery, QLQuickResponsesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLQuickResponsesQuery, QLQuickResponsesQueryVariables>(QuickResponsesDocument, {}, options);
}
export function useQuickResponsesLazyQuery(options: VueApolloComposable.UseQueryOptions<QLQuickResponsesQuery, QLQuickResponsesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLQuickResponsesQuery, QLQuickResponsesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLQuickResponsesQuery, QLQuickResponsesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLQuickResponsesQuery, QLQuickResponsesQueryVariables>(QuickResponsesDocument, {}, options);
}
export type QuickResponsesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLQuickResponsesQuery, QLQuickResponsesQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...FRAGMENT_USER_ME
  }
}
    ${FragmentUserMeFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a Vue component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMeQuery();
 */
export function useMeQuery(options: VueApolloComposable.UseQueryOptions<QLMeQuery, QLMeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLMeQuery, QLMeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLMeQuery, QLMeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLMeQuery, QLMeQueryVariables>(MeDocument, {}, options);
}
export function useMeLazyQuery(options: VueApolloComposable.UseQueryOptions<QLMeQuery, QLMeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLMeQuery, QLMeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLMeQuery, QLMeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLMeQuery, QLMeQueryVariables>(MeDocument, {}, options);
}
export type MeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLMeQuery, QLMeQueryVariables>;
export const QuickSegmentsDocument = gql`
    query quick_segments {
  quick_segments: segments(
    only_deliverable_by_email: false
    only_deliverable_by_sms: false
    visible_dashboard: false
    archived: true
    is_event: false
    is_communication: false
  ) {
    ...FRAGMENT_SMALL_SEGMENT
  }
}
    ${FragmentSmallSegmentFragmentDoc}`;

/**
 * __useQuickSegmentsQuery__
 *
 * To run a query within a Vue component, call `useQuickSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickSegmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuickSegmentsQuery();
 */
export function useQuickSegmentsQuery(options: VueApolloComposable.UseQueryOptions<QLQuickSegmentsQuery, QLQuickSegmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLQuickSegmentsQuery, QLQuickSegmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLQuickSegmentsQuery, QLQuickSegmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLQuickSegmentsQuery, QLQuickSegmentsQueryVariables>(QuickSegmentsDocument, {}, options);
}
export function useQuickSegmentsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLQuickSegmentsQuery, QLQuickSegmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLQuickSegmentsQuery, QLQuickSegmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLQuickSegmentsQuery, QLQuickSegmentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLQuickSegmentsQuery, QLQuickSegmentsQueryVariables>(QuickSegmentsDocument, {}, options);
}
export type QuickSegmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLQuickSegmentsQuery, QLQuickSegmentsQueryVariables>;
export const UsableSegmentsDocument = gql`
    query usable_segments {
  usable_segments: segments(is_communication: false) {
    ...FRAGMENT_SMALL_SEGMENT
  }
}
    ${FragmentSmallSegmentFragmentDoc}`;

/**
 * __useUsableSegmentsQuery__
 *
 * To run a query within a Vue component, call `useUsableSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsableSegmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUsableSegmentsQuery();
 */
export function useUsableSegmentsQuery(options: VueApolloComposable.UseQueryOptions<QLUsableSegmentsQuery, QLUsableSegmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLUsableSegmentsQuery, QLUsableSegmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLUsableSegmentsQuery, QLUsableSegmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLUsableSegmentsQuery, QLUsableSegmentsQueryVariables>(UsableSegmentsDocument, {}, options);
}
export function useUsableSegmentsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLUsableSegmentsQuery, QLUsableSegmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLUsableSegmentsQuery, QLUsableSegmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLUsableSegmentsQuery, QLUsableSegmentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLUsableSegmentsQuery, QLUsableSegmentsQueryVariables>(UsableSegmentsDocument, {}, options);
}
export type UsableSegmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLUsableSegmentsQuery, QLUsableSegmentsQueryVariables>;
export const SegmentsDocument = gql`
    query segments($only_deliverable_by_email: Boolean, $only_deliverable_by_sms: Boolean, $visible_dashboard: Boolean, $archived: Boolean, $is_communication: Boolean, $is_event: Boolean) {
  segments(
    only_deliverable_by_email: $only_deliverable_by_email
    only_deliverable_by_sms: $only_deliverable_by_sms
    visible_dashboard: $visible_dashboard
    archived: $archived
    is_event: $is_event
    is_communication: $is_communication
  ) {
    ...FRAGMENT_FULL_SEGMENT
  }
}
    ${FragmentFullSegmentFragmentDoc}`;

/**
 * __useSegmentsQuery__
 *
 * To run a query within a Vue component, call `useSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSegmentsQuery({
 *   only_deliverable_by_email: // value for 'only_deliverable_by_email'
 *   only_deliverable_by_sms: // value for 'only_deliverable_by_sms'
 *   visible_dashboard: // value for 'visible_dashboard'
 *   archived: // value for 'archived'
 *   is_communication: // value for 'is_communication'
 *   is_event: // value for 'is_event'
 * });
 */
export function useSegmentsQuery(variables: QLSegmentsQueryVariables | VueCompositionApi.Ref<QLSegmentsQueryVariables> | ReactiveFunction<QLSegmentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<QLSegmentsQuery, QLSegmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLSegmentsQuery, QLSegmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLSegmentsQuery, QLSegmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLSegmentsQuery, QLSegmentsQueryVariables>(SegmentsDocument, variables, options);
}
export function useSegmentsLazyQuery(variables: QLSegmentsQueryVariables | VueCompositionApi.Ref<QLSegmentsQueryVariables> | ReactiveFunction<QLSegmentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<QLSegmentsQuery, QLSegmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLSegmentsQuery, QLSegmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLSegmentsQuery, QLSegmentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLSegmentsQuery, QLSegmentsQueryVariables>(SegmentsDocument, variables, options);
}
export type SegmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLSegmentsQuery, QLSegmentsQueryVariables>;
export const DashboardSegmentsDocument = gql`
    query dashboard_segments {
  dashboard_segments: segments(
    only_deliverable_by_email: false
    only_deliverable_by_sms: false
    visible_dashboard: true
    archived: false
    is_event: false
    is_communication: false
  ) {
    ...FRAGMENT_FULL_SEGMENT
  }
}
    ${FragmentFullSegmentFragmentDoc}`;

/**
 * __useDashboardSegmentsQuery__
 *
 * To run a query within a Vue component, call `useDashboardSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardSegmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDashboardSegmentsQuery();
 */
export function useDashboardSegmentsQuery(options: VueApolloComposable.UseQueryOptions<QLDashboardSegmentsQuery, QLDashboardSegmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLDashboardSegmentsQuery, QLDashboardSegmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLDashboardSegmentsQuery, QLDashboardSegmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLDashboardSegmentsQuery, QLDashboardSegmentsQueryVariables>(DashboardSegmentsDocument, {}, options);
}
export function useDashboardSegmentsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLDashboardSegmentsQuery, QLDashboardSegmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLDashboardSegmentsQuery, QLDashboardSegmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLDashboardSegmentsQuery, QLDashboardSegmentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLDashboardSegmentsQuery, QLDashboardSegmentsQueryVariables>(DashboardSegmentsDocument, {}, options);
}
export type DashboardSegmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLDashboardSegmentsQuery, QLDashboardSegmentsQueryVariables>;
export const InsightsUsableSegmentsDocument = gql`
    query insights_usable_segments {
  insights_usable_segments: segments(is_event: true, is_communication: false) {
    ...FRAGMENT_FULL_SEGMENT
  }
}
    ${FragmentFullSegmentFragmentDoc}`;

/**
 * __useInsightsUsableSegmentsQuery__
 *
 * To run a query within a Vue component, call `useInsightsUsableSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsUsableSegmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInsightsUsableSegmentsQuery();
 */
export function useInsightsUsableSegmentsQuery(options: VueApolloComposable.UseQueryOptions<QLInsightsUsableSegmentsQuery, QLInsightsUsableSegmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLInsightsUsableSegmentsQuery, QLInsightsUsableSegmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLInsightsUsableSegmentsQuery, QLInsightsUsableSegmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLInsightsUsableSegmentsQuery, QLInsightsUsableSegmentsQueryVariables>(InsightsUsableSegmentsDocument, {}, options);
}
export function useInsightsUsableSegmentsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLInsightsUsableSegmentsQuery, QLInsightsUsableSegmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLInsightsUsableSegmentsQuery, QLInsightsUsableSegmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLInsightsUsableSegmentsQuery, QLInsightsUsableSegmentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLInsightsUsableSegmentsQuery, QLInsightsUsableSegmentsQueryVariables>(InsightsUsableSegmentsDocument, {}, options);
}
export type InsightsUsableSegmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLInsightsUsableSegmentsQuery, QLInsightsUsableSegmentsQueryVariables>;
export const EventCalculateSegmentDocument = gql`
    query event_calculate_segment($class_model_id: ID!, $segment: SegmentInput!, $page: Int!, $first: Int!, $orderBy: [OrderByClause!]!) {
  event_calculate_segment(
    class_model_id: $class_model_id
    segment: $segment
    page: $page
    first: $first
    orderBy: $orderBy
  ) {
    data {
      id
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${PaginatorFragmentFragmentDoc}`;

/**
 * __useEventCalculateSegmentQuery__
 *
 * To run a query within a Vue component, call `useEventCalculateSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventCalculateSegmentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEventCalculateSegmentQuery({
 *   class_model_id: // value for 'class_model_id'
 *   segment: // value for 'segment'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   orderBy: // value for 'orderBy'
 * });
 */
export function useEventCalculateSegmentQuery(variables: QLEventCalculateSegmentQueryVariables | VueCompositionApi.Ref<QLEventCalculateSegmentQueryVariables> | ReactiveFunction<QLEventCalculateSegmentQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLEventCalculateSegmentQuery, QLEventCalculateSegmentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLEventCalculateSegmentQuery, QLEventCalculateSegmentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLEventCalculateSegmentQuery, QLEventCalculateSegmentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLEventCalculateSegmentQuery, QLEventCalculateSegmentQueryVariables>(EventCalculateSegmentDocument, variables, options);
}
export function useEventCalculateSegmentLazyQuery(variables: QLEventCalculateSegmentQueryVariables | VueCompositionApi.Ref<QLEventCalculateSegmentQueryVariables> | ReactiveFunction<QLEventCalculateSegmentQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLEventCalculateSegmentQuery, QLEventCalculateSegmentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLEventCalculateSegmentQuery, QLEventCalculateSegmentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLEventCalculateSegmentQuery, QLEventCalculateSegmentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLEventCalculateSegmentQuery, QLEventCalculateSegmentQueryVariables>(EventCalculateSegmentDocument, variables, options);
}
export type EventCalculateSegmentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLEventCalculateSegmentQuery, QLEventCalculateSegmentQueryVariables>;
export const StaffsDocument = gql`
    query staffs {
  staffs {
    ...FRAGMENT_STAFF
  }
}
    ${FragmentStaffFragmentDoc}`;

/**
 * __useStaffsQuery__
 *
 * To run a query within a Vue component, call `useStaffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStaffsQuery();
 */
export function useStaffsQuery(options: VueApolloComposable.UseQueryOptions<QLStaffsQuery, QLStaffsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLStaffsQuery, QLStaffsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLStaffsQuery, QLStaffsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLStaffsQuery, QLStaffsQueryVariables>(StaffsDocument, {}, options);
}
export function useStaffsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLStaffsQuery, QLStaffsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLStaffsQuery, QLStaffsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLStaffsQuery, QLStaffsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLStaffsQuery, QLStaffsQueryVariables>(StaffsDocument, {}, options);
}
export type StaffsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLStaffsQuery, QLStaffsQueryVariables>;
export const StatusDocument = gql`
    query status {
  status {
    todos {
      open
      overdue
      postponed
    }
    discussions {
      open
      open_sms
    }
    total_clients
  }
}
    `;

/**
 * __useStatusQuery__
 *
 * To run a query within a Vue component, call `useStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStatusQuery();
 */
export function useStatusQuery(options: VueApolloComposable.UseQueryOptions<QLStatusQuery, QLStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLStatusQuery, QLStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLStatusQuery, QLStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLStatusQuery, QLStatusQueryVariables>(StatusDocument, {}, options);
}
export function useStatusLazyQuery(options: VueApolloComposable.UseQueryOptions<QLStatusQuery, QLStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLStatusQuery, QLStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLStatusQuery, QLStatusQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLStatusQuery, QLStatusQueryVariables>(StatusDocument, {}, options);
}
export type StatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLStatusQuery, QLStatusQueryVariables>;
export const AllTagsDocument = gql`
    query AllTags {
  tags {
    ...FRAGMENT_ASSIGNED_TAG
  }
}
    ${FragmentAssignedTagFragmentDoc}`;

/**
 * __useAllTagsQuery__
 *
 * To run a query within a Vue component, call `useAllTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTagsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllTagsQuery();
 */
export function useAllTagsQuery(options: VueApolloComposable.UseQueryOptions<QLAllTagsQuery, QLAllTagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAllTagsQuery, QLAllTagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAllTagsQuery, QLAllTagsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLAllTagsQuery, QLAllTagsQueryVariables>(AllTagsDocument, {}, options);
}
export function useAllTagsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLAllTagsQuery, QLAllTagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLAllTagsQuery, QLAllTagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLAllTagsQuery, QLAllTagsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLAllTagsQuery, QLAllTagsQueryVariables>(AllTagsDocument, {}, options);
}
export type AllTagsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLAllTagsQuery, QLAllTagsQueryVariables>;
export const BatchTagClientsDocument = gql`
    mutation BatchTagClients($clients: [BatchTagClientIdentifierInput!]!, $tagNames: [String!]!, $action: TagAction!) {
  BatchTagClients(clients: $clients, tagNames: $tagNames, action: $action) {
    success
    message
    clientsTagged
    leadsCreated
  }
}
    `;

/**
 * __useBatchTagClientsMutation__
 *
 * To run a mutation, you first call `useBatchTagClientsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBatchTagClientsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBatchTagClientsMutation({
 *   variables: {
 *     clients: // value for 'clients'
 *     tagNames: // value for 'tagNames'
 *     action: // value for 'action'
 *   },
 * });
 */
export function useBatchTagClientsMutation(options: VueApolloComposable.UseMutationOptions<QLBatchTagClientsMutation, QLBatchTagClientsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<QLBatchTagClientsMutation, QLBatchTagClientsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<QLBatchTagClientsMutation, QLBatchTagClientsMutationVariables>(BatchTagClientsDocument, options);
}
export type BatchTagClientsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<QLBatchTagClientsMutation, QLBatchTagClientsMutationVariables>;
export const CurrentTeamDocument = gql`
    query current_team {
  current_team {
    ...FRAGMENT_CURRENT_TEAM
  }
}
    ${FragmentCurrentTeamFragmentDoc}`;

/**
 * __useCurrentTeamQuery__
 *
 * To run a query within a Vue component, call `useCurrentTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentTeamQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCurrentTeamQuery();
 */
export function useCurrentTeamQuery(options: VueApolloComposable.UseQueryOptions<QLCurrentTeamQuery, QLCurrentTeamQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCurrentTeamQuery, QLCurrentTeamQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCurrentTeamQuery, QLCurrentTeamQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLCurrentTeamQuery, QLCurrentTeamQueryVariables>(CurrentTeamDocument, {}, options);
}
export function useCurrentTeamLazyQuery(options: VueApolloComposable.UseQueryOptions<QLCurrentTeamQuery, QLCurrentTeamQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCurrentTeamQuery, QLCurrentTeamQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCurrentTeamQuery, QLCurrentTeamQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLCurrentTeamQuery, QLCurrentTeamQueryVariables>(CurrentTeamDocument, {}, options);
}
export type CurrentTeamQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLCurrentTeamQuery, QLCurrentTeamQueryVariables>;
export const CurrentTeamUsersDocument = gql`
    query current_team_users {
  current_team {
    id
    ...CurrentTeamUsers
  }
}
    ${CurrentTeamUsersFragmentDoc}`;

/**
 * __useCurrentTeamUsersQuery__
 *
 * To run a query within a Vue component, call `useCurrentTeamUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentTeamUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCurrentTeamUsersQuery();
 */
export function useCurrentTeamUsersQuery(options: VueApolloComposable.UseQueryOptions<QLCurrentTeamUsersQuery, QLCurrentTeamUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCurrentTeamUsersQuery, QLCurrentTeamUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCurrentTeamUsersQuery, QLCurrentTeamUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLCurrentTeamUsersQuery, QLCurrentTeamUsersQueryVariables>(CurrentTeamUsersDocument, {}, options);
}
export function useCurrentTeamUsersLazyQuery(options: VueApolloComposable.UseQueryOptions<QLCurrentTeamUsersQuery, QLCurrentTeamUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCurrentTeamUsersQuery, QLCurrentTeamUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCurrentTeamUsersQuery, QLCurrentTeamUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLCurrentTeamUsersQuery, QLCurrentTeamUsersQueryVariables>(CurrentTeamUsersDocument, {}, options);
}
export type CurrentTeamUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLCurrentTeamUsersQuery, QLCurrentTeamUsersQueryVariables>;
export const CurrentTeamGroupsDocument = gql`
    query current_team_groups {
  current_team {
    id
    groups {
      ...FRAGMENT_TEAM_GROUPS
    }
  }
}
    ${FragmentTeamGroupsFragmentDoc}`;

/**
 * __useCurrentTeamGroupsQuery__
 *
 * To run a query within a Vue component, call `useCurrentTeamGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentTeamGroupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCurrentTeamGroupsQuery();
 */
export function useCurrentTeamGroupsQuery(options: VueApolloComposable.UseQueryOptions<QLCurrentTeamGroupsQuery, QLCurrentTeamGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCurrentTeamGroupsQuery, QLCurrentTeamGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCurrentTeamGroupsQuery, QLCurrentTeamGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLCurrentTeamGroupsQuery, QLCurrentTeamGroupsQueryVariables>(CurrentTeamGroupsDocument, {}, options);
}
export function useCurrentTeamGroupsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLCurrentTeamGroupsQuery, QLCurrentTeamGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLCurrentTeamGroupsQuery, QLCurrentTeamGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLCurrentTeamGroupsQuery, QLCurrentTeamGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLCurrentTeamGroupsQuery, QLCurrentTeamGroupsQueryVariables>(CurrentTeamGroupsDocument, {}, options);
}
export type CurrentTeamGroupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLCurrentTeamGroupsQuery, QLCurrentTeamGroupsQueryVariables>;
export const TeamsDocument = gql`
    query teams {
  teams {
    ...FRAGMENT_TEAM
    role
  }
}
    ${FragmentTeamFragmentDoc}`;

/**
 * __useTeamsQuery__
 *
 * To run a query within a Vue component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTeamsQuery();
 */
export function useTeamsQuery(options: VueApolloComposable.UseQueryOptions<QLTeamsQuery, QLTeamsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLTeamsQuery, QLTeamsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLTeamsQuery, QLTeamsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLTeamsQuery, QLTeamsQueryVariables>(TeamsDocument, {}, options);
}
export function useTeamsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLTeamsQuery, QLTeamsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLTeamsQuery, QLTeamsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLTeamsQuery, QLTeamsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLTeamsQuery, QLTeamsQueryVariables>(TeamsDocument, {}, options);
}
export type TeamsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLTeamsQuery, QLTeamsQueryVariables>;
export const TodoDocument = gql`
    query todo($id: ID!) {
  todo(id: $id) {
    ...FRAGMENT_TODO
  }
}
    ${FragmentTodoFragmentDoc}`;

/**
 * __useTodoQuery__
 *
 * To run a query within a Vue component, call `useTodoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTodoQuery({
 *   id: // value for 'id'
 * });
 */
export function useTodoQuery(variables: QLTodoQueryVariables | VueCompositionApi.Ref<QLTodoQueryVariables> | ReactiveFunction<QLTodoQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLTodoQuery, QLTodoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLTodoQuery, QLTodoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLTodoQuery, QLTodoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLTodoQuery, QLTodoQueryVariables>(TodoDocument, variables, options);
}
export function useTodoLazyQuery(variables: QLTodoQueryVariables | VueCompositionApi.Ref<QLTodoQueryVariables> | ReactiveFunction<QLTodoQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLTodoQuery, QLTodoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLTodoQuery, QLTodoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLTodoQuery, QLTodoQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLTodoQuery, QLTodoQueryVariables>(TodoDocument, variables, options);
}
export type TodoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLTodoQuery, QLTodoQueryVariables>;
export const TodosDocument = gql`
    query todos($automation_id: ID, $client_id: ID, $home_location_id: ID, $closed: Boolean, $first: Int!, $manual: Boolean, $open: Boolean, $orderBy: [OrderByClause!], $overdue: Boolean, $page: Int, $priority: Int, $scheduled: Boolean, $tag: ID, $assigned_to_id: ID, $team_group_id: ID, $created_after: String, $created_before: String, $overdue_after: String, $overdue_before: String) {
  todos(
    automation_id: $automation_id
    client_id: $client_id
    home_location_id: $home_location_id
    closed: $closed
    page: $page
    first: $first
    manual: $manual
    open: $open
    orderBy: $orderBy
    overdue: $overdue
    priority: $priority
    tag: $tag
    scheduled: $scheduled
    assigned_to_id: $assigned_to_id
    team_group_id: $team_group_id
    created_after: $created_after
    created_before: $created_before
    overdue_after: $overdue_after
    overdue_before: $overdue_before
  ) {
    data {
      ...FRAGMENT_TODO
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentTodoFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useTodosQuery__
 *
 * To run a query within a Vue component, call `useTodosQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodosQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTodosQuery({
 *   automation_id: // value for 'automation_id'
 *   client_id: // value for 'client_id'
 *   home_location_id: // value for 'home_location_id'
 *   closed: // value for 'closed'
 *   first: // value for 'first'
 *   manual: // value for 'manual'
 *   open: // value for 'open'
 *   orderBy: // value for 'orderBy'
 *   overdue: // value for 'overdue'
 *   page: // value for 'page'
 *   priority: // value for 'priority'
 *   scheduled: // value for 'scheduled'
 *   tag: // value for 'tag'
 *   assigned_to_id: // value for 'assigned_to_id'
 *   team_group_id: // value for 'team_group_id'
 *   created_after: // value for 'created_after'
 *   created_before: // value for 'created_before'
 *   overdue_after: // value for 'overdue_after'
 *   overdue_before: // value for 'overdue_before'
 * });
 */
export function useTodosQuery(variables: QLTodosQueryVariables | VueCompositionApi.Ref<QLTodosQueryVariables> | ReactiveFunction<QLTodosQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLTodosQuery, QLTodosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLTodosQuery, QLTodosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLTodosQuery, QLTodosQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLTodosQuery, QLTodosQueryVariables>(TodosDocument, variables, options);
}
export function useTodosLazyQuery(variables: QLTodosQueryVariables | VueCompositionApi.Ref<QLTodosQueryVariables> | ReactiveFunction<QLTodosQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLTodosQuery, QLTodosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLTodosQuery, QLTodosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLTodosQuery, QLTodosQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLTodosQuery, QLTodosQueryVariables>(TodosDocument, variables, options);
}
export type TodosQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLTodosQuery, QLTodosQueryVariables>;
export const MyTodosDocument = gql`
    query my_todos($orderBy: [OrderByClause!], $first: Int!, $page: Int) {
  my_todos(first: $first, page: $page, orderBy: $orderBy) {
    data {
      ...FRAGMENT_TODO
    }
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${FragmentTodoFragmentDoc}
${PaginatorFragmentFragmentDoc}`;

/**
 * __useMyTodosQuery__
 *
 * To run a query within a Vue component, call `useMyTodosQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTodosQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyTodosQuery({
 *   orderBy: // value for 'orderBy'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useMyTodosQuery(variables: QLMyTodosQueryVariables | VueCompositionApi.Ref<QLMyTodosQueryVariables> | ReactiveFunction<QLMyTodosQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLMyTodosQuery, QLMyTodosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLMyTodosQuery, QLMyTodosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLMyTodosQuery, QLMyTodosQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLMyTodosQuery, QLMyTodosQueryVariables>(MyTodosDocument, variables, options);
}
export function useMyTodosLazyQuery(variables: QLMyTodosQueryVariables | VueCompositionApi.Ref<QLMyTodosQueryVariables> | ReactiveFunction<QLMyTodosQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLMyTodosQuery, QLMyTodosQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLMyTodosQuery, QLMyTodosQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLMyTodosQuery, QLMyTodosQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLMyTodosQuery, QLMyTodosQueryVariables>(MyTodosDocument, variables, options);
}
export type MyTodosQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLMyTodosQuery, QLMyTodosQueryVariables>;
export const MyTodosCountsDocument = gql`
    query my_todos_counts {
  my_todos_counts: my_todos(
    first: 1
    page: 1
    orderBy: [{column: "updated_at", order: DESC}]
  ) {
    paginatorInfo {
      ...PaginatorFragment
    }
  }
}
    ${PaginatorFragmentFragmentDoc}`;

/**
 * __useMyTodosCountsQuery__
 *
 * To run a query within a Vue component, call `useMyTodosCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTodosCountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyTodosCountsQuery();
 */
export function useMyTodosCountsQuery(options: VueApolloComposable.UseQueryOptions<QLMyTodosCountsQuery, QLMyTodosCountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLMyTodosCountsQuery, QLMyTodosCountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLMyTodosCountsQuery, QLMyTodosCountsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLMyTodosCountsQuery, QLMyTodosCountsQueryVariables>(MyTodosCountsDocument, {}, options);
}
export function useMyTodosCountsLazyQuery(options: VueApolloComposable.UseQueryOptions<QLMyTodosCountsQuery, QLMyTodosCountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLMyTodosCountsQuery, QLMyTodosCountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLMyTodosCountsQuery, QLMyTodosCountsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLMyTodosCountsQuery, QLMyTodosCountsQueryVariables>(MyTodosCountsDocument, {}, options);
}
export type MyTodosCountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLMyTodosCountsQuery, QLMyTodosCountsQueryVariables>;
export const VirtualClassesInfoDocument = gql`
    query virtual_classes_info {
  virtual_classes_info {
    ...FRAGMENT_VIRTUAL_CLASS_INFO
  }
}
    ${FragmentVirtualClassInfoFragmentDoc}`;

/**
 * __useVirtualClassesInfoQuery__
 *
 * To run a query within a Vue component, call `useVirtualClassesInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualClassesInfoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVirtualClassesInfoQuery();
 */
export function useVirtualClassesInfoQuery(options: VueApolloComposable.UseQueryOptions<QLVirtualClassesInfoQuery, QLVirtualClassesInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLVirtualClassesInfoQuery, QLVirtualClassesInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLVirtualClassesInfoQuery, QLVirtualClassesInfoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLVirtualClassesInfoQuery, QLVirtualClassesInfoQueryVariables>(VirtualClassesInfoDocument, {}, options);
}
export function useVirtualClassesInfoLazyQuery(options: VueApolloComposable.UseQueryOptions<QLVirtualClassesInfoQuery, QLVirtualClassesInfoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLVirtualClassesInfoQuery, QLVirtualClassesInfoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLVirtualClassesInfoQuery, QLVirtualClassesInfoQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLVirtualClassesInfoQuery, QLVirtualClassesInfoQueryVariables>(VirtualClassesInfoDocument, {}, options);
}
export type VirtualClassesInfoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLVirtualClassesInfoQuery, QLVirtualClassesInfoQueryVariables>;
export const VirtualClassDocument = gql`
    query virtual_class($id: ID!) {
  virtual_class(id: $id) {
    ...FRAGMENT_VIRTUAL_CLASS_INFO
  }
}
    ${FragmentVirtualClassInfoFragmentDoc}`;

/**
 * __useVirtualClassQuery__
 *
 * To run a query within a Vue component, call `useVirtualClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useVirtualClassQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVirtualClassQuery({
 *   id: // value for 'id'
 * });
 */
export function useVirtualClassQuery(variables: QLVirtualClassQueryVariables | VueCompositionApi.Ref<QLVirtualClassQueryVariables> | ReactiveFunction<QLVirtualClassQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLVirtualClassQuery, QLVirtualClassQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLVirtualClassQuery, QLVirtualClassQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLVirtualClassQuery, QLVirtualClassQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLVirtualClassQuery, QLVirtualClassQueryVariables>(VirtualClassDocument, variables, options);
}
export function useVirtualClassLazyQuery(variables: QLVirtualClassQueryVariables | VueCompositionApi.Ref<QLVirtualClassQueryVariables> | ReactiveFunction<QLVirtualClassQueryVariables>, options: VueApolloComposable.UseQueryOptions<QLVirtualClassQuery, QLVirtualClassQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLVirtualClassQuery, QLVirtualClassQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLVirtualClassQuery, QLVirtualClassQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLVirtualClassQuery, QLVirtualClassQueryVariables>(VirtualClassDocument, variables, options);
}
export type VirtualClassQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLVirtualClassQuery, QLVirtualClassQueryVariables>;
export const ZapierTokensDocument = gql`
    query zapier_tokens {
  zapier_tokens {
    id
    name
    created_at
  }
}
    `;

/**
 * __useZapierTokensQuery__
 *
 * To run a query within a Vue component, call `useZapierTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useZapierTokensQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useZapierTokensQuery();
 */
export function useZapierTokensQuery(options: VueApolloComposable.UseQueryOptions<QLZapierTokensQuery, QLZapierTokensQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLZapierTokensQuery, QLZapierTokensQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLZapierTokensQuery, QLZapierTokensQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QLZapierTokensQuery, QLZapierTokensQueryVariables>(ZapierTokensDocument, {}, options);
}
export function useZapierTokensLazyQuery(options: VueApolloComposable.UseQueryOptions<QLZapierTokensQuery, QLZapierTokensQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QLZapierTokensQuery, QLZapierTokensQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QLZapierTokensQuery, QLZapierTokensQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QLZapierTokensQuery, QLZapierTokensQueryVariables>(ZapierTokensDocument, {}, options);
}
export type ZapierTokensQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QLZapierTokensQuery, QLZapierTokensQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Note": [
      "ClientNote"
    ]
  }
};
      export default result;
    